import * as e from "react";
import t, { createContext as n, useCallback as r, useContext as i, useEffect as a, useId as o, useImperativeHandle as s, useLayoutEffect as c, useMemo as l, useReducer as u, useRef as d, useState as f, useSyncExternalStore as p } from "react";
import { createAnalyzerGraphNode as m, createAudioGraph as h, createStreamSourceGraphNode as g } from "@pexip/media-processor";
import { assert as _, getTimeLeft as v, isDefined as y, lastOr as b, noop as x, prig as S } from "@pexip/utils";
import { Trans as C, useTranslation as w } from "react-i18next";
import { DeniedDevices as T, EMPTY_USER_MEDIA_STATUS as E, MediaInputStatusFlag as D, createPreviewStreamController as O, hasInputStatus as k, isDeviceInUse as A, isFallback as j, isFallbackAudio as M, isFallbackVideo as N, isGrantedAudio as P, isGrantedVideo as F, isInitial as I, isInitialPermissions as L, isInitialPermissionsGranted as ee, isInitialPermissionsNotGranted as te, isRejected as ne, isRejectedOnlyAudio as R, isRejectedOnlyVideo as re, isRequestPermissionNeeded as ie } from "@pexip/media";
import { useAnimationFrame as ae, useCountDown as oe, useIsInWindowBottomHalf as se, useIsInWindowRightHalf as ce, useMatchMedia as le, usePrevious as ue, useSizeObserver as de, useToggleFullscreen as fe, useWideContainerObserver as pe } from "@pexip/hooks";
import { Accordion as me, AriaMenu as he, AspectRatio as ge, Audio as _e, Avatar as ve, AvatarType as ye, BadgeCounter as be, Bar as xe, Box as Se, Button as z, Cell as B, CenterLayout as Ce, Checkbox as we, CircleCountDown as Te, Color as Ee, CondensedTabs as De, ConfirmationModal as Oe, CoreHeader as ke, Divider as Ae, Draggable as je, FileUpload as Me, FontVariant as V, Form as Ne, FullSizeWindow as Pe, FullscreenLayout as Fe, Grid as Ie, Group as Le, Icon as H, IconTypes as U, Input as Re, InputLabel as ze, InteractiveElement as Be, KebabMenuButton as Ve, List as He, LoadingBox as Ue, LockStyle as We, Logo as Ge, Menu as Ke, Modal as qe, ModalCloseButton as Je, ModalType as Ye, NotificationTooltip as Xe, NumberStepInput as Ze, Panel as Qe, PexipLogo as $e, Pill as et, PopOutWindow as tt, ProgressBar as nt, ProgressBarColor as rt, RadioButton as it, RefButton as at, Row as W, Scrim as ot, Scrollbars as st, Select as ct, Spinner as lt, SvgImage as ut, Text as G, TextArea as dt, TextHeading as ft, TextLink as pt, ThemeConsumer as mt, ThemeProvider as ht, Toast as gt, Tooltip as _t, URLToLink as vt, User as yt, Video as bt, VideoWrapper as xt, announce as St, isImageSrcEmpty as Ct, notificationToastSignal as wt, onEnter as Tt, openPopOutWindow as Et, sizeToPadding as Dt, useBelow360 as Ot, useBreakpointChange as kt, useFocusFromOpened as At, useLandscape as jt, useLgUp as Mt, useMd as Nt, useMdDown as Pt, useMobileDevice as Ft, useModal as It, useModalHandle as Lt, useModalWithoutPreventScroll as Rt, useOutOfViewNavigation as zt, usePortrait as Bt, useSmUp as Vt, useTouchDevice as Ht, useXs as Ut, variables as Wt, withColorScheme as Gt } from "@pexip/components";
import { ClientCallType as Kt, MAIN_ROOM_ID as qt, assertParticipantID as Jt, assertRoomID as Yt } from "@pexip/infinity";
import { UAParser as Xt } from "ua-parser-js";
import { Quality as Zt, STATS_SIZE as Qt, getQuality as $t } from "@pexip/peer-connection-stats";
import K from "classnames";
import { compareDevices as en, getDeviceId as tn, isDeviceGranted as nn, reverseDeviceId as rn } from "@pexip/media-control";
import { getInteractionModality as an } from "@react-aria/interactions";
// test/testIds.ts
var q = /*#__PURE__*/ function(e) {
	return e.ActionAddToFavorites = "action-add-to-favorites", e.ActionCallMeetingId = "action-call-meeting-id", e.ActionDeleteRecent = "action-delete-recent", e.ActionRemoveFavorite = "action-remove-favorite", e.ActionEnterDTMF = "action-enter-dtmf", e.ActionFecc = "action-fecc", e.ActionLowerHand = "action-lower-hand", e.ActionMakeGuest = "action-make-guest", e.ActionMakeHost = "action-make-host", e.ActionMuteMicrophone = "action-mute-microphone", e.ActionRemoveSpotlight = "action-remove-spotlight", e.ActionSpotlight = "action-spotlight", e.ActionTransfer = "action-transfer", e.ActionUnmuteMicrophone = "action-unmute-microphone", e.AudioMeterSettings = "audio-meter-settings", e.BadgeCounterBreakoutRoomsPanelButton = "badge-counter-breakout-rooms-panel-button", e.BadgeCounterParticipantPanelButton = "badge-counter-participant-panel-button", e.BreakoutAssignAutoBtn = "breakout-assign-auto-btn", e.BreakoutAssignManuallyBtn = "breakout-assign-manually-btn", e.BreakoutAssignRoomMenu = "breakout-assign-room-menu", e.BreakoutAssignRoomMenuButton = "breakout-assign-room-menu-button", e.BreakoutNumberOfRoomsInput = "roomsInput-number-step-input", e.BreakoutRoom = "breakout-room", e.BreakoutRoomsPanelWrapper = "breakout-rooms-panel-wrapper", e.BreakoutSetupPanelBackBtn = "breakout-setup-panel-back-btn", e.ButtonAdmitParticipant = "button-admit-participant", e.ButtonAudioMeter = "button-audio-meter", e.ButtonAudioMeterMuted = "button-audio-meter-muted", e.ButtonBackgroundEffectsOff = "button-background-effects-off", e.ButtonBackgroundEffectsOn = "button-background-effects-on", e.ButtonBackgroundEffectNone = "button-background-effect-none", e.ButtonBackgroundEffectBlurLow = "button-background-effect-blur-low", e.ButtonBackgroundEffectBlurHigh = "button-background-effect-blur-high", e.ButtonBackgroundEffectUpload = "button-background-effect-upload", e.ButtonBackgroundEffectImage = "button-background-effect-image", e.ButtonBackgroundEffectRemoveImage = "button-background-effect-remove-image", e.ButtonBackgroundEffectSave = "button-background-effect-save", e.ButtonBackgroundEffectCancel = "button-background-effect-cancel", e.ButtonBackgroundEffectNavigateLeft = "button-background-effect-navigate-left", e.ButtonBackgroundEffectNavigateRight = "button-background-effect-navigate-right", e.ButtonBreakoutJoinAskingForHelp = "button-breakout-join-asking-for-help", e.ButtonBreakoutRoomAddRoom = "button-breakout-rooms-add-room", e.ButtonBreakoutRoomEdit = "button-breakout-rooms-edit", e.ButtonBreakoutRoomHeader = "button-breakout-rooms-edit-header", e.ButtonBreakoutRoomSettings = "breakout-rooms-settings", e.ButtonBreakoutRoomShuffle = "button-breakout-rooms-shuffle", e.ButtonBreakoutRooms = "button-breakout-rooms", e.ButtonBreakoutRoomsCancelGoBackToModeAssignment = "button-breakout-rooms-cancel-go-back-to-mode-assignment", e.ButtonBreakoutRoomsCancelGoBackToOpenedRooms = "button-breakout-rooms-cancel-go-back-to-opened-rooms", e.ButtonBreakoutRoomsConfiguration = "button-breakout-rooms-configuration", e.ButtonBreakoutRoomsConfirmGoBackToModeAssignment = "button-breakout-rooms-confirm-go-back-to-mode-assignment", e.ButtonBreakoutRoomsConfirmGoBackToOpenedRooms = "button-breakout-rooms-confirm-go-back-to-opened-rooms", e.ButtonBreakoutRoomsNumberOfRoomDecrement = "roomsInput-number-step-decrement", e.ButtonBreakoutRoomsNumberOfRoomIncrement = "roomsInput-number-step-increment", e.ButtonCallControlsTouchMoreMenuBack = "button-call-controls-touch-more-menu-back", e.ButtonCallHistoryDeleteAllRecents = "button-call-history-delete-all-recents", e.ButtonCallHistoryDeleteAllFavorites = "button-call-history-delete-all-favorites", e.ButtonCallHistoryItemMenu = "button-call-history-item-menu", e.ButtonCallHistoryRecentsTab = "button-call-history-recents-tab", e.ButtonCallHistoryFavoritesTab = "button-call-history-favorites-tab", e.ButtonCallHistoryPanelClose = "button-call-history-panel-close", e.ButtonChat = "button-chat", e.ButtonChatDirectMessagePreview = "button-chat-direct-message-preview", e.ButtonChatDirectTab = "button-chat-direct-tab", e.ButtonChatEveryoneTab = "button-chat-everyone-tab", e.ButtonChatNewDirectMessage = "button-chat-new-direct-message", e.ButtonChatSend = "button-chat-send", e.ButtonCloseInvitationModal = "button-invitation-modal", e.ButtonCollapseSelfview = "button-collapse-selfview", e.ButtonCopyMeetingLink = "button-copy-meeting-link", e.ButtonDenyParticipant = "button-deny-participant", e.ButtonDeviceSettings = "button-device-settings", e.ButtonDismiss = "button-dismiss", e.ButtonDragFoldedSelfview = "button-drag-folded-selfview", e.ButtonDuplicateRoomName = "button-duplicate-room-name", e.ButtonExpandSelfview = "button-hide-selfview", e.ButtonFlipCamera = "button-flip-camera", e.ButtonFlipCameraInMeetingSelfview = "button-flip-camera-in-meeting-selfview", e.ButtonInviteMemberSearchRow = "button-invite-member-search-row", e.ButtonJoinAudioOnly = "button-join-audio-only", e.ButtonJoinMeeting = "button-join-meeting", e.ButtonJoinMeetingWithOptions = "button-join-meeting-with-options", e.ButtonJoinWithVideo = "button-join-with-video", e.ButtonKickOffParticipant = "button-kick-off-participant", e.ButtonLeave = "button-leave", e.ButtonLowerHand = "button-lower-hand", e.ButtonLowerHandParticipantRow = "button-lower-hand-participant-row", e.ButtonMeetingAudioInput = "button-meeting-audioinput", e.ButtonMeetingAudioInputMuted = "button-meeting-audioinput-muted", e.ButtonMeetingBackgroundEffectsOff = "button-meeting-background-effects-off", e.ButtonMeetingBackgroundEffectsOn = "button-meeting-background-effects-on", e.ButtonMeetingVideoInput = "button-meeting-videoinput", e.ButtonMeetingVideoInputMuted = "button-meeting-videoinput-muted", e.ButtonMoveToBreakoutNow = "button-move-to-breakout-room-now", e.ButtonMuteParticipant = "button-mute-participant", e.ButtonParticipants = "button-participants", e.ButtonPeerMuted = "button-peer-muted", e.ButtonPeerMutedCamera = "button-peer-muted-camera", e.ButtonPeerPresenting = "button-peer-presenting", e.ButtonPeerUnmuteCamera = "button-peer-unmute-camera", e.ButtonQuality = "button-quality", e.ButtonRaiseHand = "button-raise-hand", e.ButtonRemoveUserCancel = "button-remove-user-cancel", e.ButtonRemoveUserConfirm = "button-remove-user-confirm", e.ButtonRequestPermissions = "button-request-permissions", e.ButtonRoomSettingsHoursInputDecrement = "hoursInput-number-step-decrement", e.ButtonRoomSettingsHoursInputIncrement = "hoursInput-number-step-increment", e.ButtonRoomSettingsMinutesInputDecrement = "minutesInput-number-step-decrement", e.ButtonRoomSettingsMinutesInputIncrement = "minutesInput-number-step-increment", e.ButtonSaveBreakoutRoomsEdit = "button-save-breakout-rooms-edit", e.ButtonSelfviewQuality = "button-selfview-quality", e.ButtonSettingsBack = "button-settings-back", e.ButtonSettingsResetToMeetingLayout = "button-settings-reset-to-meeting-layout", e.ButtonSettingsSaveAll = "button-settings-save-all", e.ButtonSettingsSaveMyself = "button-settings-save-myself", e.ButtonSuggestionItemFavoriteToggle = "button-suggestion-item-favorite-toggle", e.ButtonStartPresentation = "button-start-presentation", e.ButtonStealPresentationCancel = "button-steal-presentation-cancel", e.ButtonStealPresentationConfirm = "button-steal-presentation-confirm", e.ButtonStopPresentation = "button-stop-presentation", e.ButtonTestAudioInputAgain = "button-test-audio-input-again", e.ButtonTestAudioInputStart = "button-test-audio-input-start", e.ButtonTestAudioInputTryAgain = "button-test-audio-input-try-again", e.ButtonToggleAudioInFoldedSelfview = "button-toggle-audio-in-folded-selfview", e.ButtonToggleVideoInFoldedSelfview = "button-toggle-video-in-folded-selfview", e.ButtonToolbarMoreItems = "button-toolbar-more-items", e.ButtonTryAgain = "button-try-again", e.ButtonVideoInput = "button-videoinput", e.ButtonVideoinputMuted = "button-videoinput-muted", e.CancelBreakoutSettings = "cancel-breakout-settings", e.CallHistoryItem = "call-history-item", e.CallHistoryItemExpiredTag = "call-history-item-expired-tag", e.ChatActivityMessage = "chat-activity-message", e.ChatActivityMessageDisplayName = "chat-activity-message-display-name", e.ChatActivityMessageText = "chat-activity-message-text", e.ChatEmptyActivityMessage = "chat-empty-activity-message", e.ChatForm = "chat-form", e.ChatInput = "chat-input", e.ChatMessage = "chat-message", e.ChatMessageLink = "chat-message-link", e.ChatMessageName = "chat-message-name", e.ChatMessageNameMeta = "chat-message-name-meta", e.ChatMessageText = "chat-message-text", e.ChatMessages = "chat-messages", e.ChatPanel = "chat-panel", e.ChatPanelContent = "chat-panel-content", e.ChatRemoveActivityMessage = "chat-remove-activity-message", e.ChatUnreadEveryoneMessagesIndicator = "chat-unread-everyone-messages-indicator", e.ChatUnreadMessageIndicator = "chat-unread-message-indicator", e.ChatUnseenDirectMessagesIndicator = "chat-unseen-direct-messages-indicator", e.CheckEverythingWorksText = "check-that-everything-works", e.CloseBreakoutRoom = "close-breakout-room", e.CloseBreakoutRooms = "close-breakout-rooms", e.CloseBreakoutRoomsModalCancel = "close-breakout-rooms-modal-cancel", e.CloseBreakoutRoomsModalConfirm = "close-breakout-rooms-modal-confirm", e.ConfirmationModalCancelButton = "confirmation-modal-cancel-button", e.ConfirmationModalConfirmButton = "confirmation-modal-confirm-button", e.DevicesSelection = "devices-selection", e.DevicesSelectionBlocked = "devices-selection-blocked", e.FoldedSelfview = "folded-selfview", e.GoToBreakoutSetupPanel = "go-to-breakout-setup-panel", e.HeaderLogo = "header-logo", e.HeaderSubTitle = "header-subtitle", e.HeaderTitle = "header-title", e.IconCameraMuted = "icon-camera-muted", e.IconMuted = "icon-muted", e.IconMutedByAHost = "icon-muted-by-a-host", e.IconPresenting = "icon-presenting", e.IconSpotlight = "icon-spotlight", e.InvitationSearchInput = "invitation-search-input", e.JoinBreakoutRoom = "join-breakout-room", e.JoinCallDetailsWrapper = "join-call-details-wrapper", e.Layout = "layout", e.LayoutLabel = "layout-label", e.LinkMuteAllGuests = "link-mute-all-guests", e.LinkOpenMeetingSettings = "link-open-meeting-settings", e.LinkTestAudioInput = "link-test-audio-input", e.LinkTestAudioOutput = "link-test-audio-output", e.MeetingLinkText = "meeting-link-text", e.MeetingLinkWrapper = "meeting-link-wrapper", e.MeetingVideoFull = "meeting-video-large", e.MeetingVideoPip = "meeting-video-pip", e.MeetingWrapper = "meeting-wrapper", e.MetricAudio = "metric-audio", e.MetricAudioIn = "metric-audio-in", e.MetricAudioOut = "metric-audio-out", e.MetricPreso = "metric-preso", e.MetricPresoIn = "metric-preso-in", e.MetricPresoOut = "metric-preso-out", e.MetricVideo = "metric-video", e.MetricVideoIn = "metric-video-in", e.MetricVideoOut = "metric-video-out", e.MissingAudioDeviceAlert = "missing-audio-device-alert", e.MissingVideoDeviceAlert = "missing-video-device-alert", e.ModalBreakoutRoomsGoBackToModeAssignment = "modal-breakout-rooms-go-back-to-mode-assignment", e.ModalBreakoutRoomsGoBackToOpenedRooms = "modal-breakout-rooms-go-back-to-opened-rooms", e.ModalInvitation = "modal-invitation", e.ModalLayoutChangeConfirmation = "modal-layout-change-confirmation", e.ModalMoveToRoom = "modal-move-to-breakout-room", e.ModalOpenRoomsError = "modal-open-rooms-error", e.ModalRemoveUser = "modal-remove-user", e.ModalRoomSettings = "modal-room-settings", e.ModalStealPresentation = "modal-steal-presentation", e.NetworkConnectedState = "network-connected-state", e.NetworkReconnectedState = "network-reconnected-state", e.NetworkReconnectingState = "network-reconnecting-state", e.NotificationToolTipAudioCloseButton = "notification-tooltip-audio-close-button", e.NotificationToolTipAudioProblem = "notification-tooltip-audio-problem", e.NotificationToolTipDeviceError = "notification-tooltip-device-error", e.NotificationToolTipVideoCloseButton = "notification-tooltip-video-close-button", e.NotificationToolTipVideoProblem = "notification-tooltip-video-problem", e.NotificationTooltipPreviouslyBlocked = "notification-tooltip-previously-blocked", e.NotificationTooltipSelfviewHidden = "notification-tooltip-selfview-hidden", e.OpenBreakoutRooms = "open-breakout-rooms", e.PanelHeaderCloseButton = "panel-header-close-button", e.PanelHeaderTitle = "panel-header-title", e.ParticipantMenuButton = "participant-menu-button", e.ParticipantPanel = "participant-panel", e.ParticipantRow = "participant-row", e.PermissionsRequestMessageWrapper = "permissions-request-message-wrapper", e.PillNewChatMessage = "new-chat-message-pill", e.PresentationFull = "presentation-large", e.PresentationPip = "presentation-pip", e.RemoveBreakoutRoom = "remove-breakout-room", e.RoomSettingsHoursInput = "hoursInput-number-step-input", e.RoomSettingsMinutesInput = "minutesInput-number-step-input", e.SaveBreakoutSettings = "save-breakout-settings", e.SearchRow = "search-row", e.SelectAudioInput = "select-audio-input", e.SelectAudioInputErrorText = "select-audio-input-error-text", e.SelectAudioOutput = "select-audio-output", e.SelectTestAudioInput = "select-test-audio-input", e.SelectTestAudioInputPlayback = "select-test-audio-input-playback", e.SelectTestAudioInputSpeakerPlayback = "select-test-audio-input-speaker-playback", e.SelectVideoInput = "select-video-input", e.SelectVideoInputErrorText = "select-video-input-error-text", e.SendInviteLink = "send-invite-link", e.SettingButtonRequestPreview = "setting-button-request-preview", e.SettingButtonTryAgain = "setting-button-try-again", e.SettingIconCameraOff = "setting-icon-camera-off", e.SettingIconWarning = "setting-icon-warning", e.SettingsVideoSelfview = "settings-video-selfview", e.SettingsVideoSelfviewPreviewLabel = "settings-video-selfview-preview-label", e.SettingsVideoSelfviewWrapper = "settings-video-selfview-wrapper", e.SpeakingIndicator = "speaking-indicator", e.StatsModal = "stats-modal", e.SuggestionItem = "suggestion-item", e.TestAudioInputIndicator = "test-audio-input-indicator", e.TextLinkLearnDismissRequestPermissions = "text-link-dismiss-learn-request-permissions", e.TextLinkLearnRequestPermissions = "text-link-learn-request-permissions", e.TextLinkTryAgainRequestPermissions = "text-link-try-again-request-permissions", e.TextLinkUnblockPermissionsVideo = "text-link-unblock-permissions-video", e.TextNoStatsAvailable = "text-no-stats-available", e.ToastYouAreTemporarilyUnmuted = "toast-you-are-temporarily-unmuted", e.ToggleFecc = "toggle-fecc", e.ToggleNoiseSuppression = "toggle-noise-suppression", e.TogglePreferPresInMix = "toggle-prefer-in-mix", e.TogglePrioritizeSharingMotion = "toggle-prioritize-sharing-motion", e.TooltipDeniedDevice = "tooltip-denied-device", e.TooltipMuteDisabled = "tooltip-mute-disabled", e.UserMenuAddParticipant = "user-menu-add-participant", e.VideoMeeting = "video-meeting", e.VideoPresentation = "video-presentation", e.VideoSelfview = "video-selfview", e.VideoSelfviewWrapper = "video-selfview-wrapper", e.VideoSplashText = "video-splash-text", e.VideoStatus = "video-status", e.VideoStatusBody = "video-status-body", e.VideoStatusTitle = "video-status-title", e;
}({}), on = /*#__PURE__*/ function(e) {
	return e.BlockedDeviceSelection = "blocked-device-selection", e.DeviceSelection = "device-selection", e.Spinner = "spinner", e;
}({}), sn = /*#__PURE__*/ function(e) {
	return e.Void = "void", e.CompleteReload = "complete-reload", e.Complete = "complete", e;
}({}), cn = /*#__PURE__*/ function(e) {
	return e.Images = "images", e.Video = "video", e;
}({}), ln = /*#__PURE__*/ function(e) {
	return e.Primary = "primary", e.Secondary = "secondary", e;
}({}), un = /*#__PURE__*/ function(e) {
	return e.Large = "large", e.Full = "full", e;
}({}), dn = /*#__PURE__*/ function(e) {
	return e.Start = "start", e.Reset = "reset", e.Receive = "receive", e.SetLocalMediaStream = "setLocalMediaStream", e.SetRemoteMediaStream = "setRemoteMediaStream", e.SetEmphasis = "setEmphasis", e.SetExpandPrimary = "setExpandPrimary", e.SetShowSteal = "setShowSteal", e.SetSize = "setSize", e.SetPresenterName = "setPresenterName", e.ActivityChange = "ActivityChange", e;
}({}), J = /*#__PURE__*/ function(e) {
	return e.BrowserPip = "BrowserPip", e.Emphasized = "Emphasized", e.External = "External", e.Deemphasized = "Deemphasized", e.Expanded = "Expanded", e.Pip = "Pip", e.None = "None", e;
}({}), fn = /*#__PURE__*/ function(e) {
	return e.Disabled = "Disabled", e.Muted = "Muted", e.Unmuted = "Unmuted", e;
}({}), pn = /*#__PURE__*/ function(e) {
	return e.Direct = "Direct", e.Everyone = "Everyone", e;
}({}), mn = /*#__PURE__*/ function(e) {
	return e.Low = "low", e.Medium = "medium", e.High = "high", e.VeryHigh = "very-high", e.Auto = "auto", e;
}({}), Y = /*#__PURE__*/ function(e) {
	return e.AdaptiveComposition = "ac", e.Speaker7 = "1:7", e.Speaker21 = "1:21", e.Speaker221 = "2:21", e.Speaker33 = "1:33", e.Highlight = "1:0", e.Equal22 = "2x2", e.Equal33 = "3x3", e.Equal44 = "4x4", e.Equal55 = "5x5", e;
}({}), hn = /*#__PURE__*/ function(e) {
	return e.Connected = "connected", e.Reconnecting = "reconnecting", e.Reconnected = "reconnected", e;
}({}), gn = [
	"camera-step",
	"in-meeting",
	"ready-to-join-express",
	"ready-to-join-step",
	"force-landscape"
], _n = /*#__PURE__*/ function(e) {
	return e.Automatically = "Automatically", e.Manually = "Manually", e;
}({}), vn = /*#__PURE__*/ function(e) {
	return e[e.ModeAssignment = 0] = "ModeAssignment", e[e.InitialConfiguration = 1] = "InitialConfiguration", e[e.RoomsOpened = 2] = "RoomsOpened", e[e.EditConfiguration = 3] = "EditConfiguration", e;
}({}), yn = /*#__PURE__*/ function(e) {
	return e.Setup = "setup", e.Preview = "preview", e.Edit = "edit", e;
}({}), bn = /*#__PURE__*/ function(e) {
	return e.Incoming = "Incoming", e.Outgoing = "Outgoing", e.Missed = "Missed", e;
}({}), xn = 1e4, Sn = 767, Cn = 498, wn = 16, Tn = {
	left: 16,
	right: 16
}, En = 376, Dn = 72, On = 448, kn = mn.High, An = "calc(var(--media-components-z-index-side-panel) - 1)", jn = "main", X = {
	enter: "Enter",
	escape: "Escape",
	arrowUp: "ArrowUp",
	arrowDown: "ArrowDown"
}, Mn = 145, Nn = 80, Pn = 45, Fn = .75, In = (e, t) => {
	_(e, "Audio Track must be provided");
	let n = g(new MediaStream([e])), r = m({ fftSize: t });
	return [h([[n, r]]), r];
}, Ln = (e, t) => {
	let n = d(void 0), [r, i] = f();
	return c(() => {
		let r = !1;
		e && ((e) => {
			let [a, o] = In(e, t);
			n.current = a, r || i(o);
		})(e);
		let a = () => {
			n.current?.release?.(), i(void 0);
		};
		return () => {
			a(), r = !0;
		};
	}, [t, e]), r;
}, Rn = ({ containerRef: e, itemSelector: t, isEnabled: n = !0, loop: i = !0, scrollIntoViewOnFocus: o = !0, keepOriginFocusOnNavigate: s = !1, activateActiveItemOnEnter: c = !1, onActivateActiveItem: l }) => {
	let u = d(null), f = d(null), p = r(() => {
		f.current?.removeAttribute("aria-activedescendant"), f.current = null;
	}, []), m = r((e) => {
		u.current?.removeAttribute("data-keyboard-nav-active"), e.setAttribute("data-keyboard-nav-active", "true"), u.current = e, f.current && e.id && f.current.setAttribute("aria-activedescendant", e.id);
	}, []), h = r((e) => {
		if (!(e instanceof HTMLElement)) return !1;
		let t = e.tagName.toLowerCase();
		return t === "input" || t === "textarea" || e.isContentEditable;
	}, []), g = r(() => {
		let n = e.current;
		return !n || t.trim().length === 0 ? [] : Array.from(n.querySelectorAll(t));
	}, [e, t]), _ = r((e) => {
		if (e.length === 0) return -1;
		let n = document.activeElement?.closest(t);
		if (n) {
			let t = e.indexOf(n);
			if (t !== -1) return t;
		}
		return u.current ? e.indexOf(u.current) : -1;
	}, [t]), v = r((e, t) => {
		let n = g();
		if (n.length === 0) return;
		let r = _(n), a = r === -1 ? e === "next" ? -1 : 0 : r, s = e === "next" ? a + 1 : a - 1, c = n[i ? (s + n.length) % n.length : Math.min(Math.max(s, 0), n.length - 1)];
		c && (m(c), t || c.focus({ preventScroll: !0 }), o && typeof c.scrollIntoView == "function" && c.scrollIntoView({
			block: "nearest",
			inline: "nearest"
		}));
	}, [
		_,
		g,
		i,
		o,
		m
	]);
	a(() => {
		if (!n || t.trim().length === 0) return;
		let r = (n) => {
			let r = e.current;
			if (!r) return;
			let i = n.target;
			if (!(i instanceof HTMLElement)) return;
			f.current && i !== f.current && p();
			let a = i.closest(t);
			a && r.contains(a) && m(a);
		};
		return document.addEventListener("focusin", r), () => {
			document.removeEventListener("focusin", r);
		};
	}, [
		p,
		e,
		n,
		t,
		m
	]), a(() => {
		if (!n || t.trim().length === 0) return;
		let r = (n) => {
			if (n.key === X.enter && c) {
				let r = e.current, i = u.current;
				if (!r || !i || !r.contains(i)) return;
				let a = document.activeElement instanceof HTMLElement ? document.activeElement : null, o = a?.closest(t), c = s && a === f.current && h(a), d = !!(a && r.contains(a)) && !o;
				if (!c && !d) return;
				if (n.preventDefault(), n.stopPropagation(), l) {
					l(i);
					return;
				}
				i.click();
				return;
			}
			if (n.key !== X.arrowDown && n.key !== X.arrowUp || n.repeat) return;
			let r = e.current;
			if (!r) return;
			let i = document.activeElement, a = n.target, o = i?.closest(t) !== null || u.current !== null, d = !!(i && r.contains(i)) || !!(a && r.contains(a)), m = h(n.target), g = s && m;
			(d || m && (s || !o)) && (n.preventDefault(), n.stopPropagation(), g ? f.current = i : p(), n.key === X.arrowDown ? v("next", g) : v("previous", g));
		};
		return document.addEventListener("keydown", r), () => {
			document.removeEventListener("keydown", r), p();
		};
	}, [
		p,
		e,
		n,
		t,
		s,
		c,
		l,
		h,
		v
	]);
}, zn = (e) => {
	let t = i(e);
	if (t === void 0) throw Error("UndefinedContextValue", { cause: e });
	return t;
}, Bn = 3e3, Vn = (e, t, n) => {
	let { t: r } = w(), [i, o] = f();
	return a(() => {
		let n = 0, i = e((e) => {
			e ? o({
				title: r("device-status.no-audio-detected.title", "No audio detected from microphone"),
				message: r("device-status.no-audio-detected.message", "We are not able to detect any sound from your microphone. Please check your settings"),
				warning: T.Microphone
			}) : (o({
				title: r("device-status.audio-detected.title", "Audio detected from microphone"),
				message: r("device-status.audio-detected.message", "Great, now we have sound from you!"),
				warning: T.Microphone
			}), n = window.setTimeout(() => {
				o(void 0);
			}, Bn), t());
		});
		return () => {
			i(), n &&= (window.clearTimeout(n), 0), o(void 0);
		};
	}, [
		t,
		e,
		r,
		n
	]), i;
}, Hn = 255, Un = (e) => Math.trunc(e / Hn * 100), Wn = (e, t) => {
	if (!e?.node || !t) return 0;
	e.node.getByteFrequencyData(t);
	let n = 0;
	for (let e of t) if (e > n && (n = e, n === 255)) break;
	return n;
}, Gn = (e) => {
	let [t, n] = f(0), i = d(void 0);
	a(() => {
		e?.node && (i.current = new Uint8Array(e.node.fftSize / 2));
	}, [e?.node]);
	let o = r(() => {
		e && n(Un(Wn(e, i.current)));
	}, [e]);
	return ae(o), t;
}, Kn = () => {
	let [e, t] = f(), [n, r] = f(!1);
	return a(() => {
		if ("getBattery" in navigator) {
			let e = navigator.getBattery();
			return e.then(({ level: e, charging: n, addEventListener: i }) => {
				let a = e * 100;
				t(a), r(n), i("chargingchange", () => r(n)), i("levelchange", () => t(a));
			}).catch((e) => {
				console.error(e);
			}), () => {
				e.then(({ removeEventListener: e }) => {
					e("chargingchange", null), e("levelchange", null);
				});
			};
		}
	}, []), {
		batteryLevel: e,
		isCharging: n
	};
}, qn = (e, t) => t.includes(e) || e === "main", Jn = (e) => Array.from(e.keys()).filter((e) => e !== jn), Yn = ({ setParticipants: e, existingBreakoutNames: t = [] }) => {
	let { t: n } = w();
	return r(() => {
		e((e) => {
			let r = new Map(e.entries()), i = n("breakouts.room", "Room"), a = n("breakouts.duplicate", "duplicate"), o = `${i} ${[...e.keys()].length}`;
			return qn(o, [...Jn(e), ...t]) && (o = `${o} (${a})`), Yt(o), r.set(o, []);
		}), wt.emit([{ message: n("breakouts.add-room-done-notification", "A new room has been added") }]);
	}, [
		t,
		e,
		n
	]);
}, Xn = (e, t) => e.groupedParticipants?.length ? [...e.groupedParticipants, {
	isMe: t.isMe,
	displayName: t.displayName
}] : [{
	displayName: e.displayName,
	isMe: e.isMe
}, {
	displayName: t.displayName,
	isMe: t.isMe
}], Zn = (e, t) => ({
	...t,
	userId: void 0,
	displayName: "",
	groupedParticipants: Xn(e, t)
}), Qn = /*#__PURE__*/ function(e) {
	return e.ScrollToLastMessage = "scroll-to-last-message", e.DisplayNewMessageToast = "display-new-message-toast", e;
}({}), $n = (e, t) => !t && !e ? "display-new-message-toast" : "scroll-to-last-message", er = (e, t) => {
	let n = b(e, {});
	return !n.userId || !t ? !1 : n.userId === t;
}, tr = (e, t = !0) => {
	let n = e.current?.getScrollElement();
	if (!n) return;
	let r = () => {
		let n = e.current?.getScrollElement();
		n?.scrollTo({
			top: n?.scrollHeight,
			behavior: t ? "smooth" : "auto"
		});
	};
	n.scrollHeight === 0 ? setTimeout(r, 0) : r();
}, nr = (e = 0) => (t) => {
	let n = t?.getScrollElement();
	if (n) {
		let t = n.scrollHeight, r = n.scrollTop, i = n.clientHeight;
		return t - r <= i + e;
	}
	return !1;
}, rr = (e, t) => {
	let n = e.findIndex((e) => e.id === t);
	return n === -1 ? 0 : e.length - (n + 1);
}, ir = (e, t) => e && e.length < t, ar = /*#__PURE__*/ function(e) {
	return e.TextPlain = "text/plain", e.TextHTML = "text/html", e;
}({}), or = (e, t) => new window.ClipboardItem({ [e]: t }), sr = (e, t, { clipboardWrite: n = navigator.clipboard.write.bind(window.navigator.clipboard), createItem: r = or } = {}) => n([r(e, t)]), cr = (e, t = window.navigator.clipboard.writeText.bind(window.navigator.clipboard)) => t(e), lr = (e = window.navigator.clipboard.readText.bind(window.navigator.clipboard)) => e(), ur = async (e, t) => {
	await cr(e), t(!0);
}, dr = "audio/ogg; codecs=opus", fr = "audio/webm; codecs=opus", pr = "audio/mp4", mr = () => [
	"audio/ogg; codecs=opus",
	"audio/mp4",
	"audio/webm; codecs=opus"
].find((e) => MediaRecorder.isTypeSupported(e)) ?? "audio/ogg; codecs=opus", hr = (e, t, n) => {
	let r = ["audio", "video"].flatMap((e) => t.includes("video") || t.includes(e) ? [e] : []);
	if (!e.some((e) => r.includes(e.kind))) throw Error("No valid track");
	let i = {}, a = new MediaRecorder(new MediaStream(e.flatMap((e) => {
		if (r.includes(e.kind)) {
			let t = e.clone();
			return t.enabled = !0, t;
		}
		return [];
	})), { mimeType: t });
	return a.ondataavailable = (e) => {
		i.onDataAvailable?.(e.data), n?.add(e.data);
	}, a.onstop = () => {
		i.onStop?.();
	}, a.onstart = () => {
		i.onStart?.();
	}, a.onresume = () => {
		i.onResume?.();
	}, a.onpause = () => {
		i.onPause?.();
	}, a.onerror = () => {
		i.onError?.();
	}, {
		get stream() {
			return a.stream;
		},
		get mimeType() {
			return a.mimeType;
		},
		get state() {
			return a.state;
		},
		get audioBitsPerSecond() {
			return a.audioBitsPerSecond;
		},
		get videoBitsPerSecond() {
			return a.videoBitsPerSecond;
		},
		set onDataAvailable(e) {
			i.onDataAvailable = e;
		},
		set onStart(e) {
			i.onStart = e;
		},
		set onStop(e) {
			i.onStop = e;
		},
		set onPause(e) {
			i.onPause = e;
		},
		set onResume(e) {
			i.onResume = e;
		},
		set onError(e) {
			i.onError = e;
		},
		start(e) {
			a.start(e);
		},
		stop() {
			a.stop();
		},
		pause() {
			a.pause();
		},
		resume() {
			a.resume();
		},
		requestData() {
			a.requestData();
		},
		clean() {
			for (let e of a.stream.getTracks()) e.stop();
		}
	};
}, gr = () => {
	let e = [];
	return {
		add: (t) => {
			e.push(t);
		},
		clear: () => {
			e = [];
		},
		get: () => e
	};
}, _r = (e, t, n) => {
	let r = e.match(t);
	return r && r.length >= n && Number.parseInt(r[n] ?? "0", 10) || 0;
}, vr = (e = window) => !(!e?.navigator || !("RTCPeerConnection" in e) || !("RTCRtpTransceiver" in e)), yr = (e = window) => "mozGetUserMedia" in e || "peerIdentity" in e.RTCPeerConnection.prototype, br = (e = window) => "webkitGetUserMedia" in navigator || !e.isSecureContext && "webkitRTCPeerConnection" in e && !("RTCIceGatherer" in e), xr = (e = window) => !!(e.RTCPeerConnection && navigator.userAgent.match(/AppleWebKit\/(\d+)\./)), Sr = (e = window) => !!(e.RTCRtpTransceiver && "currentDirection" in e.RTCRtpTransceiver.prototype);
function Cr({ hasWebRTC: e = vr, isFirefox: t = yr, isChromium: n = br, isSafari: r = xr, hasUnifiedPlan: i = Sr } = {}) {
	let a = {
		browser: "",
		version: 0,
		supportsUnifiedPlan: !1
	};
	if (!e()) return a.browser = "Not a browser.", a;
	if (t()) a.browser = "firefox", a.version = _r(navigator.userAgent, /Firefox\/(\d+)\./, 1), a.supportsUnifiedPlan = i();
	else if (n()) a.browser = "chrome", a.version = _r(navigator.userAgent, /Chrom(e|ium)\/(\d+)\./, 2), a.supportsUnifiedPlan = i();
	else if (r()) {
		let e = /Version\/(\d+)\.(\d+)(?:\.(\d+))?/;
		a.browser = "safari", a.version = Number(`${_r(navigator.userAgent, e, 1)}.${_r(navigator.userAgent, e, 2)}`), a.supportsUnifiedPlan = i();
	} else return a.browser = "Not a supported browser.", a;
	return a;
}
var wr = (e) => {
	if (e.includes("Edg/")) return "Edge Chromium";
	if (e.includes("Firefox/")) return "Firefox";
	if (e.includes("Chrome/") || e.includes("CriOS/")) return "Chrome";
	if (e.includes("Android")) return "Android";
	if (e.includes("Safari/") && !e.includes("Mobile/")) return "Safari Mac";
	if (e.includes("Safari/") && e.includes("iPad")) return "Safari iPad";
	if (e.includes("Safari/") && e.includes("iPhone")) return "Safari iPhone";
}, Tr = Cr(), Er = (e = Cr) => !e().browser.includes("Not a"), Dr = Er(), Or = navigator?.mediaDevices && "getDisplayMedia" in navigator.mediaDevices, kr = Tr.browser === "firefox", Ar = Tr.version, jr = wr(navigator?.userAgent), Mr = (e = !0) => (t) => {
	e && t.stopPropagation();
}, Nr = (e, t) => Math.floor(Math.random() * (t - e + 1)) + e, Pr = (e = 1) => (t) => Math.round(t / e) / 100, Fr = 3e5, Ir = (e, t) => e.activityType === t.activityType, Lr = (e, t) => e.at.getTime() + Fr >= t.at.getTime(), Rr = (e, t) => e.type === "activity" && Ir(e, t) && Lr(e, t), zr = (e, t) => {
	let n = e.at(-1);
	return n && Rr(n, t) ? (e.splice(e.length - 1, 1, Zn(n, t)), Array.from(e)) : [...e, t];
};
// ../../shared/baseLogger.ts
function Br() {
	return Object.freeze({
		fatal: (e, t) => console.error(t, e),
		error: (e, t) => console.error(t, e),
		warn: (e, t) => console.warn(t, e),
		info: (e, t) => console.info(t, e),
		debug: (e, t) => console.debug(t, e),
		trace() {},
		silent() {},
		redact(e) {
			return e;
		},
		addRedactPattern() {}
	});
}
// src/logger.ts
var Vr = Br();
function Hr(e) {
	Vr = e;
}
// src/utils/getInitialStreamQuality.ts
var Ur = () => {
	if (!("connection" in navigator) || !(navigator.connection && "effectiveType" in navigator.connection)) return kn;
	switch (Vr.info(navigator.connection, "User connection"), navigator.connection.effectiveType) {
		case "slow-2g":
		case "2g": return mn.Low;
		case "3g": return mn.Medium;
		default: return kn;
	}
}, Wr = (e) => e !== fn.Unmuted, Gr = (e) => e === fn.Disabled, Kr = /*#__PURE__*/ function(e) {
	return e[e.IOS = 0] = "IOS", e[e.Android = 1] = "Android", e[e.WebOS = 2] = "WebOS", e[e.BlackBerry = 3] = "BlackBerry", e[e.WindowsPhone = 4] = "WindowsPhone", e[e.Mac = 5] = "Mac", e[e.Windows = 6] = "Windows", e[e.Linux = 7] = "Linux", e[e.Unknown = 8] = "Unknown", e;
}({}), qr = [
	/iPhone/i,
	/iPad/i,
	/iPod/i
], Jr = [
	/Android/i,
	/webOS/i,
	/BlackBerry/i,
	/Windows Phone/i,
	...qr
], Yr = (e, t) => !!new RegExp(t).exec(e), Xr = () => "matchMedia" in window && matchMedia("(any-pointer: fine)").matches ? !1 : "maxTouchPoints" in navigator && navigator.maxTouchPoints > 0 || "orientation" in window, Zr = (e, t) => e < t, Qr = (e, t, n = 767) => Zr(e, t) ? e < n : t < n, $r = (e = navigator.userAgent) => {
	let t = Yr(e, /Macintosh/i) && Xr();
	return qr.some((t) => Yr(e, t)) || t ? 0 : Yr(e, /Windows Phone/i) ? 4 : Yr(e, /Android/i) ? 1 : Yr(e, /webOS/i) ? 2 : Yr(e, /BlackBerry/i) ? 3 : Yr(e, /Macintosh/i) ? 5 : Yr(e, /Windows/i) ? 6 : Yr(e, /Linux/i) ? 7 : 8;
}, ei = () => $r() === 6 && Xr(), ti = ei(), ni = (e = navigator.userAgent) => ei() ? !1 : Xr() ? !0 : Jr.some((t) => Yr(e, t)), ri = ni() && Qr(window.screen.width, window.screen.height), ii = ni() && !Qr(window.screen.width, window.screen.height) && !ei(), ai = $r() !== 0 || $r() === 0 && Yr(wr(navigator.userAgent) || "", /Safari/i), oi = $r(), si = (e, t) => (n) => {
	e({ title: "" }), t?.(n);
}, ci = async () => {
	document.pictureInPictureElement && document.exitPictureInPicture && await document.exitPictureInPicture();
}, li = (e) => {
	switch (e) {
		case mn.Low: return ui(960, 540);
		case mn.VeryHigh: return ui(1920, 1080);
		default: return ui(1280, 720);
	}
}, ui = (e, t) => ({
	width: {
		ideal: e,
		max: 1920
	},
	height: {
		ideal: t,
		max: 1080
	}
}), di = (e, t) => t || !e ? "collapsed" : "expanded", fi = ni, pi = (e = 767, t = 498) => fi() ? !1 : window.innerWidth < e || window.innerHeight < t, mi = ({ allParticipants: e, identity: t, shuffleAssigned: n = !1, shuffleId: r = Date.now() % 6e4 }) => {
	let i = [], a = [], o = [];
	for (let [t, r] of e.entries()) {
		let e = t === jn;
		e || i.push(t), !n && e ? a.push(...r) : o.push(...r);
	}
	let s = o.findIndex((e) => e.uuid === t);
	if (s > -1) {
		let e = o[s];
		e && a.unshift(e), o.splice(s, 1);
	}
	let c = ["main", a], l = Array.from({ length: i.length }, (e, t) => [y(i[t]), []]);
	for (let e = 0; e < o.length; e++) {
		let [, t] = l[e % l.length] ?? [];
		if (!t) break;
		let n = o[S(e, r, o.length)];
		if (!n) break;
		t.push(n);
	}
	return l.unshift(c), new Map(l);
}, hi = ({ displayName: e, isMe: t }, n) => t ? n("meeting.name-with-you", {
	defaultValue: "{{displayName}} (You)",
	displayName: e
}) : e, gi = (e, t, n) => {
	let r = (t) => {
		let r = e.at(t);
		return r ? hi(r, n) : void 0;
	};
	switch (e.length) {
		case 2: switch (t) {
			case "joined": return n("meeting.two-participants-joined-group", {
				defaultValue: "{{second}} and {{first}} joined",
				first: r(0),
				second: r(1)
			});
			case "left": return n("meeting.two-participants-left-group", {
				defaultValue: "{{second}} and {{first}} left",
				first: r(0),
				second: r(1)
			});
			default: return;
		}
		case 3: switch (t) {
			case "joined": return n("meeting.three-participants-joined-group", {
				defaultValue: "{{third}}, {{second}} and {{first}} joined",
				first: r(0),
				second: r(1),
				third: r(2)
			});
			case "left": return n("meeting.three-participants-left-group", {
				defaultValue: "{{third}}, {{second}} and {{first}} left",
				first: r(0),
				second: r(1),
				third: r(2)
			});
			default: return;
		}
		case 4: switch (t) {
			case "joined": return n("meeting.four-participants-joined-group", {
				defaultValue: "{{third}}, {{second}}, {{first}} and 1 other joined",
				first: r(1),
				second: r(2),
				third: r(3)
			});
			case "left": return n("meeting.four-participants-left-group", {
				defaultValue: "{{third}}, {{second}}, {{first}} and 1 other left",
				first: r(1),
				second: r(2),
				third: r(3)
			});
			default: return;
		}
		default: switch (t) {
			case "joined": return n("meeting.more-than-four-participants-joined-group", {
				defaultValue: "{{third}}, {{second}}, {{first}} and {{remaining}} others joined",
				first: r(-3),
				second: r(-2),
				third: r(-1),
				remaining: e.length - 3
			});
			case "left": return n("meeting.more-than-four-participants-left-group", {
				defaultValue: "{{third}}, {{second}}, {{first}} and {{remaining}} others left",
				first: r(-3),
				second: r(-2),
				third: r(-1),
				remaining: e.length - 3
			});
			default: return;
		}
	}
}, _i = (e, t) => {
	let n = hi(e, t);
	switch (e.activityType) {
		case "joined": return t("meeting.participant-joined", {
			defaultValue: "{{displayName}} joined",
			displayName: n
		});
		case "left": return t("meeting.participant-left", {
			defaultValue: "{{displayName}} left",
			displayName: n
		});
		case "transferred": return t("meeting.participant-transfer", {
			defaultValue: "{{displayName}} transferred",
			displayName: n
		});
		case "removed": return t("meeting.participant-removed", {
			defaultValue: "{{displayName}} removed",
			displayName: n
		});
		case "empty-chat": return t("meeting.empty-chat", { defaultValue: "Looks like nobody posted chat messages while you were in the room" });
		default: return;
	}
}, vi = (e, t) => {
	let { groupedParticipants: n, activityType: r } = e;
	return n && n.length > 1 && r ? gi(n, r, t) ?? "" : _i(e, t) ?? "";
}, yi = {
	hour: "2-digit",
	hour12: !1,
	minute: "2-digit"
}, bi = (e, t) => new Intl.DateTimeFormat(t, yi).format(e), xi = {
	Chrome: "Chrome",
	Firefox: "Firefox",
	Opera: "Opera",
	Yandex: "Yandex",
	Safari: "Safari",
	InternetExplorer: "Internet Explorer",
	Edge: "Edge",
	Chromium: "Chromium",
	Ie: "IE",
	MobileSafari: "Mobile Safari",
	EdgeChromium: "Edge Chromium",
	MIUI: "MIUI Browser",
	SamsungBrowser: "Samsung Browser"
}, Si = {
	IOS: "iOS",
	Android: "Android",
	WindowsPhone: "Windows Phone",
	Windows: "Windows",
	MAC_OS: "Mac OS"
}, Ci = {
	Mobile: "mobile",
	Tablet: "tablet",
	SmartTv: "smarttv",
	Console: "console",
	Wearable: "wearable",
	Embedded: "embedded"
}, wi = "iPad", Ti = (e) => {
	let t = new Xt();
	t.setUA(e);
	let { name: n, version: r } = t.getBrowser(), { name: i, version: a } = t.getOS(), { type: o, vendor: s, model: c } = t.getDevice(), l = () => n === xi.Firefox, u = () => n === xi.Chrome, d = () => n === xi.Safari, f = () => n === xi.MobileSafari, p = () => n === xi.Edge, m = () => i === Si.Android, h = () => i === Si.MAC_OS, g = () => i === Si.IOS, _ = () => i === Si.Windows, v = () => o === Ci.Mobile, y = () => o === Ci.Tablet, b = () => c === "iPad" || (h() || g()) && (y() || Ei()), x = () => o === void 0;
	return {
		browserName: n,
		browserVersion: r,
		systemName: i,
		systemVersion: a,
		deviceType: o,
		deviceVendor: s,
		deviceModel: c,
		get isTouch() {
			return Ei();
		},
		get isFirefox() {
			return l();
		},
		get isChrome() {
			return u();
		},
		get isEdge() {
			return p();
		},
		get isSafari() {
			return d();
		},
		get isSafariMobile() {
			return f();
		},
		get isAndroid() {
			return m();
		},
		get isMacOS() {
			return h();
		},
		get isIOS() {
			return g();
		},
		get isWindows() {
			return _();
		},
		get isMobile() {
			return v();
		},
		get isTablet() {
			return y();
		},
		get isIPad() {
			return b();
		},
		get isDesktop() {
			return x();
		}
	};
}, Ei = () => {
	let e = !1;
	return window.PointerEvent && "maxTouchPoints" in navigator ? navigator.maxTouchPoints > 0 && (e = !0) : (window.matchMedia?.("(any-pointer:coarse)").matches || window.TouchEvent || "ontouchstart" in window) && (e = !0), e;
}, Di = (e) => (t) => {
	let n = [e.onMediaChanged.add(t), e.onDevicesChanged.add(t)];
	return () => {
		for (let e of n) e();
		n.length = 0;
	};
}, Oi = (e, t) => (n) => {
	let r = (e) => {
		e.kind === t && n();
	}, i = [
		e.onMediaChanged.add(n),
		e.onAddTrack.add(r),
		e.onRemoveTrack.add(r)
	];
	return () => {
		for (let e of i) e();
		i.length = 0;
	};
}, ki = (e, t) => (n) => {
	let r = t === "audio" ? e.onUpdatingAudio : e.onUpdatingVideo, i = [
		Oi(e, t)(n),
		e.onStatusChanged.add(n),
		r.add((e) => {
			e || n();
		})
	];
	return () => {
		for (let e of i) e();
		i.length = 0;
	};
}, Ai = (e) => (t) => {
	let n = [
		e.onMediaChanged.add(t),
		e.onAddTrack.add(t),
		e.onRemoveTrack.add(t),
		e.onMediaTrackStopped.add(t),
		e.onMediaTrackMuted.add(t),
		e.onMediaTrackSuspended.add(t)
	];
	return () => {
		for (let e of n) e();
		n.length = 0;
	};
}, ji = (e, t) => Mi(e, t) ?? Ni(e) ?? Pi(e), Mi = (e, t) => !t || !("kind" in t) ? void 0 : e.get(t)[0], Ni = (e) => e.get({
	kind: "audiooutput",
	deviceId: "default"
})[0], Pi = (e) => e.first("audiooutput"), Fi = (e) => "dir" in e ? e.dir(e.language) : "ltr", Ii = /*#__PURE__*/ function(e) {
	return e.NONE = "none", e.BREAKOUT_ROOMS_IN = "breakout-rooms-in", e.BREAKOUT_ROOMS_OUT = "breakout-rooms-out", e.CHAT_IN = "chat-in", e.CHAT_OUT = "chat-out", e.PARTICIPANTS_IN = "participants-in", e.PARTICIPANTS_OUT = "participants-out", e.PLUGINS_IN = "plugins-in", e.PLUGINS_OUT = "plugins-out", e.TRANSCRIPTS_IN = "transcripts-in", e.TRANSCRIPTS_OUT = "transcripts-out", e;
}({}), Li = (e) => {
	let { currentBreakoutRooms: t, currentChat: n, currentParticipants: r, currentPlugins: i, currentTranscripts: a, nextBreakoutRooms: o, nextChat: s, nextParticipants: c, nextPlugins: l, nextTranscripts: u } = e, d = !n && !r && !t && !i && !a, f = s || c || o || l || u;
	return d && s ? "chat-in" : d && c ? "participants-in" : d && o ? "breakout-rooms-in" : d && l ? "plugins-in" : n && !f ? "chat-out" : r && !f ? "participants-out" : t && !f ? "breakout-rooms-out" : i && !f ? "plugins-out" : d && u ? "transcripts-in" : a && !f ? "transcripts-out" : "none";
}, Ri = (e, { openChatPanel: t, openParticipantPanel: n, openBreakoutRoomsPanel: r, openPluginsPanel: i, openTranscriptsPanel: a }) => e === "chat" ? !t : e === "participants" ? !n : e === "plugins" ? !i : e === "transcripts" ? !a : !r, zi = (e) => (t) => {
	let n = Ri(e, {
		openChatPanel: t.openChatPanel,
		openParticipantPanel: t.openParticipantPanel,
		openBreakoutRoomsPanel: t.openBreakoutRoomsPanel,
		openPluginsPanel: t.openPluginsPanel,
		openTranscriptsPanel: t.openTranscriptsPanel
	}), r = e === "chat" && n, i = e === "participants" && n, a = e === "breakoutRooms" && n, o = e === "plugins" && n, s = e === "transcripts" && n;
	return [n, Li({
		currentBreakoutRooms: t.openBreakoutRoomsPanel,
		currentChat: t.openChatPanel,
		currentParticipants: t.openParticipantPanel,
		currentPlugins: t.openPluginsPanel,
		currentTranscripts: t.openTranscriptsPanel,
		nextBreakoutRooms: a,
		nextChat: r,
		nextParticipants: i,
		nextPlugins: o,
		nextTranscripts: s
	})];
}, Bi = ({ assignmentMode: e, myIdentity: t, numberOfRooms: n, setParticipants: r, shuffle: i = mi }) => {
	let { t: o } = w();
	a(() => {
		switch (e) {
			case _n.Manually:
				r((e) => {
					let t = [jn, [...e.get("main") ?? []]], r = Array.from({ length: n }, (e, t) => [`${o("breakouts.room", "Room")} ${t + 1}`, []]);
					return r.unshift(t), new Map(r);
				});
				break;
			case _n.Automatically: r((e) => {
				let r = [...e.get("main") ?? []], a = new Map(Array.from({ length: n }, (e, t) => [`${o("breakouts.room", "Room")} ${t + 1}`, []]));
				return a.set(jn, r), i({
					allParticipants: a,
					identity: t,
					shuffleAssigned: !0
				});
			});
		}
	}, [
		e,
		t,
		n,
		r,
		i,
		o
	]);
}, Vi = ({ participants: e, setParticipants: t }) => r((n, r) => {
	e.forEach((e, i) => {
		e.forEach((a, o) => {
			a.uuid === n && t((t) => {
				let n = new Map(t.entries()), s = [...e];
				if (s?.splice(o, 1), n.set(i, s), r) {
					let e = [...n.get(r) ?? []];
					e.push(a), n.set(r, e);
				}
				return n;
			});
		});
	});
}, [e, t]), Hi = ({ onCloseRooms: e }) => {
	let { t: n } = w(), [i, a] = f(!1), o = r(() => a(!0), []);
	return {
		breakoutCloseAllRoomsConfirmationModal: /* @__PURE__ */ t.createElement(Oe, {
			cancelButtonText: n("common.cancel", "Cancel"),
			cancelButtonTestid: q.CloseBreakoutRoomsModalCancel,
			confirmButtonText: n("common.yes", "Yes"),
			confirmButtonTestid: q.CloseBreakoutRoomsModalConfirm,
			title: n("breakouts.close-all-rooms-modal.title", "Close all rooms?"),
			uniqueTitle: n("breakouts.close-all-rooms-modal.title", "Close all rooms?"),
			description: n("breakouts.close-all-rooms-modal.description", "All participants will be moved to the main room."),
			isOpen: i,
			onConfirm: () => {
				a(!1), e();
			},
			onCancel: () => a(!1)
		}),
		openBreakoutCloseAllRoomsConfirmationModal: o
	};
}, Ui = ({ participants: e, changeParticipantRoom: t, setIsDragging: n }) => {
	let i = d({}), [a, o] = f(), s = (e) => (t) => {
		t && (i.current[e] = t);
	}, c = r((t) => {
		let n = t.getBoundingClientRect();
		for (let r in i.current) {
			let a = i.current[r];
			if (!a) return;
			let o = a.getBoundingClientRect(), s = n.left >= o.left && n.left <= o.right, c = n.top > o.top && n.bottom < o.bottom;
			if (s && c) return Yt(r), e.get(r)?.find((e) => e.uuid === t.id) ? void 0 : r;
		}
	}, [e]);
	return {
		targetRoomId: a,
		onParticipantDragging: r((e) => {
			n(!0), o(c(e));
		}, [c, n]),
		onParticipantDrag: r((e) => {
			o(void 0), n(!1);
			let r = c(e);
			r && (Jt(e.id), t(e.id, r));
		}, [
			n,
			c,
			t
		]),
		getBreakoutRoomRefCallback: s
	};
}, Wi = ({ setParticipants: e }) => r((t) => {
	e((e) => {
		let n = new Map(e.entries()), r = [...n.get("main") ?? [], ...n.get(t) ?? []];
		return n.set(jn, r), n.delete(t), n;
	});
}, [e]), Gi = ({ isOpen: e, onConfirm: n }) => {
	let { t: r } = w();
	return /*#__PURE__*/ t.createElement(Oe, {
		isOpen: e,
		title: r("breakouts.duplicate-room-name-title", "Duplicated room names"),
		uniqueTitle: r("breakouts.duplicate-room-name-title", "Duplicated room names"),
		description: r("breakouts.duplicate-room-name-description", "Two rooms can not have the same name"),
		confirmButtonText: r("common.ok", "Ok"),
		confirmButtonTestid: q.ButtonDuplicateRoomName,
		onConfirm: n
	});
}, Ki = ({ participants: e, setParticipants: n, breakoutRoomsNames: i, setBreakoutRoomsNames: a }) => {
	let [o, s] = f(!1);
	return {
		handleBreakoutRoomNameChange: r((t, r) => qn(r, [...Jn(e), ...i ? Object.values(i) : []]) ? (s(!0), !1) : (i && a && i.has(t) ? a({
			...i,
			[t]: r
		}) : n((e) => {
			let n = e.get(t);
			return n ? (Yt(r), e.set(r, n), e.delete(t), new Map(e)) : e;
		}), !0), [
			e,
			n,
			i,
			a
		]),
		duplicateRoomNameModal: l(() => /*#__PURE__*/ t.createElement(Gi, {
			isOpen: o,
			onConfirm: () => s(!1)
		}), [o])
	};
}, qi = ({ setParticipants: e, myIdentity: t, shuffle: n = mi }) => {
	let i = d(0), [o, s] = f(!1), { t: c } = w(), l = r(() => {
		s(!0), e((e) => n({
			allParticipants: e,
			identity: t
		})), i.current = window.setTimeout(() => {
			s(!1), wt.emit([{ message: c("breakouts.shuffle-done-notification", "Participants have been shuffled") }]);
		}, 500);
	}, [
		t,
		e,
		n,
		c
	]);
	return a(() => () => {
		clearTimeout(i.current);
	}, []), {
		isShuffling: o,
		doShuffle: l
	};
}, Ji = ({ localParticipants: e, liveParticipants: t, localBreakoutNames: n, liveBreakoutNames: i }) => r(() => {
	let r = {
		move: /* @__PURE__ */ new Map(),
		addRoom: /* @__PURE__ */ new Map(),
		renameRoom: /* @__PURE__ */ new Map(),
		removeRoom: []
	};
	for (let t of i.keys()) {
		if (!e.has(t)) {
			r.removeRoom.push(t);
			continue;
		}
		let a = n.get(t);
		a && a !== i.get(t) && r.renameRoom.set(t, a);
	}
	for (let t of e.keys()) t !== "main" && (i.has(t) || r.addRoom.set(t, /* @__PURE__ */ new Map()));
	for (let [n, i] of e.entries()) for (let e of i) for (let [i, a] of t.entries()) for (let t of a) if (e === t && n !== i) {
		if (r.addRoom.has(n)) {
			let t = r.addRoom.get(n);
			if (t) {
				let n = t.get(i);
				n ? n.push(e) : t.set(i, [e]);
			}
			continue;
		}
		let t = r.move.get(i) ?? /* @__PURE__ */ new Map(), a = t?.get(n);
		a ? a.push(e) : t.set(n, [e]), r.move.set(i, t);
	}
	return r;
}, [
	i,
	n,
	t,
	e
]), Yi = ({ currentParticipants: e, breakoutRoomsNames: t, myIdentity: n, onSave: i }) => {
	let [a, o] = f(e), [s, c] = f(t), [l, u] = f(!1), d = Vi({
		participants: a,
		setParticipants: o
	}), { targetRoomId: p, onParticipantDragging: m, onParticipantDrag: h, getBreakoutRoomRefCallback: g } = Ui({
		participants: a,
		changeParticipantRoom: d,
		setIsDragging: u
	}), _ = Wi({ setParticipants: o }), { handleBreakoutRoomNameChange: v } = Ki({
		setParticipants: o,
		participants: a,
		breakoutRoomsNames: s,
		setBreakoutRoomsNames: c
	}), y = Yn({
		setParticipants: o,
		existingBreakoutNames: Object.values(s)
	}), { doShuffle: b, isShuffling: x } = qi({
		setParticipants: o,
		myIdentity: n
	}), S = (e) => Array.from(e).reduce((e, [t, n]) => (e.set(t, n.map((e) => e.uuid)), e), /* @__PURE__ */ new Map()), C = Ji({
		liveBreakoutNames: t,
		localBreakoutNames: s,
		liveParticipants: S(e),
		localParticipants: S(a)
	});
	return {
		participants: a,
		breakoutRoomsNames: s,
		isDragging: l,
		currentDragTarget: p,
		onParticipantDragging: m,
		onParticipantDrag: h,
		getBreakoutRoomRefCallback: g,
		onRemoveRoom: _,
		handleBreakoutRoomNameChange: v,
		onAddRoom: y,
		doShuffle: b,
		isShuffling: x,
		doSave: r(() => {
			i(C());
		}, [C, i]),
		changeParticipantRoom: d
	};
}, Xi = ({ currentParticipants: e, participants: t, setParticipants: n, changeParticipantRoom: r }) => a(() => {
	let i = Array.from(e.values()).flat(), a = Array.from(t.values()).flat();
	if (i.length > a.length) {
		let e = i.filter((e) => !a.find((t) => t.uuid === e.uuid));
		e.length !== 0 && n((t) => {
			let n = new Map(t.entries());
			return n.get(jn)?.push(...e), n;
		});
	} else if (i.length < a.length) {
		let e = a.filter((e) => !i.find((t) => t.uuid === e.uuid));
		for (let t of e) r(t.uuid);
	}
}, [
	e,
	t,
	n,
	r
]), Zi = ({ getStreamQuality: e, callQualitySignal: t, networkState: n = hn.Connected }) => {
	let [r, i] = f(Zt.GOOD);
	return a(() => {
		if (n !== hn.Reconnecting) return t.add(([t, r]) => {
			let a = e();
			Vr.debug({
				networkState: n,
				incomingQuality: t,
				outgoingQuality: r,
				streamQuality: a,
				stats: window.pexDebug?.stats
			}, "Call quality changed"), i(Qi(t, r));
		});
	}, [
		n,
		e,
		t
	]), r;
}, Qi = (e = 0, t = 0) => Math.max(e, t), $i = { wrapper: "_wrapper_1lqo5_4" }, ea = ({ onClick: e }) => {
	let { t: n } = w();
	return /*#__PURE__*/ t.createElement(ht, { colorScheme: "light" }, /*#__PURE__*/ t.createElement("div", { className: K("d-flex align-items-center", $i.wrapper) }, /*#__PURE__*/ t.createElement(H, {
		source: U.IconWarningRound,
		className: "mr-1 flex-shrink-0"
	}), " ", /*#__PURE__*/ t.createElement(G, {
		fontVariant: V.Body,
		className: "text-center"
	}, /*#__PURE__*/ t.createElement(C, {
		t: n,
		i18nKey: "quality.poor-connection-detected"
	}, "Poor connection detected"), " ", e && /*#__PURE__*/ t.createElement(pt, {
		fontVariant: V.Body,
		onClick: e
	}, /*#__PURE__*/ t.createElement(C, {
		t: n,
		i18nKey: "quality.change-quality"
	}, "Change quality")))));
}, ta = 3e3, na = () => {
	wt.emit([{
		message: /*#__PURE__*/ t.createElement(ea, null),
		isDanger: !0,
		isInterrupt: !0,
		colorScheme: "light",
		timeout: 0
	}]);
}, ra = () => {
	wt.emit({ close: !0 });
}, ia = ({ callQuality: e, networkState: t = hn.Connected }) => {
	let n = d(0), i = r(() => {
		n.current &&= (clearTimeout(n.current), 0);
	}, []);
	a(() => ra, []), a(() => t === hn.Reconnecting ? ra() : (e === Zt.BAD || e === Zt.TERRIBLE ? (i(), na()) : n.current = window.setTimeout(ra, ta), i), [
		e,
		i,
		t
	]);
}, aa = (e, t, n) => {
	let { isMessageByCurrentUser: r, isLastMessageVisible: i, messageCount: o, scrollbarRef: s } = e;
	a(() => {
		switch ($n(r, i)) {
			case Qn.ScrollToLastMessage:
				tr(s);
				break;
			case Qn.DisplayNewMessageToast: n(t(!0));
		}
	}, [o]);
}, oa = (e, t, n) => {
	let [r, i] = f(""), { isMessageByCurrentUser: o, isLastMessageVisible: s, messages: c } = e;
	a(() => {
		let { id: e } = b(c, { id: "" });
		s && e ? i(e) : o || n(t(rr(c, r)));
	}, [
		c,
		s,
		r,
		o,
		t,
		n
	]);
}, sa = ({ currentUserId: e, messages: t, sendMessage: n, selectedChatType: r, participantInDirectChatWith: i }) => {
	let o = d(null), s = (e, t) => {
		let r = e.trim();
		r && n(r, t);
	}, [{ isLastMessageVisible: c, displayNewMessageToast: l, newMessagesCount: u }, f] = ua(), p = er(t, e);
	return aa({
		isLastMessageVisible: c,
		isMessageByCurrentUser: p,
		messageCount: t.length,
		scrollbarRef: o
	}, pa, f), oa({
		isLastMessageVisible: c,
		isMessageByCurrentUser: p,
		messages: t
	}, ma, f), a(() => {
		f(ha(!0, !1, 0));
	}, [
		r,
		i,
		f
	]), {
		closeNewChatMessage: (e) => {
			e.stopPropagation(), f(pa(!1));
		},
		displayNewMessageToast: l,
		isLastMessageVisible: c,
		newMessagesCount: u,
		onScroll: () => {
			ca(o?.current) ? f(ha(!0, !1, 0)) : f(fa(!1));
		},
		scrollbarRef: o,
		handleSubmit: s
	};
}, ca = nr(80), la = {
	isLastMessageVisible: !0,
	displayNewMessageToast: !1,
	newMessagesCount: 0
}, ua = () => u(da, la), da = (e, t) => t.type === "set-last-message-visible" ? {
	...e,
	isLastMessageVisible: t.isLastMessageVisible
} : t.type === "set-display-new-message-toast" ? {
	...e,
	displayNewMessageToast: t.displayNewMessageToast
} : t.type === "update-new-message-count" ? {
	...e,
	newMessagesCount: t.newMessagesCount
} : t.type === "update-last-message-visible" ? {
	...e,
	isLastMessageVisible: t.isLastMessageVisible,
	displayNewMessageToast: t.displayNewMessageToast,
	newMessagesCount: t.newMessagesCount
} : e, fa = (e) => ({
	type: "set-last-message-visible",
	isLastMessageVisible: e
}), pa = (e) => ({
	type: "set-display-new-message-toast",
	displayNewMessageToast: e
}), ma = (e) => ({
	type: "update-new-message-count",
	newMessagesCount: e
}), ha = (e, t, n) => ({
	type: "update-last-message-visible",
	isLastMessageVisible: e,
	displayNewMessageToast: t,
	newMessagesCount: n
}), ga = 71, _a = 114, va = 16, ya = (e) => e.desktopToolbar || e.header || e.footer, ba = (e) => {
	let [t, n] = f({
		desktopToolbar: !1,
		header: !1,
		footer: !1
	}), i = Ht(), o = l(() => i ? _a : va, [i]), { i18n: s } = w(), c = Fi(s), u = r((t) => {
		if (!e.current) {
			n({
				desktopToolbar: !1,
				header: !1,
				footer: !1
			});
			return;
		}
		if (t) {
			n(t);
			return;
		}
		let r = e.current, i = r.getBoundingClientRect(), a = !ni() && r.offsetLeft <= 88;
		c === "rtl" && (a = !ni() && i.right >= window.innerWidth - 72 - 16);
		let s = r.offsetTop <= ga, l = i.bottom >= window.innerHeight - o;
		n({
			desktopToolbar: a,
			header: s,
			footer: l
		});
	}, [
		o,
		e,
		c
	]);
	return a(() => {
		u();
	}, [u]), {
		controlsOverlap: t,
		update: u
	};
}, xa = (e, t) => {
	let n = (n) => k(e, t, n);
	return n(D.DeviceInUse) ? "device-in-use" : n(D.InvalidConstraints) ? "invalid-constraints" : n(D.Overconstrained) ? "overconstrained" : n(D.NotSupported) ? "not-supported" : n(D.TimedOut) ? "timed-out" : n(D.UnknownError) ? "unknown-error" : n(D.NoDevice) ? "no-device" : n(D.RequestedDeviceNotFound) ? "requested-device-not-found" : n(D.PermissionDenied) ? "denied" : n(D.Fallback) ? "fallback" : n(D.TrackPresent) ? "ready" : n(D.PermissionPrompt) ? "prompt" : n(D.PermissionGranted) ? "granted" : n(D.DeviceAvailable) ? "available" : "initial";
}, Sa = (e) => e === "audio" ? T.Microphone : T.Camera, Ca = (e, n) => {
	let { t: r } = w();
	return l(() => {
		let i = {
			title: "",
			message: ""
		};
		if (!e) return {
			audio: i,
			video: i
		};
		let a = /*#__PURE__*/ t.createElement(C, {
			i18nKey: "device-status.initial-permissions-not-granted.message",
			t: r
		}, "Please select ", /*#__PURE__*/ t.createElement("strong", null, "Allow"), " in the next step when prompted by your browser. We will only have access for the duration of the meeting."), o = (e, t) => {
			let n = e === "audio", o = Sa(e);
			switch (t) {
				case "denied": return {
					title: n ? r("device-status.permissions-rejected-audioinput.title", "Microphone permission not granted") : r("device-status.permissions-rejected-videoinput.title", "Camera permission not granted"),
					message: n ? r("device-status.permissions-rejected-audioinput-only.message", "You have denied permission to use your microphone. It will not be available for this meeting") : r("device-status.permissions-rejected-videoinput-only.message", "You have denied permission to use your camera. It will not be available for this meeting"),
					controls: "permissions",
					error: o
				};
				case "device-in-use": return {
					title: n ? r("device-status.audio-device-in-use.title", "Microphone unavailable") : r("device-status.video-device-in-use.title", "Camera unavailable"),
					message: n ? r("device-status.audio-device-in-use.message", "Another application (e.g. Teams or Slack) is using your microphone. Close that application to use it here.") : r("device-status.video-device-in-use.message", "Another application (e.g. Teams or Slack) is using your camera. Close that application to use it here."),
					controls: "media",
					error: o,
					retriable: !0
				};
				case "invalid-constraints": return {
					title: n ? r("device-status.invalid-audio-constraints.title", "Microphone is not configured properly") : r("device-status.invalid-video-constraints.title", "Camera is not configured properly"),
					message: r(n ? "device-status.invalid-audio-constraints.message" : "device-status.invalid-video-constraints.message", "Try clearing your browser cache"),
					controls: "media",
					error: o
				};
				case "overconstrained": return {
					title: n ? r("device-status.audio-overconstrained.title", "Microphone is overly constrained") : r("device-status.video-overconstrained.title", "Camera is overly constrained"),
					message: r(n ? "device-status.audio-overconstrained.message" : "device-status.video-overconstrained.message", "Try lowering your quality settings"),
					controls: "media",
					error: o
				};
				case "not-supported": return {
					title: r(n ? "device-status.not-supported-error-only-audio.title" : "device-status.not-supported-error-only-video.title", "Browser does not support"),
					message: r(n ? "device-status.not-supported-error-only-audio.message" : "device-status.not-supported-error-only-video.message", "We can't get media from your browser. Try to use another modern browser."),
					controls: "media",
					error: o
				};
				case "timed-out": return {
					title: n ? r("device-status.audio-request-timed-out.title", "Microphone request timed out") : r("device-status.video-request-timed-out.title", "Camera request timed out"),
					message: r(n ? "device-status.audio-request-timed-out.message" : "device-status.video-request-timed-out.message", "Your browser did not respond. Try again."),
					controls: "media",
					error: o,
					retriable: !0,
					retryOnly: !0
				};
				case "unknown-error": return {
					title: n ? r("device-status.unknown-error-only-audioinput.title", "Microphone unavailable") : r("device-status.unknown-error-only-videoinput.title", "Camera unavailable"),
					message: n ? r("device-status.unknown-error-only-audioinput.message", "We are not able to use your microphone. Try to reconnect your device or use a different one") : r("device-status.unknown-error-only-videoinput.message", "We are not able to use your camera. Try to reconnect your device or use a different one"),
					controls: "media",
					error: o
				};
				case "no-device": return {
					title: n ? r("device-status.no-audio-devices-found.title", "There’s no connected microphone") : r("device-status.no-video-devices-found.title", "There’s no connected camera"),
					message: n ? r("device-status.no-audio-devices-found.message", "Your microphone seems to be unavailable. Please check if it is plugged in and set up correctly") : r("device-status.no-video-devices-found.message", "Your camera seems to be unavailable. Please check if it is plugged in and set up correctly"),
					controls: "media",
					error: o
				};
				case "requested-device-not-found": return {
					title: n ? r("device-status.audio-device-not-found.title", "We can’t find your microphone") : r("device-status.video-device-not-found.title", "We can’t find your camera"),
					message: n ? r("device-status.audio-device-not-found.message", "Your preferred microphone is unavailable") : r("device-status.video-device-not-found.message", "Your preferred camera is unavailable"),
					controls: "media",
					error: o
				};
				case "fallback": return {
					title: n ? r("device-status.permissions-granted-fallback-audioinput.title", "Unable to use your preferred microphone") : r("device-status.permissions-granted-fallback-videoinput.title", "Unable to use your preferred camera"),
					message: n ? r("device-status.permissions-granted-fallback-audioinput.message", "We are unable to use your preferred microphone") : r("device-status.permissions-granted-fallback-videoinput.message", "We are unable to use your preferred camera"),
					controls: "media",
					warning: o
				};
				case "prompt": return {
					title: n ? r("device-status.initial-permissions-not-granted.title-audioonly", "We need your permission to use your microphone") : r("device-status.initial-permissions-not-granted.title-videoonly", "We need your permission to use your camera"),
					message: a,
					controls: "permissions-dismiss"
				};
				case "granted": return {
					title: r("device-status.initial-permissions-granted.title", "Permissions granted"),
					message: n ? r("device-status.initial-permissions-audio-input-granted.message", "You have granted permission to use your microphone") : r("device-status.initial-permissions-video-input-granted.message", "You have granted permission to use your camera"),
					controls: "media"
				};
				case "ready": return {
					...i,
					controls: "media"
				};
				case "available":
				case "initial": return i;
			}
		};
		return {
			audio: n.audio ? o("audio", xa(e, "audio")) : i,
			video: n.video ? o("video", xa(e, "video")) : i
		};
	}, [
		n.audio,
		n.video,
		e,
		r
	]);
}, wa = (e) => {
	let { t } = w(), n = e.audio.controls === "permissions-dismiss", r = e.video.controls === "permissions-dismiss";
	return e.video.error ? e.video : n && r ? {
		title: t("device-status.initial-permissions-not-granted.title", "We need your permission to use your camera and microphone"),
		message: e.audio.message,
		controls: "permissions-dismiss"
	} : n ? e.audio : r ? e.video : e.audio.error || e.audio.warning ? e.audio : e.video;
}, Ta = (e, t, n) => {
	let { t: r } = w(), i = r("media.error.unable-to-use.audio", "Cannot use audio input device. Please select another one."), o = r("media.error.unable-to-use.video", "Cannot use video input device. Please select another one.");
	a(() => n?.onAudioInputError(() => {
		e({ title: i });
	}), [
		n,
		e,
		i
	]), a(() => n?.onVideoInputError(() => {
		t({ title: o });
	}), [
		n,
		t,
		o
	]);
}, Ea = (e) => ({
	audioError: {
		title: e.audio.error ? e.audio.title : "",
		description: e.audio.error ? e.audio.message : void 0,
		...e.audio.retriable ? { retriable: !0 } : {},
		...e.audio.retryOnly ? { retryOnly: !0 } : {}
	},
	videoError: {
		title: e.video.error ? e.video.title : "",
		description: e.video.error ? e.video.message : void 0,
		...e.video.retriable ? { retriable: !0 } : {},
		...e.video.retryOnly ? { retryOnly: !0 } : {}
	}
}), Da = ({ streamStatus: e, requested: t }) => {
	let n = Ca(e, {
		audio: t.audio,
		video: t.video
	}), { audioError: r, videoError: i } = Ea(n);
	return {
		audioError: n.audio.controls === "permissions" ? {
			...r,
			deniedDevice: n.audio.error
		} : r,
		videoError: n.video.controls === "permissions" ? {
			...i,
			deniedDevice: n.video.error
		} : i
	};
}, Oa = (e, t) => {
	let { t: n } = w();
	c(() => e((e) => {
		if (e?.status && j(e.status)) {
			let r = n("media.input.connector", " and "), i = [{
				originalDeviceName: e.expectedVideoInput?.label,
				fallbackDeviceName: e.videoInput?.label,
				deviceType: n("media.input.video", "camera"),
				fallback: N(e.status) && e.expectedVideoInput?.label !== e.videoInput?.label
			}, {
				originalDeviceName: e.expectedAudioInput?.label,
				fallbackDeviceName: e.audioInput?.label,
				deviceType: n("media.input.audio", "microphone"),
				fallback: M(e.status) && e.expectedAudioInput?.label !== e.audioInput?.label
			}].reduce((e, t) => {
				if (t.fallback) for (let n of Object.keys(e)) {
					let i = n, a = t[i];
					a && (e[i] = [e[i], i === "deviceType" ? a : `'${a}'`].filter(Boolean).join(r));
				}
				return e;
			}, {
				originalDeviceName: "",
				fallbackDeviceName: "",
				deviceType: ""
			});
			if (!i.fallbackDeviceName || !i.originalDeviceName || !i.deviceType) return;
			t(n("media.input.fallback-video", {
				defaultValue: "We couldn't use {{originalDeviceName}} so we switched your {{deviceType}} to {{fallbackDeviceName}}",
				...i
			}));
		}
	}), [
		e,
		t,
		n
	]);
}, { isWindows: ka } = Ti(navigator.userAgent), Aa = (e, n) => {
	let { t: r } = w();
	return {
		audio: e ? {
			title: r("media.audio-suspended-title", "Have you muted your microphone using an external source?"),
			warning: T.Microphone,
			message: /*#__PURE__*/ t.createElement(t.Fragment, null, r("media.audio-suspended-description", "Please check if you have muted yourself using a headset or your browser, and unmute your microphone from there first."), ka && /*#__PURE__*/ t.createElement(t.Fragment, null, /*#__PURE__*/ t.createElement("div", { className: "mt-2" }, r("media.audio-suspended-computer-settings", "You can also go to your computer's settings to unmute your microphone.")), /*#__PURE__*/ t.createElement("div", { className: "mt-2" }, /*#__PURE__*/ t.createElement(z, {
				href: "ms-settings:sound",
				size: "small",
				variant: "primary"
			}, r("media.open-sound-settings", "Open Sound Settings")))))
		} : void 0,
		video: n ? {
			title: r("media.video-suspended-title", "Have you turned off your camera using an external source?"),
			warning: T.Camera,
			message: r("media.video-suspended-description", "Please check if you have turned off your camera with your browser. This may happen if you open a new tab that is using your camera.")
		} : void 0
	};
}, ja = ({ isAudioInputMuted: e, isVideoInputMuted: n, inputStatusInfo: r, iconSize: i }) => {
	let { t: a } = w(), o = !!r.audio.error, s = !!r.video.error, c = o || e, l = s || n, u = c ? a("media.unmute-microphone", "Unmute microphone") : a("media.mute-microphone", "Mute microphone"), d = l ? a("media.turn-camera-on", "Turn camera on") : a("media.turn-camera-off", "Turn camera off");
	return {
		audioProps: {
			hasError: o,
			hasAudioVideoError: !1,
			isActive: e,
			"aria-label": u,
			icon: c ? /*#__PURE__*/ t.createElement(H, {
				source: U.IconMicrophoneOff,
				size: i
			}) : /*#__PURE__*/ t.createElement(H, {
				source: U.IconMicrophoneOn,
				size: i
			})
		},
		videoProps: {
			hasError: s,
			hasAudioVideoError: !1,
			isActive: n,
			"aria-label": d,
			icon: l ? /*#__PURE__*/ t.createElement(H, {
				source: U.IconVideoOff,
				size: i
			}) : /*#__PURE__*/ t.createElement(H, {
				source: U.IconVideoOn,
				size: i
			})
		},
		audioWarning: r.audio.warning,
		videoWarning: r.video.warning,
		isAudioIconMuted: c,
		isVideoIconMuted: l
	};
}, Ma = (e, t) => {
	a(() => {
		e.tryAndGetUserMedia({
			audio: !0,
			video: !0
		});
		let n = t((t) => {
			let n = t.size("audioinput") > 0, r = t.size("videoinput") > 0;
			!(e.updatingAudio || e.updatingVideo) && e.media?.status && !ie(e.media?.status) && (n || r) && e.getUserMedia({
				audio: n,
				video: r
			});
		});
		return () => {
			Vr.debug("Media cleanup"), n(), e.media?.release().catch((e) => {
				Vr.error({ error: e }, "GUM cleanup failed");
			});
		};
	}, [t, e]);
}, Na = (e) => {
	let t = p((t) => (e?.stream.addEventListener("addtrack", t), e?.stream.addEventListener("removetrack", t), () => {
		e?.stream.removeEventListener("addtrack", t), e?.stream.removeEventListener("removetrack", t);
	}), () => e?.audioInput);
	return {
		selectedVideoInput: p((t) => (e?.stream.addEventListener("addtrack", t), e?.stream.addEventListener("removetrack", t), () => {
			e?.stream.removeEventListener("addtrack", t), e?.stream.removeEventListener("removetrack", t);
		}), () => e?.videoInput),
		selectedAudioInput: t
	};
}, Pa = (e) => p(e.subscribe, e.initial), Fa = (e) => Object.keys(e).reduce((t, n) => {
	let r = n, i = e[r];
	return i && (t[r] = () => Pa(i)), t;
}, {}), Ia = ({ expandPrimaryVideo: e, isPresenting: t, isPresentationPoppedOut: n, presentationEmphasis: i, setEmphasis: o }) => {
	let s = fe(), [c, l] = f(!1), [u, p] = f(!1), [m, h] = f(J.None), [g, _] = f(J.None), v = d(null), y = d(null);
	a(() => {
		t ? n ? (h(J.Expanded), _(J.External)) : c ? (h(J.BrowserPip), _(J.Expanded)) : u ? (h(J.Expanded), _(J.BrowserPip)) : e && i === ln.Primary ? (h(J.Pip), _(J.Expanded)) : e && i === ln.Secondary ? (h(J.Expanded), _(J.Pip)) : !e && i === ln.Secondary ? (h(J.Emphasized), _(J.Deemphasized)) : (h(J.Deemphasized), _(J.Emphasized)) : h(J.Expanded);
	}, [
		c,
		u,
		t,
		n,
		e,
		i
	]);
	let b = r(async () => {
		await La(m, () => {
			o(ln.Secondary);
		});
	}, [m, o]), x = r(async () => {
		await La(g, () => {
			o(ln.Primary);
		});
	}, [g, o]);
	return {
		meetingStreamStatus: m,
		presoStreamStatus: g,
		setIsMeetingVideoBrowserPip: l,
		setIsPresentationBrowserPip: p,
		handleMeetingVideoClick: b,
		handlePresentationVideoClick: x,
		mainOnKeyDown: (e) => {
			e.key === X.enter && (m === J.Emphasized || m === J.Expanded ? s() : b().then(() => {
				y.current?.focus();
			}));
		},
		presentationOnKeyDown: (e) => {
			e.key === X.enter && (g === J.Emphasized || g === J.Expanded ? s() : x().then(() => v.current?.focus()));
		},
		mainVideoComponentRef: v,
		presentationVideoComponentRef: y
	};
}, La = async (e, t) => {
	if (e === J.Deemphasized || e === J.Pip) return t(), Promise.resolve();
}, Ra = 2e3, za = (e, t) => {
	let [n, r] = f(hn.Connected);
	return a(() => {
		let n, i = [e.add(() => {
			clearTimeout(n), r(hn.Reconnecting);
		}), t.add(() => {
			r(hn.Reconnected), n = setTimeout(() => {
				r(hn.Connected);
			}, Ra);
		})];
		return () => {
			for (let e of i) e();
			clearTimeout(n);
		};
	}, [e, t]), n;
}, Ba = (e) => {
	let [t, n] = f(on.Spinner);
	return a(() => {
		e && (I(e) || te(e)) ? n(on.BlockedDeviceSelection) : n(on.DeviceSelection);
	}, [e]), [t, n];
}, Va = "width=848,height=480", Ha = () => {
	let e = d(null), [t, n] = f(!1);
	return {
		isPresentationPoppedOut: t,
		remotePopOutRef: e,
		setIsPresentationPoppedOut: n,
		toggleIsPresentationPoppedOut: () => {
			if (t) {
				n(!1);
				return;
			}
			let r = Et(Va);
			r && (e.current = r, n(!0));
		}
	};
}, Ua = (e, t) => {
	switch (t.type) {
		case dn.SetLocalMediaStream: return {
			...e,
			localMediaStream: t.mediaStream
		};
		case dn.SetRemoteMediaStream: return {
			...e,
			remoteMediaStream: t.mediaStream
		};
		case dn.SetEmphasis: return {
			...e,
			emphasis: t.emphasis
		};
		case dn.SetExpandPrimary: return {
			...e,
			expandPrimary: t.expandPrimary
		};
		case dn.SetShowSteal: return {
			...e,
			showSteal: t.showSteal
		};
		case dn.SetSize: return {
			...e,
			size: t.size
		};
		case dn.SetPresenterName: return {
			...e,
			presenterName: t.presenterName
		};
		case dn.ActivityChange: {
			let n = e.activity?.send, r = t.activity.send, i = e.activity?.recv, a = t.activity.recv;
			if (r) {
				let n = e.remoteMediaStream;
				return !a && i && (n = void 0), {
					...e,
					emphasis: ln.Secondary,
					size: un.Large,
					remoteMediaStream: n,
					activity: t.activity
				};
			}
			if (a) {
				let i = e.localMediaStream;
				return !r && n && (i = void 0), {
					...e,
					emphasis: ln.Primary,
					size: un.Large,
					localMediaStream: i,
					activity: t.activity
				};
			}
			return {
				emphasis: void 0,
				expandPrimary: void 0,
				showSteal: void 0,
				size: void 0,
				localMediaStream: void 0,
				remoteMediaStream: void 0,
				activity: void 0,
				presenterName: void 0
			};
		}
		default: throw Error(`${t} not implemented in Presentation.reducer`);
	}
}, Wa = (e) => e === "connecting" || e === "connected", Ga = ({ getPresentationCapability: e, handlaGetDisplayMediaError: t, handleGetDisplayMedia: n, isCallRestarting: i, present: o, presentationConnectionStateChangeSignal: s, presentationPresenterNameSignal: c, presentationReceiveStreamSignal: l, stopPresentation: d }) => {
	let [{ activity: f, emphasis: p, expandPrimary: m, showSteal: h, size: g, localMediaStream: _, remoteMediaStream: v, presenterName: y }, b] = u(Ua, {}), { send: x, recv: S } = e(), C = S && !!f?.recv, w = x && !!f?.send, T = C || w, E = m ?? !1, D = h ?? !1, O = r((e) => {
		if (e) {
			Vr.debug({ mediaStream: e }, "Presentation stream acquired");
			for (let t of e.getVideoTracks()) t.addEventListener("ended", () => {
				Vr.debug("Track ended. Stop presentation."), d();
			});
			o(e), b({
				type: dn.SetLocalMediaStream,
				mediaStream: e
			});
		}
	}, [o, d]), k = r((e) => b({
		type: dn.SetEmphasis,
		emphasis: e
	}), []), A = r((e) => b({
		type: dn.SetSize,
		size: e
	}), []), j = r((e) => {
		b({
			type: dn.SetExpandPrimary,
			expandPrimary: e
		});
	}, []), M = r((e) => {
		b({
			type: dn.SetShowSteal,
			showSteal: e
		});
	}, []), N = r(async (e) => {
		if (e) O(e);
		else try {
			let e = await n();
			e && O(e);
		} catch (e) {
			t && e instanceof Error ? t(e) : Vr.error({ error: e }, "Can't start presentation");
		}
	}, [
		n,
		O,
		t
	]), P = r(() => {
		C ? M(!0) : N();
	}, [
		C,
		M,
		N
	]);
	return a(() => l.add((e) => {
		b({
			type: dn.SetRemoteMediaStream,
			mediaStream: e
		});
	}), [l]), a(() => c?.add((e) => {
		b({
			type: dn.SetPresenterName,
			presenterName: e
		});
	}), [c]), a(() => s.add(({ send: e, recv: t }) => {
		if (i?.()) return;
		let n = Wa(e), r = Wa(t);
		b({
			type: dn.ActivityChange,
			activity: {
				send: n,
				recv: r
			}
		});
	}), [i, s]), {
		emphasis: p,
		isPrimaryExpanded: E,
		isShowSteal: D,
		isPresenting: T,
		size: g,
		localIsPresenting: w,
		localMediaStream: _,
		remoteIsPresenting: C,
		remoteMediaStream: v,
		activity: f,
		presenterName: y,
		handlePresentationRequest: P,
		setEmphasis: k,
		setExpandPrimary: j,
		setShowSteal: M,
		setSize: A,
		startPresentation: N,
		stopPresentation: d,
		poppedOut: Ha()
	};
}, Ka = ({ get: e, set: t }) => () => {
	let [n, i] = f(e);
	return {
		preview: n,
		setPreview: i,
		applyChanges: r(() => e() !== n && t(n), [n]),
		hasChanges: r(() => e() !== n, [n]),
		revertChanges: r(() => {
			i(e());
		}, [])
	};
}, qa = (e) => Ln(e?.getAudioTracks()[0]?.source.track), Ja = (e, t) => {
	let [n, r] = f(t);
	return a(() => e(r), [e]), [n, r];
}, Ya = ({ get: e, getExpected: t, set: n }) => ({ error: i, controller: a, setError: o }) => {
	let [s] = Ja(a.onAudioInputChanged, t());
	return {
		error: i,
		preview: s,
		applyChanges: r(() => {
			if (a.audioInput?.deviceId !== e()?.deviceId) {
				let { audioInput: e } = a;
				Vr.debug({ audioInput: e }, "Save AudioInput"), n(e);
			}
			return !1;
		}, [a]),
		setPreview: si(o, a?.updateAudioInput)
	};
}, Xa = (e) => (t, n) => {
	let [i, a] = f(ji(t, n));
	return {
		preview: i,
		applyChanges: r(() => (i && i.deviceId !== n?.deviceId && (Vr.debug({ audioOutput: i }, "Save AudioOutput"), e(i)), !1), [n?.deviceId, i]),
		hasChanges: r(() => !!(i && i.deviceId !== n?.deviceId), [n?.deviceId, i]),
		setPreview: a
	};
}, Za = (e) => (t) => {
	let [n, r] = f();
	return a(() => {
		if (!t) {
			r((e) => {
				e?.cleanup(), e?.revertChanges();
			});
			return;
		}
		let n = O(e());
		return r(n), () => {
			r(void 0), n.cleanup(), n.revertChanges();
		};
	}, [t]), n;
}, Qa = (e) => {
	let [t, n] = f(e?.media);
	return a(() => {
		e && n(e.media);
	}, [e]), c(() => e?.onMediaChanged((e) => {
		n(e);
	}), [e]), t;
}, $a = (e) => !e || e.length === 0 ? !0 : e.some((e) => e.stopped || e.muted) ?? !0, eo = (e) => !e || e.length === 0 ? !0 : e.some((e) => e.suspended) ?? !1, to = (e) => {
	let [t, n] = f(e?.media?.status ?? E), [r, i] = f(() => $a(e?.media?.getVideoTracks())), [o, s] = f(() => $a(e?.media?.getAudioTracks())), [c, l] = f(() => eo(e?.media?.getAudioTracks())), [u, d] = f(() => eo(e?.media?.getVideoTracks())), [p, m] = f(!1), [h, g] = f(!1), [v, y] = f(e?.videoInputChanged);
	return a(() => {
		if (!e) return;
		let t = [
			e.onUpdatingPreviewVideo((t) => {
				t || (_(e.media), n(e.media.status), y(e.videoInputChanged)), g(t);
			}),
			e.onUpdatingPreviewAudio((t) => {
				t || (_(e.media), n(e.media.status)), m(t);
			}),
			e.onVideoMuted((e) => {
				i(e ?? !0);
			}),
			e.onAudioMuted((e) => {
				s(e ?? !0);
			}),
			e.onAudioSuspended((e) => {
				l(e ?? !1);
			}),
			e.onVideoSuspended((e) => {
				d(e ?? !1);
			}),
			e.onUpdatingMain(() => {
				y(e.videoInputChanged);
			})
		];
		return () => {
			for (let e of t) e?.();
			t.length = 0;
		};
	}, [e]), {
		audioMuted: o,
		audioSuspended: c,
		status: t,
		updatingPreviewAudio: p,
		updatingPreviewVideo: h,
		videoInputChanged: v,
		videoMuted: r,
		videoSuspended: u
	};
}, no = ({ applyChanges: e, close: t, controller: n, onHandleSave: i }) => {
	let [a, o] = f(!1), s = Qa(n), { audioMuted: c, audioSuspended: l, status: u, updatingPreviewAudio: d, updatingPreviewVideo: p, videoInputChanged: m, videoMuted: h, videoSuspended: g } = to(n);
	return {
		audioMuted: c,
		audioSuspended: l,
		handleSave: r(async (r) => {
			Vr.debug("Handle saving settings modal"), i && i();
			try {
				o(!0);
				let t = e();
				await n.applyChanges(t);
			} finally {
				o(!1), t?.(r);
			}
		}, [
			e,
			t,
			n,
			i
		]),
		isSaving: a,
		previewMedia: s,
		status: u,
		updatingPreviewAudio: d,
		updatingPreviewVideo: p,
		videoInputChanged: m,
		videoMuted: h,
		videoSuspended: g
	};
}, ro = (e, t, n) => {
	let [r, i] = f({ title: "" }), [a, o] = f({ title: "" }), { videoError: s, audioError: c } = Da({
		streamStatus: t,
		requested: n
	});
	return Ta(o, i, e), {
		videoInputError: r.title ? r : s,
		setVideoInputError: i,
		audioInputError: a.title ? a : c,
		setAudioInputError: o
	};
}, io = ({ get: e, getExpected: t, set: n }) => ({ error: i, controller: a, setError: o }) => {
	let [s] = Ja(a.onVideoInputChanged, t());
	return {
		error: i,
		preview: s,
		applyChanges: r(() => {
			if (a.videoInput?.deviceId !== e()?.deviceId) {
				let { videoInput: e } = a;
				Vr.debug({ videoInput: e }, "Save VideoInput"), n(e);
			}
			return !1;
		}, [a]),
		setPreview: si(o, a?.updateVideoInput)
	};
}, ao = 500, oo = (e) => e === "Space" && !["INPUT", "TEXTAREA"].includes(document.activeElement?.tagName || ""), so = (e) => {
	oo(e.code) && e.preventDefault();
}, co = () => (document.addEventListener("keyup", so), () => document.removeEventListener("keyup", so)), lo = (e, t) => t && e(t), uo = (e, t = {
	isMuted: void 0,
	isPressed: !1
}) => {
	co();
	let n = () => {
		document.removeEventListener("keydown", s), clearTimeout(t.easeMuteTimerId);
	}, r = (e = 500) => {
		t.easeMuteTimerId = window.setTimeout(() => {
			t.isPressed = !1, clearTimeout(t.easeMuteTimerId);
		}, e);
	}, i = () => {
		e.emit(!1), window.removeEventListener("blur", i), document.removeEventListener("keyup", o), r();
	}, a = () => {
		!t.isPressed && t.isMuted?.current === !0 && (t.isPressed = !0, document.addEventListener("keyup", o, { once: !0 }), e.emit(!0), window.addEventListener("blur", i, { once: !0 }));
	}, o = (e) => {
		oo(e.code) && i();
	}, s = (e) => {
		oo(e.code) && a();
	};
	return document.addEventListener("keydown", s), n;
}, fo = (e, t) => ({ isAudioInputMuted: n, setAudioInputMuted: r, streamStatus: i, onDisabledInteraction: o, isPushToTalkDisabled: s }) => {
	let c = d(n);
	c.current = n;
	let u = l(() => lo(e, i), [i]);
	a(() => {
		if (s) return;
		let e = t.add((e) => {
			u && r(!e);
		});
		return () => e();
	}, [
		r,
		u,
		s
	]), a(() => {
		let e = (e) => {
			oo(e.code) && !e.repeat && o?.();
		};
		return s && o && document.addEventListener("keydown", e), () => {
			document.removeEventListener("keydown", e);
		};
	}, [s, o]), a(() => {
		if (u && !s) return uo(t, { isMuted: c });
	}, [u, s]);
}, po = ({ text: e, source: n = U.IconMicrophoneOn }) => /*#__PURE__*/ t.createElement("div", { className: "d-flex align-items-center" }, /*#__PURE__*/ t.createElement(H, {
	source: n,
	size: "compact",
	className: "mr-1"
}), " ", /*#__PURE__*/ t.createElement(G, { colorScheme: "light" }, e)), mo = (e) => () => {
	let { t: n } = w();
	a(() => e.add((e) => {
		let r = {
			message: /*#__PURE__*/ t.createElement(po, { text: n("media.audio.you-are-temporarily-unmuted", "You’re temporarily unmuted") }),
			testid: q.ToastYouAreTemporarilyUnmuted,
			position: "bottomCenter",
			timeout: 0,
			isInterrupt: !0
		};
		e ? wt.emit([r]) : wt.emit({ close: !0 });
	}), [n]);
}, ho = {
	isOpen: !1,
	userName: "this user",
	description: "",
	onConfirm: void 0
}, go = (e) => {
	let [{ isOpen: t, userName: n, description: r, onConfirm: i }, o] = f(ho);
	return a(() => e.add(o), [e]), {
		onConfirm: () => {
			i?.(), o({
				isOpen: !1,
				userName: n,
				onConfirm: i
			});
		},
		onCancel: () => {
			o(ho);
		},
		description: r,
		userName: n,
		isOpen: t
	};
}, _o = 3e3, vo = (e, t) => {
	a(() => {
		let t = setTimeout(() => {
			e(!1);
		}, _o);
		return () => {
			clearTimeout(t);
		};
	}, [e, t]);
}, yo = n(void 0), Z = () => zn(yo), bo = ({ devices: e, currentInput: t, requestMedia: n }) => r((r) => {
	if (!r) return n(void 0);
	let i = rn(r), [a] = e.get(i);
	t && a && en(t)(a) || n(a);
}, [
	t,
	e,
	n
]), xo = ({ muteAudio: e, muteVideo: t, preMuteAudio: n, preMuteVideo: i, signals: a }) => {
	let o = Di(a), s = Oi(a, "audio"), c = Oi(a, "video"), l = ki(a, "audio"), u = ki(a, "video"), d = (e, ...t) => (n) => {
		let r = (t) => {
			t.kind === e && n();
		}, i = [...t.map((e) => e.add(r)), Oi(a, e === "audioinput" ? "audio" : "video")(n)];
		return () => {
			for (let e of i) e();
			i.length = 0;
		};
	}, f = d("audioinput", a.onMediaTrackMuted, a.onMediaTrackStopped), m = d("audioinput", a.onMediaTrackSuspended, a.onMediaTrackResumed), h = d("videoinput", a.onMediaTrackMuted, a.onMediaTrackStopped), g = d("videoinput", a.onMediaTrackSuspended, a.onMediaTrackResumed), _ = (e = s) => {
		let t = Z();
		return p(e, () => t.media?.audioInput);
	}, v = (e = c) => {
		let t = Z();
		return p(e, () => t.media?.videoInput);
	}, y = (e = a.onDevicesChanged.add) => {
		let t = Z();
		return p(e, () => t.devices);
	}, b = (e = a.onMediaChanged.add) => {
		let t = Z();
		return p(e, () => t.media?.stream);
	}, x = (e = a.onStatusChanged.add) => {
		let t = Z();
		return p(e, () => t.media?.status ?? E);
	}, S = (e = f) => {
		let t = Z();
		return p(e, () => {
			let e = t.media?.getAudioTracks();
			return !e || e.length === 0 || e.some((e) => {
				let t = e.stopped || e.muted;
				return t === !0 || t === void 0;
			});
		});
	}, C = (e = m) => {
		let t = Z();
		return p(e, () => {
			let e = t.media?.getAudioTracks();
			return !e || e.length === 0 ? !1 : e.some((e) => e.suspended);
		});
	}, w = (e = h) => {
		let t = Z();
		return p(e, () => {
			let e = t.media?.getVideoTracks();
			return !e || e.length === 0 || e.some((e) => {
				let t = e.stopped || e.muted;
				return t === !0 || t === void 0;
			});
		});
	}, T = (e = g) => {
		let t = Z();
		return p(e, () => {
			let e = t.media?.getVideoTracks();
			return !e || e.length === 0 ? !1 : e.some((e) => e.suspended);
		});
	}, D = (t = e, i = n) => {
		let a = Z();
		return r((e, n) => {
			a.media?.audioMuted !== void 0 && (i?.(e), a.media.muteAudio(e), t(a.media.audioMuted, n));
		}, [
			a,
			t,
			i
		]);
	}, O = (e = t, n = i) => {
		let a = Z();
		return r((t, r) => {
			a.media?.videoMuted !== void 0 && (n?.(t), a.media.muteVideo(t), e(a.media.videoMuted, r));
		}, [
			a,
			e,
			n
		]);
	}, k = (t = e, i = n) => {
		let a = Z(), o = D(t, i);
		return r((e) => {
			a.media?.audioMuted !== void 0 && o(!a.media.audioMuted, e);
		}, [a, o]);
	}, A = (e = t, n = i) => {
		let a = Z(), o = O(e, n);
		return r((e) => {
			a.media?.videoMuted !== void 0 && o(!a.media.videoMuted, e);
		}, [a, o]);
	}, j = (e = l) => {
		let t = Z();
		return p(e, () => t.media?.requestedAudio() ?? !1);
	}, M = (e = u) => {
		let t = Z();
		return p(e, () => t.media?.requestedVideo() ?? !1);
	}, N = (e = s) => {
		let t = Z();
		return p(e, () => t.media?.getAudioTracks().at(0)?.source.track);
	}, P = (e = c) => {
		let t = Z();
		return p(e, () => t.media?.getVideoTracks().at(0)?.source.track);
	}, F = (e = o) => {
		let t = Z();
		return p(e, () => t.media?.isAudioInputUnavailable() ?? !1);
	}, I = (e = o) => {
		let t = Z();
		return p(e, () => t.media?.isVideoInputUnavailable() ?? !1);
	}, L = () => ({
		audio: j(),
		video: M()
	});
	return {
		useAudioInput: _,
		useAudioInputUnavailable: F,
		useAudioMuteState: S,
		useAudioSuspended: C,
		useDevices: y,
		useHaveRequestedAudio: j,
		useHaveRequestedMedia: L,
		useHaveRequestedVideo: M,
		useInputDeviceStatusInfo: () => Ca(x(), L()),
		useMediaStatus: x,
		useMediaStream: b,
		useMuteAudio: D,
		useMuteVideo: O,
		useSourceAudioTrack: N,
		useSourceVideoTrack: P,
		useToggleAudioMuted: k,
		useToggleVideoMuted: A,
		useVideoInput: v,
		useVideoInputUnavailable: I,
		useVideoMuteState: w,
		useVideoSuspended: T
	};
}, So = (e) => {
	let { t } = w();
	if (!ni()) return navigator.platform.startsWith("Mac") ? t("shortcuts.ctrl-cmd-letter", {
		defaultValue: "(Ctrl + ⌘ + {{letter}})",
		letter: e.toUpperCase()
	}) : t("shortcuts.ctrl-alt-letter", {
		defaultValue: "(Ctrl + Alt + {{letter}})",
		letter: e.toUpperCase()
	});
}, Co = (e, t) => t === "ltr" ? Math.floor(e.left) <= 448 : Math.ceil(e.right) >= window.innerWidth - 448, wo = (e, t, n = !0) => {
	let i = ue(e), o = d(void 0), s = d(!1), c = r((e) => {
		o.current = e, s.current = !1;
	}, []), { i18n: l } = w(), u = Fi(l);
	return a(() => {
		if (e !== i && n && t.current) {
			let n = t.current;
			if (e) {
				let e = n.getBoundingClientRect();
				Co(e, u) && (s.current = !0, u === "ltr" ? n.style.setProperty("translate", `${448 - e.left}px 0px`) : n.style.setProperty("translate", `${window.innerWidth - 448 - e.right}px 0px`));
			} else if (s.current) n.style.setProperty("translate", "0px 0px"), s.current = !1, o.current = void 0;
			else if (o.current !== void 0) {
				let e = n.getBoundingClientRect();
				if (u === "ltr") {
					let t = o.current - e.left;
					n.style.setProperty("translate", `${t}px 0px`);
				} else {
					let t = window.innerWidth - o.current - e.right;
					n.style.setProperty("translate", `${t}px 0px`);
				}
				o.current = void 0;
			}
		}
	}, [
		n,
		t,
		e,
		i,
		u
	]), c;
}, To = (e, t) => (n) => {
	let [r, i] = f(!1);
	return a(() => t(() => i(!0)), []), a(() => (e(n), () => e(!1)), [n]), [r, i];
}, Eo = (e, t) => Zr(e, t) ? "portrait" : "landscape", Do = Eo(window.innerWidth, window.innerHeight), Oo = () => {
	let [e, t] = f(Do), n = de(document.body), i = r(() => {
		t(Eo(window.innerWidth, window.innerHeight));
	}, []);
	return a(() => (window.addEventListener("orientationchange", i), () => {
		window.removeEventListener("orientationchange", i);
	}), [i]), a(() => {
		i();
	}, [n, i]), {
		isPortrait: e === "portrait",
		isLandscape: e === "landscape"
	};
}, ko = {
	"add-participant": { submit: "Add participant" },
	"breakout-toggle-tooltip": "Breakout Rooms",
	breakouts: {
		"add-room-button-text": "Add room",
		"add-room-done-notification": "A new room has been added",
		"asking-for-help": "Asking for help",
		"breakout-room": {
			assigned: "Assigned",
			"assigned-aria-label": "Participants assigned to breakout room {{name}}",
			"close-room-aria-label": "Close breakout room",
			"edit-button-label": "Edit breakout room name",
			"main-name": "Main Room",
			"name-label": "Breakout room name",
			"not-assigned": "Not assigned",
			"not-assigned-aria-label": "Participants not assigned to a breakout room",
			"remove-room-aria-label": "Remove breakout room",
			"send-participant-to": "Send participant to:"
		},
		"close-all-rooms-modal": {
			description: "All participants will be moved to the main room.",
			title: "Close all rooms?"
		},
		"close-room-modal": {
			text: "The participants in this room will be moved to the main room.",
			title: "Close {{name}}?"
		},
		duplicate: "duplicate",
		"duplicate-room-name-description": "Two rooms can not have the same name",
		"duplicate-room-name-title": "Duplicated room names",
		"error-on-open-rooms-description": "An error occurred while trying to open the breakout rooms. Please try again.",
		"error-on-open-rooms-title": "Could not open rooms",
		"go-back-to-mode-assignment-description": "You will lose the rooms you created.",
		"go-back-to-mode-assignment-title": "Discard rooms?",
		"go-back-to-opened-rooms-description": "You will lose the changes you made to the rooms.",
		"go-back-to-opened-rooms-title": "Discard changes?",
		"more-configuration-menu-aria-label": "See more breakout rooms configuration options",
		"move-to-room-modal": {
			"aria-label-btn": "Join {{roomName}} now",
			"join-now-btn": "Join now",
			text: "You can join right now if you are ready.",
			title: "You will be moved to {{roomName}} in {{currentCount}} {{secondString}}."
		},
		"open-rooms-btn-disabled-tooltip": "Minimum one breakout room is required",
		room: "Room",
		"room-settings-modal": {
			"close-btn": "Close room settings modal",
			"decrease-hours-aria-label": "Decrease hours",
			"decrease-minutes-aria-label": "Decrease minutes",
			"hours-label": "Hours",
			"increase-hours-aria-label": "Increase hours",
			"increase-minutes-aria-label": "Increase minutes",
			"leave-room-checkbox": "Allow participants to leave at any time",
			"leave-room-options": "Options for leaving the rooms",
			"leave-room-options-description": "By default, participants cannot leave a breakout room while it is open. When this is selected, participants can return to the main room at any time.",
			"minutes-label": "Minutes",
			"set-timer": "Do you want to set a timer?",
			"set-timer-description": "When the time is up participants will be moved to join the main room",
			"set-timer-hours": "Hours",
			"set-timer-minutes": "Minutes",
			title: "Room settings"
		},
		"settings-button-text": "Settings",
		"shuffle-button-text": "Shuffle",
		"shuffle-done-notification": "Participants have been shuffled",
		"shuffling-button-text": "Shuffling..."
	},
	common: {
		"a-pexip-meeting": "a<1></1>meeting",
		"ask-for-permission": "Request permission",
		"brand-name": "your video service",
		cancel: "Cancel",
		change: "Change",
		close: "Close",
		"close-panel": "Close panel",
		"close-tooltip": "Close tooltip",
		"close-window": "Close window",
		delete: "Delete",
		"drag-participant": "Drag participant",
		"go-back": "Go back",
		host: "Host",
		join: "Join",
		"join-audio-only": "Join audio only",
		"join-breakout-room-aria-label": "Join breakout room",
		"join-with-audio": "Join with audio",
		"join-with-presentation-only": "Join with presentation only",
		"join-with-video": "Join with video",
		"label-logo": "logo",
		"label-pexip-logo": "Pexip logo",
		"lower-hand": "Lower hand",
		ok: "Ok",
		"open-menu": "Open menu",
		"raise-hand": "Raise hand",
		remove: "Remove",
		replay: "Replay",
		save: "Save",
		"scrollable-content": "Scrollable content",
		second: "second",
		seconds: "seconds",
		send: "Send",
		"try-again": "Try again",
		yes: "Yes"
	},
	"device-status": {
		"audio-detected": {
			message: "Great, now we have sound from you!",
			title: "Audio detected from microphone"
		},
		"audio-device-in-use": {
			message: "Another application (e.g. Teams or Slack) is using your microphone. To use it here, please find that application and turn it off",
			title: "Microphone unavailable"
		},
		"audio-device-not-found": {
			message: "Your preferred microphone is unavailable",
			title: "We can’t find your microphone"
		},
		"audio-overconstrained": {
			message: "Try lowering your quality settings",
			title: "Microphone is overly constrained"
		},
		"audio-request-timed-out": {
			message: "Your browser did not respond. Try again.",
			title: "Microphone request timed out"
		},
		"initial-permissions-audio-input-granted": { message: "You have granted permission to use your microphone" },
		"initial-permissions-granted": { title: "Permissions granted" },
		"initial-permissions-not-granted": {
			message: "Please select <1>Allow</1> in the next step when prompted by your browser. We will only have access for the duration of the meeting.",
			title: "We need your permission to use your camera and microphone",
			"title-audioonly": "We need your permission to use your microphone",
			"title-videoonly": "We need your permission to use your camera"
		},
		"initial-permissions-video-input-granted": { message: "You have granted permission to use your camera" },
		"invalid-audio-constraints": {
			message: "Try clearing your browser cache",
			title: "Microphone is not configured properly"
		},
		"invalid-video-constraints": {
			message: "Try clearing your browser cache",
			title: "Camera is not configured properly"
		},
		"no-audio-detected": {
			message: "We are not able to detect any sound from your microphone. Please check your settings",
			title: "No audio detected from microphone"
		},
		"no-audio-devices-found": {
			message: "Your microphone seems to be unavailable. Please check if it is plugged in and set up correctly",
			title: "There’s no connected microphone"
		},
		"no-video-devices-found": {
			message: "Your camera seems to be unavailable. Please check if it is plugged in and set up correctly",
			title: "There’s no connected camera"
		},
		"not-supported-error-only-audio": {
			message: "We can't get media from your browser. Try to use another modern browser.",
			title: "Browser does not support"
		},
		"not-supported-error-only-video": {
			message: "We can't get media from your browser. Try to use another modern browser.",
			title: "Browser does not support"
		},
		"permissions-granted-fallback-audioinput": {
			message: "We are unable to use your preferred microphone",
			title: "Unable to use your preferred microphone"
		},
		"permissions-granted-fallback-videoinput": {
			message: "We are unable to use your preferred camera",
			title: "Unable to use your preferred camera"
		},
		"permissions-rejected-audioinput": { title: "Microphone permission not granted" },
		"permissions-rejected-audioinput-only": { message: "You have denied permission to use your microphone. It will not be available for this meeting" },
		"permissions-rejected-videoinput": { title: "Camera permission not granted" },
		"permissions-rejected-videoinput-only": { message: "You have denied permission to use your camera. It will not be available for this meeting" },
		"unknown-error-only-audioinput": {
			message: "We are not able to use your camera. Try to reconnect your device or use a different one",
			title: "Camera unavailable"
		},
		"unknown-error-only-videoinput": {
			message: "We are not able to use your microphone. Try to reconnect your device or use a different one",
			title: "Microphone unavailable"
		},
		"video-device-in-use": {
			message: "Another application (e.g. Teams or Slack) is using your camera. To use it on Pexip, please find that application and turn it off",
			title: "Camera unavailable"
		},
		"video-device-not-found": {
			message: "Your preferred camera is unavailable",
			title: "We can’t find your camera"
		},
		"video-overconstrained": {
			message: "Try lowering your quality settings",
			title: "Camera is overly constrained"
		},
		"video-request-timed-out": {
			message: "Your browser did not respond. Try again.",
			title: "Camera request timed out"
		}
	},
	dtmf: { "enter-dtmf": "Enter DTMF" },
	fecc: { "camera-control": "Camera control" },
	infocard: {
		lobby: { header: "Please wait, waiting for others to join" },
		meeting: {
			body: "Pexip Meetings",
			header: "Welcome to\n {{brandName}}"
		}
	},
	invite: {
		"cant-find-anyone": "Can’t find anyone with that name",
		"click-search": "Click on the search field above to search",
		copied: "Copied",
		copy: "Copy",
		"copy-to-clipboard": "Copy a link to clipboard",
		expiry: "Your invite link expires in {{expiryHours}} hours",
		invite: "Invite",
		"invite-person": "Invite person",
		"invite-someone": "Invite someone to the meeting",
		invited: "Invited",
		"meeting-invitation-modal": "Meeting Invitation Modal",
		"search-for-someone": "Search for someone to invite",
		"send-invite-link": "or send an invite link"
	},
	media: {
		audio: { "you-are-temporarily-unmuted": "You’re temporarily unmuted" },
		"audio-suspended-computer-settings": "You can also go to your computer's settings to unmute your microphone.",
		"audio-suspended-description": "Please check if you have muted yourself using a headset or your browser, and unmute your microphone from there first.",
		"audio-suspended-title": "Have you muted your microphone using an external source?",
		"background-effects-action": "Change background effect",
		"browser-privacy-settings-link": "privacy settings",
		"call-history": {
			"add-to-favorites": "Add to Favorites",
			"call-this-video-address": "Call this video address",
			"delete-all-favorites": "Delete all favorites",
			"delete-all-recents": "Delete all recents",
			favorites: "Favorites",
			incoming: "Incoming",
			missed: "Missed",
			"open-menu": "Open call history item menu",
			outgoing: "Outgoing",
			recents: "Recents",
			"remove-favorite": "Remove favorite",
			"remove-favorite-disabled-branding": "Added by your admin and can not be removed.",
			"reorder-favorite-drag-handle": "Drag handle to reorder favorite",
			"you-have-no-favorites-title": "You have no favorites",
			"you-have-no-recents-title": "You have no recents"
		},
		"call-quality": {
			bad: "Bad",
			good: "Good",
			ok: "Ok",
			terrible: "Terrible"
		},
		"camera-turned-off": "Camera turned off",
		"check-everything-works": "Check that everything works",
		"check-everything-works-description": "Make sure that your equipment works so you can be heard and seen when you join.",
		"date-time": {
			full: "{{date}} {{time}}",
			today: "Today, {{time}}",
			weekday: "{{weekday}}, {{time}}",
			yesterday: "Yesterday, {{time}}"
		},
		"default-camera-label": "Default camera",
		"default-microphone-label": "Default microphone",
		"default-speaker-label": "Default speaker",
		"do you have headphones connected to-your-device": "Do you have headphones connected to your device? Make sure the microphone of the headphones is near your mouth.",
		effect: {
			"light-blur": "Light blur",
			"no-background": "No background",
			"strong-blur": "Strong blur",
			"upload-background": "Upload background"
		},
		error: { "unable-to-use": {
			audio: "Cannot use audio input device. Please select another one.",
			video: "Cannot use video input device. Please select another one."
		} },
		"first-check-that-you-have-selected-microphone": "First, check that you have selected the correct microphone and that your volume is turned up.",
		"flip-camera": "Flip camera",
		"host-muted-you": "The host has muted you.",
		"host-muted-you-descriptions": "You will be able to unmute yourself once the host has given you permission.",
		"if-you-dont-hear-yourself-try-this": "If you don't hear yourself, try this",
		input: {
			audio: "microphone",
			connector: " and ",
			"fallback-video": "We couldn't use {{originalDeviceName}} so we switched your {{deviceType}} to {{fallbackDeviceName}}",
			video: "camera"
		},
		"learn-how-to-grant-access": " or go to the <3>privacy settings</3> of your browser",
		"make-sure-the-volume-is-turned-up-on-your-device": "Make sure the volume is turned up on your device.",
		"make-sure-you-have-the-correct-microphone": "Make sure you have the correct microphone",
		"make-sure-you-have-the-correct-speaker": "Make sure you have the correct speaker",
		"mute-microphone": "Mute microphone",
		muted: "Muted",
		"muted-by-a-host": "Muted by a host",
		"of-your-browser": "of your browser",
		"open-menu-for": "Open menu for {{displayName}}",
		"open-sound-settings": "Open Sound Settings",
		"or-go-to-the": "or go to the ",
		"other-browsers-privacy-settings": "To grant access please go to the privacy settings of your browser or try to refresh the page.",
		"permission-info": {
			"[camera]": { title: "camera" },
			"[microphone-and-camera]": { title: "camera and microphone" },
			"[microphone]": { title: "microphone" }
		},
		"permissions-help-video-link": "To grant access please follow the steps in <2>this short video</2>",
		presentation: {
			"nobody-sharing-screen": "No-one is currently sharing their screen",
			"pexip-presentation": "Presentation Window",
			presenting: "Presenting",
			"share-screen": "Share screen",
			"share-screen-placeholder": "When someone shares their screen it’ll appear here",
			"stop-share-screen": "Stop sharing",
			"take-over": "Take over",
			"the-current": "the current",
			"this-will-end": "This will end {{normalizedPresenterName}} presentation and start your own."
		},
		"push-to-talk": "Push and hold your space bar to unmute yourself temporarily",
		"recording-finished": "Recording finished",
		"remove-spotlight": "Remove spotlight",
		selfview: "Selfview",
		"settings-selfview": "Settings selfview",
		speaking: "Speaking",
		spotlight: "Spotlight",
		"start-test": "Start test",
		"start-test-description": "Starts a three-second countdown. When it ends, begin speaking to record your microphone.",
		suggestions: {
			directory: "Directory",
			recent: "Recent"
		},
		"test-your-microphone": "Test your microphone",
		"test-your-microphone-title-[before-testing]": "Test your microphone",
		"test-your-microphone-title-[get-ready]": "Get ready to say something",
		"test-your-microphone-title-[playback-finished]": "Playback",
		"test-your-microphone-title-[playing-back]": "Playback",
		"test-your-microphone-title-[recording]": "Recording your voice...",
		"testing-my-microphone": "\"Testing 1, 2, 3\"",
		"this-is-how-you-will-sound-to-others": "This is how you will sound to others",
		"to-grant-access-follow-steps": "To grant access please follow the steps in ",
		transfer: "Transfer",
		"trying-to-speak": "Trying to speak? Your microphone is muted",
		"turn-camera-off": "Turn camera off",
		"turn-camera-on": "Turn camera on",
		"unblock-permissions-video-link": "this short video",
		"unmute-microphone": "Unmute microphone",
		"video-suspended-description": "Please check if you have turned off your camera with your browser. This may happen if you open a new tab that is using your camera.",
		"video-suspended-title": "Have you turned off your camera using an external source?",
		"you-blocked-access": "You blocked access to your {{seeOrHearYou}}",
		"you-blocked-access-tooltip": {
			camera: "You blocked access to your camera",
			"camera-and-mic": "You blocked access to your camera & microphone",
			mic: "You blocked access to your microphone"
		},
		"you-can-say-something-like": "You can say something like ",
		"you-may-need-to-connect-speakers-or-headphones": "If you are using a desktop computer, you may need to connect speakers or headphones."
	},
	"media-presentation": { "do-you-want-to-take-over": "Do you want to take over the presentation?" },
	meeting: {
		admit: "Admit",
		authenticated: "Authenticated",
		"chat-message-participant": "Message",
		"chat-message-participant-no-direct-chat": "You can't send a message to this participant because their device doesn't support direct chat.",
		"chat-new-message": "new message",
		"chat-new-messages": "{{newMessagesCount}} new messages",
		"chat-scroll-last-message": "Scroll to last chat message",
		"chat-with-everyone": "Everyone",
		"chat-with-individual": "Direct",
		"close-new-chat-alert": "Close new chat message alert",
		deny: "Deny",
		disconnect: "Disconnect",
		"empty-chat": "Looks like nobody posted chat messages while you were in the room",
		error: "Click to resume the meeting video",
		"folded-selfview": { drag: "Move self-view" },
		"four-participants-joined-group": "{{third}}, {{second}}, {{first}} and 1 other joined",
		"four-participants-left-group": "{{third}}, {{second}}, {{first}} and 1 other left",
		"hide-self-view": "Hide self-view",
		leave: "Leave",
		"leave-aria-label": "Leave meeting",
		"lower-hand": "Lower hand",
		"make-guest": "Make guest",
		"make-host": "Make host",
		"more-controls": "More controls",
		"more-than-four-participants-joined-group": "{{third}}, {{second}}, {{first}} and {{remaining}} others joined",
		"more-than-four-participants-left-group": "{{third}}, {{second}}, {{first}} and {{remaining}} others left",
		"name-with-you": "{{displayName}} (You)",
		"network-fixed": "Fixed!",
		"network-reconnecting": "Lost network connection. Reconnecting...",
		"participant-joined": "{{displayName}} joined",
		"participant-left": "{{displayName}} left",
		"participant-removed": "{{displayName}} removed",
		"participant-transfer": "{{displayName}} transferred",
		"remove-user-confirmation": "Are you sure you want to remove {{userName}} from this meeting?",
		"show-self-view": "Show self-view",
		"three-participants-joined-group": "{{third}}, {{second}} and {{first}} joined",
		"three-participants-left-group": "{{third}}, {{second}} and {{first}} left",
		"toggle-chat-tooltip": "Chat",
		"toggle-invite-modal": "Toggle invite members modal",
		"toggle-participants-panel-tooltip": "Participants",
		"two-participants-joined-group": "{{second}} and {{first}} joined",
		"two-participants-left-group": "{{second}} and {{first}} left",
		unauthenticated: "Unauthenticated",
		"video-label": "Live video of the meeting",
		"video-label-presentation": "Live video of another participant’s presentation",
		"write-message": "Write a message",
		you: "You"
	},
	preflight: {
		"get-ready": "Get ready for your meeting",
		"in-this-meeting": {
			plural: "<0>{inMeetingCount} other people</0> are already inside.",
			singular: "<0>1 other person</0> is already inside."
		},
		"join-browser": "Join meeting in browser"
	},
	quality: {
		auto: "Auto",
		"change-quality": "Change quality",
		high: "High",
		info: "This setting affects the amount of bandwidth you’ll use for this meeting. Adjust to a lower value if your internet connection is slow or if your computer’s performance is badly affected.",
		low: "Low",
		medium: "Medium",
		"poor-connection-detected": "Poor connection detected",
		quality: "Connection quality",
		"select-quality": "Select meeting quality",
		"very-high": "Very High"
	},
	setting: {
		"preview-label-action": "Stop preview",
		"preview-label-info": "Only you can see this. Your camera remains off for everyone in the meeting."
	},
	settings: {
		"collapsed-selfview-tooltip-description": "You’re still sending video to other people in the meeting",
		"device-select": {
			"select-camera": "Select camera",
			"select-microphone": "Select microphone",
			"select-speaker": "Select speaker"
		},
		"layout-confirmation-desc": "You’re about to change the layout for everyone in the meeting, not just yourself.",
		"layout-confirmation-title": "Changing layouts will affect everyone",
		"layout-only-for-everyone": "Only available for everyone",
		"layout-reset-to-meeting-layout-info": "Resets your layout to the one chosen by host for this meeting",
		"layout[1:0]": "Highlight",
		"layout[1:21]": "Speaker + 21",
		"layout[1:33]": "Speaker + 33",
		"layout[1:7]": "Speaker + 7",
		"layout[2:21]": "2 Speaker + 21",
		"layout[2x2]": "2 x 2",
		"layout[3x3]": "3 x 3",
		"layout[4x4]": "4 x 4",
		"layout[5x5]": "5 x 5",
		"layout[ac]": "Adaptive Composition",
		"layout[one_main_nine_around]": "Speaker + 9",
		"layout[one_main_twelve_around]": "Speaker + 12",
		"layout[two_mains_eight_around]": "2 Speaker + 8",
		"playing-sound": "Playing sound...",
		"preview-label": "Private preview",
		"remove-image": "Remove image",
		"request-preview": "Request preview",
		"reset-to-meeting-layout": "Reset to meeting layout",
		"save-for-everyone": "Save for everyone",
		"save-for-myself": "Save for myself",
		"selfview-hidden": "Self-view hidden",
		"test-your-sound": "Test your sound",
		"your-camera-is-off": "Your camera is off."
	},
	shortcuts: {
		"ctrl-alt-letter": "(Ctrl + Alt + {{letter}})",
		"ctrl-cmd-letter": "(Ctrl + ⌘ + {{letter}})"
	},
	stats: {
		"[average-decode-time]": "Average decode time",
		"[average-encode-time]": "Average encode time",
		"[bitrate]": "Bitrate",
		"[codec]": "Codec",
		"[fps-volatility]": "FPS volatility",
		"[jitter]": "Jitter",
		"[packets-lost]": "Packets lost",
		"[packets-transmitted]": "Packets transmitted",
		"[quality-limitation-durations-bandwidth]": "Bandwidth constrained duration",
		"[quality-limitation-durations-cpu]": "CPU constrained duration",
		"[quality-limitation-durations-none]": "None",
		"[quality-limitation-reason]": "Quality limitation reason",
		"[recent-packet-loss]": "Recent packet loss",
		"[resolution]": "Resolution",
		"[roundtrip-time]": "Roundtrip time",
		"[time-to-capture-stats]": "Time to capture stats",
		"[total-packet-loss]": "Total packet loss",
		audio: "Audio",
		in: "In",
		"media-stats": "Media statistics",
		"no-stats-available": "No stats available",
		out: "Out",
		preso: "Presentation",
		"secure-check-code": "Secure check code",
		video: "Video"
	}
}, Ao = {
	container: "_container_2tioy_83",
	pip: "_pip_2tioy_88",
	bottomStartContent: "_bottomStartContent_2tioy_94",
	horizontal: "_horizontal_2tioy_108",
	external: "_external_2tioy_112",
	emphasized: "_emphasized_2tioy_116",
	deemphasized: "_deemphasized_2tioy_125",
	browserPip: "_browserPip_2tioy_137",
	videoWrapper: "_videoWrapper_2tioy_141",
	splashScreen: "_splashScreen_2tioy_165",
	expanded: "_expanded_2tioy_169",
	centeredInWideContainer: "_centeredInWideContainer_2tioy_169",
	overlay: "_overlay_2tioy_177"
}, jo = (e, t) => e ? t ? q.PresentationPip : q.PresentationFull : t ? q.MeetingVideoPip : q.MeetingVideoFull, Mo = /*#__PURE__*/ t.forwardRef(({ mediaStream: e, selectedAudioOutputDeviceId: n, isPresentation: i = !1, status: o, isFullHeight: c, isFullWidth: l, handleVideoClick: u, onVideoPlaying: p, onPictureInPictureChange: m, onDoubleClick: h, isContainerWide: g = !1, splashScreen: _, videoElementId: v, tabIndex: y = -1, onKeyDown: b, isReceivingVideo: x = !0, renderVideo: S, ...C }, T) => {
	let { t: E } = w(), D = d(null), [O, k] = f("loading"), A = d(null);
	s(T, () => ({ focus: () => {
		D.current?.focus(), A.current?.focus();
	} }));
	let j = o === J.Expanded, M = o === J.External, N = o === J.Pip, P = jo(i, N);
	a(() => {
		Vr.debug({ mediaStream: e }, "Media stream attached to Video component");
	}, [e]);
	let F = r((e) => {
		Vr.debug("onPlaying callback called"), p?.(e), k("playing");
	}, [p]), I = r(() => {
		k("failed");
	}, []), L = r(() => {
		D.current?.resume();
	}, []);
	return /*#__PURE__*/ t.createElement(xt, {
		className: K(Ao.videoWrapper, {
			[Ao.centeredInWideContainer]: g,
			[Ao.expanded]: j
		}),
		isFullHeight: c,
		isFullWidth: l,
		borderRadius: M || j ? "none" : "box",
		onDoubleClick: h,
		background: M ? "black" : "none",
		flexDirection: "row",
		"data-testid": P,
		...C
	}, _ && "text" in _ ? /*#__PURE__*/ t.createElement(Pe, {
		ref: A,
		tabIndex: y,
		background: "image",
		backgroundImageSrc: _.background,
		className: Ao.splashScreen,
		onClick: u,
		onKeyDown: b
	}, /*#__PURE__*/ t.createElement(Ce, { centerText: !0 }, /*#__PURE__*/ t.createElement(G, {
		fontVariant: V.H2,
		whiteSpace: "preLine",
		"data-testid": q.VideoSplashText
	}, _.text), /*#__PURE__*/ t.createElement(_e, {
		srcObject: e,
		autoPlay: !0,
		onPlaying: F,
		sinkId: n
	}))) : x ? /*#__PURE__*/ t.createElement(t.Fragment, null, /*#__PURE__*/ t.createElement(bt, {
		renderVideo: S,
		tabIndex: y,
		id: v,
		ref: D,
		srcObject: e,
		onPlaying: F,
		onFailedToResume: I,
		onPictureInPictureChange: m,
		onClick: u,
		onKeyDown: b,
		disablePictureInPicture: ni(),
		sinkId: i ? void 0 : n,
		muted: i,
		"data-testid": i ? q.VideoPresentation : q.VideoMeeting,
		"aria-label": i ? E("meeting.video-label-presentation", "Live video of another participant’s presentation") : E("meeting.video-label", "Live video of the meeting")
	}), (!e || O === "loading") && /*#__PURE__*/ t.createElement(lt, {
		className: Ao.overlay,
		colorScheme: "dark",
		sizeModifier: N ? "small" : "medium"
	}), O === "failed" && /*#__PURE__*/ t.createElement(z, {
		onClick: L,
		enhancerStart: /*#__PURE__*/ t.createElement(H, { source: U.IconPlayRound }),
		className: Ao.overlay
	}, E("meeting.error", "Click to resume the meeting video"))) : /*#__PURE__*/ t.createElement(_e, {
		srcObject: e,
		autoPlay: !0,
		onPlaying: F,
		sinkId: n
	}));
});
Mo.displayName = "MeetingVideo";
// src/views/MeetingVideo/ExternalVideo.view.tsx
var No = (e) => /*#__PURE__*/ t.createElement("div", { className: K(Ao.container, Ao.external) }, /*#__PURE__*/ t.createElement(Mo, e)), Po = {
	inMeetingDraggable: "_inMeetingDraggable_w4a3u_26",
	pauseTransition: "_pauseTransition_w4a3u_30",
	overlapsControls: "_overlapsControls_w4a3u_34",
	desktopToolbar: "_desktopToolbar_w4a3u_34",
	header: "_header_w4a3u_37",
	footer: "_footer_w4a3u_41",
	phone: "_phone_w4a3u_45",
	center: "_center_w4a3u_48",
	centerInitial: "_centerInitial_w4a3u_76",
	sidePanelOpen: "_sidePanelOpen_w4a3u_81"
}, Fo = /*#__PURE__*/ t.forwardRef(({ draggableAriaLabel: e = "", center: n = !1, isMoveableWithArrowKeys: i, isSidePanelVisible: o, isSidePanelTransformEnabled: s = !0, isDisabled: c, alwaysAllowStyles: l = !1, floatRoot: u, isPhone: p, className: m, beforeRepositionSideEffect: h, onRepositionSideEffect: g, shouldCaptureClick: _ = !0, showFocus: v = !0, alignWithFloatRootTrigger: y, pointerCapture: b, pointerCaptureTarget: x, children: S, style: C, testId: T, ...E }, D) => {
	let O = d(null);
	O = D ?? O;
	let { i18n: k } = w(), A = Fi(k), [j, M] = f(!1), [N, P] = f(!1), { controlsOverlap: F, update: I } = ba(O), L = wo(o, O, s), ee = r((e) => {
		I(), Co(e.getBoundingClientRect(), A) ? L(88) : L(void 0);
	}, [
		I,
		L,
		A
	]), te = r(() => {
		O.current && (O.current.style.removeProperty("transform"), O.current.style.removeProperty("translate")), P(!0), h && h();
	}, [h, O.current]), ne = r((e, t) => {
		ee(e);
		let n = e.offsetLeft;
		A === "rtl" && (n = window.innerWidth - e.offsetLeft - e.offsetWidth), o && n < 448 && (A === "ltr" ? e.style.left = `${448 / window.innerWidth * 100}%` : (e.style.left = `calc(${(window.innerWidth - 448) / window.innerWidth * 100}% - ${e.offsetWidth}px)`, e.style.right = "auto")), g && g(e, { floatRootOverflow: t });
	}, [
		ee,
		g,
		o,
		A
	]);
	a(() => {
		let e = O.current;
		e && ((F.header || F.footer) && (e.style.removeProperty("top"), e.style.removeProperty("bottom")), F.desktopToolbar && (A === "ltr" ? e.style.removeProperty("left") : e.style.right = "88px"));
	}, [
		F,
		A,
		O.current
	]), a(() => {
		if (N && O.current) {
			let e = O.current;
			e.style.removeProperty("transition"), e.ontransitionend = (t) => {
				if (t.propertyName !== "translate") return;
				let n;
				requestAnimationFrame((t) => {
					n = t, e.style.transition = "none", A === "ltr" ? e.style.left = `${e.getBoundingClientRect().left / window.innerWidth * 100}%` : o ? e.style.right = `${448 / window.innerWidth * 100}%` : e.style.right = `${72 / window.innerWidth * 100}%`, e.style.removeProperty("translate"), o && L(88);
				});
				let r = () => {
					requestAnimationFrame((t) => {
						t <= n ? r() : (I(), e.style.removeProperty("transition"));
					});
				};
				r(), e.ontransitionend = null;
			};
		}
	}, [
		N,
		o,
		I,
		L,
		A,
		O.current
	]), a(() => {
		c ? (I({
			desktopToolbar: !1,
			footer: !1,
			header: !1
		}), M(!0)) : (I(), M(!1));
	}, [c, I]);
	let R = (e) => (l || !c) && e;
	return /*#__PURE__*/ t.createElement(je, {
		ariaLabel: e,
		testId: T,
		isMoveableWithArrowKeys: i,
		isDisabled: c,
		showFocus: v,
		floatRoot: u,
		onReposition: ne,
		beforeReposition: te,
		shouldCaptureClick: _,
		ref: O,
		pointerCapture: b,
		pointerCaptureTarget: x,
		alignWithFloatRootTrigger: y,
		floatRootInset: Tn,
		className: K({
			[Po.inMeetingDraggable]: R(!0),
			[Po.overlapsControls]: R(ya(F)),
			[Po.desktopToolbar]: R(F.desktopToolbar),
			[Po.footer]: R(F.footer),
			[Po.header]: R(F.header),
			[Po.center]: R(n && !N && !j),
			[Po.centerInitial]: R(n && !N && j),
			[Po.sidePanelOpen]: R(o),
			[Po.phone]: R(p)
		}, m),
		style: C,
		...E
	}, S);
});
Fo.displayName = "InMeetingDraggable";
// src/views/MeetingVideo/DraggableMeetingVideo.view.tsx
var Io = /*#__PURE__*/ t.forwardRef(({ bottomStartContent: e, draggableAriaLabel: n, isHorizontal: r, isSidePanelVisible: i, floatRoot: a, videoElementId: o, onMouseEnter: s, onMouseLeave: c, onFocus: l, onBlur: u, ...d }, f) => {
	let { containerRef: p, isContainerWide: m } = pe(), h = d.status === J.Pip, g = d.status === J.BrowserPip, _ = d.status === J.Deemphasized, v = d.status === J.Emphasized;
	return /*#__PURE__*/ t.createElement(Fo, {
		draggableAriaLabel: n,
		...h && {
			onMouseEnter: s,
			onMouseLeave: c,
			onFocus: l,
			onBlur: u
		},
		...v && { "data-emphasized": !0 },
		..._ && { "data-deemphasized": !0 },
		isDisabled: !h,
		isSidePanelVisible: i,
		isSidePanelTransformEnabled: h,
		floatRoot: a,
		center: !0,
		className: K(Ao.container, {
			[Ao.pip]: h,
			[Ao.emphasized]: v,
			[Ao.deemphasized]: _,
			[Ao.horizontal]: r,
			[Ao.browserPip]: g,
			"m-0": ri && !h
		}),
		ref: p
	}, /*#__PURE__*/ t.createElement(Mo, {
		...d,
		ref: f,
		isContainerWide: m,
		videoElementId: o
	}), e && !h && !g && /*#__PURE__*/ t.createElement("div", { className: Ao.bottomStartContent }, e));
});
Io.displayName = "DraggableMeetingVideo";
var Lo = { closeButton: "_closeButton_1k468_1" }, Ro = ({ onClose: e }) => {
	let { t: n } = w();
	return /*#__PURE__*/ t.createElement(Fe, null, /*#__PURE__*/ t.createElement(G, { fontVariant: V.H3 }, /*#__PURE__*/ t.createElement(C, {
		t: n,
		i18nKey: "media.presentation.nobody-sharing-screen"
	}, "No-one is currently sharing their screen")), /*#__PURE__*/ t.createElement(G, {
		fontVariant: V.H6,
		className: "mt-2"
	}, /*#__PURE__*/ t.createElement(C, {
		t: n,
		i18nKey: "media.presentation.share-screen-placeholder"
	}, "When someone shares their screen it’ll appear here")), /*#__PURE__*/ t.createElement(z, {
		className: K("mt-5", Lo.closeButton),
		modifier: "fullWidth",
		onClick: e,
		variant: "tertiary"
	}, /*#__PURE__*/ t.createElement(C, {
		t: n,
		i18nKey: "common.close-window"
	}, "Close window")));
}, zo = {
	presenterLabel: "_presenterLabel_1oop7_4",
	text: "_text_1oop7_15"
}, Bo = ({ text: e, className: n }) => /*#__PURE__*/ t.createElement("div", { className: K(zo.presenterLabel, n) }, /*#__PURE__*/ t.createElement(G, {
	className: zo.text,
	fontVariant: V.XSmall
}, e)), Vo = /*#__PURE__*/ t.forwardRef(({ draggableAriaLabel: e, presenterText: n, status: i, localIsPresenting: a, localMediaStream: o, remoteIsPresenting: s, remoteMediaStream: c, remotePopOut: l, handleVideoClick: u, setIsPresentationBrowserPip: d, setIsPresentationPoppedOut: f, isSidePanelVisible: p, floatRoot: m, videoElementId: h, tabIndex: g, onKeyDown: _, ...v }, y) => {
	let { t: b } = w(), x = fe(), S = s || a, C = r(() => {
		f(!1);
	}, [f]);
	return i === J.External ? /*#__PURE__*/ t.createElement(tt, {
		onUnload: C,
		remotePopOut: l,
		title: b("media.presentation.pexip-presentation", "Presentation Window")
	}, S ? /*#__PURE__*/ t.createElement(No, {
		handleVideoClick: u,
		isFullHeight: !0,
		isFullWidth: !0,
		isPresentation: !0,
		mediaStream: a ? o : s ? c : void 0,
		onPictureInPictureChange: d,
		status: i,
		isReceivingVideo: v.isReceivingVideo
	}) : /*#__PURE__*/ t.createElement(Ro, { onClose: C })) : /*#__PURE__*/ t.createElement(Io, {
		draggableAriaLabel: e,
		bottomStartContent: n ? /*#__PURE__*/ t.createElement(Bo, { text: n }) : void 0,
		ref: y,
		handleVideoClick: u,
		isPresentation: !0,
		mediaStream: a ? o : s ? c : void 0,
		onDoubleClick: x,
		onPictureInPictureChange: d,
		status: i,
		isSidePanelVisible: p,
		floatRoot: m,
		videoElementId: h,
		tabIndex: g,
		onKeyDown: _,
		...v
	});
});
Vo.displayName = "PresentationMeetingVideo";
var Ho = { audioMeterWrapper: "_audioMeterWrapper_1q9kq_1" }, Uo = ({ colorScheme: e, progress: n, text: r, width: i, ...a }) => /*#__PURE__*/ t.createElement("div", {
	className: Ho.audioMeterWrapper,
	...a
}, /*#__PURE__*/ t.createElement("div", { style: { width: i ?? "100%" } }, /*#__PURE__*/ t.createElement(nt, {
	barColor: rt.Primary,
	progress: n,
	colorScheme: e
})), r && /*#__PURE__*/ t.createElement("div", { className: "text-right" }, /*#__PURE__*/ t.createElement(G, { fontVariant: V.Small }, " ", r))), Wo = ({ analyzer: e, colorScheme: n, text: r, width: i, ...a }) => {
	let o = Gn(e);
	return /*#__PURE__*/ t.createElement(Uo, {
		progress: o,
		colorScheme: n,
		text: r,
		width: i,
		...a
	});
}, Go = 510, Ko = 419, qo = () => ({
	hideVisualizer: le(`(max-width: ${Go}px)`),
	isGridXs: le(`(max-width: ${Ko}px)`)
}), Jo = { secureCheckCode: "_secureCheckCode_chbpg_1" }, Yo = ({ secureCheckCode: e }) => {
	let { isGridXs: n } = qo(), { t: r } = w();
	return e ? /*#__PURE__*/ t.createElement(He, null, /*#__PURE__*/ t.createElement(G, { fontVariant: n ? V.XSmallBold : V.BodyBold }, /*#__PURE__*/ t.createElement(C, {
		t: r,
		i18nKey: "stats.secure-check-code"
	}, "Secure check code")), /*#__PURE__*/ t.createElement(G, {
		className: Jo.secureCheckCode,
		fontVariant: n ? V.XSmall : V.Small
	}, e)) : null;
}, Xo = {
	container: "_container_1u2qv_4",
	modalContent: "_modalContent_1u2qv_8",
	statsBox: "_statsBox_1u2qv_14",
	metricCell: "_metricCell_1u2qv_21",
	closeButton: "_closeButton_1u2qv_27",
	closeButtonIcon: "_closeButtonIcon_1u2qv_33",
	dataText: "_dataText_1u2qv_37"
}, Zo = ({ isOpen: e = !0, onClose: n, secureCheckCode: r, stats: i, children: a }) => {
	let { t: o } = w();
	return /*#__PURE__*/ t.createElement(ht, { colorScheme: "light" }, /*#__PURE__*/ t.createElement(qe, {
		"data-testid": q.StatsModal,
		isOpen: e,
		onClose: n,
		sizeModifier: "medium",
		withCloseButton: !0,
		closeButtonAriaLabel: o("common.close", "Close"),
		className: "light",
		uniqueTitle: o("stats.media-stats", "Media statistics"),
		withScrollbars: !1
	}, /*#__PURE__*/ t.createElement("div", { className: Xo.modalContent }, /*#__PURE__*/ t.createElement(W, { className: "pt-1 mb-1 ml-3 mr-3" }, /*#__PURE__*/ t.createElement(G, { fontVariant: V.H5 }, /*#__PURE__*/ t.createElement(C, {
		t: o,
		i18nKey: "stats.media-stats"
	}, "Media statistics"))), i ? /*#__PURE__*/ t.createElement("div", { className: Xo.statsBox }, a, /*#__PURE__*/ t.createElement(Qo, { stats: i }), r && /*#__PURE__*/ t.createElement(Yo, { secureCheckCode: r })) : /*#__PURE__*/ t.createElement(G, {
		"data-testid": q.TextNoStatsAvailable,
		className: "ml-3"
	}, /*#__PURE__*/ t.createElement(C, {
		t: o,
		i18nKey: "stats.no-stats-available"
	}, "No stats available")))));
}, Qo = ({ stats: e }) => {
	let { t: n } = w(), r = as(e).filter(([e, t, n]) => t != null || n != null), i = os(e).filter(([e, t, n]) => t != null || n != null), a = ss(e, "video").filter(([e, t]) => t != null), o = os(e, "preso").filter(([e, t, n]) => t != null || n != null), s = ss(e, "preso").filter(([e, t]) => t != null), { isGridXs: c } = qo();
	return /*#__PURE__*/ t.createElement(t.Fragment, null, /*#__PURE__*/ t.createElement(He, null, /*#__PURE__*/ t.createElement(Ie, { className: K({ "mb-1": c }) }, /*#__PURE__*/ t.createElement(B, { xs: 6 }, /*#__PURE__*/ t.createElement(Q, {
		bold: !0,
		left: !0
	}, /*#__PURE__*/ t.createElement(C, {
		t: n,
		i18nKey: "stats.audio"
	}, "Audio"))), /*#__PURE__*/ t.createElement(B, { xs: 3 }, /*#__PURE__*/ t.createElement(Q, { bold: !0 }, /*#__PURE__*/ t.createElement(C, {
		t: n,
		i18nKey: "stats.in"
	}, "In"))), /*#__PURE__*/ t.createElement(B, { xs: 3 }, /*#__PURE__*/ t.createElement(Q, { bold: !0 }, /*#__PURE__*/ t.createElement(C, {
		t: n,
		i18nKey: "stats.out"
	}, "Out")))), r.map(([e, r, i]) => /*#__PURE__*/ t.createElement(Ie, {
		className: K(Xo.dataText, { "mb-1": c }),
		key: `audio ${e}`
	}, /*#__PURE__*/ t.createElement(B, { xs: 6 }, /*#__PURE__*/ t.createElement(Q, {
		"data-testid": `${q.MetricAudio}-${e}`,
		left: !0
	}, n(`stats.[${e}]`))), /*#__PURE__*/ t.createElement(B, { xs: 3 }, /*#__PURE__*/ t.createElement(Q, { "data-testid": `${q.MetricAudioIn}-${e}` }, r)), /*#__PURE__*/ t.createElement(B, { xs: 3 }, /*#__PURE__*/ t.createElement(Q, { "data-testid": `${q.MetricAudioOut}-${e}` }, i))))), /*#__PURE__*/ t.createElement(He, null, /*#__PURE__*/ t.createElement(Ie, { className: K({ "mb-1": c }) }, /*#__PURE__*/ t.createElement(B, { xs: 6 }, /*#__PURE__*/ t.createElement(Q, {
		bold: !0,
		left: !0
	}, /*#__PURE__*/ t.createElement(C, {
		t: n,
		i18nKey: "stats.video"
	}, "Video"))), /*#__PURE__*/ t.createElement(B, { xs: 3 }, /*#__PURE__*/ t.createElement(Q, { bold: !0 }, /*#__PURE__*/ t.createElement(C, {
		t: n,
		i18nKey: "stats.in"
	}, "In"))), /*#__PURE__*/ t.createElement(B, { xs: 3 }, /*#__PURE__*/ t.createElement(Q, { bold: !0 }, /*#__PURE__*/ t.createElement(C, {
		t: n,
		i18nKey: "stats.out"
	}, "Out")))), i.map(([e, r, i]) => /*#__PURE__*/ t.createElement(Ie, {
		className: K(Xo.dataText, { "mb-1": c }),
		key: `video ${e}`
	}, /*#__PURE__*/ t.createElement(B, { xs: 6 }, /*#__PURE__*/ t.createElement(Q, {
		"data-testid": `${q.MetricVideo}-${e}`,
		left: !0
	}, n(`stats.[${e}]`))), /*#__PURE__*/ t.createElement(B, { xs: 3 }, /*#__PURE__*/ t.createElement(Q, { "data-testid": `${q.MetricVideoIn}-${e}` }, r)), /*#__PURE__*/ t.createElement(B, { xs: 3 }, /*#__PURE__*/ t.createElement(Q, { "data-testid": `${q.MetricVideoOut}-${e}` }, i)))), a.map(([e, r]) => /*#__PURE__*/ t.createElement(Ie, {
		className: K(Xo.dataText, { "mb-1": c }),
		key: `video ${e}`
	}, /*#__PURE__*/ t.createElement(B, { xs: 9 }, /*#__PURE__*/ t.createElement(Q, {
		"data-testid": `${q.MetricVideo}-${e}`,
		left: !0
	}, n(`stats.[${e}]`))), /*#__PURE__*/ t.createElement(B, { xs: 3 }, /*#__PURE__*/ t.createElement(Q, { "data-testid": `${q.MetricVideoOut}-${e}` }, r))))), /*#__PURE__*/ t.createElement(He, null, /*#__PURE__*/ t.createElement(Ie, { className: K({ "mb-1": c }) }, /*#__PURE__*/ t.createElement(B, { xs: 6 }, /*#__PURE__*/ t.createElement(Q, {
		bold: !0,
		left: !0
	}, /*#__PURE__*/ t.createElement(C, {
		t: n,
		i18nKey: "stats.preso"
	}, "Presentation"))), /*#__PURE__*/ t.createElement(B, { xs: 3 }, /*#__PURE__*/ t.createElement(Q, { bold: !0 }, /*#__PURE__*/ t.createElement(C, {
		t: n,
		i18nKey: "stats.in"
	}, "In"))), /*#__PURE__*/ t.createElement(B, { xs: 3 }, /*#__PURE__*/ t.createElement(Q, { bold: !0 }, /*#__PURE__*/ t.createElement(C, {
		t: n,
		i18nKey: "stats.out"
	}, "Out")))), o.map(([e, r, i]) => /*#__PURE__*/ t.createElement(Ie, {
		className: K(Xo.dataText, { "mb-1": c }),
		key: `preso ${e}`
	}, /*#__PURE__*/ t.createElement(B, { xs: 6 }, /*#__PURE__*/ t.createElement(Q, {
		"data-testid": `${q.MetricPreso}-${e}`,
		left: !0
	}, n(`stats.[${e}]`))), /*#__PURE__*/ t.createElement(B, { xs: 3 }, /*#__PURE__*/ t.createElement(Q, { "data-testid": `${q.MetricPresoIn}-${e}` }, r)), /*#__PURE__*/ t.createElement(B, { xs: 3 }, /*#__PURE__*/ t.createElement(Q, { "data-testid": `${q.MetricPresoOut}-${e}` }, i)))), s.map(([e, r]) => /*#__PURE__*/ t.createElement(Ie, {
		className: K(Xo.dataText, { "mb-1": c }),
		key: `video ${e}`
	}, /*#__PURE__*/ t.createElement(B, { xs: 9 }, /*#__PURE__*/ t.createElement(Q, {
		"data-testid": `${q.MetricVideo}-${e}`,
		left: !0
	}, n(`stats.[${e}]`))), /*#__PURE__*/ t.createElement(B, { xs: 3 }, /*#__PURE__*/ t.createElement(Q, { "data-testid": `${q.MetricVideoOut}-${e}` }, r))))));
}, $o = (e) => typeof e == "number" ? es(e * 100) : null, es = (e) => typeof e == "number" ? `${e.toFixed(1)}%` : null, ts = (e) => typeof e == "number" ? e > 1e3 ? `${Math.round(e / 1e3)}Kbps` : Math.round(e) : e, ns = (e, t) => e && t ? `${e}p${Math.round(t)}` : e, rs = (e) => typeof e == "number" ? `${Math.round(e * 1e3)}ms` : e, is = (e, t) => typeof e == "number" ? `${e}${t}` : e, as = (e) => [
	[
		"packets-transmitted",
		e.inbound?.audio?.packetsTransmitted,
		e.outbound?.audio?.packetsTransmitted
	],
	[
		"packets-lost",
		e.inbound?.audio?.packetsLost,
		e.outbound?.audio?.packetsLost
	],
	[
		"recent-packet-loss",
		$o(e.inbound?.audio?.recentPercentageLost),
		$o(e.outbound?.audio?.recentPercentageLost)
	],
	[
		"total-packet-loss",
		$o(e.inbound?.audio?.totalPercentageLost),
		$o(e.outbound?.audio?.totalPercentageLost)
	],
	[
		"jitter",
		rs(e.inbound?.audio?.jitter),
		rs(e.outbound?.audio?.jitter)
	],
	[
		"bitrate",
		ts(e.inbound?.audio?.bitrate),
		ts(e.outbound?.audio?.bitrate)
	],
	[
		"codec",
		e.inbound?.audio?.codec,
		e.outbound?.audio?.codec
	],
	[
		"roundtrip-time",
		rs(e.outbound?.audio?.roundTripTime),
		""
	],
	[
		"time-to-capture-stats",
		is(e.inbound?.audio?.timeToCaptureStats, "ms"),
		is(e.outbound?.audio?.timeToCaptureStats, "ms")
	]
], os = (e, t = "video") => [
	[
		"packets-transmitted",
		e.inbound?.[t]?.packetsTransmitted,
		e.outbound?.[t]?.packetsTransmitted
	],
	[
		"packets-lost",
		e.inbound?.[t]?.packetsLost,
		e.outbound?.[t]?.packetsLost
	],
	[
		"recent-packet-loss",
		$o(e.inbound?.[t]?.recentPercentageLost),
		$o(e.outbound?.[t]?.recentPercentageLost)
	],
	[
		"total-packet-loss",
		$o(e.inbound?.[t]?.totalPercentageLost),
		$o(e.outbound?.[t]?.totalPercentageLost)
	],
	[
		"bitrate",
		ts(e.inbound?.[t]?.bitrate),
		ts(e.outbound?.[t]?.bitrate)
	],
	[
		"codec",
		e.inbound?.[t]?.codec,
		e.outbound?.[t]?.codec
	],
	[
		"resolution",
		ns(e.inbound?.[t]?.resolution, e.inbound?.[t]?.framesPerSecond),
		ns(e.outbound?.[t]?.resolution, e.outbound?.[t]?.framesPerSecond)
	],
	[
		"roundtrip-time",
		rs(e.outbound?.[t]?.roundTripTime),
		""
	],
	[
		"average-encode-time",
		null,
		rs(e.outbound?.[t]?.averageEncodeTime)
	],
	[
		"average-decode-time",
		rs(e.inbound?.[t]?.averageDecodeTime),
		null
	],
	[
		"time-to-capture-stats",
		is(e.inbound?.[t]?.timeToCaptureStats, "ms"),
		is(e.outbound?.[t]?.timeToCaptureStats, "ms")
	],
	[
		"fps-volatility",
		es(e.inbound?.[t]?.fpsVolatility),
		es(e.outbound?.[t]?.fpsVolatility)
	],
	[
		"quality-limitation-reason",
		null,
		e.outbound?.[t]?.qualityLimitationReason
	]
], ss = (e, t = "video") => [["quality-limitation-durations-cpu", is(e.outbound?.[t]?.qualityLimitationDurations?.cpu, "s")], ["quality-limitation-durations-bandwidth", is(e.outbound?.[t]?.qualityLimitationDurations?.bandwidth, "s")]], Q = ({ children: e, left: n = !1, bold: r = !1, ...i }) => {
	let { isGridXs: a } = qo();
	return /*#__PURE__*/ t.createElement("div", {
		className: K(Xo.metricCell, {
			"text-left": n,
			"text-right": !n
		}),
		...i
	}, /*#__PURE__*/ t.createElement(G, { fontVariant: a ? r ? V.XSmallBold : V.XSmall : r ? V.BodyBold : V.Body }, e));
}, cs = /*#__PURE__*/ function(e) {
	return e.GOOD = "Good", e.OK = "Ok", e.BAD = "Bad", e.TERRIBLE = "Terrible", e;
}({}), ls = (e) => `${Math.round(e * 100)}%`, us = /*#__PURE__*/ t.forwardRef(({ width: e, height: n, quality: { name: r, value: i }, icon: a }, o) => {
	let { t: s } = w(), c = r === "Bad" || r === "Terrible", { isGridXs: l, hideVisualizer: u } = qo();
	return /*#__PURE__*/ t.createElement(xe, null, /*#__PURE__*/ t.createElement(He, { spacing: "none" }, /*#__PURE__*/ t.createElement(G, {
		fontVariant: l ? V.XSmallBold : V.BodyBold,
		variant: c ? "danger" : void 0
	}, ls(i)), /*#__PURE__*/ t.createElement(G, {
		fontVariant: l ? V.XSmall : V.Body,
		variant: c ? "danger" : void 0,
		isTruncated: !0
	}, s(`media.call-quality.${r.toLowerCase()}`, r), " ", /*#__PURE__*/ t.createElement(H, {
		size: "mini",
		source: a
	}))), !u && /*#__PURE__*/ t.createElement("canvas", {
		ref: o,
		width: e,
		height: n
	}));
});
us.displayName = "CallQualityVisualizer";
// src/viewModels/AVQualityStats.viewModel.tsx
var ds = 170, fs = 18, ps = Qt, ms = Ee.DeepBlue90, hs = ({ callQualityStatsSignal: e }) => {
	let n = d(null), r = d(null), [i, o] = f({
		name: cs.GOOD,
		value: 1
	}), [s, c] = f({
		name: cs.GOOD,
		value: 1
	});
	return a(() => e.add((e) => {
		n.current && e?.inbound?.audio.length > 0 && o(gs(e.inbound.audio, n.current)), r.current && e?.outbound?.audio.length > 0 && c(gs(e.outbound.audio, r.current));
	}), [e]), /*#__PURE__*/ t.createElement(He, null, /*#__PURE__*/ t.createElement(Ie, null, /*#__PURE__*/ t.createElement(B, { xs: 6 }, /*#__PURE__*/ t.createElement(us, {
		ref: n,
		width: ds,
		height: fs,
		quality: i,
		icon: U.IconArrowDown
	})), /*#__PURE__*/ t.createElement(B, { xs: 6 }, /*#__PURE__*/ t.createElement(us, {
		ref: r,
		width: ds,
		height: fs,
		quality: s,
		icon: U.IconArrowUp
	}))));
};
function gs(e, t) {
	let { goodOrOkQuality: n, quality: r, qualityOverTime: i } = $t(e);
	return _s(t, i), {
		value: n,
		name: ys(r)
	};
}
function _s(e, t, n = ps) {
	let r = e.getContext("2d");
	r && (r.clearRect(0, 0, e.width, e.height), r.beginPath(), r.lineJoin = "round", r.strokeStyle = ms, r.moveTo(e.width, vs(t[0]) * e.height), t.forEach((t, i) => {
		i !== 0 && r.lineTo(e.width - i * e.width / n, vs(t) * e.height);
	}), r.stroke());
}
function vs(e) {
	switch (e) {
		case Zt.GOOD: return 0;
		case Zt.OK: return .33;
		case Zt.BAD: return .66;
		default: return 1;
	}
}
function ys(e) {
	switch (e) {
		case Zt.TERRIBLE: return cs.TERRIBLE;
		case Zt.BAD: return cs.BAD;
		case Zt.OK: return cs.OK;
		default: return cs.GOOD;
	}
}
// src/viewModels/Stats.viewModel.tsx
var bs = ({ cachedStats: e, statsSignal: n, callQualityStatsSignal: r, isOpen: i, onClose: o, secureCheckCode: s }) => {
	let [c, l] = f(e);
	return a(() => n.add(l), [n]), /*#__PURE__*/ t.createElement(Zo, {
		isOpen: i,
		onClose: o,
		stats: c,
		secureCheckCode: s
	}, /*#__PURE__*/ t.createElement(hs, { callQualityStatsSignal: r }));
}, xs = {
	roomName: "_roomName_1800j_4",
	timeLeft: "_timeLeft_1800j_5",
	truncated: "_truncated_1800j_9",
	smallText: "_smallText_1800j_18",
	breakoutIcon: "_breakoutIcon_1800j_22"
}, Ss = ({ meetingName: e, roomName: n, timeLeft: r, headingTestId: i, isSmallText: a = !1 }) => /*#__PURE__*/ t.createElement(t.Fragment, null, /*#__PURE__*/ t.createElement(G, {
	fontVariant: a ? V.SmallBold : V.H5,
	className: K(xs.roomName),
	"data-testid": i
}, e ?? "/ ", n), r && /*#__PURE__*/ t.createElement(G, {
	className: K("ml-2", xs.timeLeft, { [xs.smallText]: a }),
	fontVariant: a ? V.Body : V.H6
}, `/ ${r}`)), Cs = ({ roomEndAt: e, ...n }) => {
	let [r, i] = f("");
	return a(() => {
		let t;
		if ((e ?? 0 - Date.now() / 1e3) > 0) {
			let n = () => {
				i(v(e ?? 0, Date.now() / 1e3));
			};
			n(), t = window.setInterval(n, 1e3);
		}
		return () => clearInterval(t);
	}, [e]), /*#__PURE__*/ t.createElement(Ss, {
		timeLeft: r,
		...n
	});
}, ws = (e, t) => !e && !!t?.getVideoTracks().length, Ts = (e, t) => !t || !te(t) || e && F(t), Es = (e, { audio: t, video: n }) => !!e && (ne(e) || n && (re(e) || P(e) && !F(e)) || t && (R(e) || F(e) && !P(e)) || A(e)), Ds = {
	wrapper: "_wrapper_1wksk_189",
	overlayWrapper: "_overlayWrapper_1wksk_194",
	childWrapper: "_childWrapper_1wksk_204",
	overlayWrapperShadow: "_overlayWrapperShadow_1wksk_208",
	videoWrapper: "_videoWrapper_1wksk_226",
	hide: "_hide_1wksk_238",
	video: "_video_1wksk_226",
	withInfoBorder: "_withInfoBorder_1wksk_255",
	withErrorBorder: "_withErrorBorder_1wksk_259",
	flipper: "_flipper_1wksk_264",
	flipped: "_flipped_1wksk_287",
	label: "_label_1wksk_291",
	dimmedVideo: "_dimmedVideo_1wksk_295",
	permissionsRequestMessage: "_permissionsRequestMessage_1wksk_299",
	previewLabel: "_previewLabel_1wksk_306"
}, Os = ({ displayName: e = "Guest", size: n }) => /*#__PURE__*/ t.createElement(Ce, null, /*#__PURE__*/ t.createElement(ve, {
	type: ye.Initials,
	translate: "no",
	displayName: e,
	sizeModifier: n
})), ks = ({ className: e, children: n, isPhone: r, showLabel: i, labelContent: a, labelTestId: o, showVideo: s, isMobileDevice: c, isVideoInitiallyShown: l, isFlipped: u, showPlaceholder: d, username: f, sizeModifier: p, showShadow: m = !1 }) => /*#__PURE__*/ t.createElement("div", { className: K(Ds.overlayWrapper, e, { [Ds.overlayWrapperShadow]: m }) }, s && c && l && /*#__PURE__*/ t.createElement("div", { className: K(Ds.flipper, { [Ds.flipped]: u }) }), i && a && /*#__PURE__*/ t.createElement("div", {
	className: K(Ds.childWrapper, Ds.label, "d-flex flex-direction-column align-items-end", "justify-content-start"),
	"data-testid": o
}, /*#__PURE__*/ t.createElement(et, { className: Ds.previewLabel }, a)), (!!n || d) && /*#__PURE__*/ t.createElement("div", { className: K(Ds.childWrapper, "d-flex flex-direction-column align-items-stretch", {
	"justify-content-center": r,
	"justify-content-end": !r
}) }, d && /*#__PURE__*/ t.createElement(Os, {
	displayName: f,
	size: p === "small" ? p : "medium"
}), n)), As = ({ "aria-label": e, "data-testid": n, "wrapper-data-testid": r, children: i, className: o, isMirrored: s, isMobileDevice: c = !1, isVideoInputMuted: l, labelContent: u, labelTestId: d, localMediaStream: p, overlayClassName: m, shouldShowBorder: h, shouldShowErrorBorder: g = !1, shouldShowUserAvatar: _, showLabel: v, showOverlayShadow: y, sizeModifier: b, username: x, ...S }) => {
	let { t: C } = w(), T = ws(l, p), [E, D] = f(!1);
	return a(() => {
		T && D(!0);
	}, [T]), /*#__PURE__*/ t.createElement("div", {
		className: Ds.wrapper,
		...S
	}, /*#__PURE__*/ t.createElement(xt, {
		className: K(Ds.videoWrapper, {
			[Ds.withInfoBorder]: h,
			[Ds.withErrorBorder]: g
		}, o),
		size: b,
		background: "secondary",
		alignItems: "stretch",
		isFullHeight: !0,
		"data-testid": r ?? q.VideoSelfviewWrapper
	}, /*#__PURE__*/ t.createElement(bt, {
		"aria-label": e ?? C("media.selfview", "Selfview"),
		"data-testid": n ?? q.VideoSelfview,
		isMirrored: s,
		srcObject: p,
		disablePictureInPicture: c,
		muted: !0,
		className: K(Ds.video, { [Ds.hide]: !T })
	})), /*#__PURE__*/ t.createElement(ks, {
		className: m,
		isVideoInitiallyShown: E,
		labelContent: u,
		labelTestId: d,
		showLabel: v,
		showPlaceholder: !T && !g && _,
		showShadow: y,
		username: x
	}, i));
}, js = {
	selfviewAspectRatio: "_selfviewAspectRatio_8wap7_147",
	cameraStep: "_cameraStep_8wap7_155",
	readyToJoinExpress: "_readyToJoinExpress_8wap7_158",
	readyToJoinStep: "_readyToJoinStep_8wap7_162",
	forceLandscape: "_forceLandscape_8wap7_166"
};
// src/views/Selfview/AspectRatioSelfview/AspectRatioSelfview.tsx
function Ms(e) {
	return function(n) {
		let { aspectRatioType: r = "camera-step", aspectRatioWrapperClassName: i, ...a } = n;
		return /*#__PURE__*/ t.createElement(ge, { className: K(js.selfviewAspectRatio, {
			[js.cameraStep]: r === "camera-step",
			[js.readyToJoinStep]: r === "ready-to-join-step",
			[js.readyToJoinExpress]: r === "ready-to-join-express",
			[js.forceLandscape]: r === "force-landscape"
		}, i) }, /*#__PURE__*/ t.createElement(e, a));
	};
}
var Ns = Ms(As), Ps = {
	wrapper: "_wrapper_wdkwq_4",
	inner: "_inner_wdkwq_21",
	selfviewWrapper: "_selfviewWrapper_wdkwq_34",
	joinWrapper: "_joinWrapper_wdkwq_49",
	aspectRatio: "_aspectRatio_wdkwq_67"
}, Fs = ({ media: e, children: n }) => /*#__PURE__*/ t.createElement("div", { className: Ps.wrapper }, /*#__PURE__*/ t.createElement("div", { className: Ps.inner }, /*#__PURE__*/ t.createElement("div", { className: Ps.selfviewWrapper }, /*#__PURE__*/ t.createElement(ge, { className: Ps.aspectRatio }, e)), /*#__PURE__*/ t.createElement("div", { className: Ps.joinWrapper }, n))), Is = {
	wrapper: "_wrapper_txln1_29",
	phone: "_phone_txln1_32"
}, Ls = ({ children: e, isPhone: n, position: r, shouldCenter: i }) => /*#__PURE__*/ t.createElement(xe, {
	className: K(Is.wrapper, {
		[Is.phone]: n,
		"justify-content-center": i
	}),
	padding: r === "relative" && !n ? "medium" : "small",
	position: r
}, i ? /*#__PURE__*/ t.createElement(Le, {
	spacing: "compact",
	justifyContent: "center"
}, e) : e), Rs = {
	tooltipWrapper: "_tooltipWrapper_gpt3y_4",
	close: "_close_gpt3y_8"
}, zs = ({ ariaLabel: e, content: n, children: r, onClose: i, visible: a, ...o }) => {
	let { t: s } = w();
	return /*#__PURE__*/ t.createElement(t.Fragment, null, /*#__PURE__*/ t.createElement(qe, {
		isOpen: a,
		closeOnOutsideClick: !0,
		withCloseButton: !1,
		onClose: i,
		uniqueTitle: e,
		scrollbarsAriaLabel: s("common.scrollable-content", "Scrollable content"),
		...o
	}, n, /*#__PURE__*/ t.createElement(z, {
		size: "large",
		className: "mt-3",
		modifier: "fullWidth",
		onClick: i
	}, s("common.ok", "Ok"))), r);
}, Bs = ({ ariaLabel: e, content: n, children: r, visible: i, tooltipClassName: a, wrapperClassName: o, position: s, testid: c, ...l }) => /*#__PURE__*/ t.createElement(Xe, {
	zIndex: An,
	ariaLabel: e,
	className: a,
	header: void 0,
	text: "",
	controlledIsVisible: i,
	ctaText: /*#__PURE__*/ t.createElement("div", { className: "p-0" }, n),
	position: s,
	testIdInner: c,
	...l
}, r), Vs = ({ ariaLabel: e, isTouch: n = Ti(navigator.userAgent).isTouch, children: r, content: i, contentWrapperClassName: a, mainWrapperClassName: o, position: s = "topCenter", onClose: c, tooltipClassName: l, visible: u, testid: d, ...f }) => n ? /*#__PURE__*/ t.createElement(zs, {
	ariaLabel: e,
	content: i,
	visible: u,
	onClose: c,
	...f
}, r) : /*#__PURE__*/ t.createElement(Bs, {
	ariaLabel: e,
	visible: u,
	position: s,
	content: i,
	tooltipClassName: l,
	testid: d,
	...f
}, r), Hs = (e) => {
	let { t: n } = w();
	return /*#__PURE__*/ t.createElement(Je, {
		className: Rs.close,
		"aria-label": n("common.close-tooltip", "Close tooltip"),
		...e
	});
}, Us = {
	tooltipWrapper: "_tooltipWrapper_1y0pv_4",
	close: "_close_1y0pv_8",
	tryAgain: "_tryAgain_1y0pv_14"
}, Ws = ({ children: e, contentWrapperClassName: n, deniedDevice: r, setShowHelpVideo: i, learnHowToGrantAccessURL: a, permissionInfoType: o, mainWrapperClassName: s, onClose: c, visible: l, isTouch: u = Ti(navigator.userAgent).isTouch, ...d }) => {
	let { t: f } = w(), p = r === T.Camera ? f("media.you-blocked-access-tooltip.camera", "You blocked access to your camera") : r === T.Microphone ? f("media.you-blocked-access-tooltip.mic", "You blocked access to your microphone") : f("media.you-blocked-access-tooltip.camera-and-mic", "You blocked access to your camera & microphone"), m = /*#__PURE__*/ t.createElement(He, { className: K([u ? "pl-0 pr-0" : ""]) }, /*#__PURE__*/ t.createElement(W, { className: "pt-3 pb-1" }, /*#__PURE__*/ t.createElement(G, { fontVariant: V.BodyBold }, p), /*#__PURE__*/ t.createElement(Je, {
		className: Us.close,
		onClose: c,
		"aria-label": f("common.close-tooltip", "Close tooltip")
	})), /*#__PURE__*/ t.createElement(W, { className: "pt-0" }, (o === sn.Complete || o === sn.CompleteReload) && /*#__PURE__*/ t.createElement(G, null, /*#__PURE__*/ t.createElement(C, {
		t: f,
		i18nKey: "media.permissions-help-video-link"
	}, "To grant access please follow the steps in", " ", /*#__PURE__*/ t.createElement(pt, {
		isUnderlined: !0,
		onClick: () => i(!0),
		target: "_blank",
		"data-testid": q.TextLinkUnblockPermissionsVideo
	}, "this short video")), " ", /*#__PURE__*/ t.createElement(C, {
		t: f,
		i18nKey: "media.learn-how-to-grant-access"
	}, " ", "or go to the", " ", /*#__PURE__*/ t.createElement(pt, {
		isUnderlined: !0,
		href: a,
		target: "_blank",
		"data-testid": q.TextLinkLearnRequestPermissions
	}, "privacy settings"), " ", "of your browser")), o === sn.Void && /*#__PURE__*/ t.createElement(G, null, f("media.other-browsers-privacy-settings", "To grant access please go to the privacy settings of your browser or try to refresh the page."))));
	return /*#__PURE__*/ t.createElement(Vs, {
		ariaLabel: p,
		isTouch: u,
		mainWrapperClassName: s,
		onClose: c,
		contentWrapperClassName: n,
		visible: l,
		...d,
		content: m
	}, e);
}, Gs = ({ hasAudioVideoError: e, hasError: n, icon: r, variant: i = "translucent", isActive: a, ...o }) => {
	let s = o.isDisabled ? "translucent" : e || n ? "danger" : i;
	return /*#__PURE__*/ t.createElement(z, {
		modifier: "square",
		size: "medium",
		isActive: a,
		variant: s,
		...o
	}, r);
}, Ks = ({ iconSize: e, isTooltipVisible: n, tooltipPosition: r = "top", isBlurred: i, ...a }) => {
	let { t: o } = w(), s = o("media.background-effects-action", "Change background effect"), c = /*#__PURE__*/ t.createElement(Gs, {
		...a,
		"aria-label": s,
		icon: /*#__PURE__*/ t.createElement(H, {
			source: U.IconBackgroundReplace,
			size: e
		}),
		isActive: i
	});
	return n ? /*#__PURE__*/ t.createElement(_t, {
		text: s,
		position: r
	}, c) : c;
}, qs = ({ control: e, inputStatusInfo: n, isSuspended: r, isTooltipVisible: i, learnHowToGrantAccessURL: a, permissionInfoType: o, requestMediaPermissions: s, setIsTooltipVisible: c, setShowHelpVideo: l, testIdCloseButton: u, toolTipTestId: d, tooltipPosition: f = "topEnd", ...p }) => {
	let { t: m } = w(), h = e && !n?.error && !n?.warning ? e : /*#__PURE__*/ t.createElement(Gs, {
		...p,
		variant: r ? "translucent" : p.variant
	});
	return n?.error && n?.controls === "permissions" ? /*#__PURE__*/ t.createElement(Ws, {
		deniedDevice: n.error,
		onClose: () => c(!i),
		visible: i,
		"data-testid": q.TooltipDeniedDevice,
		setShowHelpVideo: l,
		learnHowToGrantAccessURL: a,
		permissionInfoType: o
	}, h) : /*#__PURE__*/ t.createElement(Xe, {
		zIndex: An,
		controlledIsVisible: i && !!(n?.title || n?.message),
		controlledOnChange: c,
		ctaText: n?.retriable ? /*#__PURE__*/ t.createElement(z, {
			className: "px-3",
			isLoading: p.isLoading,
			onClick: () => {
				c(!1), s();
			},
			size: "small",
			variant: "primary",
			enhancerStart: /*#__PURE__*/ t.createElement(H, {
				colorScheme: "dark",
				source: U.IconRefresh
			})
		}, m("common.try-again", "Try again")) : void 0,
		header: n?.title,
		position: f,
		testIdCloseButton: u,
		testIdInner: d,
		text: n?.message ?? "",
		closeButtonAriaLabel: m("common.close-tooltip", "Close tooltip")
	}, h);
}, Js = ({ audioInputControl: e, enhancerEnd: n, inputStatusInfo: r, isAudioInputMuted: i, isAudioInputSuspended: o, isAudioInputUnavailable: s, isBlurred: c, isMobileDevice: l = !1, isRequestingAudio: u, isRequestingVideo: d, isVideoInputMuted: p, isVideoInputSuspended: m, isVideoInputUnavailable: h, learnHowToGrantAccessURL: g, permissionInfoType: _, requestAudioPermissions: v, requestVideoPermissions: y, segmentationEnabled: b, setShowHelpVideo: x, silentTooltipInfo: S, streamStatus: C, toggleAudioInput: T, toggleBlur: E, toggleFacingMode: D, toggleVideoInput: O, ...k }) => {
	let { t: A } = w(), { audioProps: j, videoProps: M, audioWarning: N, videoWarning: P, isAudioIconMuted: F, isVideoIconMuted: I } = ja({
		isAudioInputMuted: i,
		isVideoInputMuted: p,
		inputStatusInfo: r,
		iconSize: "medium"
	}), ne = Aa(o, m), R = r.audio.error || r.audio.warning ? r.audio : void 0, ie = ne.audio ?? R, ae = ie ?? S, oe = ne.video ?? (r.video.error || r.video.warning ? r.video : void 0), se = oe, ce = !!ae?.retriable, le = !!se?.retriable, [ue, de] = f(!!(N || ie && s)), [fe, pe] = f(!!(P || oe && h));
	a(() => {
		de(!o && !!(N || S || ie && s));
	}, [
		ie,
		N,
		o,
		s,
		S
	]), a(() => {
		pe(!!(P || oe && h));
	}, [
		h,
		oe,
		P
	]);
	let [me, he] = f(!0);
	a(() => {
		C && !te(C) && !(L(C) && ee(C) && re(C)) && he(p || !!r.video.error || !!P);
	}, [
		r.video.error,
		p,
		C,
		P
	]);
	let ge = {
		size: "large",
		tooltipPosition: l ? "topCenter" : "topEnd"
	}, _e = T, ve = O;
	return ie && (_e = () => de((e) => !e)), oe && (ve = () => pe((e) => !e)), /*#__PURE__*/ t.createElement(Le, {
		spacing: l ? "small" : "medium",
		justifyContent: "center",
		...k
	}, !l && !!b && /*#__PURE__*/ t.createElement(Ks, {
		variant: "transparentAlternative",
		size: "large",
		isBlurred: c,
		isDisabled: h || me,
		onClick: E,
		iconSize: "medium",
		"data-testid": c ? q.ButtonBackgroundEffectsOn : q.ButtonBackgroundEffectsOff
	}), D && /*#__PURE__*/ t.createElement(z, {
		"aria-label": A("media.flip-camera", "Flip camera"),
		"data-testid": q.ButtonFlipCamera,
		modifier: "square",
		onClick: D,
		size: "large",
		variant: "transparentAlternative",
		disabled: p,
		isLoading: d
	}, /*#__PURE__*/ t.createElement(H, {
		source: U.IconFlipCamera,
		size: "medium"
	})), n && n, /*#__PURE__*/ t.createElement(qs, {
		...j,
		...ge,
		isDisabled: s && !ce,
		isLoading: u,
		isSuspended: o,
		isTooltipVisible: (!s || !!ie) && ue,
		setIsTooltipVisible: de,
		toolTipTestId: q.NotificationToolTipAudioProblem,
		"data-testid": F ? q.ButtonAudioMeterMuted : q.ButtonAudioMeter,
		onClick: _e,
		requestMediaPermissions: v,
		testIdCloseButton: q.NotificationToolTipAudioCloseButton,
		variant: "transparentAlternative",
		control: e,
		inputStatusInfo: ae,
		setShowHelpVideo: x,
		learnHowToGrantAccessURL: g,
		permissionInfoType: _
	}), /*#__PURE__*/ t.createElement(qs, {
		...M,
		...ge,
		isDisabled: h && !le,
		isLoading: d,
		isSuspended: m,
		isTooltipVisible: (!h || !!oe) && fe,
		setIsTooltipVisible: pe,
		toolTipTestId: q.NotificationToolTipVideoProblem,
		"data-testid": I ? q.ButtonVideoinputMuted : q.ButtonVideoInput,
		onClick: ve,
		requestMediaPermissions: y,
		testIdCloseButton: q.NotificationToolTipVideoCloseButton,
		variant: "transparentAlternative",
		inputStatusInfo: se,
		setShowHelpVideo: x,
		learnHowToGrantAccessURL: g,
		permissionInfoType: _
	}));
}, Ys = ({ audioInputControl: e, inputStatusInfo: n, isAudioInputMuted: r, isAudioInputSuspended: i, isAudioInputUnavailable: a, isBlurred: o, isMobileDevice: s, isRequestingAudio: c, isRequestingVideo: l, isVideoInputMuted: u, isVideoInputSuspended: d, isVideoInputUnavailable: f, learnHowToGrantAccessURL: p, permissionInfoType: m, requestAudioPermissions: h, requestVideoPermissions: g, segmentationEnabled: _, setShowHelpVideo: v, shouldCenter: y, shouldShowVideoStatus: b, silentTooltipInfo: x, streamStatus: S, toggleAudioInput: C, toggleBlur: w, toggleFacingMode: T, toggleVideoInput: E }) => /*#__PURE__*/ t.createElement(Ls, {
	position: b ? "relative" : "absoluteBottom",
	isPhone: s,
	shouldCenter: y
}, /*#__PURE__*/ t.createElement(Js, {
	audioInputControl: e,
	inputStatusInfo: n,
	isAudioInputMuted: r,
	isAudioInputSuspended: i,
	isAudioInputUnavailable: a,
	isBlurred: o,
	isMobileDevice: s,
	isRequestingAudio: c,
	isRequestingVideo: l,
	isVideoInputMuted: u,
	isVideoInputSuspended: d,
	isVideoInputUnavailable: f,
	learnHowToGrantAccessURL: p,
	permissionInfoType: m,
	requestAudioPermissions: h,
	requestVideoPermissions: g,
	segmentationEnabled: _,
	setShowHelpVideo: v,
	silentTooltipInfo: x,
	streamStatus: S,
	toggleAudioInput: C,
	toggleBlur: w,
	toggleFacingMode: T,
	toggleVideoInput: E
})), Xs = {
	selfView: "_selfView_1tpp7_1",
	portrait: "_portrait_1tpp7_8",
	withVideo: "_withVideo_1tpp7_8"
}, Zs = {
	width: 9,
	height: 16
}, Qs = {
	width: 16,
	height: 9
}, $s = ({ children: e, isPhone: n, media: r, shouldShowAspectRatio: i }) => {
	let { t: a } = w(), { isPortrait: o } = Oo();
	return /*#__PURE__*/ t.createElement(Pe, {
		background: "dark",
		flexDirection: "column",
		justifyContent: n ? "flexStart" : "center",
		padding: "none"
	}, /*#__PURE__*/ t.createElement($e, {
		"aria-label": a("common.label-pexip-logo", "Pexip logo"),
		className: "mb-5 mt-4",
		colorScheme: "dark",
		size: "small"
	}), /*#__PURE__*/ t.createElement(ft, {
		className: n ? "mb-4" : "mb-5",
		fontVariant: V.H4,
		htmlTag: "h1"
	}, /*#__PURE__*/ t.createElement(C, {
		t: a,
		i18nKey: "preflight.get-ready"
	}, "Get ready for your meeting")), /*#__PURE__*/ t.createElement("div", { className: K(Xs.selfView, {
		[Xs.portrait]: o,
		[Xs.withVideo]: i
	}) }, /*#__PURE__*/ t.createElement(ge, {
		className: "justify-content-center",
		dimensions: o ? Zs : Qs,
		isActive: i
	}, r)), e);
}, ec = {
	videoStatus: "_videoStatus_1tiqs_1",
	phone: "_phone_1tiqs_9"
}, tc = ({ title: e, body: n, isPhone: r, ...i }) => /*#__PURE__*/ t.createElement("div", { className: K(ec.videoStatus, {
	[ec.phone]: r,
	"pl-5": !r,
	"px-4": r
}) }, /*#__PURE__*/ t.createElement(ft, {
	className: "pb-1",
	htmlTag: "h5",
	"data-testid": i["heading-data-testid"] ?? q.VideoStatusTitle
}, e), /*#__PURE__*/ t.createElement(G, {
	variant: "tinted",
	"data-testid": i["body-data-testid"] ?? q.VideoStatusBody
}, n)), nc = {
	preflightSelfViewWrapper: "_preflightSelfViewWrapper_1xbjx_215",
	mobile: "_mobile_1xbjx_222",
	hideBackground: "_hideBackground_1xbjx_227"
}, rc = (e) => {
	let { aspectRatioType: n = "camera-step", isMobileDevice: r = !1, isVideoInputMuted: i, shouldShowErrorBorder: a, streamStatus: o, preflightControls: s, effectsManagerView: c, requestedVideo: l = !0, requestedAudio: u = !0, ...d } = e, f = wa(Ca(e.streamStatus, {
		audio: u,
		video: l
	})), p = Ts(i, o) || !l, m = l && o && te(o);
	return /*#__PURE__*/ t.createElement("div", { className: nc.preflightSelfViewWrapper }, /*#__PURE__*/ t.createElement(Ns, {
		isVideoInputMuted: i,
		...d,
		shouldShowUserAvatar: p,
		shouldShowErrorBorder: a,
		className: K({ [nc.hideBackground]: r && m }),
		aspectRatioType: n
	}, m && /*#__PURE__*/ t.createElement(tc, {
		title: f.title,
		body: f.message,
		"data-testid": q.VideoStatus,
		isPhone: r
	}), c, !c && s));
}, ic = (e) => {
	let { level: t = 0, peak: n = 0, enabled: r = !0, isHoveringButton: i } = e, a = r ? "enabled" : `disabled-${i ? "hovering" : "not-hovering"}`;
	return `linear-gradient(
        to top,
        var(--mic-button-${a}-background-color-dark) 0% ${t}%,
        var(--mic-button-${a}-background-color-light) ${t}% ${n}%,
        var(--mic-button-${a}-background-color) ${n}% 100%)`;
}, ac = (e = 0, t = 3e3, n = 0) => {
	let r, i = e, a = n, o = () => {
		r?.();
	}, s = (e = 0) => new Promise((n, s) => {
		r = s, i > e ? a > 0 ? n({
			level: e,
			peak: i
		}) : a = window.setTimeout(() => {
			a = 0, clearTimeout(a), i = 0, n({
				level: e,
				peak: 0
			}), o();
		}, t) : (i = e, n({
			level: e,
			peak: 0
		}));
	});
	return s.cancel = o, s;
}, oc = {
	enabled: "_enabled_1n0g5_19",
	disabled: "_disabled_1n0g5_23"
}, sc = ac(), cc = ({ level: e, hasAudioVideoError: n, hasError: i, isMuted: o, ...s }) => {
	let [c, l] = f(""), [u, d] = f(!1), p = r((e) => {
		e.pointerType !== "touch" && d(!0);
	}, []), m = r((e) => {
		e.pointerType !== "touch" && d(!1);
	}, []);
	return a(() => {
		let t = !1;
		return sc(e).then((e) => {
			t || l(ic({
				...e,
				enabled: !o,
				isHoveringButton: u
			}));
		}).catch(() => {}), () => {
			t = !0, sc?.cancel();
		};
	}, [
		o,
		u,
		e
	]), /*#__PURE__*/ t.createElement(Gs, {
		style: n || i ? {} : { backgroundImage: c },
		className: K(oc[o ? "disabled" : "enabled"]),
		variant: "transparentAlternative",
		size: "large",
		hasAudioVideoError: n,
		hasError: i,
		onPointerEnter: p,
		onPointerLeave: m,
		...s
	});
}, lc = (e) => {
	let { t: n } = w(), r = n("media.host-muted-you", "The host has muted you.");
	return /*#__PURE__*/ t.createElement(Vs, {
		ariaLabel: r,
		content: /*#__PURE__*/ t.createElement(He, { className: "p-0" }, /*#__PURE__*/ t.createElement(W, { className: "pt-0 pb-1" }, /*#__PURE__*/ t.createElement(G, { fontVariant: V.BodyBold }, r), /*#__PURE__*/ t.createElement(Hs, { onClose: e.onClose })), /*#__PURE__*/ t.createElement(W, { className: "pt-0" }, /*#__PURE__*/ t.createElement(G, null, /*#__PURE__*/ t.createElement(C, {
			t: n,
			i18nKey: "media.host-muted-you-descriptions"
		}, "You will be able to unmute yourself once the host has given you permission."), " "))),
		position: "topEnd",
		testid: q.TooltipMuteDisabled,
		...e
	});
}, uc = { autoHideTooltip: "_autoHideTooltip_hvk6d_1" }, dc = ({ canMute: e = !0, errorTooltipCloseBtnTestID: n, errorTooltipTestID: r, inputStatusInfo: i, isSuspended: a, learnHowToGrantAccessURL: o, permissionInfoType: s, requestDeviceAgain: c, setShowHelpVideo: l, shouldShowTooltip: u = !0, showDeniedDeviceTooltip: d = !1, size: f = "large", toggleTooltip: p, tooltipClassName: m, tooltipPosition: h = "top", tooltipText: g, variant: _ = "translucent", ...v }) => {
	let { t: y } = w();
	return e ? i?.error && i?.controls === "permissions" && l ? /*#__PURE__*/ t.createElement(Ws, {
		"data-testid": q.TooltipDeniedDevice,
		deniedDevice: i.error,
		learnHowToGrantAccessURL: o,
		permissionInfoType: s,
		visible: d,
		setShowHelpVideo: l,
		tooltipClassName: uc.autoHideTooltip
	}, /*#__PURE__*/ t.createElement(Gs, {
		variant: _,
		size: f,
		...v
	})) : i?.error || i?.warning ? /*#__PURE__*/ t.createElement(Xe, {
		zIndex: An,
		className: K(uc.autoHideTooltip, m),
		controlledIsVisible: u,
		controlledOnChange: p,
		ctaFn: i.retriable && c ? c : void 0,
		ctaText: i.retriable ? /*#__PURE__*/ t.createElement(z, {
			className: "px-3",
			isLoading: v.isLoading,
			onClick: c,
			size: "small",
			variant: "primary",
			enhancerStart: /*#__PURE__*/ t.createElement(H, {
				colorScheme: "dark",
				source: U.IconRefresh
			})
		}, y("common.try-again", "Try again")) : void 0,
		header: i.title,
		position: "topEnd",
		testIdCloseButton: n,
		testIdInner: r,
		role: "tooltip",
		text: i.message,
		"aria-label": v["aria-label"],
		closeButtonAriaLabel: y("common.close-tooltip", "Close tooltip")
	}, /*#__PURE__*/ t.createElement(Gs, {
		variant: a ? "translucent" : _,
		size: f,
		...v,
		onClick: p
	})) : g ? /*#__PURE__*/ t.createElement(_t, {
		text: g,
		position: h,
		className: K(uc.autoHideTooltip, m),
		role: "tooltip",
		"aria-label": v["aria-label"]
	}, /*#__PURE__*/ t.createElement(Gs, {
		size: f,
		variant: _,
		...v
	})) : /*#__PURE__*/ t.createElement(Gs, {
		size: f,
		variant: _,
		...v
	}) : /*#__PURE__*/ t.createElement(lc, {
		onClose: p,
		tooltipClassName: uc.autoHideTooltip,
		visible: u
	}, /*#__PURE__*/ t.createElement(Gs, {
		variant: _,
		size: f,
		...v,
		onClick: p
	}));
}, fc = ({ isFeccHidden: e, iconSource: n, tooltipPosition: r = "top", onClickFecc: i, ...a }) => {
	let { t: o } = w();
	return e ? null : /*#__PURE__*/ t.createElement(dc, {
		icon: /*#__PURE__*/ t.createElement(ut, {
			size: "small",
			source: n
		}),
		"aria-label": o("fecc.camera-control", "Camera control"),
		tooltipText: o("fecc.camera-control", "Camera control"),
		tooltipPosition: r,
		onClick: i,
		...a
	});
}, pc = ({ isHandRaised: e, isRaiseHandHidden: n = !1, onRaiseHand: r, iconSize: i, tooltipPosition: a = "top", ...o }) => {
	let { t: s } = w(), c = So("R");
	if (n) return null;
	let l = e ? s("common.lower-hand", "Lower hand") : s("common.raise-hand", "Raise hand"), u = c ? `${l} ${c}` : l;
	return /*#__PURE__*/ t.createElement(dc, {
		icon: /*#__PURE__*/ t.createElement(H, {
			source: U.IconRaiseHand,
			size: i
		}),
		"aria-label": u,
		tooltipText: u,
		tooltipPosition: a,
		onClick: () => r(!e),
		isActive: e,
		"data-testid": e ? q.ButtonLowerHand : q.ButtonRaiseHand,
		...o
	});
}, mc = ({ localIsPresenting: e, tooltipPosition: n = "top", iconSize: r, isDisabled: i = !1, disabledReason: a, startPresentation: o, stopPresentation: s, ...c }) => {
	let { t: l } = w(), u = Ft(), d = So("P"), f = (e ? "stop" : "start") == "stop", p = f ? l("media.presentation.stop-share-screen", "Stop sharing") : l("media.presentation.share-screen", "Share screen"), m = i && a ? a : p, h = !f && !i && d ? `${m} ${d}` : m;
	return /*#__PURE__*/ t.createElement(dc, {
		onClick: () => e ? s() : o(),
		"aria-label": h,
		tooltipText: h,
		tooltipPosition: n,
		icon: /*#__PURE__*/ t.createElement(H, {
			source: U.IconShare,
			size: r
		}),
		isActive: e,
		shouldShowTooltip: !u,
		"data-testid": f ? q.ButtonStopPresentation : q.ButtonStartPresentation,
		isDisabled: i,
		...c
	});
}, hc = {
	callControlsWrapper: "_callControlsWrapper_13pki_4",
	desktopWrapper: "_desktopWrapper_13pki_15",
	desktopMediaBtnWrapper: "_desktopMediaBtnWrapper_13pki_22",
	desktopLeaveBtn: "_desktopLeaveBtn_13pki_28",
	desktopLeaveBtnWrapper: "_desktopLeaveBtnWrapper_13pki_34",
	desktopLeaveText: "_desktopLeaveText_13pki_44",
	touchWrapper: "_touchWrapper_13pki_49",
	touchCallControlBtnWrapper: "_touchCallControlBtnWrapper_13pki_54",
	moreMenu: "_moreMenu_13pki_61",
	moreMenuItem: "_moreMenuItem_13pki_69",
	moreMenuBadge: "_moreMenuBadge_13pki_73"
}, gc = ({ items: e, isTouch: n = !1, ...r }) => /*#__PURE__*/ t.createElement(he, {
	items: e,
	popoverPlacement: n ? "top" : "right",
	popoverOffset: n ? 30 : 19,
	menuClassName: hc.moreMenu,
	itemClassName: hc.moreMenuItem,
	...r
}), _c = ({ items: e, onOpenChange: n, isTouch: r = !1, isMobile: i = !1, children: a, ...o }) => {
	let [s, c] = f(!1), { t: l, i18n: u } = w(), d = Fi(u), p = l("meeting.more-controls", "More controls");
	return /*#__PURE__*/ t.createElement(gc, {
		items: e,
		onOpenChange: (e) => {
			c(e), n?.(e);
		},
		button: /*#__PURE__*/ t.createElement(z, {
			isActive: s,
			"aria-label": p,
			modifier: "square",
			"data-testid": q.ButtonToolbarMoreItems,
			variant: r ? "neutral" : "translucent",
			size: "large"
		}, /*#__PURE__*/ t.createElement(H, {
			source: i ? U.IconMoreHorizontal : U.IconMoreVertical,
			size: i ? "medium" : void 0
		}), a),
		isTouch: r,
		renderButton: (e) => /*#__PURE__*/ t.createElement(_t, {
			text: p,
			role: "tooltip",
			position: r ? "top" : d === "rtl" ? "left" : "right"
		}, e),
		...o
	});
}, vc = {
	footer: "_footer_1yjuf_40",
	phone: "_phone_1yjuf_47",
	start: "_start_1yjuf_59",
	middle: "_middle_1yjuf_60",
	end: "_end_1yjuf_64"
}, yc = ({ className: e, children: n, position: r = "middle", isPhone: i = !1, ...a }) => /*#__PURE__*/ t.createElement("div", {
	className: K(vc.footer, i && vc.phone, vc[r], e),
	...a
}, n), bc = {
	toolbar: "_toolbar_1ax2v_112",
	withBoxShadow: "_withBoxShadow_1ax2v_129",
	withSidePanel: "_withSidePanel_1ax2v_133",
	core: "_core_1ax2v_149"
}, xc = ({ core: e, withSidePanel: n = !1, withBoxShadow: r = !0, className: i, ...a }) => /*#__PURE__*/ t.createElement(xe, {
	flexDirection: "column",
	className: K(bc.toolbar, {
		[bc.withSidePanel]: n,
		[bc.withBoxShadow]: r
	}, i),
	...a
}, e && /*#__PURE__*/ t.createElement("div", { className: bc.core }, e)), Sc = {
	foldedSelfview: "_foldedSelfview_1df2f_15",
	inheritCursor: "_inheritCursor_1df2f_21",
	notificationTooltipInner: "_notificationTooltipInner_1df2f_25",
	selfviewBtnTooltipContainer: "_selfviewBtnTooltipContainer_1df2f_29",
	foldedSelfviewButton: "_foldedSelfviewButton_1df2f_33",
	disabled: "_disabled_1df2f_36",
	disabledIcon: "_disabledIcon_1df2f_42",
	indicator: "_indicator_1df2f_46",
	indicatorIcon: "_indicatorIcon_1df2f_50",
	button: "_button_1df2f_54",
	buttonIcon: "_buttonIcon_1df2f_57"
}, Cc = ({ icon: e, iconClassName: n, isDisabled: r, isMobileDevice: i, onClick: a, tooltipPosition: o = "topEnd", tooltipText: s, variant: c = "translucent", tooltipContainerClassName: l = Sc.selfviewBtnTooltipContainer, iconSize: u, className: d, ...f }) => {
	let p = /*#__PURE__*/ t.createElement(z, {
		onClick: a,
		className: K(Sc.foldedSelfviewButton, { [Sc.disabled]: r }, d),
		variant: c,
		modifier: "square",
		...f
	}, /*#__PURE__*/ t.createElement(H, {
		source: e,
		className: K(r && Sc.disabledIcon, n),
		size: u ?? (i ? "compact" : "small")
	}));
	return r || i || !s ? p : /*#__PURE__*/ t.createElement(_t, {
		text: s,
		position: o,
		onPointerDownCapture: Mr(a !== void 0),
		tooltipContainerClassName: l
	}, p);
}, wc = ({ isAudioInputMuted: e, isVideoInputMuted: n, isAudioInputMissing: r, isVideoInputMissing: i, isAudioInputDisabled: a, isMobileDevice: o, onExpandSelfview: s, showSelfviewTooltip: c, setShowSelfviewTooltip: l, notificationTooltipPos: u = "bottomEnd", selfviewBtnTooltipPos: d = "topEnd", expandSelfView: f }) => {
	let { t: p } = w(), m = e ? p("media.unmute-microphone", "Unmute microphone") : p("media.mute-microphone", "Mute microphone"), h = p("meeting.show-self-view", "Show self-view"), g = p("media.turn-camera-on", "Turn camera on"), _ = p("meeting.folded-selfview.drag", "Move self-view"), v = e || r;
	return /*#__PURE__*/ t.createElement(Xe, {
		zIndex: An,
		controlledIsVisible: c && !n && !i,
		controlledOnChange: l,
		header: p("settings.selfview-hidden", "Self-view hidden"),
		position: u,
		testIdInner: q.NotificationTooltipSelfviewHidden,
		text: p("settings.collapsed-selfview-tooltip-description", "You’re still sending video to other people in the meeting"),
		closeButtonAriaLabel: p("common.close-tooltip", "Close tooltip"),
		stopPointerDownPropagation: !0,
		className: Sc.notificationTooltipInner
	}, /*#__PURE__*/ t.createElement(Se, {
		className: K(Sc.foldedSelfview, "foldedSelfviewGlobal"),
		"data-testid": q.FoldedSelfview
	}, /*#__PURE__*/ t.createElement(Cc, {
		"data-drag-handle": !0,
		"data-testid": q.ButtonDragFoldedSelfview,
		icon: U.IconDraggable,
		"aria-label": _,
		className: K(Sc.inheritCursor, Sc.button),
		iconClassName: Sc.buttonIcon
	}), v && /*#__PURE__*/ t.createElement(Cc, {
		"data-testid": q.ButtonToggleAudioInFoldedSelfview,
		"aria-label": m,
		isDisabled: a || r,
		icon: v ? U.IconMicrophoneOff : U.IconMicrophoneOn,
		htmlTag: "div",
		noHover: !0,
		className: Sc.indicator,
		iconClassName: Sc.indicatorIcon
	}), (n || i) && /*#__PURE__*/ t.createElement(Cc, {
		"data-testid": q.ButtonToggleVideoInFoldedSelfview,
		"aria-label": g,
		icon: U.IconVideoOff,
		isDisabled: i,
		htmlTag: "div",
		noHover: !0,
		className: Sc.indicator,
		iconClassName: Sc.indicatorIcon
	}), !f && !(n || i) && /*#__PURE__*/ t.createElement(Cc, {
		onClick: s,
		"data-testid": q.ButtonExpandSelfview,
		tooltipText: o ? void 0 : h,
		tooltipPosition: d,
		"aria-label": h,
		icon: U.IconPasswordShow,
		className: Sc.button,
		iconClassName: Sc.buttonIcon
	})));
}, Tc = {
	header: "_header_1jh3u_32",
	footer: "_footer_1jh3u_33",
	selfviewOverlay: "_selfviewOverlay_1jh3u_38",
	forceHover: "_forceHover_1jh3u_44",
	collapseSelfviewButton: "_collapseSelfviewButton_1jh3u_49",
	effectsButton: "_effectsButton_1jh3u_50",
	expandSelfviewButton: "_expandSelfviewButton_1jh3u_54",
	mobile: "_mobile_1jh3u_58",
	mutedMicrophoneIndicator: "_mutedMicrophoneIndicator_1jh3u_73",
	headerControls: "_headerControls_1jh3u_83"
}, Ec = ({ isMobileDevice: e, isMaximized: n, controlsVisible: r, onClick: i, setIsMaximized: a, areEffectsApplied: o, areEffectsEnabled: s, openEffects: c }) => {
	let { t: l } = w();
	return /*#__PURE__*/ t.createElement(xe, {
		className: Tc.header,
		position: "absoluteTop",
		flexDirection: n ? "row" : "rowReverse"
	}, n ? /*#__PURE__*/ t.createElement(z, {
		colorScheme: "light",
		variant: "secondary",
		onClick: () => a?.(!1),
		onPointerDownCapture: Mr()
	}, l("common.close", "Close")) : (!e || r) && /*#__PURE__*/ t.createElement("div", { className: Tc.headerControls }, /*#__PURE__*/ t.createElement(Cc, {
		onClick: i,
		onPointerDownCapture: Mr(),
		onTouchStartCapture: (e) => e.stopPropagation(),
		"data-testid": q.ButtonCollapseSelfview,
		tooltipText: l("meeting.hide-self-view", "Hide self-view"),
		"aria-label": l("meeting.hide-self-view", "Hide self-view"),
		className: K(Tc.collapseSelfviewButton, e && Tc.mobile),
		backgroundTransparency: .75,
		icon: U.IconPasswordHide,
		isMobileDevice: e,
		variant: "neutral",
		colorScheme: "dark",
		noHover: e,
		style: { color: "#fff" },
		size: "medium",
		iconSize: e ? "medium" : "small"
	}), s && /*#__PURE__*/ t.createElement(Cc, {
		"aria-label": l("media.background-effects-action", "Change background effect"),
		tooltipText: l("media.background-effects-action", "Change background effect"),
		tooltipPosition: "bottomEnd",
		onClick: c,
		isActive: o,
		icon: U.IconBackgroundReplace,
		onPointerDownCapture: Mr(!0),
		onTouchStartCapture: (e) => e.stopPropagation(),
		isMobileDevice: e,
		className: K(Tc.effectsButton, e && Tc.mobile),
		backgroundTransparency: .75,
		"data-testid": o ? q.ButtonMeetingBackgroundEffectsOn : q.ButtonMeetingBackgroundEffectsOff,
		size: "medium",
		variant: "neutral",
		noHover: e,
		iconSize: e ? "medium" : "small"
	})));
}, Dc = { disabled: "_disabled_qb7es_1" }, Oc = ({ ariaLabel: e, className: n, children: r, iconClassName: i, isDisabled: a, isActive: o, isMobileDevice: s, onClick: c, onPointerDownCapture: l, source: u, ...d }) => /*#__PURE__*/ t.createElement(z, {
	modifier: "square",
	size: s ? "medium" : "compact",
	variant: "neutral",
	className: K({ [Dc.disabled]: a }, n),
	"aria-label": e,
	disabled: a || !1,
	isActive: o,
	onClick: c,
	onPointerDownCapture: l,
	noHover: s || a || !0,
	...d
}, r || /*#__PURE__*/ t.createElement(H, {
	source: u || U.IconAdd,
	size: s ? "medium" : "small",
	className: i
})), kc = ({ isMaximized: e, setIsMaximized: n, controlsVisible: r, isAudioInputMuted: i, isAudioInputDisabled: a = !1, isMobileDevice: o, areEffectsApplied: s, toggleFacingMode: c }) => /*#__PURE__*/ t.createElement(xe, {
	className: Tc.footer,
	position: "absoluteBottom"
}, i && !e && /*#__PURE__*/ t.createElement(H, {
	className: K(o && "mr-1", { "visibility-hidden": a }, Tc.mutedMicrophoneIndicator),
	color: Ee.White,
	source: U.IconMicrophoneOff,
	size: "compact"
}), /*#__PURE__*/ t.createElement(Le, {
	spacing: "compact",
	justifyContent: "center",
	modifier: "fullWidth"
}, o && e && /*#__PURE__*/ t.createElement(Oc, {
	onClick: c,
	source: U.IconFlipCamera,
	isMobileDevice: o,
	className: K(o && Tc.mobile),
	onPointerDownCapture: Mr(!0),
	onTouchStartCapture: (e) => e.stopPropagation(),
	variant: "neutral",
	noHover: o,
	backgroundTransparency: .75,
	"data-testid": q.ButtonFlipCameraInMeetingSelfview
}), !e && o && r && /*#__PURE__*/ t.createElement(Oc, {
	onClick: () => n?.(!e),
	isActive: s,
	source: U.IconFullscreenOn,
	onPointerDownCapture: Mr(!0),
	onTouchStartCapture: (e) => e.stopPropagation(),
	isMobileDevice: o,
	className: K(o && "ml-1", Tc.expandSelfviewButton, o && Tc.mobile),
	variant: "neutral",
	noHover: o,
	backgroundTransparency: .75
}))), Ac = ({ overlayClassName: e, isAudioInputMuted: n, isAudioInputDisabled: r, isMobileDevice: i, quality: a, forceHover: o = !1, areEffectsEnabled: s, areEffectsApplied: c, isMaximized: l, onCollapseSelfview: u, toggleFacingMode: d, openEffects: p, setIsMaximized: m, effectsManagerView: h, ...g }) => {
	let [_, v] = f(!i), y = () => {
		v((e) => !e);
	};
	return /*#__PURE__*/ t.createElement(Ns, {
		isMobileDevice: i,
		aspectRatioType: "in-meeting",
		overlayClassName: K(Tc.selfviewOverlay, e, { [Tc.forceHover]: o }),
		onTouchStart: y,
		showOverlayShadow: i && (_ || l),
		...g
	}, h, !h && /*#__PURE__*/ t.createElement(t.Fragment, null, /*#__PURE__*/ t.createElement(Ec, {
		onClick: u,
		isMobileDevice: i,
		isMaximized: l,
		setIsMaximized: m,
		controlsVisible: _,
		openEffects: p,
		areEffectsApplied: c,
		areEffectsEnabled: s
	}), /*#__PURE__*/ t.createElement(kc, {
		isAudioInputMuted: n,
		isAudioInputDisabled: r,
		isMobileDevice: i,
		quality: a,
		areEffectsApplied: c,
		toggleFacingMode: d,
		controlsVisible: _,
		isMaximized: l,
		setIsMaximized: m
	})));
}, jc = (e, t = 300) => {
	let n = d(0);
	return r((r) => {
		r.preventDefault();
		let i = Date.now(), a = i - n.current;
		n.current > 0 && a < t && e(r), n.current = i;
	}, [e, t]);
}, Mc = {
	light: "_light_1i8o8_205",
	dark: "_dark_1i8o8_211",
	pip: "_pip_1i8o8_299",
	effectsManagerDesktopPip: "_effectsManagerDesktopPip_1i8o8_317",
	foldedSelfviewWrapper: "_foldedSelfviewWrapper_1i8o8_326",
	inMeetingSelfviewPosition: "_inMeetingSelfviewPosition_1i8o8_344",
	maximized: "_maximized_1i8o8_350",
	maximizedMask: "_maximizedMask_1i8o8_375"
}, Nc = ({ isFolded: e, draggableAriaLabel: n, testId: i, floatRoot: o, isSidePanelVisible: s, onMouseEnter: l, onMouseLeave: u, onFocus: p, onBlur: m, expandSelfView: h, ...g }) => {
	let _ = d(null), v = d(null), { isInBottomHalf: y, update: b } = se(), { isInRightHalf: x, update: S } = ce(), [C, T] = f(!1), E = jc((e) => {
		e.stopPropagation(), T((e) => !e);
	}), { i18n: D } = w(), O = Fi(D), k = r((e, t) => {
		b(e), S(e), O === "ltr" && t.floatRootOverflow.right && e.style.removeProperty("left");
	}, [
		b,
		S,
		O
	]);
	a(() => {
		_.current && S(_.current);
	}, [S]), a(() => {
		_.current && b(_.current);
	}, [b]), c(() => {
		_.current && o?.current && v.current && v.current();
	}, [o, e]), c(() => {
		_.current?.style.removeProperty("top"), _.current?.style.removeProperty("bottom"), _.current?.style.removeProperty("left"), _.current?.style.removeProperty("right"), _.current?.style.removeProperty("transform"), _.current?.style.removeProperty("translate");
	}, [C]);
	let A = () => y ? x ? O === "ltr" ? "topEnd" : "topStart" : O === "ltr" ? "topStart" : "topEnd" : x ? O === "ltr" ? "bottomEnd" : "bottomStart" : O === "ltr" ? "bottomStart" : "bottomEnd", j = !!g.effectsManagerView && !g.isMobileDevice, M = r(() => e ? { [Mc.foldedSelfviewWrapper]: !0 } : {
		[Mc.pip]: !0,
		[Mc.maximized]: C,
		[Mc.effectsManagerDesktopPip]: j
	}, [
		e,
		C,
		j
	]), N = A(), P = A(), { isAudioInputMuted: F, isAudioInputMissing: I, isAudioInputDisabled: L, isVideoInputMuted: ee, isVideoInputMissing: te, onToggleVideoClick: ne, onExpandSelfview: R, onToggleAudioClick: re, showSelfviewTooltip: ie, setShowSelfviewTooltip: ae, ...oe } = g, le = {
		isAudioInputDisabled: L,
		isAudioInputMuted: F,
		isAudioInputMissing: I,
		isVideoInputMuted: ee,
		isVideoInputMissing: te,
		onToggleVideoClick: ne,
		onExpandSelfview: R,
		onToggleAudioClick: re,
		showSelfviewTooltip: ie,
		setShowSelfviewTooltip: ae
	};
	return /*#__PURE__*/ t.createElement(t.Fragment, null, C && /*#__PURE__*/ t.createElement("div", {
		className: Mc.maximizedMask,
		onPointerUp: (e) => e.stopPropagation()
	}), /*#__PURE__*/ t.createElement(Fo, {
		isDisabled: C,
		draggableAriaLabel: n,
		testId: i,
		isMoveableWithArrowKeys: !0,
		tabIndex: e ? -1 : 0,
		showFocus: !1,
		floatRoot: o,
		isSidePanelVisible: s,
		isPhone: g.isMobileDevice,
		onRepositionSideEffect: k,
		shouldCaptureClick: !1,
		className: K(Mc.inMeetingSelfviewPosition, M()),
		ref: _,
		alignWithFloatRootTrigger: v,
		onMouseEnter: l,
		onMouseLeave: u,
		onFocus: p,
		onBlur: m
	}, e && /*#__PURE__*/ t.createElement(wc, {
		...le,
		notificationTooltipPos: N,
		selfviewBtnTooltipPos: P,
		expandSelfView: h,
		isMobileDevice: g.isMobileDevice
	}), /*#__PURE__*/ t.createElement(Ac, {
		isAudioInputMuted: F,
		isAudioInputDisabled: L,
		isVideoInputMuted: ee,
		aspectRatioWrapperClassName: e ? "d-none" : "",
		...oe,
		onPointerDownCapture: g.isMobileDevice ? (e) => {
			C && e.stopPropagation(), E(e);
		} : void 0,
		isMaximized: C,
		setIsMaximized: T
	})));
}, Pc = ({ draggableAriaLabel: e, floatRoot: n, isSidePanelVisible: r, isMobileDevice: i, onMouseEnter: a, onMouseLeave: o, onFocus: s, onBlur: c, ...l }) => /*#__PURE__*/ t.createElement(Fo, {
	draggableAriaLabel: e,
	onMouseEnter: a,
	onMouseLeave: o,
	onFocus: s,
	onBlur: c,
	floatRoot: n,
	isSidePanelVisible: r,
	isPhone: i,
	className: K(Mc.inMeetingSelfviewPosition, Mc.pip)
}, /*#__PURE__*/ t.createElement(Ac, l)), Fc = {
	joinCallDetailsWrapper: "_joinCallDetailsWrapper_172vs_4",
	joinCallDetailsInnerWrapper: "_joinCallDetailsInnerWrapper_172vs_18"
}, Ic = ({ className: e, children: n, otherWaysToJoin: r, onMouseOut: i, onMouseOver: a, wrapperClassName: o, ...s }) => /*#__PURE__*/ t.createElement(He, {
	className: K(Fc.joinCallDetailsWrapper, o),
	...s,
	"data-testid": q.JoinCallDetailsWrapper
}, /*#__PURE__*/ t.createElement("div", {
	role: "region",
	onMouseOut: i,
	onMouseOver: a,
	onFocus: a,
	onBlur: i,
	className: Fc.joinCallDetailsInnerWrapper
}, /*#__PURE__*/ t.createElement("div", { className: e }, n), r)), Lc = {
	joinTextWrapper: "_joinTextWrapper_16hcp_1",
	joinTextMargin: "_joinTextMargin_16hcp_5"
}, Rc = ({ children: e, displayInviteesModal: n, ...r }) => /*#__PURE__*/ t.createElement(pt, {
	onClick: n,
	...r
}, e), zc = ({ displayInviteesModal: e, descriptionFontVariant: n = V.H6, descriptionVariant: r = "tinted", isGuest: i, inMeetingCount: a, headingFontVariant: o = V.H3, headingClassName: s = "mb-2" }) => {
	let { t: c } = w();
	return /*#__PURE__*/ t.createElement(t.Fragment, null, /*#__PURE__*/ t.createElement(ft, {
		htmlTag: V.H1,
		fontVariant: o,
		className: s,
		"data-testid": q.CheckEverythingWorksText
	}, /*#__PURE__*/ t.createElement(C, {
		t: c,
		i18nKey: "media.check-everything-works"
	}, "Check that everything works")), /*#__PURE__*/ t.createElement(G, {
		fontVariant: n,
		variant: r
	}, !i && a ? a === 1 ? /*#__PURE__*/ t.createElement(t.Fragment, null, /*#__PURE__*/ t.createElement(C, {
		t: c,
		i18nKey: "preflight.in-this-meeting.singular"
	}, /*#__PURE__*/ t.createElement(Rc, {
		displayInviteesModal: e,
		fontVariant: n
	}, "1 other person"), " ", "is already inside."), " ") : /*#__PURE__*/ t.createElement(t.Fragment, null, /*#__PURE__*/ t.createElement(C, {
		t: c,
		i18nKey: "preflight.in-this-meeting.plural",
		values: { inMeetingCount: a }
	}, /*#__PURE__*/ t.createElement(Rc, {
		displayInviteesModal: e,
		fontVariant: n
	}, "{{inMeetingCount}}", " other people"), " ", "are already inside."), " ") : null, /*#__PURE__*/ t.createElement(C, {
		t: c,
		i18nKey: "media.check-everything-works-description"
	}, "Make sure that your equipment works so you can be heard and seen when you join.")));
}, Bc = ({ displayInviteesModal: e, inMeetingCount: n, isGuest: r }) => /*#__PURE__*/ t.createElement("div", { className: Lc.joinTextMargin }, /*#__PURE__*/ t.createElement(He, { className: Lc.joinTextWrapper }, /*#__PURE__*/ t.createElement(zc, {
	displayInviteesModal: e,
	isGuest: r,
	inMeetingCount: n
}))), Vc = {
	joinCallDetails: "_joinCallDetails_mv0je_4",
	blockingOverlay: "_blockingOverlay_mv0je_9"
}, Hc = (e) => [on.DeviceSelection, on.BlockedDeviceSelection].includes(e), Uc = ({ children: e, displayInviteesModal: n, inMeetingCount: r, isGuest: i, joinDetailsToRender: a, onMouseOut: o, onMouseOver: s, otherWaysToJoin: c, preflightDeviceSelection: l }) => /*#__PURE__*/ t.createElement(Ic, {
	className: K(Vc.joinCallDetails, a === on.BlockedDeviceSelection && Vc.blockingOverlay),
	onMouseOut: o,
	onMouseOver: s,
	otherWaysToJoin: c
}, /*#__PURE__*/ t.createElement(zc, {
	isGuest: i,
	inMeetingCount: r,
	displayInviteesModal: n,
	descriptionFontVariant: V.Body,
	descriptionVariant: "standard",
	headingFontVariant: V.H4,
	headingClassName: "mb-4"
}), Hc(a) && /*#__PURE__*/ t.createElement("div", { "data-testid": a === on.BlockedDeviceSelection ? q.DevicesSelectionBlocked : q.DevicesSelection }, l), /*#__PURE__*/ t.createElement(Le, {
	spacing: "compact",
	className: "mt-3"
}, e)), Wc = ({ isDisabled: e, onClick: n, className: r, callType: i, isLoading: a }) => {
	let { t: o } = w();
	return /*#__PURE__*/ t.createElement(z, {
		className: r,
		isDisabled: e,
		onClick: n,
		onKeyDown: Tt(n),
		size: "large",
		type: "submit",
		variant: "success",
		modifier: "fullWidth",
		"data-testid": q.ButtonJoinMeeting,
		isLoading: a
	}, (() => {
		switch (i) {
			case Kt.AudioSendRecvVideoSendRecvPresentationSendRecv: return o("common.join-with-video", "Join with video");
			case Kt.AudioSendRecvPresentationSendRecv: return o("common.join-with-audio", "Join with audio");
			case Kt.PresentationSendRecv: return o("common.join-with-presentation-only", "Join with presentation only");
			default: return o("common.join", "Join");
		}
	})());
}, Gc = ({ isDisabled: e, className: n, onWithVideoClick: r, onWithAudioOnlyClick: i }) => {
	let { t: a } = w(), [o, s] = f(!1), c = [{
		key: "join-with-video",
		label: a("common.join-with-video", "Join with video"),
		testId: q.ButtonJoinWithVideo,
		onItemClick: r,
		closeMenuOnItemClick: !0
	}, {
		key: "join-audio-only",
		label: a("common.join-audio-only", "Join audio only"),
		testId: q.ButtonJoinAudioOnly,
		onItemClick: i,
		closeMenuOnItemClick: !0
	}];
	return /*#__PURE__*/ t.createElement(he, {
		onOpenChange: s,
		items: c,
		button: /*#__PURE__*/ t.createElement(z, {
			className: n,
			isActive: o,
			enhancerStart: /*#__PURE__*/ t.createElement(H, { source: U.IconVideoOn }),
			enhancerEnd: /*#__PURE__*/ t.createElement(H, { source: o ? U.IconChevronUp : U.IconChevronDown }),
			isDisabled: e,
			size: "medium",
			variant: "success",
			"data-testid": q.ButtonJoinMeetingWithOptions
		}, a("common.join", "Join")),
		popoverPlacement: "bottom right"
	});
}, Kc = ({ join: e, children: n }) => {
	let { t: r } = w();
	return /*#__PURE__*/ t.createElement(t.Fragment, null, /*#__PURE__*/ t.createElement(z, {
		size: "large",
		modifier: "fullWidth",
		onClick: e,
		variant: "tertiary",
		className: "mt-5"
	}, /*#__PURE__*/ t.createElement(C, {
		t: r,
		i18nKey: "preflight.join-browser"
	}, "Join meeting in browser")), n);
}, qc = ({ devices: e, defaultDeviceLabel: t, label: n, selectedDeviceId: r }) => {
	if (e.length === 0) return [];
	if (!e.some(nn)) {
		let r = e.at(0);
		return _(r, "Placeholder device must be defined"), [{
			id: "",
			label: n
		}, {
			id: tn(r),
			label: t
		}];
	}
	let i = e.map((e) => ({
		id: tn(e),
		label: e.label
	}));
	return r ? i : [{
		label: n,
		id: ""
	}, ...i];
}, Jc = ({ devices: e, kind: n, iconType: r, isDisabled: i = !1, label: a, selected: o, onDeviceChange: s, className: c, sizeModifier: u = "small", ...d }) => {
	let { t: f } = w(), p = o ? tn(o) : "", m = l(() => {
		let t = "";
		switch (n) {
			case "audioinput":
				t = f("media.default-microphone-label", "Default microphone");
				break;
			case "videoinput":
				t = f("media.default-camera-label", "Default camera");
				break;
			case "audiooutput": t = f("media.default-speaker-label", "Default speaker");
		}
		return qc({
			devices: e.get({ kind: n }),
			defaultDeviceLabel: t,
			selectedDeviceId: p,
			label: a
		});
	}, [
		e,
		n,
		f,
		p,
		a
	]);
	return /*#__PURE__*/ t.createElement(ct, {
		value: p,
		onValueChange: s,
		options: m,
		iconType: r,
		label: a,
		labelModifier: "hidden",
		className: K("mb-1", c),
		isFullWidth: !0,
		isDisabled: i,
		sizeModifier: u,
		...d
	});
}, Yc = {
	missingDeviceButton: "_missingDeviceButton_2r0qq_4",
	deviceDeniedTooltipMainWrapper: "_deviceDeniedTooltipMainWrapper_2r0qq_21",
	deviceDeniedTooltipWrapper: "_deviceDeniedTooltipWrapper_2r0qq_25",
	warningIcon: "_warningIcon_2r0qq_29",
	missingDeviceText: "_missingDeviceText_2r0qq_34"
}, Xc = ({ className: e, deniedDevice: n, learnHowToGrantAccessURL: r, permissionInfoType: i, title: a, tooltip: o, setIsTooltipVisible: s, isTooltipVisible: c, icon: l = U.IconAlert, setShowHelpVideo: u, showTooltip: d = !0, retry: f, ...p }) => {
	let { t: m } = w(), h = /*#__PURE__*/ t.createElement(Be, {
		htmlTag: "div",
		className: K("pl-2", "pr-3", Yc.missingDeviceButton, e),
		onClick: () => s(!c),
		title: a,
		...p
	}, /*#__PURE__*/ t.createElement(H, {
		source: l,
		className: K("mr-2", Yc.warningIcon),
		colorScheme: "dark",
		size: "compact"
	}), /*#__PURE__*/ t.createElement(G, {
		isTruncated: !0,
		variant: "inherit",
		className: Yc.missingDeviceText
	}, a));
	return d ? n && u ? /*#__PURE__*/ t.createElement(Ws, {
		learnHowToGrantAccessURL: r,
		permissionInfoType: i,
		deniedDevice: n,
		onClose: () => s(!c),
		visible: c,
		"data-testid": q.TooltipDeniedDevice,
		contentWrapperClassName: Yc.deviceDeniedTooltipWrapper,
		mainWrapperClassName: Yc.deviceDeniedTooltipMainWrapper,
		setShowHelpVideo: u
	}, h) : /*#__PURE__*/ t.createElement(Xe, {
		header: a,
		text: o || "",
		ctaFn: f ?? (() => s(!c)),
		ctaText: f ? /*#__PURE__*/ t.createElement(z, {
			className: "px-3",
			onClick: f,
			size: "small",
			variant: "primary",
			enhancerStart: /*#__PURE__*/ t.createElement(H, {
				colorScheme: "dark",
				source: U.IconRefresh
			})
		}, m("common.try-again", "Try again")) : void 0,
		position: "topCenter",
		controlledIsVisible: c,
		controlledOnChange: s,
		testIdInner: q.NotificationToolTipDeviceError,
		mainWrapperClassName: Yc.deviceDeniedTooltipMainWrapper,
		closeButtonAriaLabel: m("common.close-tooltip", "Close tooltip")
	}, h) : h;
}, Zc = { deviceListWrapper: "_deviceListWrapper_a3bcs_1" }, Qc = ({ audioInput: e, audioInputError: n, audioOutput: r, devices: i, isLoading: a = !1, requestedAudio: o = !0, requestedVideo: s = !0, onAudioInputChange: c, onAudioOutputChange: l, onVideoInputChange: u, retryAudioInput: d, retryVideoInput: p, inputAudioTester: m, outputAudioTester: h, videoInput: g, videoInputError: _, learnHowToGrantAccessURL: v, permissionInfoType: y, sizeModifier: b, setShowHelpVideo: x, showTooltip: S = !1, disableAudioInputSelector: C, disableVideoInputSelector: T, disableAudioOutputSelector: E }) => {
	let { t: D } = w(), [O, k] = f({
		audio: !1,
		video: !1
	}), A = (e) => {
		k({
			audio: !1,
			video: e
		});
	}, j = (e) => {
		k({
			audio: e,
			video: !1
		});
	}, M = !T && _?.title && (_.retryOnly || i.size("videoinput") < 2), N = !C && n?.title && (n.retryOnly || i.size("audioinput") < 2), P = !!r || i.size("audiooutput") > 0;
	return /*#__PURE__*/ t.createElement(He, {
		spacing: "none",
		className: Zc.deviceListWrapper
	}, M ? /*#__PURE__*/ t.createElement(Xc, {
		className: "mb-3",
		title: _.title,
		tooltip: _.description,
		deniedDevice: _.deniedDevice,
		retry: _.retriable ? p : void 0,
		learnHowToGrantAccessURL: v,
		permissionInfoType: y,
		"data-testid": q.MissingVideoDeviceAlert,
		setIsTooltipVisible: A,
		isTooltipVisible: O.video,
		setShowHelpVideo: x,
		showTooltip: S
	}) : /*#__PURE__*/ t.createElement(Jc, {
		className: "mb-3",
		kind: "videoinput",
		isDisabled: a || T,
		label: D("settings.device-select.select-camera", "Select camera"),
		"data-testid": q.SelectVideoInput,
		errorText: _?.title,
		errorTextTestId: q.SelectVideoInputErrorText,
		hasError: s && !!_?.title,
		onDeviceChange: u,
		iconType: U.IconVideoOn,
		selected: g,
		devices: i,
		sizeModifier: b
	}), N ? /*#__PURE__*/ t.createElement(Xc, {
		className: "mb-2",
		title: n.title,
		tooltip: n.description,
		deniedDevice: n.deniedDevice,
		retry: n.retriable ? d : void 0,
		learnHowToGrantAccessURL: v,
		permissionInfoType: y,
		"data-testid": q.MissingAudioDeviceAlert,
		setIsTooltipVisible: j,
		isTooltipVisible: O.audio,
		setShowHelpVideo: x,
		showTooltip: S
	}) : /*#__PURE__*/ t.createElement(Jc, {
		className: m ? "mb-2" : "mb-3",
		kind: "audioinput",
		isDisabled: a || C,
		label: D("settings.device-select.select-microphone", "Select microphone"),
		"data-testid": q.SelectAudioInput,
		errorText: n?.title,
		errorTextTestId: q.SelectAudioInputErrorText,
		hasError: o && !!n?.title,
		onDeviceChange: c,
		iconType: U.IconMicrophoneOn,
		selected: e,
		devices: i,
		sizeModifier: b
	}), m && /*#__PURE__*/ t.createElement("div", { className: K("p-0", "mb-2", "d-flex", "flex-direction-column", "align-items-end") }, m, !P && h), P && /*#__PURE__*/ t.createElement(t.Fragment, null, /*#__PURE__*/ t.createElement(Jc, {
		isDisabled: a || E,
		kind: "audiooutput",
		label: D("settings.device-select.select-speaker", "Select speaker"),
		"data-testid": q.SelectAudioOutput,
		onDeviceChange: l,
		iconType: U.IconSpeakerOn,
		selected: r,
		devices: i,
		sizeModifier: b,
		className: "m-0"
	}), h && /*#__PURE__*/ t.createElement(W, { className: "p-0 mt-2 justify-content-end" }, h)));
}, $c = ({ devices: e, videoInputError: n, audioInputError: r, videoInput: i, audioInput: a, audioOutput: o, disableAudioInputSelector: s, disableVideoInputSelector: c, disableAudioOutputSelector: l, onAudioInputChange: u, onAudioOutputChange: d, onVideoInputChange: f, isLoading: p = !1, requestedAudio: m = !0, requestedVideo: h = !0, inputAudioTester: g, outputAudioTester: _, learnHowToGrantAccessURL: v, permissionInfoType: y, sizeModifier: b, setShowHelpVideo: x }) => /*#__PURE__*/ t.createElement(W, { spacing: "medium" }, /*#__PURE__*/ t.createElement(Qc, {
	disableVideoInputSelector: c,
	disableAudioInputSelector: s,
	disableAudioOutputSelector: l,
	requestedAudio: m,
	requestedVideo: h,
	devices: e,
	videoInputError: n,
	audioInputError: r,
	videoInput: i,
	audioInput: a,
	audioOutput: o,
	onAudioInputChange: u,
	onAudioOutputChange: d,
	onVideoInputChange: f,
	isLoading: p,
	inputAudioTester: g,
	outputAudioTester: _,
	learnHowToGrantAccessURL: v,
	permissionInfoType: y,
	sizeModifier: b,
	setShowHelpVideo: x,
	showTooltip: !0
})), el = { wrapper: "_wrapper_pgsa7_1" }, tl = ({ onClick: e, shouldPlay: n, isDisabled: r }) => {
	let { t: i } = w(), o = n ? i("settings.playing-sound", "Playing sound...") : i("settings.test-your-sound", "Test your sound"), s = d(o), [c, l] = f();
	return a(() => {
		s.current !== o && (l(o), s.current = o);
	}, [o]), /*#__PURE__*/ t.createElement(t.Fragment, null, /*#__PURE__*/ t.createElement(pt, {
		fontVariant: V.SmallLink,
		"data-testid": q.LinkTestAudioOutput,
		onClick: e,
		isDisabled: r,
		className: el.wrapper
	}, o), /*#__PURE__*/ t.createElement(G, {
		"aria-atomic": "true",
		"aria-live": "assertive",
		variant: "hidden"
	}, c));
}, nl = {
	modal: "_modal_11l0l_4",
	audioSelect: "_audioSelect_11l0l_8",
	screenReaderStatus: "_screenReaderStatus_11l0l_12",
	playingBackDeviceSelectionContent: "_playingBackDeviceSelectionContent_11l0l_24",
	contentBoxWrapper: "_contentBoxWrapper_11l0l_28",
	playbackDescriptionRow: "_playbackDescriptionRow_11l0l_39",
	tryThis: "_tryThis_11l0l_43",
	tryThisOrderedList: "_tryThisOrderedList_11l0l_46",
	replayButton: "_replayButton_11l0l_57",
	replayText: "_replayText_11l0l_63"
}, rl = ({ devices: e, selectedAudioInput: n, onAudioInputChange: r, startTest: i }) => {
	let { t: a } = w(), s = o();
	return /*#__PURE__*/ t.createElement(t.Fragment, null, /*#__PURE__*/ t.createElement(W, null, /*#__PURE__*/ t.createElement(G, { fontVariant: V.H6 }, a("media.first-check-that-you-have-selected-microphone", "First, check that you have selected the correct microphone and that your volume is turned up."))), /*#__PURE__*/ t.createElement(W, { className: "p-0 mt-4" }, /*#__PURE__*/ t.createElement(Jc, {
		isDisabled: !1,
		kind: "audioinput",
		onDeviceChange: r,
		selected: n,
		iconType: U.IconMicrophoneOn,
		label: a("settings.device-select.select-microphone", "Select microphone"),
		devices: e,
		className: nl.audioSelect,
		sizeModifier: "medium",
		"data-testid": q.SelectTestAudioInput
	})), /*#__PURE__*/ t.createElement(W, { className: "p-0 mt-10 justify-content-center" }, /*#__PURE__*/ t.createElement(G, {
		id: s,
		variant: "hidden"
	}, a("media.start-test-description", "Starts a three-second countdown. When it ends, begin speaking to record your microphone.")), /*#__PURE__*/ t.createElement(z, {
		"aria-describedby": s,
		onClick: i,
		size: "large",
		"data-testid": q.ButtonTestAudioInputStart
	}, a("media.start-test", "Start test"))));
}, il = ({ className: e, titleVariant: n = V.H6, countTitleVariant: r = V.H5 }) => {
	let { t: i } = w();
	return /*#__PURE__*/ t.createElement("div", { className: e }, /*#__PURE__*/ t.createElement(G, { fontVariant: n }, /*#__PURE__*/ t.createElement(C, {
		t: i,
		i18nKey: "media.you-can-say-something-like"
	}, "You can say something like", " "), /*#__PURE__*/ t.createElement(G, { fontVariant: r }, i("media.testing-my-microphone", "\"Testing 1, 2, 3\""))));
}, al = ({ children: e, showBorder: n }) => /*#__PURE__*/ t.createElement(Se, {
	className: K(nl.contentBoxWrapper),
	isWithShadow: !1,
	isWithBorder: n
}, e), ol = 3, sl = ({ currentCount: e }) => /*#__PURE__*/ t.createElement("div", null, /*#__PURE__*/ t.createElement(il, { className: "mt-2 mb-4" }), /*#__PURE__*/ t.createElement(W, null, /*#__PURE__*/ t.createElement(al, null, /*#__PURE__*/ t.createElement(Te, {
	currentCount: e,
	shouldStartCountDown: !0,
	startCountFrom: ol
})))), cl = ({ children: e, isRecordSuccess: n }) => /*#__PURE__*/ t.createElement("div", null, !n && /*#__PURE__*/ t.createElement(il, { className: "mt-2 mb-4" }), /*#__PURE__*/ t.createElement(W, { className: K("mt-2", n && "mt-10") }, e)), ll = ({ devices: e, selectedAudioInput: n, selectedAudioOutput: r, onOutputInputChange: i, onAudioInputChange: a, tryAgain: o }) => {
	let { t: s } = w();
	return /*#__PURE__*/ t.createElement(W, { className: nl.playingBackDeviceSelectionContent }, /*#__PURE__*/ t.createElement(me, {
		className: nl.tryThis,
		title: s("media.if-you-dont-hear-yourself-try-this", "If you don't hear yourself, try this"),
		dataTestId: q.ButtonTestAudioInputTryAgain
	}, /*#__PURE__*/ t.createElement(W, null, /*#__PURE__*/ t.createElement("ol", { className: nl.tryThisOrderedList }, /*#__PURE__*/ t.createElement("li", null, /*#__PURE__*/ t.createElement(G, null, s("media.make-sure-you-have-the-correct-microphone", "Make sure you have the correct microphone")), /*#__PURE__*/ t.createElement(W, null, /*#__PURE__*/ t.createElement(Jc, {
		isDisabled: !1,
		kind: "audioinput",
		onDeviceChange: a,
		selected: n,
		iconType: U.IconMicrophoneOn,
		label: s("settings.device-select.select-microphone", "Select microphone"),
		devices: e,
		className: nl.audioSelect,
		"data-testid": q.SelectTestAudioInputPlayback
	})), e.size("audiooutput") > 0 && /*#__PURE__*/ t.createElement(t.Fragment, null, /*#__PURE__*/ t.createElement(G, null, s("media.make-sure-you-have-the-correct-speaker", "Make sure you have the correct speaker")), /*#__PURE__*/ t.createElement(W, null, /*#__PURE__*/ t.createElement(Jc, {
		isDisabled: !1,
		kind: "audiooutput",
		onDeviceChange: i,
		selected: r,
		iconType: U.IconSpeakerOn,
		label: s("settings.device-select.select-speaker", "Select speaker"),
		devices: e,
		className: nl.audioSelect,
		"data-testid": q.SelectTestAudioInputSpeakerPlayback
	}))), /*#__PURE__*/ t.createElement(W, { className: "justify-content-end" }, /*#__PURE__*/ t.createElement(z, {
		onClick: o,
		"data-testid": q.ButtonTestAudioInputAgain
	}, s("common.try-again", "Try again")))), /*#__PURE__*/ t.createElement("li", null, s("media.make-sure-the-volume-is-turned-up-on-your-device", "Make sure the volume is turned up on your device.")), /*#__PURE__*/ t.createElement("li", null, s("media.do you have headphones connected to-your-device", "Do you have headphones connected to your device? Make sure the microphone of the headphones is near your mouth.")), /*#__PURE__*/ t.createElement("li", null, s("media.you-may-need-to-connect-speakers-or-headphones", "If you are using a desktop computer, you may need to connect speakers or headphones."))))));
}, ul = ({ devices: e, children: n, selectedAudioInput: r, selectedAudioOutput: i, onOutputInputChange: a, onAudioInputChange: o, tryAgain: s }) => {
	let { t: c } = w();
	return /*#__PURE__*/ t.createElement("div", null, /*#__PURE__*/ t.createElement(W, { className: K("mt-2", nl.playbackDescriptionRow) }, /*#__PURE__*/ t.createElement(G, { fontVariant: V.H6 }, c("media.this-is-how-you-will-sound-to-others", "This is how you will sound to others"))), n, /*#__PURE__*/ t.createElement(W, { className: "mt-2" }, /*#__PURE__*/ t.createElement(ll, {
		devices: e,
		selectedAudioInput: r,
		selectedAudioOutput: i,
		onOutputInputChange: a,
		onAudioInputChange: o,
		tryAgain: s
	})));
}, dl = ({ currentStage: e }) => {
	let { t: n } = w();
	return /*#__PURE__*/ t.createElement(ft, {
		htmlTag: "h3",
		fontVariant: V.H3
	}, n([`media.test-your-microphone-title-[${e}]`, `media.test-your-microphone-title-[${pl.BeforeTesting}]`], "Test your microphone"));
}, fl = ({ replay: e }) => {
	let { t: n } = w(), r = n("common.replay", "Replay");
	return /*#__PURE__*/ t.createElement(al, null, /*#__PURE__*/ t.createElement("div", { className: "d-flex flex-direction-column align-items-center" }, /*#__PURE__*/ t.createElement(z, {
		"aria-label": r,
		onClick: e,
		className: nl.replayButton,
		variant: "tertiary",
		size: "none"
	}, /*#__PURE__*/ t.createElement(H, { source: U.IconRefresh })), /*#__PURE__*/ t.createElement(G, {
		"aria-hidden": "true",
		className: nl.replayText
	}, r)));
}, pl = /*#__PURE__*/ function(e) {
	return e.BeforeTesting = "before-testing", e.GetReady = "get-ready", e.Recording = "recording", e.RecordingSuccess = "recording-success", e.PlayingBack = "playing-back", e.PlaybackFinished = "playback-finished", e;
}({}), ml = ({ audioMeter: e, className: n, currentStage: r = "before-testing", devices: i, getReadyCount: o = 3, selectedAudioInput: s, selectedAudioOutput: l, isOpen: u, onClose: p, onAudioInputChange: m, onAudioOutputChange: h, startTest: g, closeOnOutsideClick: _ = !1, tryAgain: v, replay: y }) => {
	let { t: b } = w(), x = b("media.recording-finished", "Recording finished"), [S, C] = f({
		message: "",
		stage: r
	}), T = d(null), E = S.stage === r ? S.message : "", { modalHandleRef: D, focusModal: O } = Lt();
	return a(() => {
		u && O();
	}, [u, O]), a(() => {
		if (r === "get-ready" && (C((e) => e.stage === "get-ready" && o > 0 ? e : {
			message: "",
			stage: "get-ready"
		}), o > 0)) {
			let e = window.setTimeout(() => {
				C({
					message: String(o),
					stage: "get-ready"
				});
			}, 100);
			return () => window.clearTimeout(e);
		}
	}, [r, o]), a(() => {
		r === "playing-back" && C((e) => e.stage === "playing-back" && e.message === x ? e : {
			message: x,
			stage: "playing-back"
		});
	}, [r, x]), c(() => {
		r === "get-ready" && T.current?.focus();
	}, [r]), u ? /*#__PURE__*/ t.createElement(qe, {
		ref: D,
		padding: "medium",
		isOpen: u,
		closeOnOutsideClick: _,
		onClose: p,
		withCloseButton: !0,
		closeButtonAriaLabel: b("common.close", "Close"),
		scrollbarsAriaLabel: b("common.scrollable-content", "Scrollable content"),
		uniqueTitle: b("media.test-your-microphone", "Test your microphone"),
		className: K(nl.modal, n)
	}, /*#__PURE__*/ t.createElement("span", {
		"aria-atomic": "true",
		"aria-live": "assertive",
		className: nl.screenReaderStatus,
		ref: T,
		role: "status",
		tabIndex: -1
	}, E), /*#__PURE__*/ t.createElement(dl, { currentStage: r }), (() => {
		switch (r) {
			case "get-ready": return /*#__PURE__*/ t.createElement(sl, { currentCount: o });
			case "recording":
			case "recording-success": return /*#__PURE__*/ t.createElement(cl, { isRecordSuccess: r === "recording-success" }, e);
			case "playing-back":
			case "playback-finished": return /*#__PURE__*/ t.createElement(ul, {
				devices: i,
				onAudioInputChange: m,
				onOutputInputChange: h,
				selectedAudioInput: s,
				selectedAudioOutput: l,
				tryAgain: v
			}, r === "playback-finished" ? /*#__PURE__*/ t.createElement(fl, { replay: y }) : e);
			default: return /*#__PURE__*/ t.createElement(rl, {
				onAudioInputChange: m,
				selectedAudioInput: s,
				devices: i,
				startTest: g
			});
		}
	})()) : null;
}, hl = { wrapper: "_wrapper_pgsa7_1" }, gl = ({ onClick: e, isDisabled: n }) => /*#__PURE__*/ t.createElement(pt, {
	fontVariant: V.SmallLink,
	"data-testid": q.LinkTestAudioInput,
	onClick: e,
	isDisabled: n,
	className: hl.wrapper
}, /*#__PURE__*/ t.createElement(C, { i18nKey: "media.test-your-microphone" }, "Test your microphone")), _l = { fullSizeWindow: "_fullSizeWindow_t2v2h_1" }, vl = ({ ...e }) => /*#__PURE__*/ t.createElement(Pe, {
	padding: "none",
	background: "dark",
	flexDirection: "column",
	justifyContent: "center",
	position: "absolute",
	className: _l.fullSizeWindow,
	"data-testid": q.MeetingWrapper,
	"data-meeting-wrapper": !0,
	...e
}), yl = (t) => /* @__PURE__ */ e.createElement("svg", {
	width: 348,
	height: 177,
	viewBox: "0 0 348 177",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	...t
}, /* @__PURE__ */ e.createElement("rect", {
	width: 348,
	height: 177,
	rx: 6.51312,
	fill: "#F4F4F4"
}), /* @__PURE__ */ e.createElement("rect", {
	x: 51,
	y: 29,
	width: 235.287,
	height: 120.164,
	rx: 4.0707,
	fill: "#E0E0E0"
}), /* @__PURE__ */ e.createElement("rect", {
	x: 129.148,
	y: 49.1641,
	width: 139.491,
	height: 10.0837,
	rx: 4.0707,
	fill: "#AEAEAE"
}), /* @__PURE__ */ e.createElement("rect", {
	x: 129.148,
	y: 68.4961,
	width: 139.491,
	height: 10.0837,
	rx: 4.0707,
	fill: "#AEAEAE"
}), /* @__PURE__ */ e.createElement("rect", {
	x: 129.148,
	y: 89.5,
	width: 139.491,
	height: 10.0837,
	rx: 4.0707,
	fill: "#AEAEAE"
}), /* @__PURE__ */ e.createElement("rect", {
	x: 189.094,
	y: 110.914,
	width: 78.7858,
	height: 23.4242,
	rx: 4.38484,
	stroke: "#575757"
}), /* @__PURE__ */ e.createElement("path", {
	d: "M206.076 127.113H204.587L207.297 119.416H209.018L211.732 127.113H210.244L208.188 120.995H208.128L206.076 127.113ZM206.124 124.095H210.184V125.215H206.124V124.095ZM214.046 119.416V127.113H212.686V119.416H214.046ZM216.806 119.416V127.113H215.445V119.416H216.806ZM220.723 127.226C220.159 127.226 219.671 127.102 219.257 126.854C218.844 126.606 218.523 126.259 218.295 125.813C218.07 125.367 217.957 124.846 217.957 124.249C217.957 123.653 218.07 123.131 218.295 122.682C218.523 122.234 218.844 121.885 219.257 121.637C219.671 121.389 220.159 121.265 220.723 121.265C221.287 121.265 221.776 121.389 222.189 121.637C222.602 121.885 222.922 122.234 223.147 122.682C223.375 123.131 223.489 123.653 223.489 124.249C223.489 124.846 223.375 125.367 223.147 125.813C222.922 126.259 222.602 126.606 222.189 126.854C221.776 127.102 221.287 127.226 220.723 127.226ZM220.731 126.136C221.036 126.136 221.292 126.052 221.497 125.884C221.703 125.714 221.856 125.486 221.956 125.2C222.059 124.915 222.11 124.596 222.11 124.246C222.11 123.892 222.059 123.573 221.956 123.287C221.856 122.999 221.703 122.77 221.497 122.599C221.292 122.429 221.036 122.344 220.731 122.344C220.417 122.344 220.157 122.429 219.949 122.599C219.743 122.77 219.589 122.999 219.487 123.287C219.386 123.573 219.336 123.892 219.336 124.246C219.336 124.596 219.386 124.915 219.487 125.2C219.589 125.486 219.743 125.714 219.949 125.884C220.157 126.052 220.417 126.136 220.731 126.136ZM225.67 127.113L224.039 121.34H225.426L226.441 125.399H226.493L227.531 121.34H228.903L229.94 125.377H229.996L230.996 121.34H232.387L230.752 127.113H229.335L228.252 123.212H228.173L227.091 127.113H225.67Z",
	fill: "#333333"
}), /* @__PURE__ */ e.createElement("rect", {
	x: 85.7812,
	y: 110.414,
	width: 79.7858,
	height: 24.4242,
	rx: 4.0707,
	fill: "#AEAEAE"
}), /* @__PURE__ */ e.createElement("circle", {
	cx: 94.6987,
	cy: 73.5385,
	r: 20.1674,
	fill: "#AEAEAE"
}), /* @__PURE__ */ e.createElement("rect", {
	x: 159,
	y: 98,
	width: 143.694,
	height: 49.8195,
	fill: "url(#pattern0)"
}), /* @__PURE__ */ e.createElement("defs", null, /* @__PURE__ */ e.createElement("pattern", {
	id: "pattern0",
	patternContentUnits: "objectBoundingBox",
	width: 1,
	height: 1
}, /* @__PURE__ */ e.createElement("use", {
	xlinkHref: "#image0_4573_112121",
	transform: "scale(0.00286533 0.00826446)"
})), /* @__PURE__ */ e.createElement("image", {
	id: "image0_4573_112121",
	width: 349,
	height: 121,
	xlinkHref: "data:image/png;base64,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"
}))), bl = {
	boxWrapper: "_boxWrapper_17qck_1",
	svgWrapper: "_svgWrapper_17qck_5"
}, xl = ({ requestAccess: e, requesting: n, title: r, message: i }) => {
	let { t: a } = w();
	return /*#__PURE__*/ t.createElement(ht, { colorScheme: "light" }, /*#__PURE__*/ t.createElement(Se, {
		padding: "large",
		className: bl.boxWrapper
	}, /*#__PURE__*/ t.createElement(He, { spacing: "none" }, /*#__PURE__*/ t.createElement(ut, {
		className: bl.svgWrapper,
		source: yl
	}), /*#__PURE__*/ t.createElement(G, {
		fontVariant: V.H3,
		className: "mt-4"
	}, r), /*#__PURE__*/ t.createElement(G, { className: "mt-4" }, i), /*#__PURE__*/ t.createElement(xe, { className: "mt-7" }, /*#__PURE__*/ t.createElement(z, {
		"data-testid": q.ButtonRequestPermissions,
		modifier: "fullWidth",
		onClick: e,
		size: "large",
		isLoading: n
	}, /*#__PURE__*/ t.createElement(C, {
		t: a,
		i18nKey: "common.ask-for-permission"
	}, "Request permission"))))));
}, Sl = {
	newMessagesPillWrapper: "_newMessagesPillWrapper_1bmzr_4",
	newMessagesPill: "_newMessagesPill_1bmzr_4",
	newMessagesPillContent: "_newMessagesPillContent_1bmzr_12",
	newMessageText: "_newMessageText_1bmzr_18",
	closeButton: "_closeButton_1bmzr_25"
}, Cl = ({ newMessagesCount: e, closeNewChatMessage: n, scrollToLastMessage: r }) => {
	let { t: i } = w(), a = l(() => e > 1 ? i("meeting.chat-new-messages", {
		defaultValue: "{{newMessagesCount}} new messages",
		newMessagesCount: e
	}) : i("meeting.chat-new-message", "new message"), [e, i]);
	return /*#__PURE__*/ t.createElement("div", { className: Sl.newMessagesPillWrapper }, /*#__PURE__*/ t.createElement(Be, {
		"aria-label": i("meeting.chat-scroll-last-message", "Scroll to last chat message"),
		onClick: r,
		"data-testid": q.PillNewChatMessage
	}, /*#__PURE__*/ t.createElement(et, { className: Sl.newMessagesPill }, /*#__PURE__*/ t.createElement("div", { className: Sl.newMessagesPillContent }, /*#__PURE__*/ t.createElement(H, {
		source: U.IconArrowDown,
		size: "compact"
	}), /*#__PURE__*/ t.createElement("div", { className: "ml-2 mr-2" }, /*#__PURE__*/ t.createElement(G, { className: Sl.newMessageText }, a))), /*#__PURE__*/ t.createElement("div", { className: "pr-3" }))), /*#__PURE__*/ t.createElement(Je, {
		onClose: n,
		"aria-label": i("meeting.close-new-chat-alert", "Close new chat message alert"),
		className: Sl.closeButton
	}));
}, wl = ({ iconSource: e, iconSize: n = "compact", children: r, variant: i = "translucent", hideChildren: a, ...o }) => {
	let s = Pt(), c = !!r, l = a ?? s;
	return /*#__PURE__*/ t.createElement(z, {
		variant: i,
		hideChildren: l,
		noEnhancerPadding: !c || l,
		modifier: l ? "square" : void 0,
		enhancerStart: e && /*#__PURE__*/ t.createElement(H, {
			source: e,
			size: n
		}),
		...o
	}, r);
}, Tl = ({ onLeave: e }) => {
	let { t: n } = w();
	return /*#__PURE__*/ t.createElement(wl, {
		className: hc.desktopLeaveBtn,
		iconSource: U.IconPhoneHorisontal,
		onClick: e,
		variant: "danger",
		"data-testid": q.ButtonLeave,
		hideChildren: !1,
		size: "large",
		noEnhancerPadding: !0
	}, /*#__PURE__*/ t.createElement("div", { className: hc.desktopLeaveText }, n("meeting.leave", "Leave")));
}, El = ({ onLeave: e, iconSize: n, ...r }) => {
	let { t: i } = w();
	return /*#__PURE__*/ t.createElement(z, {
		onClick: e,
		variant: "danger",
		modifier: "square",
		size: "large",
		"aria-label": i("meeting.leave-aria-label", "Leave meeting"),
		"data-testid": q.ButtonLeave,
		...r
	}, /*#__PURE__*/ t.createElement(H, {
		source: U.IconPhoneHorisontal,
		size: n
	}));
}, Dl = ({ isVideoMuted: e, onVideoBtnClick: n, iconSize: r, tooltipClassName: i, ...a }) => {
	let { t: o } = w(), s = e ? o("media.turn-camera-on", "Turn camera on") : o("media.turn-camera-off", "Turn camera off"), c = e ? q.ButtonMeetingVideoInputMuted : q.ButtonMeetingVideoInput;
	return /*#__PURE__*/ t.createElement(dc, {
		isActive: e,
		onClick: n,
		tooltipPosition: "top",
		tooltipText: s,
		tooltipClassName: i,
		"data-testid": c,
		"aria-label": s,
		icon: e ? /*#__PURE__*/ t.createElement(H, {
			source: U.IconVideoOff,
			size: r
		}) : /*#__PURE__*/ t.createElement(H, {
			source: U.IconVideoOn,
			size: r
		}),
		...a
	});
}, Ol = ({ isAudioMuted: e, muteText: n }) => {
	let { t: r } = w();
	return /*#__PURE__*/ t.createElement("div", { className: "p-2 d-flex flex-direction-column align-items-center" }, /*#__PURE__*/ t.createElement(G, null, `${n} (M)`), e && /*#__PURE__*/ t.createElement(G, {
		fontVariant: V.Small,
		className: "mt-1"
	}, /*#__PURE__*/ t.createElement(C, {
		t: r,
		i18nKey: "media.push-to-talk"
	}, "Push and hold your space bar to unmute yourself temporarily")));
}, kl = ({ isMicrophoneMuted: e, onAudioBtnClick: n, iconSize: r, canMute: i = !0, tooltipClassName: a, ...o }) => {
	let { t: s } = w(), c = e ? s("media.unmute-microphone", "Unmute microphone") : s("media.mute-microphone", "Mute microphone"), l = e ? q.ButtonMeetingAudioInputMuted : q.ButtonMeetingAudioInput;
	return /*#__PURE__*/ t.createElement(dc, {
		canMute: i,
		isActive: e,
		onClick: n,
		tooltipPosition: "top",
		tooltipText: /*#__PURE__*/ t.createElement(Ol, {
			isAudioMuted: e,
			muteText: c
		}),
		tooltipClassName: a,
		"data-testid": l,
		"aria-label": c,
		icon: e ? /*#__PURE__*/ t.createElement(H, {
			source: U.IconMicrophoneOff,
			size: r
		}) : /*#__PURE__*/ t.createElement(H, {
			source: U.IconMicrophoneOn,
			size: r
		}),
		...o
	});
}, Al = ({ isAudioError: e, isVideoError: n, isBothError: r, audioTooltipVisible: i, videoTooltipVisible: a, toggleAudioTooltip: o, toggleVideoTooltip: s, audioStatusInfo: c, audioRequestDeviceAgain: l, videoStatusInfo: u, audioTooltipText: d, canMuteAudio: f, iconSize: p, inputStatusInfo: m, isAudioMuteDisabled: h, isAudioSuspended: g, isMicrophoneMuted: _, isRequestingAudio: v, isRequestingVideo: y, isVideoMuteDisabled: b, isVideoMuted: x, isVideoSuspended: S, onAudioBtnClick: C, onLeave: w, onVideoBtnClick: T, videoRequestDeviceAgain: E, ...D }) => {
	let O = "neutral";
	return /*#__PURE__*/ t.createElement("div", {
		className: K(hc.callControlsWrapper, hc.desktopWrapper),
		...D
	}, /*#__PURE__*/ t.createElement("div", { className: hc.desktopMediaBtnWrapper }, /*#__PURE__*/ t.createElement(kl, {
		canMute: f,
		hasError: e || r,
		iconSize: p,
		inputStatusInfo: c,
		isDisabled: h,
		isLoading: v,
		isMicrophoneMuted: _,
		isSuspended: g,
		onAudioBtnClick: C,
		requestDeviceAgain: l,
		shouldShowTooltip: i,
		toggleTooltip: o,
		variant: O
	}), /*#__PURE__*/ t.createElement(Dl, {
		hasError: n,
		iconSize: p,
		inputStatusInfo: u,
		isDisabled: b,
		isLoading: y,
		isSuspended: S,
		isVideoMuted: x,
		onVideoBtnClick: T,
		requestDeviceAgain: E,
		shouldShowTooltip: a,
		toggleTooltip: s,
		variant: O
	})), /*#__PURE__*/ t.createElement("div", { className: hc.desktopLeaveBtnWrapper }, /*#__PURE__*/ t.createElement(Tl, { onLeave: w })));
}, jl = {
	container: "_container_mqb2l_4",
	nonePaddingTop: "_nonePaddingTop_mqb2l_7",
	nonePaddingRight: "_nonePaddingRight_mqb2l_10",
	nonePaddingBottom: "_nonePaddingBottom_mqb2l_13",
	nonePaddingLeft: "_nonePaddingLeft_mqb2l_16",
	compactPaddingTop: "_compactPaddingTop_mqb2l_19",
	compactPaddingRight: "_compactPaddingRight_mqb2l_22",
	compactPaddingBottom: "_compactPaddingBottom_mqb2l_25",
	compactPaddingLeft: "_compactPaddingLeft_mqb2l_28",
	smallPaddingTop: "_smallPaddingTop_mqb2l_31",
	smallPaddingRight: "_smallPaddingRight_mqb2l_34",
	smallPaddingBottom: "_smallPaddingBottom_mqb2l_37",
	smallPaddingLeft: "_smallPaddingLeft_mqb2l_40",
	mediumPaddingTop: "_mediumPaddingTop_mqb2l_43",
	mediumPaddingRight: "_mediumPaddingRight_mqb2l_46",
	mediumPaddingBottom: "_mediumPaddingBottom_mqb2l_49",
	mediumPaddingLeft: "_mediumPaddingLeft_mqb2l_52",
	largePaddingTop: "_largePaddingTop_mqb2l_55",
	largePaddingRight: "_largePaddingRight_mqb2l_58",
	largePaddingBottom: "_largePaddingBottom_mqb2l_61",
	largePaddingLeft: "_largePaddingLeft_mqb2l_64",
	topContentContainer: "_topContentContainer_mqb2l_68",
	startContent: "_startContent_mqb2l_73",
	endContent: "_endContent_mqb2l_78"
}, Ml = ({ padding: e, topPadding: n = e, rightPadding: r = e, bottomPadding: i = e, leftPadding: a = e, endContent: o, bottomContent: s, backButtonAriaLabel: c, closeButtonAriaLabel: l, closeButtonTestId: u = "", backButtonTestId: d, title: f, onCloseClick: p, onBackClick: m }) => {
	let { t: h, i18n: g } = w(), _ = Fi(g);
	return /*#__PURE__*/ t.createElement("div", { className: K(jl.container, n && jl[`${Dt(n)}Top`], r && jl[`${Dt(r)}Right`], i && jl[`${Dt(i)}Bottom`], a && jl[`${Dt(a)}Left`]) }, /*#__PURE__*/ t.createElement("div", { className: jl.topContentContainer }, /*#__PURE__*/ t.createElement("div", { className: jl.startContent }, m && /*#__PURE__*/ t.createElement(z, {
		"aria-label": c ?? h("common.go-back", "Go back"),
		onClick: m,
		className: "me-1",
		size: "none",
		variant: "translucent",
		"data-testid": d
	}, /*#__PURE__*/ t.createElement(H, {
		size: "small",
		source: U.IconArrowLeftRegular,
		style: { transform: `rotateY(${_ === "rtl" ? 180 : 0}deg)` }
	})), f && /*#__PURE__*/ t.createElement(ft, {
		"data-testid": q.PanelHeaderTitle,
		htmlTag: "h2",
		fontVariant: V.H5
	}, f)), (o ?? p) && /*#__PURE__*/ t.createElement("div", { className: jl.endContent }, o, p && /*#__PURE__*/ t.createElement(z, {
		"aria-label": l ?? h("common.close-panel", "Close panel"),
		onClick: p,
		size: "compact",
		modifier: "square",
		variant: "translucent",
		"data-testid": u
	}, /*#__PURE__*/ t.createElement(H, { source: U.IconClose })))), s);
}, Nl = ({ ableToPresent: e, allowedToPresent: n, canMuteAudio: r = !0, clearPluginMenu: i, inputStatusInfo: a, isAudioMuteDisabled: o, isHandRaised: s, isMicrophoneMuted: c, isMoreMenuBadgeCounterVisible: l = !1, isRaiseHandHidden: u, isRequestingAudio: d, isRequestingVideo: f, isVideoMuteDisabled: p, isVideoMuted: m, localIsPresenting: h, moreMenuItems: g, onAudioBtnClick: _, onLeave: v, onMoreMenuOpenChange: y, onRaiseHand: b, onVideoBtnClick: x, pluginMenuParent: S, presentationDisabledText: C, presentationModeToggle: w, videoRequestDeviceAgain: T, startPresentation: E, stopPresentation: D, isAudioError: O, isVideoError: k, isBothError: A, audioTooltipVisible: j, videoTooltipVisible: M, toggleAudioTooltip: N, toggleVideoTooltip: P, audioStatusInfo: F, audioRequestDeviceAgain: I, videoStatusInfo: L, ...ee }) => {
	let te = Ft(), ne = Ot(), R = te ? "medium" : "small", re = "neutral";
	return /*#__PURE__*/ t.createElement("div", {
		className: K(hc.callControlsWrapper, hc.touchWrapper),
		...ee
	}, /*#__PURE__*/ t.createElement("div", { className: hc.touchCallControlBtnWrapper }, /*#__PURE__*/ t.createElement(_c, {
		isTouch: !0,
		isMobile: te,
		items: g,
		onOpenChange: y,
		headerContent: S ? /*#__PURE__*/ t.createElement(Ml, {
			title: S,
			onBackClick: i,
			backButtonTestId: q.ButtonCallControlsTouchMoreMenuBack
		}) : void 0
	}, /*#__PURE__*/ t.createElement(be, {
		variant: "info",
		isTruncated: !0,
		isVisible: l,
		badgeClassName: hc.moreMenuBadge
	})), w, !ne && /*#__PURE__*/ t.createElement(pc, {
		variant: re,
		isHandRaised: s,
		onRaiseHand: b,
		iconSize: R,
		isRaiseHandHidden: u
	}), e && /*#__PURE__*/ t.createElement(mc, {
		variant: re,
		localIsPresenting: h,
		iconSize: R,
		stopPresentation: D,
		startPresentation: E,
		isDisabled: !n,
		disabledReason: C
	}), /*#__PURE__*/ t.createElement(kl, {
		canMute: r,
		hasError: O || A,
		iconSize: R,
		inputStatusInfo: F,
		isDisabled: o,
		isLoading: d,
		isMicrophoneMuted: c,
		onAudioBtnClick: _,
		requestDeviceAgain: I,
		shouldShowTooltip: j,
		toggleTooltip: N,
		variant: re
	}), /*#__PURE__*/ t.createElement(Dl, {
		hasError: k,
		iconSize: R,
		inputStatusInfo: L,
		isDisabled: p,
		isLoading: f,
		isVideoMuted: m,
		onVideoBtnClick: x,
		requestDeviceAgain: T,
		shouldShowTooltip: M,
		toggleTooltip: P,
		variant: re
	}), /*#__PURE__*/ t.createElement(El, {
		onLeave: v,
		iconSize: R
	})));
}, Pl = {
	wrapper: "_wrapper_kcjjv_18",
	sendButton: "_sendButton_kcjjv_24"
}, Fl = ({ disabled: e }) => {
	let { t: n } = w(), r = n("common.send", "Send"), i = /*#__PURE__*/ t.createElement(z, {
		"aria-label": r,
		className: K(Pl.sendButton),
		disabled: e,
		"data-testid": q.ButtonChatSend,
		variant: "text",
		type: "submit"
	}, /*#__PURE__*/ t.createElement(H, {
		source: U.IconSend,
		size: "compact"
	}));
	return e ? i : /*#__PURE__*/ t.createElement(_t, {
		text: /*#__PURE__*/ t.createElement(G, { variant: "standard" }, r),
		position: "top"
	}, i);
}, Il = ({ isDisabled: e }) => /*#__PURE__*/ t.createElement("div", { className: K(Pl.wrapper) }, /*#__PURE__*/ t.createElement(Fl, { disabled: e })), Ll = {
	form: "_form_1jzpp_129",
	wrapper: "_wrapper_1jzpp_142",
	input: "_input_1jzpp_160"
}, Rl = "chatInputForm", zl = "chatTextInput", Bl = ({ onSubmit: e, isDisabled: n = !1, placeholder: r, className: i, maxHeight: a = 145, ...o }) => {
	let { t: s } = w(), [c, l] = f(""), u = ni(), d = jt(), p = u && d;
	return /*#__PURE__*/ t.createElement(Ne, {
		onSubmit: (t) => {
			t.preventDefault(), e(c), l("");
		},
		id: Rl,
		className: K(Ll.form, i),
		"data-testid": q.ChatForm
	}, /*#__PURE__*/ t.createElement(dt, {
		isAutoResize: !p,
		isLabelHidden: !0,
		autoResizeMaxHeight: p ? void 0 : a,
		rows: 1,
		id: zl,
		label: s("meeting.write-message", "Write a message"),
		className: Ll.wrapper,
		textareaClassname: Ll.input,
		onValueChange: (e) => l(e),
		value: c,
		placeholder: r,
		isDisabled: n,
		autoComplete: "off",
		"data-testid": q.ChatInput,
		maxLength: xn,
		onKeyDown: (e) => {
			e.key === X.enter && (e.shiftKey || (e.preventDefault(), e.currentTarget.form?.dispatchEvent(new Event("submit", {
				cancelable: !0,
				bubbles: !0
			}))));
		},
		...o
	}), /*#__PURE__*/ t.createElement(Il, { isDisabled: !c || n }));
}, Vl = {
	container: "_container_h60ka_4",
	withBorder: "_withBorder_h60ka_10"
}, Hl = ({ className: e, testId: n, withBorder: r, ...i }) => /*#__PURE__*/ t.createElement("div", {
	...i,
	"data-testid": n,
	className: K(Vl.container, { [Vl.withBorder]: r }, e)
}), $ = {
	box: "_box_1vuls_11",
	useHover: "_useHover_1vuls_16",
	isYou: "_isYou_1vuls_19",
	light: "_light_1vuls_19",
	dark: "_dark_1vuls_20",
	messageInformationContainer: "_messageInformationContainer_1vuls_24",
	timestamp: "_timestamp_1vuls_29",
	activityMessageWrapper: "_activityMessageWrapper_1vuls_33",
	messageTitle: "_messageTitle_1vuls_41",
	messageName: "_messageName_1vuls_48",
	messageNameWrapper: "_messageNameWrapper_1vuls_54",
	messageNameMeta: "_messageNameMeta_1vuls_58",
	messageDate: "_messageDate_1vuls_65",
	messageText: "_messageText_1vuls_70",
	truncated: "_truncated_1vuls_70",
	messagePending: "_messagePending_1vuls_91",
	activityMessageIcon: "_activityMessageIcon_1vuls_95"
}, Ul = Gt(Se, "light"), Wl = ({ isYou: e = !1, message: n, displayNameMeta: r, withAvatar: i = !1, isUnread: a = !1, isTruncated: o = !1, noPadding: s = !1, useHoverStyle: c = !1, className: l, children: u }) => {
	let { t: d, i18n: f } = w();
	return /*#__PURE__*/ t.createElement(mt, null, ({ colorScheme: p }) => /*#__PURE__*/ t.createElement(Ul, {
		isWithShadow: !1,
		className: K(l, $.box, p, $[p], {
			[$.messagePending]: n.pending,
			"p-3": !s,
			[$.useHover]: c,
			[$.isYou]: e
		}),
		key: n.id,
		"data-testid": q.ChatMessage
	}, i && /*#__PURE__*/ t.createElement(ve, {
		className: "mr-2",
		colorScheme: "dark",
		displayName: n.displayName,
		sizeModifier: "small",
		type: ye.Initials
	}), /*#__PURE__*/ t.createElement("div", { className: $.messageInformationContainer }, /*#__PURE__*/ t.createElement("div", { className: $.messageTitle }, /*#__PURE__*/ t.createElement("div", { className: K("d-flex align-items-center", $.messageNameWrapper) }, /*#__PURE__*/ t.createElement(G, {
		fontVariant: V.BodyBold,
		className: $.messageName,
		"data-testid": q.ChatMessageName,
		translate: "no"
	}, e ? d("meeting.you", "You") : n.displayName), r && /*#__PURE__*/ t.createElement(G, {
		fontVariant: V.Body,
		className: $.messageNameMeta,
		isTruncated: !0,
		title: r,
		"data-testid": q.ChatMessageNameMeta,
		translate: "no"
	}, "/ ", r), a && /*#__PURE__*/ t.createElement(Hl, {
		testId: q.ChatUnreadMessageIndicator,
		className: "ml-1"
	})), /*#__PURE__*/ t.createElement(G, {
		fontVariant: V.Small,
		className: $.messageDate
	}, bi(n.at, f.language))), /*#__PURE__*/ t.createElement(G, {
		htmlTag: "p",
		fontVariant: a ? V.BodyBold : V.Body,
		className: K($.messageText, { [$.truncated]: o }),
		"data-testid": q.ChatMessageText
	}, u ?? n.message))));
}, Gl = (e) => {
	switch (e) {
		case "removed": return q.ChatRemoveActivityMessage;
		case "empty-chat": return q.ChatEmptyActivityMessage;
		default: return q.ChatActivityMessage;
	}
}, Kl = ({ message: e, className: n }) => {
	let { t: r, i18n: i } = w();
	return /*#__PURE__*/ t.createElement(Se, {
		isWithShadow: !1,
		className: K("p-3", $.activityMessageWrapper, n),
		key: e.id,
		"data-testid": Gl(e.activityType),
		hasBackground: !1
	}, /*#__PURE__*/ t.createElement("div", { className: $.messageText }, /*#__PURE__*/ t.createElement(G, {
		isItalicized: !0,
		htmlTag: "p",
		className: $.messageText
	}, /*#__PURE__*/ t.createElement(G, {
		variant: "tinted",
		"data-testid": q.ChatActivityMessageText
	}, /*#__PURE__*/ t.createElement(H, {
		color: Ee.Neutral70,
		className: $.activityMessageIcon,
		size: "compact",
		source: U.IconInfoRound
	}), vi(e, r)), e.activityType === "removed" && /*#__PURE__*/ t.createElement(G, {
		variant: "tinted",
		className: $.messageName,
		translate: "no"
	}, "\xA0", e.removedParticipant?.displayName)), (e.activityType === "joined" || e.activityType === "left") && /*#__PURE__*/ t.createElement(G, {
		fontVariant: V.Small,
		className: $.messageDate
	}, bi(e.at, i.language))));
}, ql = ({ messages: e, className: n, currentUserId: r }) => /*#__PURE__*/ t.createElement("div", {
	"data-testid": q.ChatMessages,
	className: n
}, e.map((e, n, i) => {
	let a = n + 1 === i.length, o = r ? e.userId === r : !1, s = n > 0 && i[n - 1]?.userId === r, c = n + 1 < i.length && i[n + 1]?.userId === r;
	return e.type === "activity" ? /*#__PURE__*/ t.createElement(Kl, {
		key: e.id,
		className: K({
			"mt-3": s,
			"mb-3": c
		}),
		message: e
	}) : /*#__PURE__*/ t.createElement(Wl, {
		isYou: o,
		className: K({
			"mt-1": s && o,
			"mb-1": a && o
		}),
		key: e.id,
		message: e
	}, /*#__PURE__*/ t.createElement(vt, { text: e.message }));
})), Jl = {
	chatWrapper: "_chatWrapper_1ehtb_143",
	chatMessagesWrapper: "_chatMessagesWrapper_1ehtb_151",
	box: "_box_1ehtb_160",
	messageTitle: "_messageTitle_1ehtb_165",
	messageName: "_messageName_1ehtb_172",
	messageDate: "_messageDate_1ehtb_178",
	newMessagesPillWrapper: "_newMessagesPillWrapper_1ehtb_183",
	"chat-message-from-top": "_chat-message-from-top_1ehtb_1",
	chatMessageFromTop: "_chat-message-from-top_1ehtb_1"
}, Yl = ({ currentUserId: e, closeNewChatMessage: n, displayNewMessageToast: r, messages: i, newMessagesCount: a, scrollbarRef: o, chatPanelMessagesClassName: s }) => /*#__PURE__*/ t.createElement("div", { className: Jl.chatWrapper }, r && /*#__PURE__*/ t.createElement("div", { className: Jl.newMessagesPillWrapper }, /*#__PURE__*/ t.createElement(Cl, {
	newMessagesCount: a,
	scrollToLastMessage: () => tr(o),
	closeNewChatMessage: n
})), /*#__PURE__*/ t.createElement("div", { className: Jl.chatMessagesWrapper }, i.length > 0 && /*#__PURE__*/ t.createElement(ql, {
	currentUserId: e,
	messages: i,
	className: s
}))), Xl = {
	enhancerStart: "_enhancerStart_1yb1h_11",
	enhancerEnd: "_enhancerEnd_1yb1h_19",
	logoWrapper: "_logoWrapper_1yb1h_25",
	logoText: "_logoText_1yb1h_32",
	interactive: "_interactive_1yb1h_37",
	titleSection: "_titleSection_1yb1h_41",
	title: "_title_1yb1h_41",
	subTitle: "_subTitle_1yb1h_53"
}, Zl = ({ className: e, onClick: n, ...r }) => {
	let { t: i } = w();
	return /*#__PURE__*/ t.createElement(G, {
		className: K(e, { [Xl.interactive]: !!n }),
		"data-testid": q.HeaderLogo,
		fontVariant: V.Body,
		onClick: n,
		...r
	}, /*#__PURE__*/ t.createElement(C, {
		t: i,
		i18nKey: "common.a-pexip-meeting"
	}, "a", /*#__PURE__*/ t.createElement($e, {
		"aria-label": i("common.label-pexip-logo", "Pexip logo"),
		size: "medium",
		className: "ml-1 mr-1"
	}), "meeting"));
}, Ql = ({ className: e, text: n, ...r }) => /*#__PURE__*/ t.createElement(ft, {
	htmlTag: "h1",
	fontVariant: V.H5,
	className: K(Xl.title, e),
	...r
}, n), $l = ({ text: e, className: n, ...r }) => /*#__PURE__*/ t.createElement(G, {
	fontVariant: V.Body,
	className: K(Xl.subTitle, n),
	...r
}, "/ ", e), eu = ({ enhancerStartActions: e, onClick: n, subTitle: r, title: i }) => /*#__PURE__*/ t.createElement("div", { className: Xl.enhancerStart }, /*#__PURE__*/ t.createElement("div", { className: Xl.logoWrapper }, /*#__PURE__*/ t.createElement(Zl, {
	className: K(Xl.logoText, "ml-4"),
	onClick: n
}), /*#__PURE__*/ t.createElement(Ae, {
	direction: "vertical",
	className: "ml-4"
})), /*#__PURE__*/ t.createElement(Le, {
	spacing: "compact",
	className: Xl.titleSection
}, i && /*#__PURE__*/ t.createElement(Ql, {
	text: i,
	"data-testid": q.HeaderTitle,
	className: "hideOnMobile"
}), r && /*#__PURE__*/ t.createElement($l, {
	text: r,
	"data-testid": q.HeaderSubTitle,
	className: "hideOnMobile"
}), e)), tu = ({ enhancerEndActions: e, enhancerStartActions: n, onClick: r, subTitle: i, title: a, userAvatar: o, ...s }) => /*#__PURE__*/ t.createElement(ke, {
	enhancerStart: /*#__PURE__*/ t.createElement(eu, {
		enhancerStartActions: n,
		onClick: r,
		subTitle: i,
		title: a
	}),
	enhancerEnd: /*#__PURE__*/ t.createElement(Le, {
		spacing: "small",
		className: Xl.enhancerEnd
	}, e, o),
	...s
}), nu = {
	background: "_background_jsasl_1",
	bar: "_bar_jsasl_2",
	meter: "_meter_jsasl_1"
}, ru = ({ ...e }) => {
	let { t: n } = w();
	return /*#__PURE__*/ t.createElement("svg", {
		viewBox: "-2 0 12 1",
		width: "24",
		height: "10",
		xmlns: "http://www.w3.org/2000/svg",
		role: "img",
		"aria-label": n("media.speaking", "Speaking"),
		...e
	}, /*#__PURE__*/ t.createElement("g", null, /*#__PURE__*/ t.createElement("path", {
		d: "M 0,0.5 h 8",
		className: nu.background
	}), /*#__PURE__*/ t.createElement("path", {
		d: "M 0,0.5 h 8",
		className: nu.bar
	})));
}, iu = {
	speakerPill: "_speakerPill_7pmbs_4",
	speakerName: "_speakerName_7pmbs_15",
	indicator: "_indicator_7pmbs_20"
}, au = ({ speakerName: e }) => /*#__PURE__*/ t.createElement("div", { className: iu.speakerPill }, /*#__PURE__*/ t.createElement(G, {
	fontVariant: V.XSmall,
	className: iu.speakerName
}, e), /*#__PURE__*/ t.createElement(ru, { className: iu.indicator })), ou = {
	container: "_container_sxicr_119",
	horizontal: "_horizontal_sxicr_130",
	noMargin: "_noMargin_sxicr_133",
	external: "_external_sxicr_141",
	expanded: "_expanded_sxicr_141",
	withSidePanel: "_withSidePanel_sxicr_146"
}, su = /*#__PURE__*/ t.forwardRef(({ children: e, className: n, isHorizontal: r, isPrimaryVideoExpanded: i, isSidePanelVisible: a, noMargin: o, ...s }, c) => /*#__PURE__*/ t.createElement("div", {
	className: K(ou.container, n, {
		[ou.horizontal]: !!r,
		[ou.withSidePanel]: !!a && !o,
		[ou.expanded]: !!i,
		[ou.noMargin]: !!o
	}),
	...s,
	ref: c
}, e));
su.displayName = "MeetingStageContainer";
// src/views/ChatPanelToggle/ChatPanelToggle.view.tsx
var cu = ({ isPanelOpen: e, newMessagesCount: n, isTouchDevice: r, ...i }) => {
	let { t: a, i18n: o } = w(), s = So("N"), c = Fi(o), l = a("meeting.toggle-chat-tooltip", "Chat"), u = s ? `${l} ${s}` : l;
	return /*#__PURE__*/ t.createElement(be, {
		number: 0,
		isVisible: !e && n > 0,
		isTruncated: !0
	}, /*#__PURE__*/ t.createElement(dc, {
		shouldShowTooltip: !r,
		tooltipPosition: c === "rtl" ? "left" : "right",
		tooltipText: u,
		"aria-label": u,
		"aria-expanded": e,
		"data-testid": q.ButtonChat,
		icon: /*#__PURE__*/ t.createElement(H, {
			source: U.IconChat,
			size: "small"
		}),
		isActive: e,
		...i
	}));
}, lu = (e) => {
	let t = Ut(), [n, r] = f(!1);
	return a(() => {
		r(t && e);
	}, [e, t]), n;
}, uu = {
	panel: "_panel_j6y6q_255",
	show: "_show_j6y6q_283",
	animateIn: "_animateIn_j6y6q_287",
	"slide-in-panel": "_slide-in-panel_j6y6q_1",
	slideInPanel: "_slide-in-panel_j6y6q_1",
	"slide-in-panel-rtl": "_slide-in-panel-rtl_j6y6q_1",
	slideInPanelRtl: "_slide-in-panel-rtl_j6y6q_1",
	animateOut: "_animateOut_j6y6q_293",
	"slide-out-panel": "_slide-out-panel_j6y6q_1",
	slideOutPanel: "_slide-out-panel_j6y6q_1",
	"slide-out-panel-rtl": "_slide-out-panel-rtl_j6y6q_1",
	slideOutPanelRtl: "_slide-out-panel-rtl_j6y6q_1",
	isMobile: "_isMobile_j6y6q_407",
	networkAlert: "_networkAlert_j6y6q_411"
}, du = ({ children: e, className: n, isShown: r, animateIn: i = !1, animateOut: a = !1, allowScroll: o = !1, isNetworkAlertDisplayed: s = !1, testId: c, ...l }) => {
	let [u, d] = f(null);
	At(u, r);
	let p = lu(r), { ref: m } = It(!o && p), { ref: h } = Rt(o && p), g = ni();
	return /*#__PURE__*/ t.createElement("div", { ref: o ? h : m }, /*#__PURE__*/ t.createElement("div", {
		"data-testid": c,
		ref: d,
		role: l["aria-label"] ? "region" : void 0,
		className: K(uu.panel, {
			[uu.show]: r,
			[uu.animateIn]: i,
			[uu.animateOut]: a,
			[uu.isMobile]: g,
			[uu.networkAlert]: s
		}, n),
		...l
	}, e));
}, fu = { container: "_container_1oh3w_1" }, pu = ({ isTouchDevice: e, className: n, displayName: r, isAuthenticated: i, showParticipantAuthenticatedState: a }) => {
	let { t: o } = w();
	return /*#__PURE__*/ t.createElement("div", { className: K(fu.container, n) }, /*#__PURE__*/ t.createElement(ve, {
		colorScheme: "dark",
		displayName: r,
		sizeModifier: e ? "medium" : "small",
		type: ye.Initials
	}), /*#__PURE__*/ t.createElement(ft, {
		htmlTag: e ? V.H2 : V.H5,
		fontVariant: e ? V.H2 : V.H5,
		className: `${e ? "mt-3" : "mt-1"} text-center`
	}, r), a && /*#__PURE__*/ t.createElement(G, {
		fontVariant: e ? V.BodyBold : V.Small,
		variant: i ? "success" : "danger",
		className: `${e ? "mt-2" : ""} text-center`
	}, i ? o("meeting.authenticated", "Authenticated") : o("meeting.unauthenticated", "Unauthenticated")));
}, mu = {
	modalContent: "_modalContent_1kvwc_4",
	buttonContainer: "_buttonContainer_1kvwc_8"
}, hu = ({ displayName: e, isAuthenticated: n, showParticipantAuthenticatedState: r, isOpen: i, button: a, menuContent: o, onOpenChange: s }) => {
	let { t: c } = w();
	return /*#__PURE__*/ t.createElement(t.Fragment, null, a, /*#__PURE__*/ t.createElement(qe, {
		padding: "compact",
		withCloseButton: !0,
		closeButtonAriaLabel: c("common.close", "Close"),
		scrollbarsAriaLabel: c("common.scrollable-content", "Scrollable content"),
		uniqueTitle: c("media.open-menu-for", {
			defaultValue: "Open menu for {{displayName}}",
			displayName: e
		}),
		closeOnOutsideClick: !0,
		isOpen: i,
		onClose: () => s(!1)
	}, /*#__PURE__*/ t.createElement("div", { className: mu.modalContent }, /*#__PURE__*/ t.createElement(pu, {
		isTouchDevice: !0,
		displayName: e,
		isAuthenticated: n,
		showParticipantAuthenticatedState: r
	}), /*#__PURE__*/ t.createElement("div", { className: mu.buttonContainer }, o.map((e) => /*#__PURE__*/ t.createElement(z, {
		className: "justify-content-start",
		size: "large",
		modifier: "fullWidth",
		key: e.key,
		variant: "text",
		enhancerStart: e.icon,
		onClick: () => {
			e.onItemClick?.(), e.closeMenuOnItemClick !== !1 && s(!1);
		}
	}, e.label))))));
}, gu = ({ isOpen: e, isTouchDevice: n, showParticipantAuthenticatedState: r, displayName: i, handleTransfer: a, handleDTMF: o, handleFecc: s, handleRemoveUserRequest: c, shouldShowHostActions: u, shouldShowHostActionsForCurrentPeer: d, isApiParticipant: f = !1, isMuted: p, isDirectMedia: m, isCurrentPeer: h, isSpotlight: g, isSpotlightAvailable: _, participant: v, additionalMenuContent: y = [], button: b, onOpenChange: x }) => {
	let { t: S } = w(), C = l(() => {
		let e = [
			!!v.lowerHand && !h && v.canRaiseHand && v.raisedHand && {
				label: S("meeting.lower-hand", "Lower hand"),
				onItemClick: () => v.lowerHand?.(),
				testId: q.ActionLowerHand,
				key: "lowerHand",
				closeMenuOnItemClick: !1,
				icon: /*#__PURE__*/ t.createElement(H, {
					size: n ? "small" : "compact",
					source: U.IconLowerhand
				})
			},
			!f && (u || p && d) && v.canMute && {
				label: p ? S("media.unmute-microphone", "Unmute microphone") : S("media.mute-microphone", "Mute microphone"),
				onItemClick: v.mute,
				testId: p ? q.ActionUnmuteMicrophone : q.ActionMuteMicrophone,
				key: "microphone",
				icon: /*#__PURE__*/ t.createElement(H, {
					size: n ? "small" : "compact",
					source: p ? U.IconMicrophoneOff : U.IconMicrophoneOn
				})
			},
			!f && !m && _ && !!v.spotlight && v.canSpotlight && {
				label: g ? S("media.remove-spotlight", "Remove spotlight") : S("media.spotlight", "Spotlight"),
				onItemClick: () => v.spotlight?.(),
				testId: g ? q.ActionRemoveSpotlight : q.ActionSpotlight,
				closeMenuOnItemClick: !1,
				key: "spotlight",
				icon: /*#__PURE__*/ t.createElement(H, {
					size: n ? "small" : "compact",
					source: U.IconSpotlight
				})
			},
			!(!v.setRole || h) && !v.isExternal && v.roomId === qt && {
				label: v.isHost ? S("meeting.make-guest", "Make guest") : S("meeting.make-host", "Make host"),
				onItemClick: () => v.setRole?.(),
				testId: v.isHost ? q.ActionMakeGuest : q.ActionMakeHost,
				key: "setRole",
				closeMenuOnItemClick: !1,
				icon: /*#__PURE__*/ t.createElement(H, {
					size: n ? "small" : "compact",
					source: v.isHost ? U.IconGuest : U.IconHost
				})
			},
			!!a && v.canTransfer && {
				label: S("media.transfer", "Transfer"),
				onItemClick: () => a?.(v.uuid),
				testId: q.ActionTransfer,
				key: "transfer",
				icon: /*#__PURE__*/ t.createElement(H, {
					size: n ? "small" : "compact",
					source: U.IconArrowCornerDown
				})
			},
			!m && !!o && !v.isConnecting && {
				label: S("dtmf.enter-dtmf", "Enter DTMF"),
				onItemClick: () => o?.(v.uuid),
				testId: q.ActionEnterDTMF,
				key: "dtmf",
				icon: /*#__PURE__*/ t.createElement(H, {
					size: n ? "small" : "compact",
					source: U.IconDtmf
				})
			},
			!!s && v.canFecc && {
				label: S("fecc.camera-control", "Camera control"),
				onItemClick: () => s?.(v.uuid),
				testId: q.ActionFecc,
				key: "fecc",
				icon: /*#__PURE__*/ t.createElement(H, {
					size: n ? "small" : "compact",
					source: U.IconFecc
				})
			}
		].filter(Boolean), r = y.map((t, n) => ({
			...t,
			withTopDivider: n === 0 && e.length > 0
		})), l = u && v.canDisconnect ? {
			label: S("meeting.disconnect", "Disconnect"),
			onItemClick: () => c(v, i),
			testId: q.ButtonKickOffParticipant,
			key: "disconnect",
			icon: /*#__PURE__*/ t.createElement(H, {
				size: n ? "small" : "compact",
				source: U.IconPhoneHorisontal
			}),
			withTopDivider: e.length > 0 || r.length > 0,
			isDanger: !0
		} : void 0;
		return [
			...e,
			...r,
			...l ? [l] : []
		];
	}, [
		m,
		v,
		g,
		_,
		S,
		a,
		h,
		o,
		s,
		y,
		i,
		c,
		u,
		d,
		f,
		p,
		n
	]);
	return n ? /*#__PURE__*/ t.createElement(hu, {
		showParticipantAuthenticatedState: r,
		isAuthenticated: !!v.isIdpAuthenticated,
		displayName: i,
		isOpen: e,
		onOpenChange: x,
		menuContent: C,
		button: b
	}) : /*#__PURE__*/ t.createElement(he, {
		headerContent: /*#__PURE__*/ t.createElement(pu, {
			isTouchDevice: !1,
			className: "pt-4 pl-4 pr-4 pb-1",
			displayName: i,
			isAuthenticated: !!v.isIdpAuthenticated,
			showParticipantAuthenticatedState: r
		}),
		onOpenChange: x,
		button: b,
		items: C,
		testId: "kebab-menu"
	});
}, _u = ({ canPerformHostActions: e, isInteracted: t }) => !e || e && !t, vu = ({ canPerformHostActions: e, isCurrentPeer: t, isHost: n, isInteracted: r }) => n && r && !t && e, yu = {
	actionButtonIcon: "_actionButtonIcon_j9fqt_4",
	indicator: "_indicator_j9fqt_9",
	noneRosterCanMuteButton: "_noneRosterCanMuteButton_j9fqt_13",
	additionalOptions: "_additionalOptions_j9fqt_17",
	dragButton: "_dragButton_j9fqt_21",
	moreMenuAndIndicatorsContainer: "_moreMenuAndIndicatorsContainer_j9fqt_25",
	visuallyHidden: "_visuallyHidden_j9fqt_31"
}, bu = (e) => /*#__PURE__*/ t.createElement(H, {
	color: Ee.Neutral70,
	size: "compact",
	...e
}), xu = ({ isTouchDevice: e, isDirectMedia: n, showParticipantAuthenticatedState: r, displayName: i, displayLowerHandOnly: a = !1, handleRemoveUserRequest: o, handleTransfer: s, handleDTMF: c, handleFecc: l, handleLowerHand: u, isApiParticipant: d, isCurrentPeer: p, canPerformHostActions: m, isHost: h, isHover: g, isSpeaking: _, participant: v, onMouseLeave: y, isSpotlightAvailable: b, additionalMenuContent: x = [] }) => {
	let { t: S } = w(), [C, T] = f(!1), { isMuted: E, isClientMuted: D, isCameraMuted: O, isPresenting: k, isSpotlight: A } = v, j = /*#__PURE__*/ t.createElement(_t, {
		text: S("common.lower-hand", "Lower hand"),
		position: "top"
	}, /*#__PURE__*/ t.createElement(z, {
		"data-testid": q.ButtonLowerHandParticipantRow,
		"aria-label": S("common.lower-hand", "Lower hand"),
		role: "button",
		variant: "transparent",
		modifier: "square",
		size: "compact",
		onClick: () => u?.(v.uuid)
	}, /*#__PURE__*/ t.createElement(H, {
		"data-testid": q.ActionLowerHand,
		source: U.IconLowerhand,
		size: "compact"
	})));
	if (u && a && m) return /*#__PURE__*/ t.createElement("div", { className: yu.moreMenuAndIndicatorsContainer }, j);
	let M = g || C, N = _u({
		canPerformHostActions: m,
		isInteracted: M
	}), P = vu({
		canPerformHostActions: m,
		isCurrentPeer: p,
		isHost: h,
		isInteracted: M
	}), F = vu({
		canPerformHostActions: m,
		isCurrentPeer: !1,
		isHost: h,
		isInteracted: M
	}), I = N || P, L = v.spotlight ?? v.setRole ?? v.lowerHand ?? s ?? c ?? l, ee = x.length > 0 || h && m && L && (v.canSpotlight || v.canTransfer || v.canDisconnect), te = ee && M, ne = /*#__PURE__*/ t.createElement(z, {
		"aria-label": i ? S("media.open-menu-for", {
			defaultValue: "Open menu for {{displayName}}",
			displayName: i
		}) : S("common.open-menu", "Open menu"),
		role: "button",
		className: K(yu.indicator, { [yu.visuallyHidden]: !te }),
		isActive: C,
		variant: "secondary",
		modifier: "square",
		size: "compact",
		onClick: () => T(!C),
		"data-testid": q.ParticipantMenuButton
	}, /*#__PURE__*/ t.createElement(H, {
		size: "small",
		className: yu.actionButtonIcon,
		source: U.IconMoreHorizontal
	})), R = E ? S("media.muted-by-a-host", "Muted by a host") : S("media.muted", "Muted"), re = S("media.camera-turned-off", "Camera turned off"), ie = S("media.spotlight", "Spotlight"), ae = S("media.presentation.presenting", "Presenting");
	return /*#__PURE__*/ t.createElement("div", { className: yu.moreMenuAndIndicatorsContainer }, ee && /*#__PURE__*/ t.createElement(gu, {
		isOpen: C,
		isTouchDevice: e,
		showParticipantAuthenticatedState: r,
		isMuted: E,
		displayName: i,
		handleTransfer: s,
		handleDTMF: c,
		handleFecc: l,
		handleRemoveUserRequest: o,
		shouldShowHostActions: P,
		shouldShowHostActionsForCurrentPeer: F,
		isApiParticipant: d,
		isDirectMedia: n,
		isCurrentPeer: p,
		participant: v,
		isSpotlight: A,
		isSpotlightAvailable: b,
		additionalMenuContent: x,
		button: ne,
		onOpenChange: (e) => {
			T(e), e || y();
		}
	}), k && I && /*#__PURE__*/ t.createElement(_t, {
		text: ae,
		position: "top"
	}, /*#__PURE__*/ t.createElement(bu, {
		"aria-hidden": "false",
		"aria-label": ae,
		"data-testid": q.IconPresenting,
		source: U.IconPresentationOn
	})), u && !a && m && j, O && /*#__PURE__*/ t.createElement(_t, {
		text: re,
		position: "top"
	}, /*#__PURE__*/ t.createElement(bu, {
		"aria-hidden": "false",
		"aria-label": re,
		"data-testid": q.IconCameraMuted,
		source: U.IconVideoOff
	})), (E || D) && /*#__PURE__*/ t.createElement(_t, {
		text: R,
		position: "top"
	}, /*#__PURE__*/ t.createElement(bu, {
		"aria-hidden": "false",
		"aria-label": R,
		"data-testid": E ? q.IconMutedByAHost : q.IconMuted,
		source: E ? U.IconMicrophoneMutedByHost : U.IconMicrophoneOff
	})), A && /*#__PURE__*/ t.createElement(_t, {
		text: ie,
		position: "top"
	}, /*#__PURE__*/ t.createElement(bu, {
		"aria-hidden": "false",
		"aria-label": ie,
		"data-testid": q.IconSpotlight,
		source: U.IconSpotlight
	})), _ && !E && N && /*#__PURE__*/ t.createElement(ru, { "data-testid": q.SpeakingIndicator }));
}, Su = /*#__PURE__*/ function(e) {
	return e.BreakoutParticipantDragSvg = "breakout-participant-drag-svg", e;
}({}), Cu = (e) => (t) => (n) => {
	t?.(), e(n);
}, wu = ({ rooms: e, onRoomChange: n, close: r, onPointerDownCapture: i }) => {
	let { t: a } = w(), o = Cu(r), s = Object.entries(e).map(([e, t]) => (Yt(e), {
		label: e === "main" ? a("breakouts.breakout-room.main-name", "Main Room") : t,
		clickAction: o(() => n(e))
	}));
	return /*#__PURE__*/ t.createElement(Ke, {
		testId: q.BreakoutAssignRoomMenu,
		onPointerDownCapture: i,
		menuContent: { [a("breakouts.breakout-room.send-participant-to", "Send participant to:")]: s }
	});
}, Tu = ({ rooms: e, onRoomChange: n, isHover: r, isDragging: i }) => {
	let { t: a } = w(), [o, s] = f(!1), c = r || o;
	return /*#__PURE__*/ t.createElement(t.Fragment, null, !i && c && /*#__PURE__*/ t.createElement(Ve, {
		"data-testid": q.BreakoutAssignRoomMenuButton,
		position: "bottomMiddle",
		buttonSize: "compact",
		buttonModifier: "square",
		direction: "horizontal",
		buttonVariant: "primary",
		reactiveButtonStyles: !1,
		menuComponent: (r) => /*#__PURE__*/ t.createElement(wu, {
			onPointerDownCapture: (e) => e.stopPropagation(),
			close: (e) => {
				r(e);
			},
			rooms: e,
			onRoomChange: n
		}),
		onContentVisibilityChange: s,
		onPointerDownCapture: (e) => e.stopPropagation(),
		onPointerUpCapture: (e) => e.stopPropagation()
	}), /*#__PURE__*/ t.createElement(z, {
		"aria-label": a("common.drag-participant", "Drag participant"),
		className: K(yu.indicator, yu.dragButton),
		size: "compact",
		modifier: "square",
		variant: "translucent",
		noHover: !0
	}, /*#__PURE__*/ t.createElement(H, {
		id: Su.BreakoutParticipantDragSvg,
		size: "small",
		source: U.IconDraggable
	})));
}, Eu = ({ children: e, ...n }) => /*#__PURE__*/ t.createElement("div", {
	role: "list",
	...n
}, e), Du = ({ children: e, ...n }) => /*#__PURE__*/ t.createElement("div", {
	role: "listitem",
	...n
}, e), Ou = {
	participantRow: "_participantRow_1qw2v_11",
	scrim: "_scrim_1qw2v_27",
	actionsWrapper: "_actionsWrapper_1qw2v_46",
	participant: "_participant_1qw2v_11",
	metaText: "_metaText_1qw2v_62",
	mark: "_mark_1qw2v_67"
}, ku = (e, n, r) => {
	if (n.length === 0) return [e];
	let i = [...n].sort((e, t) => e.start - t.start), a = [];
	for (let e of i) if (a.length === 0) a.push({ ...e });
	else {
		let t = a[a.length - 1];
		t && e.start <= t.end + 1 ? t.end = Math.max(t.end, e.end) : a.push({ ...e });
	}
	let o = 0, s = [];
	for (let n = 0; n < a.length; n++) {
		let i = a[n];
		if (!i) continue;
		let c = Math.max(0, Math.min(i.start, e.length)), l = Math.max(0, Math.min(i.end, e.length - 1));
		o < c && s.push(e.slice(o, c));
		let u = e.slice(c, l + 1), d = `${c}-${l}`;
		u && s.push(/*#__PURE__*/ t.createElement("mark", {
			className: r,
			key: d
		}, u)), o = l + 1;
	}
	return o < e.length && s.push(e.slice(o)), s;
}, Au = ({ isTouchDevice: e, admit: n }) => {
	let { t: r } = w(), [i, a] = f(!1);
	return /*#__PURE__*/ t.createElement(_t, {
		text: r("meeting.admit", "Admit"),
		position: "top"
	}, /*#__PURE__*/ t.createElement(z, {
		"aria-label": r("meeting.admit", "Admit"),
		noEnhancerPadding: !0,
		onClick: () => {
			a(!0), n?.();
		},
		variant: "text",
		isLoading: i,
		isDisabled: i,
		size: e ? "small" : "compact",
		"data-testid": q.ButtonAdmitParticipant
	}, /*#__PURE__*/ t.createElement(H, {
		source: U.IconAdmit,
		color: Ee.Join,
		size: e ? "small" : "compact"
	})));
}, ju = ({ isTouchDevice: e, kick: n }) => {
	let { t: r } = w(), [i, a] = f(!1);
	return /*#__PURE__*/ t.createElement(_t, {
		text: r("meeting.deny", "Deny"),
		position: "top"
	}, /*#__PURE__*/ t.createElement(z, {
		"aria-label": r("meeting.deny", "Deny"),
		noEnhancerPadding: !0,
		onClick: () => {
			a(!0), n?.();
		},
		variant: "text",
		isLoading: i,
		isDisabled: i,
		size: e ? "small" : "compact",
		"data-testid": q.ButtonDenyParticipant
	}, /*#__PURE__*/ t.createElement(H, {
		source: U.IconDeny,
		color: Ee.Red70,
		size: e ? "small" : "compact"
	})));
}, Mu = ({ isBreakout: e = !1, isTouchDevice: n, showParticipantAuthenticatedState: r = !1, participant: i, isCurrentPeer: a, onMouseEnter: o, onMouseLeave: s, onPointerDownCapture: c, children: l, className: u, highlightedCharacters: d }) => {
	let { t: f } = w();
	return /*#__PURE__*/ t.createElement("div", {
		key: i.uuid,
		className: K(Ou.participantRow, u),
		onMouseEnter: o,
		onFocus: o,
		onMouseLeave: s,
		onBlur: (e) => {
			e.currentTarget.contains(e.relatedTarget) || s();
		},
		"data-testid": q.ParticipantRow,
		onPointerDownCapture: c
	}, /*#__PURE__*/ t.createElement("div", { className: Ou.participant }, !e && r && /*#__PURE__*/ t.createElement(_t, {
		text: i.isIdpAuthenticated ? f("meeting.authenticated", "Authenticated") : f("meeting.unauthenticated", "Unauthenticated"),
		position: "topRight"
	}, /*#__PURE__*/ t.createElement(H, {
		className: "mr-1",
		source: i.isIdpAuthenticated ? U.IconAuthenticated : U.IconNotauthenticated,
		size: n ? "medium" : "small",
		color: i.isIdpAuthenticated ? Ee.Neutral70 : Ee.SignalOrange130
	})), /*#__PURE__*/ t.createElement(G, {
		fontVariant: V.Body,
		isTruncated: !0,
		title: i.displayName,
		translate: "no"
	}, d && d.length > 0 && i.displayName ? ku(i.displayName, d, Ou.mark) : i.displayName || "User"), a && /*#__PURE__*/ t.createElement(G, {
		className: Ou.metaText,
		fontVariant: V.Body,
		title: f("meeting.you", "You"),
		translate: "no"
	}, "/ ", f("meeting.you", "You")), i.isHost && /*#__PURE__*/ t.createElement(G, {
		className: Ou.metaText,
		fontVariant: V.Body,
		title: f("common.host", "Host"),
		translate: "no"
	}, "/ ", f("common.host", "Host"))), /*#__PURE__*/ t.createElement("div", { className: Ou.actionsWrapper }, /*#__PURE__*/ t.createElement("div", { className: Ou.scrim }), l));
}, Nu = ({ participant: e, isCurrentPeer: n, rooms: i, onParticipantRoomChange: a, isDragging: o, className: s }) => {
	let [c, l] = f(!1), u = r(() => l(!0), []), d = r(() => l(!1), []), p = r((t) => {
		a?.(e.uuid, t);
	}, [a, e.uuid]);
	return /*#__PURE__*/ t.createElement(Mu, {
		isBreakout: !0,
		participant: e,
		isCurrentPeer: n,
		onMouseEnter: u,
		onMouseLeave: d,
		className: s
	}, i && Object.entries(i).length > 0 && /*#__PURE__*/ t.createElement(Tu, {
		rooms: i,
		onRoomChange: p,
		isHover: c,
		isDragging: o
	}));
}, Pu = ({ className: e, isTouchDevice: n, isDirectMedia: i, showParticipantAuthenticatedState: a, displayName: o, handleRemoveUserRequest: s, handleTransfer: c, handleDTMF: l, handleFecc: u, isCurrentPeer: d, canPerformHostActions: p = !0, isApiParticipant: m, isHost: h, isSpeaking: g, participant: _, additionalMenuContent: v = [], displayLowerHandOnly: y, isSpotlightAvailable: b, handleLowerHand: x, highlightedCharacters: S }) => {
	let [C, w] = f(!1), T = r(() => w(!0), []), E = r(() => w(!1), []);
	return /*#__PURE__*/ t.createElement(Du, null, /*#__PURE__*/ t.createElement(Mu, {
		className: e,
		participant: _,
		showParticipantAuthenticatedState: a,
		isCurrentPeer: d,
		onMouseEnter: T,
		onMouseLeave: E,
		isTouchDevice: n,
		highlightedCharacters: S
	}, _.isWaiting || _.serviceType === "ivr" ? /*#__PURE__*/ t.createElement(t.Fragment, null, /*#__PURE__*/ t.createElement(Au, {
		isTouchDevice: n,
		admit: _?.admit
	}), /*#__PURE__*/ t.createElement(ju, {
		isTouchDevice: n,
		kick: _?.kick
	})) : /*#__PURE__*/ t.createElement(xu, {
		displayLowerHandOnly: y,
		isTouchDevice: n,
		showParticipantAuthenticatedState: !!a,
		participant: _,
		isDirectMedia: i,
		canPerformHostActions: p,
		isApiParticipant: m,
		isHost: h,
		isSpeaking: g,
		isHover: C,
		isCurrentPeer: d,
		handleRemoveUserRequest: s,
		handleTransfer: c,
		handleDTMF: l,
		handleFecc: u,
		displayName: o,
		onMouseLeave: E,
		additionalMenuContent: v,
		handleLowerHand: x,
		isSpotlightAvailable: b
	})));
}, Fu = {
	container: "_container_1owbl_4",
	title: "_title_1owbl_10"
}, Iu = ({ children: e, closeButtonAriaLabel: n = "Close panel", onCloseClick: r }) => /*#__PURE__*/ t.createElement("div", { className: Fu.container }, /*#__PURE__*/ t.createElement("div", { className: Fu.title }, e), r && /*#__PURE__*/ t.createElement(z, {
	"aria-label": n,
	onClick: r,
	onPointerDownCapture: (e) => e.stopPropagation(),
	size: "compact",
	variant: "translucent"
}, /*#__PURE__*/ t.createElement(H, {
	size: "compact",
	source: U.IconClose
}))), Lu = {
	scrim: "_scrim_fsdkg_130",
	scrimTop: "_scrimTop_fsdkg_137"
}, Ru = ({ position: e = "top", ...n }) => /*#__PURE__*/ t.createElement(ot, {
	className: K(Lu.scrim, { [Lu.scrimTop]: e === "top" }),
	position: e,
	...n
}), zu = ({ isPanelOpen: e, inMeetingParticipantsCount: n = 0, participantsActionCount: r = 0, shouldAnimate: i, isTouchDevice: a, ...o }) => {
	let { t: s, i18n: c } = w(), l = Fi(c), u = !e && r > 0, d = s("meeting.toggle-participants-panel-tooltip", "Participants"), f = `${d}: ${n}`;
	return /*#__PURE__*/ t.createElement(be, {
		"data-testid": q.BadgeCounterParticipantPanelButton,
		variant: "info",
		isTruncated: u,
		isVisible: n > 0,
		number: n,
		shouldAnimate: i
	}, /*#__PURE__*/ t.createElement(dc, {
		"aria-label": f,
		"aria-expanded": e,
		"data-testid": q.ButtonParticipants,
		tooltipText: d,
		tooltipPosition: l === "rtl" ? "left" : "right",
		shouldShowTooltip: !a,
		icon: /*#__PURE__*/ t.createElement(H, {
			source: U.IconGroup,
			size: "small"
		}),
		isActive: e,
		...o
	}));
}, Bu = ({ isActive: e, count: n = 0, actionCount: r = 0, shouldAnimate: i = !1, isTouchDevice: a = !1, ariaLabel: o, tooltipText: s, icon: c, badgeTestId: l = "", buttonTestId: u = "", tooltipPosition: d = "right", ...f }) => {
	let p = !e && r > 0;
	return /*#__PURE__*/ t.createElement(be, {
		"data-testid": l,
		variant: "info",
		isTruncated: p,
		isVisible: n > 0,
		number: n,
		shouldAnimate: i
	}, /*#__PURE__*/ t.createElement(dc, {
		"aria-label": o,
		"data-testid": u,
		tooltipText: s,
		tooltipPosition: d,
		shouldShowTooltip: !a,
		icon: /*#__PURE__*/ t.createElement(H, {
			source: c,
			size: "small"
		}),
		isActive: e,
		...f
	}));
}, Vu = {
	boxWrapper: "_boxWrapper_74zcz_14",
	background: "_background_74zcz_20",
	barsWrapper: "_barsWrapper_74zcz_24",
	frequencyBar: "_frequencyBar_74zcz_34",
	backgroundProgressAnimation: "_backgroundProgressAnimation_74zcz_44",
	animateBackground: "_animateBackground_74zcz_1"
}, Hu = ({ className: e }) => /*#__PURE__*/ t.createElement("div", { className: K(Vu.frequencyBar, e) }), Uu = ({ barClassName: e, barsNumber: n = 20 }) => /*#__PURE__*/ t.createElement(t.Fragment, null, Array.from({ length: n }, (e, t) => t).map((n) => /*#__PURE__*/ t.createElement(Hu, {
	key: n,
	className: e
}))), Wu = ({ backgroundAnimationDuration: e = 5, barClassName: n, barsWrapperClassName: r, barsNumber: i = 20, className: a, barsWrapperId: o, showBackground: s = !1, showBackgroundAnimation: c = !0, children: l, ...u }) => /*#__PURE__*/ t.createElement("div", {
	style: { animationDuration: c ? `${e}s` : void 0 },
	className: K(Vu.boxWrapper, c && Vu.backgroundProgressAnimation, s && Vu.background, a),
	"data-testid": q.TestAudioInputIndicator,
	...u
}, /*#__PURE__*/ t.createElement("div", {
	className: K(Vu.barsWrapper, r),
	id: o
}, /*#__PURE__*/ t.createElement(Uu, {
	barsNumber: i,
	barClassName: n
})), l), Gu = { main: "_main_1rjir_1" }, Ku = ({ children: e }) => /*#__PURE__*/ t.createElement("div", { className: Gu.main }, e), qu = ({ isOpen: e, presenterName: n, onConfirm: r, onCancel: i }) => {
	let { t: a } = w(), o = n ? Ju(n) : a("media.presentation.the-current", "the current");
	return /*#__PURE__*/ t.createElement(Oe, {
		cancelButtonTestid: q.ButtonStealPresentationCancel,
		cancelButtonText: a("common.cancel", "Cancel"),
		confirmButtonTestid: q.ButtonStealPresentationConfirm,
		confirmButtonText: a("media.presentation.take-over", "Take over"),
		"data-testid": q.ModalStealPresentation,
		description: a("media.presentation.this-will-end", {
			defaultValue: "This will end {{normalizedPresenterName}} presentation and start your own.",
			normalizedPresenterName: o
		}),
		isOpen: e,
		onCancel: i,
		onConfirm: r,
		title: a("media-presentation.do-you-want-to-take-over", "Do you want to take over the presentation?"),
		uniqueTitle: a("media-presentation.do-you-want-to-take-over", "Do you want to take over the presentation?")
	});
}, Ju = (e) => e === "" ? e : e.slice(-1).toLowerCase() === "s" ? `${e}’` : `${e}’s`, Yu = {
	panel: "_panel_1egg8_102",
	scrollbar: "_scrollbar_1egg8_115"
}, Xu = (e) => /*#__PURE__*/ t.createElement(Qe, {
	className: Yu.panel,
	scrollbarsClassname: Yu.scrollbar,
	colorScheme: "light",
	hasFooterShadow: !1,
	headerPadding: "none",
	isWithShadow: !1,
	...e
}), Zu = (t) => /* @__PURE__ */ e.createElement("svg", {
	width: 140,
	height: 89,
	viewBox: "0 0 140 89",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...t
}, /* @__PURE__ */ e.createElement("rect", {
	x: .5,
	y: .5,
	width: 139,
	height: 88,
	rx: 3.5,
	fill: "currentColor",
	stroke: "#BBBFC3"
}), /* @__PURE__ */ e.createElement("rect", {
	x: 3,
	y: 3,
	width: 65,
	height: 36,
	rx: 2,
	fill: "#BBBFC3"
}), /* @__PURE__ */ e.createElement("rect", {
	x: 118.5,
	y: 70,
	width: 17,
	height: 16,
	rx: 2,
	fill: "#BBBFC3"
}), /* @__PURE__ */ e.createElement("rect", {
	x: 3,
	y: 41,
	width: 43,
	height: 27,
	rx: 2,
	fill: "#BBBFC3"
}), /* @__PURE__ */ e.createElement("rect", {
	x: 4.5,
	y: 70,
	width: 17,
	height: 16,
	rx: 2,
	fill: "#BBBFC3"
}), /* @__PURE__ */ e.createElement("rect", {
	x: 42.5,
	y: 70,
	width: 17,
	height: 16,
	rx: 2,
	fill: "#BBBFC3"
}), /* @__PURE__ */ e.createElement("rect", {
	x: 80.5,
	y: 70,
	width: 17,
	height: 16,
	rx: 2,
	fill: "#BBBFC3"
}), /* @__PURE__ */ e.createElement("rect", {
	x: 23.5,
	y: 70,
	width: 17,
	height: 16,
	rx: 2,
	fill: "#BBBFC3"
}), /* @__PURE__ */ e.createElement("rect", {
	x: 61.5,
	y: 70,
	width: 17,
	height: 16,
	rx: 2,
	fill: "#BBBFC3"
}), /* @__PURE__ */ e.createElement("rect", {
	x: 99.5,
	y: 70,
	width: 17,
	height: 16,
	rx: 2,
	fill: "#BBBFC3"
}), /* @__PURE__ */ e.createElement("rect", {
	x: 48,
	y: 41,
	width: 44,
	height: 27,
	rx: 2,
	fill: "#BBBFC3"
}), /* @__PURE__ */ e.createElement("rect", {
	x: 94,
	y: 41,
	width: 43,
	height: 27,
	rx: 2,
	fill: "#BBBFC3"
}), /* @__PURE__ */ e.createElement("rect", {
	x: 70,
	y: 3,
	width: 67,
	height: 36,
	rx: 2,
	fill: "#BBBFC3"
})), Qu = (t) => /* @__PURE__ */ e.createElement("svg", {
	width: 140,
	height: 90,
	viewBox: "0 0 140 90",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...t
}, /* @__PURE__ */ e.createElement("rect", {
	x: .5,
	y: .5,
	width: 139,
	height: 88.7739,
	rx: 3.5,
	fill: "currentColor",
	stroke: "#BBBFC3"
}), /* @__PURE__ */ e.createElement("rect", {
	x: 33,
	y: 12.1044,
	width: 74,
	height: 45.3913,
	rx: 2,
	fill: "#BBBFC3"
}), /* @__PURE__ */ e.createElement("rect", {
	x: 4,
	y: 66,
	width: 18,
	height: 14,
	rx: 2,
	fill: "#BBBFC3"
}), /* @__PURE__ */ e.createElement("rect", {
	x: 23,
	y: 66,
	width: 18,
	height: 14,
	rx: 2,
	fill: "#BBBFC3"
}), /* @__PURE__ */ e.createElement("rect", {
	x: 42,
	y: 66,
	width: 17,
	height: 14,
	rx: 2,
	fill: "#BBBFC3"
}), /* @__PURE__ */ e.createElement("rect", {
	x: 61,
	y: 66,
	width: 17,
	height: 14,
	rx: 2,
	fill: "#BBBFC3"
}), /* @__PURE__ */ e.createElement("rect", {
	x: 80,
	y: 66,
	width: 18,
	height: 14,
	rx: 2,
	fill: "#BBBFC3"
}), /* @__PURE__ */ e.createElement("rect", {
	x: 99,
	y: 66,
	width: 18,
	height: 14,
	rx: 2,
	fill: "#BBBFC3"
}), /* @__PURE__ */ e.createElement("rect", {
	x: 118,
	y: 66,
	width: 18,
	height: 14,
	rx: 2,
	fill: "#BBBFC3"
})), $u = (t) => /* @__PURE__ */ e.createElement("svg", {
	width: 140,
	height: 90,
	viewBox: "0 0 140 90",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...t
}, /* @__PURE__ */ e.createElement("rect", {
	x: .5,
	y: .5,
	width: 139,
	height: 88.7739,
	rx: 3.5,
	fill: "currentColor",
	stroke: "#BBBFC3"
}), /* @__PURE__ */ e.createElement("rect", {
	x: 5,
	y: 59.9163,
	width: 17.2832,
	height: 11.5771,
	rx: 2,
	fill: "#BBBFC3"
}), /* @__PURE__ */ e.createElement("rect", {
	x: 5,
	y: 47,
	width: 17.2832,
	height: 11.5771,
	rx: 2,
	fill: "#BBBFC3"
}), /* @__PURE__ */ e.createElement("rect", {
	x: 23.7891,
	y: 59.9163,
	width: 17.2832,
	height: 11.5771,
	rx: 2,
	fill: "#BBBFC3"
}), /* @__PURE__ */ e.createElement("rect", {
	x: 23.7891,
	y: 47,
	width: 17.2832,
	height: 11.5771,
	rx: 2,
	fill: "#BBBFC3"
}), /* @__PURE__ */ e.createElement("rect", {
	x: 42.5703,
	y: 59.9163,
	width: 17.2832,
	height: 11.5771,
	rx: 2,
	fill: "#BBBFC3"
}), /* @__PURE__ */ e.createElement("rect", {
	x: 42.5703,
	y: 47,
	width: 17.2832,
	height: 11.5771,
	rx: 2,
	fill: "#BBBFC3"
}), /* @__PURE__ */ e.createElement("rect", {
	x: 61.3594,
	y: 59.9163,
	width: 17.2832,
	height: 11.5771,
	rx: 2,
	fill: "#BBBFC3"
}), /* @__PURE__ */ e.createElement("rect", {
	x: 61.3594,
	y: 47,
	width: 17.2832,
	height: 11.5771,
	rx: 2,
	fill: "#BBBFC3"
}), /* @__PURE__ */ e.createElement("rect", {
	x: 98.9297,
	y: 59.9163,
	width: 17.2832,
	height: 11.5771,
	rx: 2,
	fill: "#BBBFC3"
}), /* @__PURE__ */ e.createElement("rect", {
	x: 98.9297,
	y: 47,
	width: 17.2832,
	height: 11.5771,
	rx: 2,
	fill: "#BBBFC3"
}), /* @__PURE__ */ e.createElement("rect", {
	x: 80.1484,
	y: 59.9163,
	width: 17.2832,
	height: 11.5771,
	rx: 2,
	fill: "#BBBFC3"
}), /* @__PURE__ */ e.createElement("rect", {
	x: 80.1484,
	y: 47,
	width: 17.2832,
	height: 11.5771,
	rx: 2,
	fill: "#BBBFC3"
}), /* @__PURE__ */ e.createElement("rect", {
	x: 117.719,
	y: 59.9163,
	width: 17.2832,
	height: 11.5771,
	rx: 2,
	fill: "#BBBFC3"
}), /* @__PURE__ */ e.createElement("rect", {
	x: 117.719,
	y: 47,
	width: 17.2832,
	height: 11.5771,
	rx: 2,
	fill: "#BBBFC3"
}), /* @__PURE__ */ e.createElement("rect", {
	x: 5,
	y: 73.4229,
	width: 17.2832,
	height: 11.5771,
	rx: 2,
	fill: "#BBBFC3"
}), /* @__PURE__ */ e.createElement("rect", {
	x: 23.7891,
	y: 73.4229,
	width: 17.2832,
	height: 11.5771,
	rx: 2,
	fill: "#BBBFC3"
}), /* @__PURE__ */ e.createElement("rect", {
	x: 42.5703,
	y: 73.4229,
	width: 17.2832,
	height: 11.5771,
	rx: 2,
	fill: "#BBBFC3"
}), /* @__PURE__ */ e.createElement("rect", {
	x: 61.3594,
	y: 73.4229,
	width: 17.2832,
	height: 11.5771,
	rx: 2,
	fill: "#BBBFC3"
}), /* @__PURE__ */ e.createElement("rect", {
	x: 98.9297,
	y: 73.4229,
	width: 17.2832,
	height: 11.5771,
	rx: 2,
	fill: "#BBBFC3"
}), /* @__PURE__ */ e.createElement("rect", {
	x: 80.1484,
	y: 73.4229,
	width: 17.2832,
	height: 11.5771,
	rx: 2,
	fill: "#BBBFC3"
}), /* @__PURE__ */ e.createElement("rect", {
	x: 117.719,
	y: 73.4229,
	width: 17.2832,
	height: 11.5771,
	rx: 2,
	fill: "#BBBFC3"
}), /* @__PURE__ */ e.createElement("rect", {
	x: 37,
	y: 5,
	width: 66,
	height: 38,
	rx: 2,
	fill: "#BBBFC3"
})), ed = (t) => /* @__PURE__ */ e.createElement("svg", {
	width: 140,
	height: 90,
	viewBox: "0 0 140 90",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...t
}, /* @__PURE__ */ e.createElement("rect", {
	x: .5,
	y: .5,
	width: 139,
	height: 88.7739,
	rx: 3.5,
	fill: "currentColor",
	stroke: "#BBBFC3"
}), /* @__PURE__ */ e.createElement("rect", {
	x: 5,
	y: 5,
	width: 63,
	height: 39,
	rx: 2,
	fill: "#BBBFC3"
}), /* @__PURE__ */ e.createElement("rect", {
	x: 72,
	y: 5,
	width: 63,
	height: 39,
	rx: 2,
	fill: "#BBBFC3"
}), /* @__PURE__ */ e.createElement("rect", {
	x: 5,
	y: 59.9163,
	width: 17.2832,
	height: 11.5771,
	rx: 2,
	fill: "#BBBFC3"
}), /* @__PURE__ */ e.createElement("rect", {
	x: 5,
	y: 47,
	width: 17.2832,
	height: 11.5771,
	rx: 2,
	fill: "#BBBFC3"
}), /* @__PURE__ */ e.createElement("rect", {
	x: 23.7891,
	y: 59.9163,
	width: 17.2832,
	height: 11.5771,
	rx: 2,
	fill: "#BBBFC3"
}), /* @__PURE__ */ e.createElement("rect", {
	x: 23.7891,
	y: 47,
	width: 17.2832,
	height: 11.5771,
	rx: 2,
	fill: "#BBBFC3"
}), /* @__PURE__ */ e.createElement("rect", {
	x: 42.5703,
	y: 59.9163,
	width: 17.2832,
	height: 11.5771,
	rx: 2,
	fill: "#BBBFC3"
}), /* @__PURE__ */ e.createElement("rect", {
	x: 42.5703,
	y: 47,
	width: 17.2832,
	height: 11.5771,
	rx: 2,
	fill: "#BBBFC3"
}), /* @__PURE__ */ e.createElement("rect", {
	x: 61.3594,
	y: 59.9163,
	width: 17.2832,
	height: 11.5771,
	rx: 2,
	fill: "#BBBFC3"
}), /* @__PURE__ */ e.createElement("rect", {
	x: 61.3594,
	y: 47,
	width: 17.2832,
	height: 11.5771,
	rx: 2,
	fill: "#BBBFC3"
}), /* @__PURE__ */ e.createElement("rect", {
	x: 98.9297,
	y: 59.9163,
	width: 17.2832,
	height: 11.5771,
	rx: 2,
	fill: "#BBBFC3"
}), /* @__PURE__ */ e.createElement("rect", {
	x: 98.9297,
	y: 47,
	width: 17.2832,
	height: 11.5771,
	rx: 2,
	fill: "#BBBFC3"
}), /* @__PURE__ */ e.createElement("rect", {
	x: 80.1484,
	y: 59.9163,
	width: 17.2832,
	height: 11.5771,
	rx: 2,
	fill: "#BBBFC3"
}), /* @__PURE__ */ e.createElement("rect", {
	x: 80.1484,
	y: 47,
	width: 17.2832,
	height: 11.5771,
	rx: 2,
	fill: "#BBBFC3"
}), /* @__PURE__ */ e.createElement("rect", {
	x: 117.719,
	y: 59.9163,
	width: 17.2832,
	height: 11.5771,
	rx: 2,
	fill: "#BBBFC3"
}), /* @__PURE__ */ e.createElement("rect", {
	x: 117.719,
	y: 47,
	width: 17.2832,
	height: 11.5771,
	rx: 2,
	fill: "#BBBFC3"
}), /* @__PURE__ */ e.createElement("rect", {
	x: 5,
	y: 73.4229,
	width: 17.2832,
	height: 11.5771,
	rx: 2,
	fill: "#BBBFC3"
}), /* @__PURE__ */ e.createElement("rect", {
	x: 23.7891,
	y: 73.4229,
	width: 17.2832,
	height: 11.5771,
	rx: 2,
	fill: "#BBBFC3"
}), /* @__PURE__ */ e.createElement("rect", {
	x: 42.5703,
	y: 73.4229,
	width: 17.2832,
	height: 11.5771,
	rx: 2,
	fill: "#BBBFC3"
}), /* @__PURE__ */ e.createElement("rect", {
	x: 61.3594,
	y: 73.4229,
	width: 17.2832,
	height: 11.5771,
	rx: 2,
	fill: "#BBBFC3"
}), /* @__PURE__ */ e.createElement("rect", {
	x: 98.9297,
	y: 73.4229,
	width: 17.2832,
	height: 11.5771,
	rx: 2,
	fill: "#BBBFC3"
}), /* @__PURE__ */ e.createElement("rect", {
	x: 80.1484,
	y: 73.4229,
	width: 17.2832,
	height: 11.5771,
	rx: 2,
	fill: "#BBBFC3"
}), /* @__PURE__ */ e.createElement("rect", {
	x: 117.719,
	y: 73.4229,
	width: 17.2832,
	height: 11.5771,
	rx: 2,
	fill: "#BBBFC3"
})), td = (t) => /* @__PURE__ */ e.createElement("svg", {
	width: 140,
	height: 90,
	viewBox: "0 0 140 90",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...t
}, /* @__PURE__ */ e.createElement("rect", {
	x: .5,
	y: .5,
	width: 139,
	height: 88.7739,
	rx: 3.5,
	fill: "currentColor",
	stroke: "#BBBFC3"
}), /* @__PURE__ */ e.createElement("rect", {
	x: 43,
	y: 4,
	width: 55,
	height: 39,
	rx: 2.51724,
	fill: "#BBBFC3"
}), /* @__PURE__ */ e.createElement("rect", {
	x: 119,
	y: 45,
	width: 17,
	height: 12,
	rx: 2,
	fill: "#BBBFC3"
}), /* @__PURE__ */ e.createElement("rect", {
	x: 99,
	y: 45,
	width: 18,
	height: 12,
	rx: 2,
	fill: "#BBBFC3"
}), /* @__PURE__ */ e.createElement("rect", {
	x: 80,
	y: 45,
	width: 18,
	height: 12,
	rx: 2,
	fill: "#BBBFC3"
}), /* @__PURE__ */ e.createElement("rect", {
	x: 62,
	y: 45,
	width: 17,
	height: 12,
	rx: 2,
	fill: "#BBBFC3"
}), /* @__PURE__ */ e.createElement("rect", {
	x: 43,
	y: 45,
	width: 18,
	height: 12,
	rx: 2,
	fill: "#BBBFC3"
}), /* @__PURE__ */ e.createElement("rect", {
	x: 24,
	y: 45,
	width: 18,
	height: 12,
	rx: 2,
	fill: "#BBBFC3"
}), /* @__PURE__ */ e.createElement("rect", {
	x: 5,
	y: 45,
	width: 17,
	height: 12,
	rx: 2,
	fill: "#BBBFC3"
}), /* @__PURE__ */ e.createElement("rect", {
	x: 119,
	y: 18,
	width: 17,
	height: 12,
	rx: 2,
	fill: "#BBBFC3"
}), /* @__PURE__ */ e.createElement("rect", {
	x: 99,
	y: 18,
	width: 18,
	height: 12,
	rx: 2,
	fill: "#BBBFC3"
}), /* @__PURE__ */ e.createElement("rect", {
	x: 24,
	y: 18,
	width: 18,
	height: 12,
	rx: 2,
	fill: "#BBBFC3"
}), /* @__PURE__ */ e.createElement("rect", {
	x: 5,
	y: 18,
	width: 17,
	height: 12,
	rx: 2,
	fill: "#BBBFC3"
}), /* @__PURE__ */ e.createElement("rect", {
	x: 119,
	y: 4,
	width: 17,
	height: 12,
	rx: 2,
	fill: "#BBBFC3"
}), /* @__PURE__ */ e.createElement("rect", {
	x: 99,
	y: 4,
	width: 18,
	height: 12,
	rx: 2,
	fill: "#BBBFC3"
}), /* @__PURE__ */ e.createElement("rect", {
	x: 24,
	y: 4,
	width: 18,
	height: 12,
	rx: 2,
	fill: "#BBBFC3"
}), /* @__PURE__ */ e.createElement("rect", {
	x: 5,
	y: 4,
	width: 17,
	height: 12,
	rx: 2,
	fill: "#BBBFC3"
}), /* @__PURE__ */ e.createElement("rect", {
	x: 119,
	y: 59,
	width: 17,
	height: 12,
	rx: 2,
	fill: "#BBBFC3"
}), /* @__PURE__ */ e.createElement("rect", {
	x: 99,
	y: 59,
	width: 18,
	height: 12,
	rx: 2,
	fill: "#BBBFC3"
}), /* @__PURE__ */ e.createElement("rect", {
	x: 80,
	y: 59,
	width: 18,
	height: 12,
	rx: 2,
	fill: "#BBBFC3"
}), /* @__PURE__ */ e.createElement("rect", {
	x: 62,
	y: 59,
	width: 17,
	height: 12,
	rx: 2,
	fill: "#BBBFC3"
}), /* @__PURE__ */ e.createElement("rect", {
	x: 43,
	y: 59,
	width: 18,
	height: 12,
	rx: 2,
	fill: "#BBBFC3"
}), /* @__PURE__ */ e.createElement("rect", {
	x: 24,
	y: 59,
	width: 18,
	height: 12,
	rx: 2,
	fill: "#BBBFC3"
}), /* @__PURE__ */ e.createElement("rect", {
	x: 5,
	y: 59,
	width: 17,
	height: 12,
	rx: 2,
	fill: "#BBBFC3"
}), /* @__PURE__ */ e.createElement("rect", {
	x: 119,
	y: 32,
	width: 17,
	height: 11,
	rx: 2,
	fill: "#BBBFC3"
}), /* @__PURE__ */ e.createElement("rect", {
	x: 99,
	y: 32,
	width: 18,
	height: 11,
	rx: 2,
	fill: "#BBBFC3"
}), /* @__PURE__ */ e.createElement("rect", {
	x: 24,
	y: 32,
	width: 18,
	height: 11,
	rx: 2,
	fill: "#BBBFC3"
}), /* @__PURE__ */ e.createElement("rect", {
	x: 5,
	y: 32,
	width: 17,
	height: 11,
	rx: 2,
	fill: "#BBBFC3"
}), /* @__PURE__ */ e.createElement("rect", {
	x: 119,
	y: 73,
	width: 17,
	height: 12,
	rx: 2,
	fill: "#BBBFC3"
}), /* @__PURE__ */ e.createElement("rect", {
	x: 99,
	y: 73,
	width: 18,
	height: 12,
	rx: 2,
	fill: "#BBBFC3"
}), /* @__PURE__ */ e.createElement("rect", {
	x: 80,
	y: 73,
	width: 18,
	height: 12,
	rx: 2,
	fill: "#BBBFC3"
}), /* @__PURE__ */ e.createElement("rect", {
	x: 62,
	y: 73,
	width: 17,
	height: 12,
	rx: 2,
	fill: "#BBBFC3"
}), /* @__PURE__ */ e.createElement("rect", {
	x: 43,
	y: 73,
	width: 18,
	height: 12,
	rx: 2,
	fill: "#BBBFC3"
}), /* @__PURE__ */ e.createElement("rect", {
	x: 24,
	y: 73,
	width: 18,
	height: 12,
	rx: 2,
	fill: "#BBBFC3"
}), /* @__PURE__ */ e.createElement("rect", {
	x: 5,
	y: 73,
	width: 17,
	height: 12,
	rx: 2,
	fill: "#BBBFC3"
})), nd = (t) => /* @__PURE__ */ e.createElement("svg", {
	width: 140,
	height: 89,
	viewBox: "0 0 140 89",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...t
}, /* @__PURE__ */ e.createElement("rect", {
	x: .5,
	y: .5,
	width: 139,
	height: 88,
	rx: 3.5,
	fill: "currentColor",
	stroke: "#BBBFC3"
}), /* @__PURE__ */ e.createElement("rect", {
	x: 9,
	y: 12,
	width: 124,
	height: 65,
	rx: 2,
	fill: "#BBBFC3"
})), rd = (t) => /* @__PURE__ */ e.createElement("svg", {
	width: 140,
	height: 89,
	viewBox: "0 0 140 89",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...t
}, /* @__PURE__ */ e.createElement("rect", {
	x: .5,
	y: .5,
	width: 139,
	height: 88,
	rx: 3.5,
	fill: "currentColor",
	stroke: "#BBBFC3"
}), /* @__PURE__ */ e.createElement("rect", {
	x: 8,
	y: 12,
	width: 58,
	height: 29,
	rx: 2,
	fill: "#BBBFC3"
}), /* @__PURE__ */ e.createElement("rect", {
	x: 8,
	y: 49,
	width: 58,
	height: 29,
	rx: 2,
	fill: "#BBBFC3"
}), /* @__PURE__ */ e.createElement("rect", {
	x: 74,
	y: 12,
	width: 58,
	height: 29,
	rx: 2,
	fill: "#BBBFC3"
}), /* @__PURE__ */ e.createElement("rect", {
	x: 74,
	y: 49,
	width: 58,
	height: 29,
	rx: 2,
	fill: "#BBBFC3"
})), id = (t) => /* @__PURE__ */ e.createElement("svg", {
	width: 140,
	height: 88,
	viewBox: "0 0 140 88",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...t
}, /* @__PURE__ */ e.createElement("rect", {
	x: .5,
	y: .5,
	width: 139,
	height: 86.3964,
	rx: 3.5,
	fill: "currentColor",
	stroke: "#BBBFC3"
}), /* @__PURE__ */ e.createElement("rect", {
	x: 8,
	y: 9.81982,
	width: 38.6231,
	height: 19.9617,
	rx: 2.03279,
	fill: "#BBBFC3"
}), /* @__PURE__ */ e.createElement("rect", {
	x: 8,
	y: 33.3873,
	width: 38.6231,
	height: 19.9617,
	rx: 2.03279,
	fill: "#BBBFC3"
}), /* @__PURE__ */ e.createElement("rect", {
	x: 8,
	y: 56.9551,
	width: 38.6231,
	height: 19.9617,
	rx: 2.03279,
	fill: "#BBBFC3"
}), /* @__PURE__ */ e.createElement("rect", {
	x: 50.6875,
	y: 9.81982,
	width: 38.6231,
	height: 19.9617,
	rx: 2.03279,
	fill: "#BBBFC3"
}), /* @__PURE__ */ e.createElement("rect", {
	x: 50.6875,
	y: 33.3873,
	width: 38.6231,
	height: 19.9617,
	rx: 2.03279,
	fill: "#BBBFC3"
}), /* @__PURE__ */ e.createElement("rect", {
	x: 50.6875,
	y: 56.9551,
	width: 38.6231,
	height: 19.9617,
	rx: 2.03279,
	fill: "#BBBFC3"
}), /* @__PURE__ */ e.createElement("rect", {
	x: 92.3594,
	y: 9.81982,
	width: 39.6395,
	height: 19.9617,
	rx: 2.03279,
	fill: "#BBBFC3"
}), /* @__PURE__ */ e.createElement("rect", {
	x: 92.3594,
	y: 33.3873,
	width: 39.6395,
	height: 19.9617,
	rx: 2.03279,
	fill: "#BBBFC3"
}), /* @__PURE__ */ e.createElement("rect", {
	x: 92.3594,
	y: 56.9551,
	width: 39.6395,
	height: 19.9617,
	rx: 2.03279,
	fill: "#BBBFC3"
})), ad = (t) => /* @__PURE__ */ e.createElement("svg", {
	width: 140,
	height: 89,
	viewBox: "0 0 140 89",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...t
}, /* @__PURE__ */ e.createElement("rect", {
	x: .5,
	y: .5,
	width: 139,
	height: 88,
	rx: 3.5,
	fill: "currentColor",
	stroke: "#BBBFC3"
}), /* @__PURE__ */ e.createElement("rect", {
	x: 41.1016,
	y: 63.8228,
	width: 27.2728,
	height: 14.3541,
	rx: 1.43541,
	fill: "#BBBFC3"
}), /* @__PURE__ */ e.createElement("rect", {
	x: 71.1953,
	y: 29.2743,
	width: 27.9905,
	height: 14.3541,
	rx: 1.43541,
	fill: "#BBBFC3"
}), /* @__PURE__ */ e.createElement("rect", {
	x: 11,
	y: 29.2743,
	width: 27.2728,
	height: 14.3541,
	rx: 1.43541,
	fill: "#BBBFC3"
}), /* @__PURE__ */ e.createElement("rect", {
	x: 11,
	y: 12,
	width: 27.2728,
	height: 14.3541,
	rx: 1.43541,
	fill: "#BBBFC3"
}), /* @__PURE__ */ e.createElement("rect", {
	x: 11,
	y: 46.5486,
	width: 27.2728,
	height: 14.3541,
	rx: 1.43541,
	fill: "#BBBFC3"
}), /* @__PURE__ */ e.createElement("rect", {
	x: 11,
	y: 63.8228,
	width: 27.2728,
	height: 14.3541,
	rx: 1.43541,
	fill: "#BBBFC3"
}), /* @__PURE__ */ e.createElement("rect", {
	x: 41.1016,
	y: 29.2743,
	width: 27.2728,
	height: 14.3541,
	rx: 1.43541,
	fill: "#BBBFC3"
}), /* @__PURE__ */ e.createElement("rect", {
	x: 41.1016,
	y: 12,
	width: 27.2728,
	height: 14.3541,
	rx: 1.43541,
	fill: "#BBBFC3"
}), /* @__PURE__ */ e.createElement("rect", {
	x: 41.1016,
	y: 46.5486,
	width: 27.2728,
	height: 14.3541,
	rx: 1.43541,
	fill: "#BBBFC3"
}), /* @__PURE__ */ e.createElement("rect", {
	x: 71.1953,
	y: 12,
	width: 27.9905,
	height: 14.3541,
	rx: 1.43541,
	fill: "#BBBFC3"
}), /* @__PURE__ */ e.createElement("rect", {
	x: 102.008,
	y: 29.2743,
	width: 27.9905,
	height: 14.3541,
	rx: 1.43541,
	fill: "#BBBFC3"
}), /* @__PURE__ */ e.createElement("rect", {
	x: 102.008,
	y: 12,
	width: 27.9905,
	height: 14.3541,
	rx: 1.43541,
	fill: "#BBBFC3"
}), /* @__PURE__ */ e.createElement("rect", {
	x: 102.008,
	y: 46.5486,
	width: 27.9905,
	height: 14.3541,
	rx: 1.43541,
	fill: "#BBBFC3"
}), /* @__PURE__ */ e.createElement("rect", {
	x: 102.008,
	y: 63.8228,
	width: 27.9905,
	height: 14.3541,
	rx: 1.43541,
	fill: "#BBBFC3"
}), /* @__PURE__ */ e.createElement("rect", {
	x: 71.1953,
	y: 46.5486,
	width: 27.9905,
	height: 14.3541,
	rx: 1.43541,
	fill: "#BBBFC3"
}), /* @__PURE__ */ e.createElement("rect", {
	x: 71.1953,
	y: 63.8228,
	width: 27.9905,
	height: 14.3541,
	rx: 1.43541,
	fill: "#BBBFC3"
})), od = (t) => /* @__PURE__ */ e.createElement("svg", {
	width: 140,
	height: 89,
	viewBox: "0 0 140 89",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...t
}, /* @__PURE__ */ e.createElement("rect", {
	x: .5,
	y: .5,
	width: 139,
	height: 88,
	rx: 3.5,
	fill: "currentColor",
	stroke: "#BBBFC3"
}), /* @__PURE__ */ e.createElement("rect", {
	x: 31.0859,
	y: 67.6501,
	width: 23.6379,
	height: 12.441,
	rx: 1.2441,
	fill: "#BBBFC3"
}), /* @__PURE__ */ e.createElement("rect", {
	x: 57.1717,
	y: 37.7063,
	width: 24.26,
	height: 12.441,
	rx: 1.2441,
	fill: "#BBBFC3"
}), /* @__PURE__ */ e.createElement("rect", {
	x: 5,
	y: 37.7063,
	width: 23.6379,
	height: 12.441,
	rx: 1.2441,
	fill: "#BBBFC3"
}), /* @__PURE__ */ e.createElement("rect", {
	x: 5,
	y: 22.7343,
	width: 23.6379,
	height: 12.441,
	rx: 1.2441,
	fill: "#BBBFC3"
}), /* @__PURE__ */ e.createElement("rect", {
	x: 5,
	y: 8,
	width: 23.6379,
	height: 12.441,
	rx: 1.2441,
	fill: "#BBBFC3"
}), /* @__PURE__ */ e.createElement("rect", {
	x: 5,
	y: 52.6782,
	width: 23.6379,
	height: 12.441,
	rx: 1.2441,
	fill: "#BBBFC3"
}), /* @__PURE__ */ e.createElement("rect", {
	x: 5,
	y: 67.6501,
	width: 23.6379,
	height: 12.441,
	rx: 1.2441,
	fill: "#BBBFC3"
}), /* @__PURE__ */ e.createElement("rect", {
	x: 31.0859,
	y: 37.7063,
	width: 23.6379,
	height: 12.441,
	rx: 1.2441,
	fill: "#BBBFC3"
}), /* @__PURE__ */ e.createElement("rect", {
	x: 31.0859,
	y: 22.7344,
	width: 23.6379,
	height: 12.441,
	rx: 1.2441,
	fill: "#BBBFC3"
}), /* @__PURE__ */ e.createElement("rect", {
	x: 31.0859,
	y: 8,
	width: 23.6379,
	height: 12.441,
	rx: 1.2441,
	fill: "#BBBFC3"
}), /* @__PURE__ */ e.createElement("rect", {
	x: 31.0859,
	y: 52.6782,
	width: 23.6379,
	height: 12.441,
	rx: 1.2441,
	fill: "#BBBFC3"
}), /* @__PURE__ */ e.createElement("rect", {
	x: 57.1717,
	y: 22.7343,
	width: 24.26,
	height: 12.441,
	rx: 1.2441,
	fill: "#BBBFC3"
}), /* @__PURE__ */ e.createElement("rect", {
	x: 57.1717,
	y: 8,
	width: 24.26,
	height: 12.441,
	rx: 1.2441,
	fill: "#BBBFC3"
}), /* @__PURE__ */ e.createElement("rect", {
	x: 83.8828,
	y: 37.7063,
	width: 24.26,
	height: 12.441,
	rx: 1.2441,
	fill: "#BBBFC3"
}), /* @__PURE__ */ e.createElement("rect", {
	x: 110.742,
	y: 37.7063,
	width: 24.26,
	height: 12.441,
	rx: 1.2441,
	fill: "#BBBFC3"
}), /* @__PURE__ */ e.createElement("rect", {
	x: 83.8828,
	y: 22.7344,
	width: 24.26,
	height: 12.441,
	rx: 1.2441,
	fill: "#BBBFC3"
}), /* @__PURE__ */ e.createElement("rect", {
	x: 83.8828,
	y: 8,
	width: 24.26,
	height: 12.441,
	rx: 1.2441,
	fill: "#BBBFC3"
}), /* @__PURE__ */ e.createElement("rect", {
	x: 110.742,
	y: 22.7344,
	width: 24.26,
	height: 12.441,
	rx: 1.2441,
	fill: "#BBBFC3"
}), /* @__PURE__ */ e.createElement("rect", {
	x: 110.742,
	y: 8,
	width: 24.26,
	height: 12.441,
	rx: 1.2441,
	fill: "#BBBFC3"
}), /* @__PURE__ */ e.createElement("rect", {
	x: 83.8828,
	y: 52.6782,
	width: 24.26,
	height: 12.441,
	rx: 1.2441,
	fill: "#BBBFC3"
}), /* @__PURE__ */ e.createElement("rect", {
	x: 110.742,
	y: 52.6782,
	width: 24.26,
	height: 12.441,
	rx: 1.2441,
	fill: "#BBBFC3"
}), /* @__PURE__ */ e.createElement("rect", {
	x: 83.8828,
	y: 67.6501,
	width: 24.26,
	height: 12.441,
	rx: 1.2441,
	fill: "#BBBFC3"
}), /* @__PURE__ */ e.createElement("rect", {
	x: 110.742,
	y: 67.6501,
	width: 24.26,
	height: 12.441,
	rx: 1.2441,
	fill: "#BBBFC3"
}), /* @__PURE__ */ e.createElement("rect", {
	x: 57.1717,
	y: 52.6782,
	width: 24.26,
	height: 12.441,
	rx: 1.2441,
	fill: "#BBBFC3"
}), /* @__PURE__ */ e.createElement("rect", {
	x: 57.1717,
	y: 67.6501,
	width: 24.26,
	height: 12.441,
	rx: 1.2441,
	fill: "#BBBFC3"
})), sd = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 140,
	height: 88,
	viewBox: "0 0 140 88",
	fill: "none",
	...t
}, /* @__PURE__ */ e.createElement("rect", {
	x: .5,
	y: .5,
	width: 139,
	height: 87,
	rx: 3.5,
	fill: "currentColor",
	stroke: "#BBBFC3"
})), cd = {
	thumbnail: "_thumbnail_1hb4h_12",
	caption: "_caption_1hb4h_17",
	container: "_container_1hb4h_23",
	dark: "_dark_1hb4h_29",
	active: "_active_1hb4h_32",
	light: "_light_1hb4h_36"
}, ld = [
	Y.AdaptiveComposition,
	"teams",
	"teams_focus"
];
function ud(e) {
	switch (e) {
		case Y.AdaptiveComposition: return Zu;
		case Y.Speaker7: return Qu;
		case Y.Speaker21: return $u;
		case Y.Speaker221: return ed;
		case Y.Speaker33: return td;
		case Y.Equal22: return rd;
		case Y.Equal33: return id;
		case Y.Equal44: return ad;
		case Y.Equal55: return od;
		case Y.Highlight: return nd;
		default: return sd;
	}
}
var dd = ({ className: e, layout: n, colorScheme: i, selectLayout: a, children: o, active: s, canChangePersonalLayout: c }) => {
	let { t: l } = w(), u = r(() => a(n), [n, a]);
	return /*#__PURE__*/ t.createElement(mt, null, ({ colorScheme: r }) => /*#__PURE__*/ t.createElement("div", null, /*#__PURE__*/ t.createElement(Be, {
		onClick: u,
		className: K(cd.container, "mb-2", "mt-2", e),
		"data-testid": `${q.Layout}-${n}`,
		"aria-label": l(`settings.layout[${n}]`, {
			defaultValue: n,
			nsSeparator: !1
		})
	}, o, n && /*#__PURE__*/ t.createElement("div", { style: {
		display: "flex",
		flexDirection: "column",
		alignItems: "flex-start"
	} }, /*#__PURE__*/ t.createElement(G, {
		className: cd.caption,
		colorScheme: i ?? r,
		htmlTag: "span",
		"data-testid": `${q.LayoutLabel}-${n}`,
		isTruncated: !0
	}, l(`settings.layout[${n}]`, {
		defaultValue: n,
		nsSeparator: !1
	})), c && ld.includes(n) && /*#__PURE__*/ t.createElement(G, { fontVariant: V.Small }, /*#__PURE__*/ t.createElement(C, { i18nKey: "settings.layout-only-for-everyone" }, "Only available for everyone"))), s && /*#__PURE__*/ t.createElement("div", {
		style: {
			flex: "1 1",
			justifyContent: "flex-end",
			display: "flex"
		},
		className: "mr-1"
	}, /*#__PURE__*/ t.createElement(H, {
		source: U.IconCheckmark,
		color: Wt[i ?? r]["border/accent"]
	}))), /*#__PURE__*/ t.createElement(Ae, null)));
}, fd = ({ active: e, className: n, colorScheme: r, layout: i, selectLayout: a, ...o }) => {
	let s = ud(i);
	return /*#__PURE__*/ t.createElement(dd, {
		layout: i,
		selectLayout: a,
		...o
	}, /*#__PURE__*/ t.createElement(mt, null, ({ colorScheme: i }) => /*#__PURE__*/ t.createElement(ut, {
		source: s,
		className: K(cd.thumbnail, cd[r ?? i], "mr-2", { [cd.active]: !!e }, n),
		...o
	})));
}, pd = ({ svg: e, name: n, active: r, colorScheme: i, ...a }) => /*#__PURE__*/ t.createElement(mt, null, ({ colorScheme: o }) => /*#__PURE__*/ t.createElement("img", {
	src: r ? e.active : e.primary,
	className: K(cd.thumbnail, cd[i ?? o], "mr-2", { [cd.active]: !!r }),
	...a,
	alt: `${n} layout thumbnail`
})), md = {
	layoutLoadingWrapper: "_layoutLoadingWrapper_1gawf_4",
	layoutOption: "_layoutOption_1gawf_8"
}, hd = /* @__PURE__ */ new Map([
	[Y.AdaptiveComposition, [
		"5:7",
		"ac_presentation_in_mix",
		"ac_presentation_in_mix_group",
		"ac_extended"
	]],
	[Y.Equal22, ["4:0"]],
	[Y.Equal33, ["9:0"]],
	[Y.Equal44, ["16:0"]],
	[Y.Equal55, ["25:0"]]
]), gd = (e, t) => t === e || !!(t && hd.get(e)?.includes(t)), _d = () => /*#__PURE__*/ t.createElement(Xu, {
	fillHeight: !1,
	withScrollbars: !1
}, /*#__PURE__*/ t.createElement(Ce, { className: md.layoutLoadingWrapper }, /*#__PURE__*/ t.createElement(lt, { colorScheme: "dark" }))), vd = ({ currentLayout: e, currentPersonalLayout: n, setLayout: i, setPersonalLayout: o, resetToMeetingLayout: s, canChangeLayout: c, canChangePersonalLayout: l, isConfirmationOpen: u, openConfirmation: d, closeConfirmation: p, layouts: m, close: h }) => {
	let { t: g } = w(), [_, v] = f(!1), [y, b] = f(n ?? e), x = r((e) => {
		v(!0), y && i(y, () => {
			n ? s(() => {
				v(!1), h(e);
			}, () => {
				v(!1);
			}) : (v(!1), h(e));
		}, () => {
			v(!1);
		}), p();
	}, [
		y,
		p,
		i,
		h,
		n,
		s
	]), S = r((e) => {
		v(!0), y && o(y, () => {
			v(!1), h(e);
		}, () => v(!1));
	}, [
		y,
		o,
		h
	]), T = r((e) => {
		v(!0), s(() => {
			v(!1), h(e);
		}, () => v(!1));
	}, [s, h]), E = (e) => /*#__PURE__*/ t.createElement(fd, {
		active: gd(e, y),
		canChangePersonalLayout: l,
		className: md.layoutOption,
		layout: e,
		key: e,
		selectLayout: b
	}), D = () => [
		Y.AdaptiveComposition,
		Y.Speaker7,
		Y.Speaker21,
		Y.Speaker221,
		Y.Speaker33,
		Y.Highlight,
		Y.Equal22,
		Y.Equal33,
		Y.Equal44,
		Y.Equal55
	].map(E), O = () => Array.from(m.entries()).flatMap(([e, n]) => !c && ld.includes(e) ? [] : n.primary && n.active ? [/*#__PURE__*/ t.createElement(dd, {
		key: e,
		layout: e,
		canChangePersonalLayout: l,
		selectLayout: b,
		active: gd(e, y)
	}, /*#__PURE__*/ t.createElement(pd, {
		name: e,
		svg: n,
		active: gd(e, y)
	}))] : [E(e)]);
	a(() => {
		b(n ?? e);
	}, [e, n]);
	let k = l && !(ld.includes(y ?? "") || ld.includes(e ?? ""));
	return /*#__PURE__*/ t.createElement(t.Fragment, null, /*#__PURE__*/ t.createElement(Xu, { footerContent: /*#__PURE__*/ t.createElement(ht, { colorScheme: "light" }, k && /*#__PURE__*/ t.createElement(z, {
		onClick: S,
		type: "submit",
		modifier: "fullWidth",
		className: "mb-2",
		isLoading: _,
		isDisabled: _,
		"data-testid": q.ButtonSettingsSaveMyself
	}, /*#__PURE__*/ t.createElement(C, {
		t: g,
		i18nKey: "settings.save-for-myself"
	}, "Save for myself")), c && /*#__PURE__*/ t.createElement(z, {
		onClick: () => {
			d();
		},
		variant: "secondary",
		size: "medium",
		modifier: "fullWidth",
		isLoading: _,
		isDisabled: _,
		"data-testid": q.ButtonSettingsSaveAll
	}, /*#__PURE__*/ t.createElement(C, {
		t: g,
		i18nKey: "settings.save-for-everyone"
	}, "Save for everyone"))) }, /*#__PURE__*/ t.createElement(ht, { colorScheme: "light" }, m.size > 0 ? O() : D(), l && n && /*#__PURE__*/ t.createElement(t.Fragment, null, /*#__PURE__*/ t.createElement(z, {
		onClick: T,
		className: "mt-4 mb-1",
		variant: "tertiary",
		size: "medium",
		modifier: "fullWidth",
		"data-testid": q.ButtonSettingsResetToMeetingLayout
	}, /*#__PURE__*/ t.createElement(C, {
		t: g,
		i18nKey: "settings.reset-to-meeting-layout"
	}, "Reset to meeting layout")), /*#__PURE__*/ t.createElement(G, { fontVariant: V.Small }, /*#__PURE__*/ t.createElement(C, {
		t: g,
		i18nKey: "settings.layout-reset-to-meeting-layout-info"
	}, "Resets your layout to the one chosen by host for this meeting"))))), /*#__PURE__*/ t.createElement(Oe, {
		closeOnOutsideClick: !1,
		cancelButtonTestid: q.ConfirmationModalCancelButton,
		cancelButtonText: g("common.cancel", "Cancel"),
		confirmButtonTestid: q.ConfirmationModalConfirmButton,
		confirmButtonText: g("common.change", "Change"),
		"data-testid": q.ModalLayoutChangeConfirmation,
		description: g("settings.layout-confirmation-desc", "You’re about to change the layout for everyone in the meeting, not just yourself."),
		isOpen: u,
		onCancel: p,
		onClose: p,
		onConfirm: x,
		title: g("settings.layout-confirmation-title", "Changing layouts will affect everyone"),
		uniqueTitle: g("settings.layout-confirmation-title", "Changing layouts will affect everyone")
	}));
}, yd = ({ isOpen: e, toggle: n, ...r }) => {
	let { t: i } = w();
	return /*#__PURE__*/ t.createElement(z, {
		"aria-label": i("meeting.toggle-invite-modal", "Toggle invite members modal"),
		modifier: "square",
		onClick: n,
		size: "medium",
		isActive: e,
		variant: "translucent",
		...r
	}, /*#__PURE__*/ t.createElement(H, { source: U.IconAddSomeone }));
}, bd = {
	row: "_row_lp417_4",
	actionButton: "_actionButton_lp417_13"
}, xd = ({ addMember: e, className: n, displayName: i, identity: a, ...o }) => {
	let { t: s } = w(), [c, l] = f(!1), u = r(() => {
		c || (l(!0), e(a));
	}, [
		e,
		a,
		c
	]);
	return /*#__PURE__*/ t.createElement("div", {
		className: K(bd.row, n),
		"data-testid": q.SearchRow,
		...o
	}, /*#__PURE__*/ t.createElement(yt, {
		displayName: i,
		usernameFontVariant: V.Body,
		avatarType: ye.Initials
	}), /*#__PURE__*/ t.createElement(z, {
		"aria-label": s("invite.invite-person", "Invite person"),
		className: bd.actionButton,
		"data-testid": q.ButtonInviteMemberSearchRow,
		onClick: u,
		variant: "secondary",
		size: "small",
		isDisabled: c
	}, c ? s("invite.invited", "Invited") : s("invite.invite", "Invite")));
}, Sd = ({ onValueChange: e, value: n }) => {
	let { t: r } = w();
	return /*#__PURE__*/ t.createElement(Re, {
		"data-testid": q.InvitationSearchInput,
		label: r("invite.search-for-someone", "Search for someone to invite"),
		labelModifier: "hidden",
		name: "search-someone-to-invite",
		onValueChange: e,
		placeholder: r("invite.search-for-someone", "Search for someone to invite"),
		showClearButton: !!n,
		sizeModifier: "small",
		type: "text",
		value: n
	});
}, Cd = {
	inMeetingModal: "_inMeetingModal_gj99v_18",
	shouldTransform: "_shouldTransform_gj99v_36",
	results: "_results_gj99v_40",
	emptyResults: "_emptyResults_gj99v_49",
	spinner: "_spinner_gj99v_58"
}, wd = ({ className: e, inviteLinkBox: n }) => {
	let { t: r } = w();
	return /*#__PURE__*/ t.createElement("div", { className: K("m-4", e) }, /*#__PURE__*/ t.createElement(G, {
		fontVariant: V.Body,
		"data-testid": q.SendInviteLink
	}, /*#__PURE__*/ t.createElement(C, {
		t: r,
		i18nKey: "invite.send-invite-link"
	}, "or send an invite link")), n);
}, Td = ({ invitees: e, loading: n, searched: r = !1, onInviteeAdd: i }) => {
	let { t: a } = w();
	return /*#__PURE__*/ t.createElement("div", { className: K(Cd.results, { [Cd.emptyResults]: !e.length }) }, n ? /*#__PURE__*/ t.createElement(lt, {
		className: Cd.spinner,
		colorScheme: "dark",
		sizeModifier: "medium"
	}) : e.length > 0 ? e.map(({ identity: e, name: n }) => /*#__PURE__*/ t.createElement(xd, {
		key: e,
		addMember: i,
		displayName: n,
		identity: e
	})) : /*#__PURE__*/ t.createElement(G, { fontVariant: V.Body }, r ? a("invite.cant-find-anyone", "Can’t find anyone with that name") : a("invite.click-search", "Click on the search field above to search")));
}, Ed = ({ children: e, className: n, searchValue: r, onSearchValueChange: i, ...a }) => {
	let { t: o } = w();
	return /*#__PURE__*/ t.createElement("div", {
		className: K("mt-4 ml-4", n),
		...a
	}, /*#__PURE__*/ t.createElement(ft, {
		htmlTag: "h5",
		fontVariant: V.H5
	}, /*#__PURE__*/ t.createElement(C, {
		t: o,
		i18nKey: "invite.invite-someone"
	}, "Invite someone to the meeting")), /*#__PURE__*/ t.createElement("div", { className: "mt-4 mr-4" }, /*#__PURE__*/ t.createElement(Sd, {
		value: r,
		onValueChange: i
	})), e);
}, Dd = ({ children: e, className: n, isOpen: r, modalType: i = Ye.Positioned, onClose: o, ...s }) => {
	let { t: c } = w(), { modalHandleRef: l, focusModal: u } = Lt();
	return a(() => {
		r && u();
	}, [u, r]), /*#__PURE__*/ t.createElement(ht, { colorScheme: "light" }, /*#__PURE__*/ t.createElement(qe, {
		ref: l,
		className: n,
		"data-testid": q.ModalInvitation,
		isOpen: r,
		modalType: i,
		onClose: o,
		padding: "none",
		testIdCloseButton: q.ButtonCloseInvitationModal,
		uniqueTitle: c("invite.meeting-invitation-modal", "Meeting Invitation Modal"),
		withCloseButton: !0,
		closeButtonAriaLabel: c("common.close", "Close"),
		scrollbarsAriaLabel: c("common.scrollable-content", "Scrollable content"),
		withMask: !1,
		...s
	}, e));
}, Od = ({ children: e, shouldTransform: n, ...r }) => /*#__PURE__*/ t.createElement(Dd, {
	className: K(Cd.inMeetingModal, { [Cd.shouldTransform]: n }),
	...r
}, e), kd = {
	linkCopyButton: "_linkCopyButton_1sn92_4",
	linkBox: "_linkBox_1sn92_9",
	linkText: "_linkText_1sn92_19"
}, Ad = ({ className: e, expiryHours: n, link: r, isCopied: i = !1, onClick: o }) => {
	let { t: s } = w();
	return a(() => {
		i && St(s("invite.copied", "Copied"), "assertive");
	}, [i, s]), /*#__PURE__*/ t.createElement(t.Fragment, null, /*#__PURE__*/ t.createElement(Se, {
		isWithBorder: !0,
		isWithShadow: !1,
		colorScheme: "light",
		hasBackground: !0,
		bgColor: Ee.DeepBlue10,
		style: i ? { borderColor: Ee.SignalGreen } : {},
		className: K(e, kd.linkBox),
		"data-testid": q.MeetingLinkWrapper
	}, /*#__PURE__*/ t.createElement(G, {
		colorScheme: "light",
		className: kd.linkText,
		"data-testid": q.MeetingLinkText
	}, r), /*#__PURE__*/ t.createElement(z, {
		variant: i ? "success" : "primary",
		colorScheme: "light",
		className: kd.linkCopyButton,
		noEnhancerPadding: !0,
		onClick: o,
		"aria-label": s("invite.copy-to-clipboard", "Copy a link to clipboard"),
		"data-testid": q.ButtonCopyMeetingLink
	}, i ? s("invite.copied", "Copied") : s("invite.copy", "Copy"))), n && /*#__PURE__*/ t.createElement("div", { className: "mt-2" }, /*#__PURE__*/ t.createElement(G, { fontVariant: V.Small }, /*#__PURE__*/ t.createElement(C, {
		t: s,
		i18nKey: "invite.expiry"
	}, "Your invite link expires in ", { expiryHours: n }, " hours"))));
}, jd = {
	mainWrapper: "_mainWrapper_11530_215",
	mobile: "_mobile_11530_224",
	hideBackground: "_hideBackground_11530_229",
	mutedWrapper: "_mutedWrapper_11530_233",
	mutedDisabled: "_mutedDisabled_11530_241",
	childrenWrapper: "_childrenWrapper_11530_245",
	tooltipButtonWrapper: "_tooltipButtonWrapper_11530_254"
}, Md = ({ children: e, deviceStatusInfo: n, isDisabled: r, requestCameraPreview: i, showPreviewLabel: a, stopCameraPreview: o, updatingPreviewAudio: s, updatingPreviewVideo: c, ...l }) => {
	let { t: u } = w(), [d, p] = f(!0), [m, h] = f(!1), g = n.error === T.Both || n.error === T.Camera, _ = n.retriable ? {
		icon: U.IconRefresh,
		text: u("common.try-again", "Try again"),
		testid: q.SettingButtonTryAgain
	} : {
		icon: U.IconVideoOn,
		text: u("settings.request-preview", "Request preview"),
		testid: q.SettingButtonRequestPreview
	}, v = c || s;
	return /*#__PURE__*/ t.createElement("div", { className: jd.mainWrapper }, /*#__PURE__*/ t.createElement(Ns, {
		"aria-label": u("media.settings-selfview", "Settings selfview"),
		aspectRatioWrapperClassName: "mb-2",
		"data-testid": q.SettingsVideoSelfview,
		labelContent: /*#__PURE__*/ t.createElement(G, { fontVariant: V.XSmall }, /*#__PURE__*/ t.createElement("div", { className: "d-flex align-items-center" }, u("settings.preview-label", "Private preview"), /*#__PURE__*/ t.createElement(Xe, {
			controlledIsVisible: m,
			controlledOnChange: h,
			position: "bottomEnd",
			text: u("setting.preview-label-info", "Only you can see this. Your camera remains off for everyone in the meeting."),
			ctaText: /*#__PURE__*/ t.createElement(z, {
				modifier: "fluid",
				variant: "text",
				size: "compact",
				onClick: () => {
					h(!1), o?.();
				}
			}, u("setting.preview-label-action", "Stop preview"))
		}, /*#__PURE__*/ t.createElement(z, {
			modifier: "disc",
			variant: "transparent",
			size: "compact",
			onClick: () => h((e) => !e)
		}, /*#__PURE__*/ t.createElement(H, {
			source: U.IconInfoRound,
			size: "compact"
		}))))),
		labelTestId: q.SettingsVideoSelfviewPreviewLabel,
		showLabel: a,
		"wrapper-data-testid": q.SettingsVideoSelfviewWrapper,
		shouldShowUserAvatar: !1,
		username: "",
		...l
	}, l.isVideoInputMuted && /*#__PURE__*/ t.createElement(t.Fragment, null, /*#__PURE__*/ t.createElement(Ce, { className: K(jd.mutedWrapper, { [jd.mutedDisabled]: r }) }, /*#__PURE__*/ t.createElement(Ue, {
		colorScheme: "dark",
		isLoading: v,
		sizeModifier: "medium"
	}, /*#__PURE__*/ t.createElement(H, {
		size: "medium",
		colorScheme: "dark",
		"data-testid": n.error ? q.SettingIconWarning : q.SettingIconCameraOff,
		source: n.error ? U.IconAlert : U.IconVideoOff
	}), /*#__PURE__*/ t.createElement(G, {
		colorScheme: "dark",
		fontVariant: V.BodyBold
	}, n.error ? n.title : u("settings.your-camera-is-off", "Your camera is off.")))), !r && !v && /*#__PURE__*/ t.createElement("div", { className: K("d-flex flex-direction-column align-items-center", jd.tooltipButtonWrapper) }, /*#__PURE__*/ t.createElement(Xe, {
		controlledIsVisible: d,
		controlledOnChange: p,
		position: "topCenter",
		header: n.title,
		text: n.message
	}, /*#__PURE__*/ t.createElement(z, {
		colorScheme: "dark",
		onClick: i,
		variant: "tertiary",
		"data-testid": _.testid,
		isDisabled: g && !n.retriable,
		isLoading: v,
		enhancerStart: /*#__PURE__*/ t.createElement(H, { source: _.icon })
	}, _.text))))), /*#__PURE__*/ t.createElement("div", { className: jd.childrenWrapper }, e));
}, Nd = {
	wrapper: "_wrapper_11ow6_4",
	innerWrapper: "_innerWrapper_11ow6_8",
	meetingSettingsLink: "_meetingSettingsLink_11ow6_15",
	guestMuteLink: "_guestMuteLink_11ow6_16"
}, Pd = ({ addParticipant: e }) => {
	let { t: n } = w();
	return /*#__PURE__*/ t.createElement(ht, { colorScheme: "light" }, /*#__PURE__*/ t.createElement("div", { className: Nd.wrapper }, /*#__PURE__*/ t.createElement(Ae, null), /*#__PURE__*/ t.createElement(z, {
		className: K("p-3", "text-center"),
		size: "large",
		modifier: "fullWidth",
		title: n("add-participant.submit", "Add participant"),
		variant: "text",
		onClick: e,
		"data-testid": q.UserMenuAddParticipant
	}, n("add-participant.submit", "Add participant"))));
}, Fd = ({ voiceDetected: e, audioMuted: n, setVoiceDetected: i }) => {
	let { t: o } = w(), [s, c] = f(!1);
	a(() => (n || (c(!1), i(!1)), () => {
		i(!1);
	}), [n, i]);
	let l = e && n && !s, u = r((e) => {
		e && c(!0), i(!1);
	}, [i]);
	return /*#__PURE__*/ t.createElement(gt, {
		message: o("media.trying-to-speak", "Trying to speak? Your microphone is muted"),
		isDisplayed: l,
		isVisible: l,
		onDismiss: () => u(n),
		position: "bottomCenter",
		colorScheme: "light",
		timeout: 0
	});
}, Id = {
	[hn.Reconnecting]: {
		iconSrc: U.IconAlert,
		testId: q.NetworkReconnectingState
	},
	[hn.Reconnected]: {
		iconSrc: U.IconCheckmark,
		testId: q.NetworkReconnectedState
	},
	[hn.Connected]: {
		iconSrc: U.IconCheckmark,
		testId: q.NetworkConnectedState
	}
}, Ld = {
	main: "_main_1jk4n_39",
	shown: "_shown_1jk4n_50",
	hidden: "_hidden_1jk4n_57",
	check: "_check_1jk4n_61",
	alert: "_alert_1jk4n_65"
}, Rd = ({ networkState: e }) => {
	let { t: n } = w(), { iconSrc: r, testId: i } = Id[e], a = e === hn.Connected, o = /*#__PURE__*/ t.createElement(G, {
		className: "text-center",
		colorScheme: "light",
		fontVariant: V.BodyBold
	}, e === hn.Reconnecting ? n("meeting.network-reconnecting", "Lost network connection. Reconnecting...") : n("meeting.network-fixed", "Fixed!"));
	return /*#__PURE__*/ t.createElement(xe, {
		className: K(Ld.main, {
			[Ld.shown]: !a,
			[Ld.hidden]: a
		}),
		"data-testid": i,
		"aria-hidden": a
	}, /*#__PURE__*/ t.createElement(H, {
		source: r,
		size: "compact",
		className: K("mr-2", "flex-shrink-0", {
			[Ld.alert]: e === hn.Reconnecting,
			[Ld.check]: e !== hn.Reconnecting
		})
	}), o);
}, zd = ({ isOpen: e, userName: n, description: r, onCancel: i, onConfirm: a, ...o }) => {
	let { t: s } = w();
	return /*#__PURE__*/ t.createElement(Oe, {
		...o,
		cancelButtonTestid: q.ButtonRemoveUserCancel,
		cancelButtonText: s("common.cancel", "Cancel"),
		confirmButtonTestid: q.ButtonRemoveUserConfirm,
		confirmButtonText: s("common.remove", "Remove"),
		confirmButtonVariant: "danger",
		"data-testid": q.ModalRemoveUser,
		description: r,
		isOpen: e,
		onCancel: i,
		onConfirm: a,
		title: s("meeting.remove-user-confirmation", {
			defaultValue: "Are you sure you want to remove {{userName}} from this meeting?",
			userName: n
		}),
		titleWordBreak: "overflowWrap",
		uniqueTitle: s("meeting.remove-user-confirmation", {
			defaultValue: "Are you sure you want to remove {{userName}} from this meeting?",
			userName: n
		})
	});
}, Bd = /*#__PURE__*/ function(e) {
	return e.Narrow = "280px", e.NarrowTouch = "296px", e.Wide = "664px", e.HundredPercent = "100%", e;
}({}), Vd = /*#__PURE__*/ function(e) {
	return e.Meeting = "meeting", e.Lobby = "lobby", e;
}({}), Hd = () => {
	let e = Mt(), t = Nt(), n = Pt();
	if (e || n) return "vertical";
	if (t) return "horizontal";
}, Ud = () => {
	let e = Mt(), t = Nt(), n = Pt(), r = Ht();
	if (e) return r ? Bd.NarrowTouch : Bd.Narrow;
	if (t) return Bd.Wide;
	if (n) return Bd.HundredPercent;
}, Wd = /*#__PURE__*/ function(e) {
	return e.NoAnimation = "", e.VerticalOpen = "verticalOpen", e.VerticalClose = "verticalClose", e.HorizontalOpen = "horizontalOpen", e.HorizontalClose = "horizontalClose", e;
}({}), Gd = 1e3, Kd = ({ isVertical: e, shouldAnimate: t, updateStates: n, onAnimateComplete: i }) => {
	let o = d(!1), s = d(x), [c, l] = f(""), u = r(() => {
		l(""), s.current = x, o.current = !1, i();
	}, [i]), p = kt();
	a(() => p.add(() => {
		o.current && u();
	}), [p, u]);
	let m = r(() => {
		o.current = !0, l(e ? "verticalClose" : "horizontalClose"), s.current = () => {
			s.current = () => {
				setTimeout(() => {
					u();
				}, 200);
			}, setTimeout(() => {
				n(), l(e ? "horizontalOpen" : "verticalOpen");
			}, Gd);
		};
	}, [
		e,
		n,
		u
	]);
	return a(() => {
		t && !o.current && m();
	}, [t, m]), [c, s.current];
}, qd = ({ orientation: e, width: t, imageUrl: n, logoUrl: i, imageContent: a, headerText: o, bodyContent: s }) => {
	let [c, l] = f(e === "vertical"), [u, d] = f(t), [p, m] = f(n), [h, g] = f(i), [_, v] = f(a), [y, b] = f(o), [x, S] = f(s), C = r(() => {
		let r = e === "vertical";
		r !== c && l(r), u !== t && d(t), p !== n && m(n), h !== i && g(i), _ !== a && v(a), y !== o && b(o), x !== s && S(s);
	}, [
		u,
		t,
		e,
		c,
		p,
		n,
		h,
		i,
		_,
		a,
		s,
		x,
		o,
		y
	]);
	return [{
		isVertical: c,
		cardWidth: u,
		cardImageUrl: p,
		cardLogoUrl: h,
		cardImageContent: _,
		cardHeaderText: y,
		cardBodyContent: x
	}, C];
}, Jd = {
	body: "_body_5gqyr_105",
	isVertical: "_isVertical_5gqyr_113",
	bodyVerticalOpen: "_bodyVerticalOpen_5gqyr_1",
	opacityOpen: "_opacityOpen_5gqyr_1",
	bodyVerticalClose: "_bodyVerticalClose_5gqyr_1",
	opacityClose: "_opacityClose_5gqyr_1",
	bodyHorizontalOpen: "_bodyHorizontalOpen_5gqyr_1",
	bodyHorizontalClose: "_bodyHorizontalClose_5gqyr_1",
	contentContainer: "_contentContainer_5gqyr_198",
	mainContent: "_mainContent_5gqyr_207",
	logo: "_logo_5gqyr_223",
	infoCard: "_infoCard_5gqyr_228",
	transitionWidth: "_transitionWidth_5gqyr_238",
	infoCardImage: "_infoCardImage_5gqyr_242",
	transitionHeight: "_transitionHeight_5gqyr_259",
	infoCardImageContent: "_infoCardImageContent_5gqyr_263"
}, Yd = /*#__PURE__*/ t.memo(({ imageUrl: e, logoUrl: n, headerText: r, bodyContent: i, imageContent: o, orientation: s, width: c, animate: { shouldAnimate: l = !1, onAnimateComplete: u = x } = {}, type: d, brandName: f }) => {
	let { t: p } = w(), m = p("common.label-logo", "logo"), h = p("common.brand-name", "your video service"), g = d === Vd.Meeting ? p("infocard.meeting.header", {
		defaultValue: "Welcome to\n {{brandName}}",
		brandName: f || h
	}) : p("infocard.lobby.header", "Please wait, waiting for others to join"), _ = r || g, v = i || p("infocard.meeting.body", "Pexip Meetings"), y = e || "data:image/png;base64,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", b = Hd(), S = Ud(), C = c ?? S, T = s ?? b, [{ isVertical: E, cardWidth: D, cardImageUrl: O, cardLogoUrl: k, cardImageContent: A, cardHeaderText: j, cardBodyContent: M }, N] = qd({
		orientation: T,
		width: C,
		imageUrl: y,
		logoUrl: n,
		imageContent: o,
		headerText: _,
		bodyContent: v
	}), [P, F] = Kd({
		isVertical: E,
		shouldAnimate: l,
		updateStates: N,
		onAnimateComplete: u
	});
	a(() => {
		l || N();
	}, [N, l]);
	let I = /*#__PURE__*/ t.createElement(t.Fragment, null, /*#__PURE__*/ t.createElement(ft, {
		htmlTag: "h2",
		fontVariant: V.H4,
		colorScheme: "light"
	}, j), E && M && (typeof M == "string" ? /*#__PURE__*/ t.createElement(G, {
		className: "mt-2 mb-0",
		htmlTag: "p",
		fontVariant: V.Body,
		colorScheme: "light"
	}, /*#__PURE__*/ t.createElement(vt, { text: M })) : M));
	return !C || !T ? null : /*#__PURE__*/ t.createElement("div", {
		style: { width: P === Wd.HorizontalClose ? C : D },
		className: K(Jd.infoCard, E ? "flex-direction-column" : "flex-direction-row-reverse", {
			[Jd.isVertical]: E,
			[Jd.transitionWidth]: P === Wd.HorizontalClose || P === Wd.HorizontalOpen
		})
	}, /*#__PURE__*/ t.createElement("div", {
		className: K(Jd.infoCardImage, {
			[Jd.isVertical]: E,
			[Jd.transitionHeight]: P === Wd.VerticalOpen
		}),
		style: { backgroundImage: `url('${O}')` }
	}, A && /*#__PURE__*/ t.createElement("div", { className: Jd.infoCardImageContent }, A)), /*#__PURE__*/ t.createElement("div", {
		onAnimationEnd: F,
		className: K(Jd.body, {
			[P]: l,
			[Jd.isVertical]: E
		})
	}, /*#__PURE__*/ t.createElement("div", { className: K(Jd.contentContainer, E ? "flex-direction-column" : "flex-direction-column-reverse", {
		[Jd.isVertical]: E,
		"justify-content-space-between": !E
	}) }, /*#__PURE__*/ t.createElement("div", { className: K(Jd.mainContent, { [Jd.isVertical]: E }) }, I), /*#__PURE__*/ t.createElement("div", { className: K({ "mt-12": E }) }, k && !Ct(k) ? /*#__PURE__*/ t.createElement(Ge, {
		className: Jd.logo,
		imageSrc: k,
		alt: f ? `${f} ${m}` : m,
		"aria-label": f ? `${f} ${m}` : m
	}) : /*#__PURE__*/ t.createElement($e, {
		className: Jd.logo,
		"aria-label": p("common.label-pexip-logo", "Pexip logo"),
		size: "full",
		colorScheme: "light"
	})))));
});
Yd.displayName = "InfoCard";
// src/views/BreakoutRoomsPanelToggle/BreakoutRoomsPanelToggle.view.tsx
var Xd = ({ breakoutActionsCount: e, isPanelOpen: n, tooltipPosition: r = "top", ...i }) => {
	let { t: a } = w(), o = a("breakout-toggle-tooltip", "Breakout Rooms");
	return /*#__PURE__*/ t.createElement(be, {
		"data-testid": q.BadgeCounterBreakoutRoomsPanelButton,
		number: e,
		isVisible: !n && e > 0,
		isTruncated: e > 9
	}, /*#__PURE__*/ t.createElement(dc, {
		"aria-label": o,
		"aria-expanded": n,
		"data-testid": q.ButtonBreakoutRooms,
		tooltipText: o,
		tooltipPosition: r,
		icon: /*#__PURE__*/ t.createElement(H, {
			source: U.IconBreakoutRooms,
			size: "small"
		}),
		isActive: n,
		...i
	}));
}, Zd = {
	wrapper: "_wrapper_150qp_4",
	input: "_input_150qp_8",
	text: "_text_150qp_12",
	editButton: "_editButton_150qp_16"
}, Qd = ({ name: e, showEditButton: n, onSaveAction: i, className: a }) => {
	let [o, s] = f(!1), [c, l] = f(e), { t: u } = w(), d = r(() => {
		l(e), s(!0);
	}, [e]), p = r(() => {
		let t = c.trim();
		(t === e || i?.(t)) && s(!1);
	}, [
		c,
		e,
		i
	]), m = r((e) => {
		e.key === X.enter && p(), e.key === X.escape && s(!1);
	}, [p]);
	return /*#__PURE__*/ t.createElement(W, {
		className: K(Zd.wrapper, a),
		spacing: "none"
	}, o ? /*#__PURE__*/ t.createElement(Re, {
		autoComplete: "off",
		ref: (e) => {
			e?.focus();
		},
		className: Zd.input,
		value: c,
		label: u("breakouts.breakout-room.name-label", "Breakout room name"),
		labelModifier: "hidden",
		name: "inputValue",
		onKeyDown: m,
		onBlur: p,
		onValueChange: l,
		maxLength: 36
	}) : /*#__PURE__*/ t.createElement(G, {
		isTruncated: !0,
		fontVariant: V.BodyBold,
		className: Zd.text
	}, e), n && !o && /*#__PURE__*/ t.createElement(z, {
		"data-testid": q.ButtonBreakoutRoomHeader,
		className: Zd.editButton,
		"aria-label": u("breakouts.breakout-room.edit-button-label", "Edit breakout room name"),
		onClick: d,
		size: "small",
		variant: "translucent",
		modifier: "square"
	}, /*#__PURE__*/ t.createElement(H, {
		source: U.IconEdit,
		size: "small"
	})));
}, $d = {
	modalWrapper: "_modalWrapper_f2eh5_1",
	progressBarWrapper: "_progressBarWrapper_f2eh5_5",
	progressBar: "_progressBar_f2eh5_5"
}, ef = ({ className: e, roomName: n, secondsBeforeMove: r, onJoin: i, ...o }) => {
	let { t: s } = w(), [c, l] = f(r > 0), u = () => {
		i(), l(!1), m();
	}, { startCountDown: d, currentCount: p, cleanup: m } = oe({
		startCountFrom: r,
		enabled: !0
	}, u);
	a(() => (d(), m), [m, d]);
	let h = `<strong>${n}</strong>`;
	return /*#__PURE__*/ t.createElement(ht, { colorScheme: "light" }, /*#__PURE__*/ t.createElement(qe, {
		isOpen: c,
		closeOnOutsideClick: !0,
		className: K($d.modalWrapper, e),
		"data-testid": q.ModalMoveToRoom,
		scrollbarsAriaLabel: s("common.scrollable-content", "Scrollable content"),
		...o
	}, /*#__PURE__*/ t.createElement(nt, {
		backgroundClassName: $d.progressBarWrapper,
		barClassName: $d.progressBar,
		progress: r === p ? 0 : 100,
		barColor: rt.Primary,
		style: { transitionDuration: `${r - 1}s` }
	}), /*#__PURE__*/ t.createElement(G, {
		fontVariant: V.Body,
		htmlTag: "p",
		className: "mt-1 mb-2"
	}, /*#__PURE__*/ t.createElement(C, {
		t: s,
		i18nKey: "breakouts.move-to-room-modal.title",
		defaults: "You will be moved to {{roomName}} in {{currentCount}} {{secondString}}.",
		values: {
			roomName: h,
			currentCount: p,
			secondString: p >= 2 ? s("common.seconds", "seconds") : s("common.second", "second")
		}
	})), /*#__PURE__*/ t.createElement(G, {
		fontVariant: V.Body,
		htmlTag: "p",
		className: "mb-4"
	}, /*#__PURE__*/ t.createElement(C, {
		t: s,
		i18nKey: "breakouts.move-to-room-modal.text"
	}, "You can join right now if you are ready.")), /*#__PURE__*/ t.createElement(z, {
		"data-testid": q.ButtonMoveToBreakoutNow,
		modifier: "fullWidth",
		size: "large",
		onClick: u
	}, /*#__PURE__*/ t.createElement(C, {
		t: s,
		i18nKey: "breakouts.move-to-room-modal.join-now-btn",
		"aria-label": s("breakouts.move-to-room-modal.aria-label-btn", {
			defaultValue: "Join {{roomName}} now",
			roomName: n
		})
	}, "Join now"))));
}, tf = {
	wrapper: "_wrapper_1bofa_4",
	item: "_item_1bofa_9",
	dragging: "_dragging_1bofa_13",
	draggableContent: "_draggableContent_1bofa_17"
}, nf = /*#__PURE__*/ t.forwardRef(({ participants: e, myIdentity: n, rooms: r, variant: i = yn.Setup, scrollElementRef: a, onParticipantDragging: o, onParticipantDrag: s, onParticipantRoomChange: c, className: l, lockStyle: u = We.VERTICAL, ...d }, p) => {
	let [m, h] = f();
	return /*#__PURE__*/ t.createElement(Se, {
		...d,
		ref: p,
		role: "list",
		className: K(tf.wrapper, l)
	}, e.map((e) => /*#__PURE__*/ t.createElement(je, {
		role: "listitem",
		scrollElementRef: a,
		pointerCapture: !0,
		className: K(tf.item, { [tf.dragging]: i !== yn.Preview && m === e.uuid }),
		id: e.uuid,
		key: e.uuid,
		onPointerMoveExtra: o,
		onPointerUpExtra: s,
		onPointerDown: () => h(e.uuid),
		onPointerUp: () => h(void 0),
		isDisabled: i === yn.Preview || !r || r && Object.entries(r).length === 0,
		lockStyle: u
	}, /*#__PURE__*/ t.createElement(Nu, {
		participant: e,
		isCurrentPeer: e.uuid === n,
		rooms: r,
		isDragging: m !== void 0,
		onParticipantRoomChange: c,
		className: K(tf.draggableContent, { [tf.dragging]: i !== yn.Preview && m === e.uuid })
	}))));
});
nf.displayName = "BreakoutRoomParticipantList";
var rf = {
	wrapper: "_wrapper_ilyhc_11",
	dragTarget: "_dragTarget_ilyhc_17",
	mainRoom: "_mainRoom_ilyhc_24",
	footer: "_footer_ilyhc_28",
	dragDivider: "_dragDivider_ilyhc_37"
}, af = /*#__PURE__*/ t.forwardRef(({ id: e, name: n, participants: i, myIdentity: a, amIControlOnlyParticipant: o, rooms: s, variant: c = yn.Setup, onNameChanged: l, isDragTarget: u, scrollElementRef: d, canEditRoomName: p = !1, renderParticipants: m, onParticipantDragging: h, onParticipantDrag: g, onParticipantRoomChange: _, _onAssignParticipants: v, onJoinRoom: y, onCloseRoom: b, onRemoveRoom: x, lockStyle: S, ...C }, T) => {
	let { t: E } = w(), [D, O] = f(!1), k = e === jn, A = i.some(({ uuid: e }) => e === a), j = r((t) => l?.(e, t), [e, l]), M = r(() => {
		O(!1), b?.(e);
	}, [e, b]), N = () => {
		switch (c) {
			case yn.Setup: return null;
			case yn.Preview: return !k && b ? /*#__PURE__*/ t.createElement(z, {
				variant: "dangerBordered",
				onClick: () => O(!0),
				"aria-label": E("breakouts.breakout-room.close-room-aria-label", "Close breakout room"),
				"data-testid": q.CloseBreakoutRoom
			}, E("common.close", "Close")) : null;
			case yn.Edit: return null;
		}
	}, P = () => {
		switch (c) {
			case yn.Setup:
			case yn.Edit: return k ? null : /*#__PURE__*/ t.createElement(wl, {
				variant: "tertiary",
				iconSource: U.IconTrash,
				hideChildren: !0,
				onClick: () => x?.(e),
				"aria-label": E("breakouts.breakout-room.remove-room-aria-label", "Remove breakout room"),
				"data-testid": q.RemoveBreakoutRoom
			});
			case yn.Preview: return o ? null : /*#__PURE__*/ t.createElement(z, {
				variant: "success",
				isDisabled: A,
				"aria-label": E("common.join-breakout-room-aria-label", "Join breakout room"),
				onClick: () => y?.(e),
				"data-testid": q.JoinBreakoutRoom
			}, E("common.join", "Join"));
		}
	};
	return /*#__PURE__*/ t.createElement(Se, {
		...C,
		"data-testid": q.BreakoutRoom,
		id: e,
		ref: T,
		className: K(rf.wrapper, C.className, {
			[rf.mainRoom]: e === jn,
			[rf.dragTarget]: u
		})
	}, /*#__PURE__*/ t.createElement(Qd, {
		className: "mb-2",
		onSaveAction: j,
		name: k ? E("breakouts.breakout-room.main-name", "Main Room") : n,
		showEditButton: p && !k
	}), /*#__PURE__*/ t.createElement(me, {
		title: /*#__PURE__*/ t.createElement(t.Fragment, null, /*#__PURE__*/ t.createElement(G, {
			fontVariant: V.SmallBold,
			className: "me-2"
		}, e === "main" ? E("breakouts.breakout-room.not-assigned", "Not assigned") : E("breakouts.breakout-room.assigned", "Assigned")), /*#__PURE__*/ t.createElement(G, null, i.length)),
		"aria-label": e === "main" ? E("breakouts.breakout-room.not-assigned-aria-label", "Participants not assigned to a breakout room") : E("breakouts.breakout-room.assigned-aria-label", "Participants assigned to breakout room {{name}}"),
		isExpanded: !0
	}, m ? m(i) : /*#__PURE__*/ t.createElement(nf, {
		lockStyle: S,
		scrollElementRef: d,
		participants: i,
		myIdentity: a,
		rooms: s,
		onParticipantDragging: h,
		onParticipantDrag: g,
		onParticipantRoomChange: _,
		variant: c
	}), u && /*#__PURE__*/ t.createElement(Ae, { className: rf.dragDivider })), /*#__PURE__*/ t.createElement("div", { className: rf.footer }, /*#__PURE__*/ t.createElement(N, null), /*#__PURE__*/ t.createElement(P, null)), /*#__PURE__*/ t.createElement(Oe, {
		cancelButtonText: E("common.cancel", "Cancel"),
		onCancel: () => O(!1),
		confirmButtonText: E("common.yes", "Yes"),
		onConfirm: M,
		title: E("breakouts.close-room-modal.title", {
			defaultValue: "Close {{name}}?",
			name: n
		}),
		uniqueTitle: E("breakouts.close-room-modal.title", {
			defaultValue: "Close {{name}}?",
			name: n
		}),
		description: E("breakouts.close-room-modal.text", "The participants in this room will be moved to the main room."),
		isOpen: D
	}));
});
af.displayName = "BreakoutRoom";
// src/views/BreakoutRoomsConfiguration/BreakoutRoomsConfiguration.view.tsx
var of = ({ onAddRoomButtonClick: e, onShuffledButtonClick: n, onSettingsButtonClick: r, isShuffling: i = !1 }) => {
	let { t: a } = w(), [o, s] = t.useState(!1), c = [
		!!e && {
			key: "addRoom",
			label: a("breakouts.add-room-button-text", "Add room"),
			icon: /*#__PURE__*/ t.createElement(H, {
				source: U.IconAdd,
				size: "compact"
			}),
			onItemClick: e,
			closeMenuOnItemClick: !1,
			testId: q.ButtonBreakoutRoomAddRoom
		},
		!!n && {
			key: "shuffle",
			label: i ? a("breakouts.shuffling-button-text", "Shuffling...") : a("breakouts.shuffle-button-text", "Shuffle"),
			icon: /*#__PURE__*/ t.createElement(H, {
				source: U.IconShuffle,
				size: "compact"
			}),
			onItemClick: n,
			testId: q.ButtonBreakoutRoomShuffle,
			closeMenuOnItemClick: !1
		},
		!!r && {
			key: "settings",
			label: a("breakouts.settings-button-text", "Settings"),
			icon: /*#__PURE__*/ t.createElement(H, {
				source: U.IconSettings,
				size: "compact"
			}),
			onItemClick: r,
			closeMenuOnItemClick: !0,
			testId: q.ButtonBreakoutRoomSettings
		}
	].filter(Boolean);
	return /*#__PURE__*/ t.createElement(he, {
		onOpenChange: s,
		items: c,
		button: /*#__PURE__*/ t.createElement(z, {
			isActive: o,
			size: "compact",
			modifier: "square",
			variant: "translucent",
			"aria-label": a("breakouts.more-configuration-menu-aria-label", "See more breakout rooms configuration options"),
			"data-testid": q.ButtonBreakoutRoomsConfiguration
		}, /*#__PURE__*/ t.createElement(H, { source: U.IconMoreVertical })),
		popoverPlacement: "bottom left"
	});
}, sf = ({ currentParticipants: e, myIdentity: n, openRoomsText: r, isOpeningRooms: i = !1, numberOfRooms: a = 0, assignmentMode: o, headerText: s, onBack: c, onClosePanel: u, onOpenRooms: p, onSettingsButtonClick: m, shuffle: h = mi, children: g }) => {
	let { t: _ } = w(), v = Vt(), [y, b] = f(e), [x, S] = f(!1), C = d(null), { handleBreakoutRoomNameChange: T, duplicateRoomNameModal: E } = Ki({
		participants: y,
		setParticipants: b
	}), D = Vi({
		participants: y,
		setParticipants: b
	});
	Xi({
		currentParticipants: e,
		participants: y,
		setParticipants: b,
		changeParticipantRoom: D
	}), Bi({
		assignmentMode: o,
		myIdentity: n,
		numberOfRooms: a,
		setParticipants: b,
		shuffle: h
	});
	let { targetRoomId: O, onParticipantDragging: k, onParticipantDrag: A, getBreakoutRoomRefCallback: j } = Ui({
		participants: y,
		changeParticipantRoom: D,
		setIsDragging: S
	}), M = Wi({ setParticipants: b }), { doShuffle: N, isShuffling: P } = qi({
		myIdentity: n,
		setParticipants: b,
		shuffle: h
	}), F = Yn({ setParticipants: b }), I = l(() => Jn(y).length < 1, [y]), L = /*#__PURE__*/ t.createElement(z, {
		onClick: () => p(y),
		isLoading: i,
		modifier: "fullWidth",
		isDisabled: I,
		"data-testid": q.OpenBreakoutRooms
	}, r);
	return /*#__PURE__*/ t.createElement(t.Fragment, null, /*#__PURE__*/ t.createElement(Qe, {
		scrollElementRef: C,
		overflowHidden: x,
		isRounded: v,
		padding: "none",
		footerPadding: "small",
		headerContent: /*#__PURE__*/ t.createElement(Ml, {
			title: s,
			onBackClick: c,
			onCloseClick: u,
			backButtonTestId: q.BreakoutSetupPanelBackBtn,
			closeButtonTestId: q.PanelHeaderCloseButton,
			endContent: /*#__PURE__*/ t.createElement(of, {
				onAddRoomButtonClick: F,
				onSettingsButtonClick: m,
				onShuffledButtonClick: N,
				isShuffling: P
			})
		}),
		footerContent: I ? /*#__PURE__*/ t.createElement(_t, {
			tooltipContainerClassName: "d-flex",
			text: _("breakouts.open-rooms-btn-disabled-tooltip", "Minimum one breakout room is required"),
			position: "top"
		}, L) : L,
		scrollElementClassname: "pt-2 pr-3 pb-3 pl-3"
	}, Array.from(y.entries()).map(([e, r]) => /*#__PURE__*/ t.createElement(af, {
		scrollElementRef: C,
		id: e,
		key: e,
		name: e,
		rooms: Array.from(y.keys()).reduce((t, n) => (e !== n && (t[n] = n), t), {}),
		myIdentity: n,
		participants: r,
		isDragTarget: O === e,
		onNameChanged: T,
		onParticipantDragging: k,
		onParticipantDrag: A,
		onParticipantRoomChange: D,
		onRemoveRoom: M,
		ref: j(e),
		canEditRoomName: !0
	}))), E, g);
}, cf = {
	wrapper: "_wrapper_4dxr1_4",
	roomRow: "_roomRow_4dxr1_12",
	room: "_room_4dxr1_12"
}, lf = {
	roomRow: "_roomRow_r8vpr_4",
	room: "_room_r8vpr_4"
}, uf = ({ breakoutName: e, roomId: n, onJoinRoom: r, className: i }) => {
	let { t: a } = w();
	return /*#__PURE__*/ t.createElement("div", { className: K(lf.roomRow, i) }, /*#__PURE__*/ t.createElement("div", { className: lf.room }, /*#__PURE__*/ t.createElement(G, {
		fontVariant: V.Body,
		isTruncated: !0,
		title: e,
		translate: "no"
	}, e)), /*#__PURE__*/ t.createElement(z, {
		"data-testid": q.ButtonBreakoutJoinAskingForHelp,
		size: "small",
		className: "mr-2 ml-2",
		variant: "success",
		"aria-label": a("common.join-breakout-room-aria-label", "Join breakout room"),
		onClick: () => r(n)
	}, a("common.join", "Join")));
}, df = ({ breakoutsAskingForHelp: e, onJoinRoom: n, ...r }) => {
	let { t: i } = w(), [a, o] = f(!0), s = () => /*#__PURE__*/ t.createElement(z, {
		variant: "text",
		size: "compact",
		enhancerStart: /*#__PURE__*/ t.createElement(H, {
			className: "mr-1",
			source: a ? U.IconChevronUp : U.IconChevronDown,
			size: "mini"
		}),
		onClick: () => o((e) => !e),
		underlineText: !1
	}, /*#__PURE__*/ t.createElement("div", { className: "d-flex align-items-center" }, /*#__PURE__*/ t.createElement(G, { fontVariant: V.H5 }, i("breakouts.asking-for-help", "Asking for help")), /*#__PURE__*/ t.createElement(G, { className: "ml-2" }, e.length)));
	return e.length === 0 ? null : /*#__PURE__*/ t.createElement(Se, {
		padding: "small",
		...r,
		className: K(cf.wrapper)
	}, /*#__PURE__*/ t.createElement(s, null), a && /*#__PURE__*/ t.createElement("div", { className: "mt-4" }, e.map(({ breakoutName: e, roomId: r }) => /*#__PURE__*/ t.createElement(uf, {
		className: "mt-2",
		key: r,
		breakoutName: e,
		roomId: r,
		onJoinRoom: n
	}))));
}, ff = { editButton: "_editButton_15vug_1" }, pf = ({ breakoutsAskingForHelp: e, currentParticipants: n, showCloseRoomsButton: r, closeRoomsText: i, editRoomsText: a, breakoutRoomsNames: o, myIdentity: s, amIControlOnlyParticipant: c, headerText: l, onJoinRoom: u, onJoinRoomViaHelp: d, onCloseRoom: f, onCloseRooms: p, onClosePanel: m, onEditRooms: h }) => {
	let g = Vt(), { openBreakoutCloseAllRoomsConfirmationModal: _, breakoutCloseAllRoomsConfirmationModal: v } = Hi({ onCloseRooms: p });
	return /*#__PURE__*/ t.createElement(t.Fragment, null, /*#__PURE__*/ t.createElement(Qe, {
		isRounded: g,
		padding: "none",
		footerPadding: "small",
		headerContent: /*#__PURE__*/ t.createElement(Ml, {
			title: l,
			onCloseClick: m
		}),
		footerContent: r ? /*#__PURE__*/ t.createElement(z, {
			onClick: _,
			modifier: "fullWidth",
			variant: "danger",
			"data-testid": q.CloseBreakoutRooms
		}, i) : void 0,
		scrollElementClassname: "pt-2 pr-3 pb-3 pl-3"
	}, /*#__PURE__*/ t.createElement(z, {
		className: ff.editButton,
		modifier: "fullWidth",
		enhancerStart: /*#__PURE__*/ t.createElement(H, {
			size: "compact",
			source: U.IconEdit
		}),
		onClick: h,
		variant: "tertiary",
		"data-testid": q.ButtonBreakoutRoomEdit
	}, a), /*#__PURE__*/ t.createElement(df, {
		breakoutsAskingForHelp: e,
		onJoinRoom: d
	}), Array.from(n.entries()).map(([e, n]) => /*#__PURE__*/ t.createElement(af, {
		key: e,
		name: o.get(e) ?? e,
		id: e,
		participants: n,
		myIdentity: s,
		amIControlOnlyParticipant: c,
		variant: yn.Preview,
		onJoinRoom: u,
		onCloseRoom: f
	}))), v);
}, mf = ({ isOpen: e, onConfirm: n, onCancel: r }) => {
	let { t: i } = w();
	return /*#__PURE__*/ t.createElement(Oe, {
		isOpen: e,
		title: i("breakouts.go-back-to-mode-assignment-title", "Discard rooms?"),
		uniqueTitle: i("breakouts.go-back-to-mode-assignment-title", "Discard rooms?"),
		"data-testid": q.ModalBreakoutRoomsGoBackToModeAssignment,
		description: i("breakouts.go-back-to-mode-assignment-description", "You will lose the rooms you created."),
		confirmButtonText: i("common.ok", "Ok"),
		confirmButtonTestid: q.ButtonBreakoutRoomsConfirmGoBackToModeAssignment,
		cancelButtonText: i("common.cancel", "Cancel"),
		cancelButtonTestid: q.ButtonBreakoutRoomsCancelGoBackToModeAssignment,
		onConfirm: n,
		onCancel: r
	});
}, hf = ({ isOpen: e, onConfirm: n, onCancel: r }) => {
	let { t: i } = w();
	return /*#__PURE__*/ t.createElement(Oe, {
		isOpen: e,
		title: i("breakouts.go-back-to-opened-rooms-title", "Discard changes?"),
		uniqueTitle: i("breakouts.go-back-to-opened-rooms-title", "Discard changes?"),
		"data-testid": q.ModalBreakoutRoomsGoBackToOpenedRooms,
		description: i("breakouts.go-back-to-opened-rooms-description", "You will lose the changes you made to the rooms."),
		confirmButtonText: i("common.ok", "Ok"),
		confirmButtonTestid: q.ButtonBreakoutRoomsConfirmGoBackToOpenedRooms,
		cancelButtonText: i("common.cancel", "Cancel"),
		cancelButtonTestid: q.ButtonBreakoutRoomsCancelGoBackToOpenedRooms,
		onConfirm: n,
		onCancel: r
	});
}, gf = { amountOfRooms: "_amountOfRooms_10ig1_4" }, _f = ({ headerText: e, nextButtonText: n, initialAssignmentMode: r, assignmentModeLabel: i, assignmentModeAutomaticallyLabel: a, assignmentModeAutomaticallyDescription: o, assignmentModeManuallyLabel: s, assignmentModeManuallyDescription: c, amountOfRoomsLabel: l, increaseAmountOfRoomsLabel: u, decreaseAmountOfRoomsLabel: d, initialAmountOfRooms: p = 5, minAmountOfRooms: m = 1, maxAmountOfRooms: h = 50, onNextClick: g, onClosePanel: _ }) => {
	let v = Vt(), [y, b] = f(r), [x, S] = f(p);
	return /*#__PURE__*/ t.createElement(Qe, {
		isRounded: v,
		headerPadding: "none",
		headerContent: /*#__PURE__*/ t.createElement(Ml, {
			title: e,
			onCloseClick: _
		}),
		footerContent: /*#__PURE__*/ t.createElement(z, {
			modifier: "fullWidth",
			onClick: () => {
				g({
					amountOfRooms: x,
					assignmentMode: y
				});
			},
			"data-testid": q.GoToBreakoutSetupPanel
		}, n)
	}, /*#__PURE__*/ t.createElement("div", { className: K(gf.amountOfRooms, "mb-7") }, /*#__PURE__*/ t.createElement(ze, {
		className: "mb-0",
		text: l
	}), /*#__PURE__*/ t.createElement(Ze, {
		value: x,
		name: "roomsInput",
		label: l,
		ariaLabelDecrement: d,
		ariaLabelIncrement: u,
		minValue: m,
		maxValue: h,
		onChange: S,
		testIDInput: q.BreakoutNumberOfRoomsInput,
		testIDIncrement: q.ButtonBreakoutRoomsNumberOfRoomIncrement,
		testIDDecrement: q.ButtonBreakoutRoomsNumberOfRoomDecrement
	})), /*#__PURE__*/ t.createElement(ze, {
		className: "mb-7",
		text: i
	}), /*#__PURE__*/ t.createElement("div", { className: "mb-5" }, /*#__PURE__*/ t.createElement(it, {
		groupName: "mode",
		checked: y === _n.Automatically,
		label: a,
		value: _n.Automatically,
		onValueChange: (e) => e && b(_n.Automatically),
		"data-testid": q.BreakoutAssignAutoBtn
	}), /*#__PURE__*/ t.createElement(G, {
		fontVariant: V.Body,
		htmlTag: "p",
		className: "pl-5 pt-1"
	}, o)), /*#__PURE__*/ t.createElement("div", null, /*#__PURE__*/ t.createElement(it, {
		groupName: "mode",
		checked: y === _n.Manually,
		label: s,
		value: _n.Manually,
		onValueChange: (e) => e && b(_n.Manually),
		"data-testid": q.BreakoutAssignManuallyBtn
	}), /*#__PURE__*/ t.createElement(G, {
		fontVariant: V.Body,
		htmlTag: "p",
		className: "pl-5 pt-1"
	}, c)));
}, vf = {
	modalWrapper: "_modalWrapper_1fz0k_4",
	modalSectionWrapper: "_modalSectionWrapper_1fz0k_9",
	timerTextWrapper: "_timerTextWrapper_1fz0k_14",
	timerText: "_timerText_1fz0k_14",
	line: "_line_1fz0k_24"
}, yf = ({ className: e, isOpen: n, onSave: r, onCancel: i, timerValues: a, ...o }) => {
	let { t: s } = w(), [c, l] = f(a.defaultHours), [u, d] = f(a.defaultMinutes), [p, m] = f(!1), h = (e) => {
		e < a.maxHours && l(e);
	}, g = (e) => {
		e > a.maxMinutes && c < a.maxHours ? (h(c + 1), d(0)) : d(e);
	}, _ = /*#__PURE__*/ t.createElement(Ie, null, /*#__PURE__*/ t.createElement(B, { xs: 6 }, /*#__PURE__*/ t.createElement(z, {
		onClick: i,
		variant: "secondary",
		modifier: "fullWidth",
		"data-testid": q.CancelBreakoutSettings
	}, s("common.cancel", "Cancel"))), /*#__PURE__*/ t.createElement(B, { xs: 6 }, /*#__PURE__*/ t.createElement(z, {
		type: "submit",
		onClick: () => r(c, u, p),
		variant: "primary",
		modifier: "fullWidth",
		"data-testid": q.SaveBreakoutSettings
	}, s("common.save", "Save"))));
	return /*#__PURE__*/ t.createElement(ht, { colorScheme: "light" }, /*#__PURE__*/ t.createElement(qe, {
		isOpen: n,
		withCloseButton: !0,
		onClose: i,
		closeButtonAriaLabel: s("breakouts.room-settings-modal.close-btn", "Close room settings modal"),
		closeOnOutsideClick: !1,
		className: K(e, vf.modalWrapper),
		"data-testid": q.ModalRoomSettings,
		padding: "large",
		scrollbarsAriaLabel: s("common.scrollable-content", "Scrollable content"),
		footerContent: _,
		footerPadding: "small",
		hasFooterShadow: !0,
		uniqueTitle: s("breakouts.room-settings-modal.title", "Room settings"),
		...o
	}, /*#__PURE__*/ t.createElement(ft, {
		fontVariant: V.H5,
		htmlTag: "h3",
		className: "mt-2 mb-4"
	}, s("breakouts.room-settings-modal.title", "Room settings")), /*#__PURE__*/ t.createElement("div", { className: K(vf.modalSectionWrapper, "mx-2") }, /*#__PURE__*/ t.createElement(Le, {
		spacing: "compact",
		className: "mb-2"
	}, /*#__PURE__*/ t.createElement(H, { source: U.IconClock }), /*#__PURE__*/ t.createElement(G, {
		fontVariant: V.BodyBold,
		htmlTag: "span"
	}, s("breakouts.room-settings-modal.set-timer", "Do you want to set a timer?"))), /*#__PURE__*/ t.createElement(G, {
		fontVariant: V.Body,
		htmlTag: "p",
		color: Ee.Neutral70,
		className: "mb-6"
	}, s("breakouts.room-settings-modal.set-timer-description", "When the time is up participants will be moved to join the main room")), /*#__PURE__*/ t.createElement(Ie, { className: "mb-1" }, /*#__PURE__*/ t.createElement(B, {
		xs: 3,
		className: vf.timerTextWrapper
	}, /*#__PURE__*/ t.createElement(G, {
		className: vf.timerText,
		fontVariant: V.BodyBold,
		htmlTag: "p"
	}, s("breakouts.room-settings-modal.set-timer-hours", "Hours"))), /*#__PURE__*/ t.createElement(B, { xs: 9 }, /*#__PURE__*/ t.createElement(Ze, {
		colorScheme: "light",
		label: s("breakouts.room-settings-modal.hours-label", "Hours"),
		ariaLabelDecrement: s("breakouts.room-settings-modal.decrease-hours-aria-label", "Decrease hours"),
		ariaLabelIncrement: s("breakouts.room-settings-modal.increase-hours-aria-label", "Increase hours"),
		name: "hoursInput",
		value: c,
		onChange: h,
		testIDInput: q.RoomSettingsHoursInput,
		testIDDecrement: q.ButtonRoomSettingsHoursInputDecrement,
		testIDIncrement: q.ButtonRoomSettingsHoursInputIncrement
	}))), /*#__PURE__*/ t.createElement(Ie, null, /*#__PURE__*/ t.createElement(B, {
		xs: 3,
		className: vf.timerTextWrapper
	}, /*#__PURE__*/ t.createElement(G, {
		className: vf.timerText,
		fontVariant: V.BodyBold,
		htmlTag: "p"
	}, s("breakouts.room-settings-modal.set-timer-minutes", "Minutes"))), /*#__PURE__*/ t.createElement(B, { xs: 9 }, /*#__PURE__*/ t.createElement(Ze, {
		colorScheme: "light",
		label: s("breakouts.room-settings-modal.minutes-label", "Minutes"),
		ariaLabelDecrement: s("breakouts.room-settings-modal.decrease-minutes-aria-label", "Decrease minutes"),
		ariaLabelIncrement: s("breakouts.room-settings-modal.increase-minutes-aria-label", "Increase minutes"),
		name: "minutesInput",
		value: u,
		onChange: g,
		stepValue: a.minuteStepValue,
		testIDInput: q.RoomSettingsMinutesInput,
		testIDDecrement: q.ButtonRoomSettingsMinutesInputDecrement,
		testIDIncrement: q.ButtonRoomSettingsMinutesInputIncrement
	})))), /*#__PURE__*/ t.createElement("div", { className: K(vf.line, "my-6") }), /*#__PURE__*/ t.createElement("div", { className: K(vf.modalSectionWrapper, "mx-2") }, /*#__PURE__*/ t.createElement(Le, {
		spacing: "compact",
		className: "mb-6"
	}, /*#__PURE__*/ t.createElement(H, { source: U.IconLeave }), /*#__PURE__*/ t.createElement(G, {
		fontVariant: V.BodyBold,
		htmlTag: "span"
	}, s("breakouts.room-settings-modal.leave-room-options", "Options for leaving the rooms"))), /*#__PURE__*/ t.createElement(we, {
		checked: p,
		label: s("breakouts.room-settings-modal.leave-room-checkbox", "Allow participants to leave at any time"),
		name: "Participants can leave at any time checkbox",
		onChange: () => m(!p),
		className: "mb-2"
	}), /*#__PURE__*/ t.createElement(G, {
		fontVariant: V.Body,
		htmlTag: "p",
		className: "mb-4"
	}, s("breakouts.room-settings-modal.leave-room-options-description", "By default, participants cannot leave a breakout room while it is open. When this is selected, participants can return to the main room at any time.")))));
}, bf = { footer: "_footer_hi8l7_4" }, xf = ({ currentParticipants: e, myIdentity: n, breakoutRoomsNames: r, saveButtonText: i, cancelButtonText: a, headerText: o, onSave: s, onCancel: c, onClosePanel: l, onSettingsButtonClick: u }) => {
	let f = Vt(), p = d(null), { participants: m, breakoutRoomsNames: h, isDragging: g, isShuffling: _, onAddRoom: v, doSave: y, doShuffle: b, currentDragTarget: x, handleBreakoutRoomNameChange: S, onParticipantDragging: C, onParticipantDrag: w, changeParticipantRoom: T, onRemoveRoom: E, getBreakoutRoomRefCallback: D } = Yi({
		currentParticipants: e,
		breakoutRoomsNames: r,
		myIdentity: n,
		onSave: s
	});
	return /*#__PURE__*/ t.createElement(Qe, {
		scrollElementRef: p,
		overflowHidden: g,
		isRounded: f,
		padding: "none",
		footerPadding: "small",
		headerContent: /*#__PURE__*/ t.createElement(Ml, {
			title: o,
			onCloseClick: l,
			closeButtonTestId: q.PanelHeaderCloseButton,
			endContent: /*#__PURE__*/ t.createElement(of, {
				onAddRoomButtonClick: v,
				onSettingsButtonClick: u,
				onShuffledButtonClick: b,
				isShuffling: _
			})
		}),
		footerContent: /*#__PURE__*/ t.createElement("div", { className: bf.footer }, /*#__PURE__*/ t.createElement(z, {
			variant: "secondary",
			modifier: "fullWidth",
			onClick: c
		}, a), /*#__PURE__*/ t.createElement(z, {
			modifier: "fullWidth",
			onClick: y,
			"data-testid": q.ButtonSaveBreakoutRoomsEdit
		}, i)),
		scrollElementClassname: "pt-2 pr-3 pb-3 pl-3"
	}, Array.from(m.entries()).map(([e, r]) => /*#__PURE__*/ t.createElement(af, {
		scrollElementRef: p,
		variant: yn.Edit,
		id: e,
		key: e,
		name: h.get(e) ?? e,
		rooms: Array.from(m.keys()).reduce((t, n) => (e !== n && (t[n] = h.get(n) ?? n), t), {}),
		myIdentity: n,
		participants: r,
		isDragTarget: x === e,
		onNameChanged: S,
		onParticipantDragging: C,
		onParticipantDrag: w,
		onParticipantRoomChange: T,
		onRemoveRoom: E,
		ref: D(e),
		canEditRoomName: !h.get(e)
	})));
}, Sf = ({ isOpen: e, onConfirm: n }) => {
	let { t: r } = w();
	return /*#__PURE__*/ t.createElement(Oe, {
		"data-testid": q.ModalOpenRoomsError,
		isOpen: e,
		onConfirm: n,
		confirmButtonText: r("common.ok", "Ok"),
		title: r("breakouts.error-on-open-rooms-title", "Could not open rooms"),
		uniqueTitle: r("breakouts.error-on-open-rooms-title", "Could not open rooms"),
		description: r("breakouts.error-on-open-rooms-description", "An error occurred while trying to open the breakout rooms. Please try again.")
	});
}, Cf = ({ setStreamQuality: e, streamQuality: n }) => {
	let { t: r } = w();
	return /*#__PURE__*/ t.createElement(t.Fragment, null, /*#__PURE__*/ t.createElement(G, { fontVariant: V.BodyBold }, /*#__PURE__*/ t.createElement(C, {
		t: r,
		i18nKey: "quality.quality"
	}, "Connection quality")), /*#__PURE__*/ t.createElement(G, {
		fontVariant: V.Small,
		htmlTag: "p"
	}, /*#__PURE__*/ t.createElement(C, {
		t: r,
		i18nKey: "quality.info"
	}, "This setting affects the amount of bandwidth you’ll use for this meeting. Adjust to a lower value if your internet connection is slow or if your computer’s performance is badly affected.")), /*#__PURE__*/ t.createElement(ct, {
		className: "mb-5 mt-4",
		"data-testid": q.ButtonQuality,
		iconType: U.IconBandwidth,
		isFullWidth: !0,
		label: r("quality.select-quality", "Select meeting quality"),
		labelModifier: "hidden",
		options: [
			{
				id: mn.Low,
				label: r("quality.low", "Low")
			},
			{
				id: mn.Medium,
				label: r("quality.medium", "Medium")
			},
			{
				id: mn.High,
				label: r("quality.high", "High")
			},
			{
				id: mn.VeryHigh,
				label: r("quality.very-high", "Very High")
			},
			{
				id: mn.Auto,
				label: r("quality.auto", "Auto")
			}
		],
		onValueChange: (t) => {
			e(t);
		},
		sizeModifier: "small",
		value: n
	}));
}, wf = { unreadIndicator: "_unreadIndicator_18unp_1" }, Tf = ({ allowChatTypeActiveTabClick: e, selectedChatType: n, unreadChatMessages: r, unseenUnreadDirectChatMessages: i, onChatTypeChange: a }) => {
	let { t: o } = w(), s = Ht();
	return /*#__PURE__*/ t.createElement(De, {
		allowActiveTabToBeClicked: e,
		sizeModifier: s ? "large" : "medium",
		selectedTabID: n,
		onTabChange: (e) => a(e),
		tabs: [{
			id: pn.Everyone,
			name: o("meeting.chat-with-everyone", "Everyone"),
			textEndContent: r.length > 0 ? /*#__PURE__*/ t.createElement(Hl, {
				testId: q.ChatUnreadEveryoneMessagesIndicator,
				className: wf.unreadIndicator
			}) : void 0,
			testId: q.ButtonChatEveryoneTab
		}, {
			id: pn.Direct,
			name: o("meeting.chat-with-individual", "Direct"),
			textEndContent: i.length > 0 ? /*#__PURE__*/ t.createElement(Hl, {
				testId: q.ChatUnseenDirectMessagesIndicator,
				withBorder: n === pn.Direct,
				className: wf.unreadIndicator
			}) : void 0,
			testId: q.ButtonChatDirectTab
		}]
	});
}, Ef = {
	container: "_container_14dkz_4",
	row: "_row_14dkz_11",
	tooltip: "_tooltip_14dkz_18"
}, Df = ({ displayName: e }) => /*#__PURE__*/ t.createElement("div", { className: Ef.row }, /*#__PURE__*/ t.createElement(ve, {
	colorScheme: "dark",
	displayName: e,
	sizeModifier: "small",
	type: ye.Initials,
	className: "mr-2"
}), /*#__PURE__*/ t.createElement(G, {
	fontVariant: V.BodyBold,
	isTruncated: !0
}, e)), Of = ({ className: e, participant: n, onMessageClick: r }) => {
	let { t: i } = w();
	return /*#__PURE__*/ t.createElement("div", { className: K(Ef.container, e) }, /*#__PURE__*/ t.createElement(Df, { displayName: n.displayName }), /*#__PURE__*/ t.createElement(z, {
		"data-testid": q.ButtonChatNewDirectMessage,
		onClick: () => r(n),
		size: "compact",
		variant: "tertiary"
	}, i("meeting.chat-message-participant", "Message")));
}, kf = ({ className: e, participant: n }) => {
	let { t: r } = w();
	return /*#__PURE__*/ t.createElement("div", { className: K(Ef.container, e) }, /*#__PURE__*/ t.createElement(Df, { displayName: n.displayName }), /*#__PURE__*/ t.createElement(_t, {
		text: r("meeting.chat-message-participant-no-direct-chat", "You can't send a message to this participant because their device doesn't support direct chat."),
		className: Ef.tooltip
	}, /*#__PURE__*/ t.createElement(z, {
		"data-testid": q.ButtonChatNewDirectMessage,
		isDisabled: !0,
		size: "compact",
		variant: "tertiary"
	}, r("meeting.chat-message-participant", "Message"))));
}, Af = ({ participantInDirectChatWith: e, latestMessage: n, roomName: r, hasUnreadMessages: i, handleGoToDirectChat: a }) => /*#__PURE__*/ t.createElement(Be, {
	"data-testid": q.ButtonChatDirectMessagePreview,
	tabIndex: 0,
	htmlTag: "div",
	onClick: a,
	onKeyDown: (e) => {
		e.key === X.enter && a();
	}
}, /*#__PURE__*/ t.createElement(Wl, {
	isUnread: i,
	useHoverStyle: !0,
	withAvatar: !0,
	isTruncated: !0,
	displayNameMeta: r,
	message: {
		...n,
		displayName: e.displayName ?? ""
	}
}, /*#__PURE__*/ t.createElement(vt, { text: n.message }))), jf = {
	container: "_container_11970_32",
	header: "_header_11970_39",
	footer: "_footer_11970_45",
	footerInner: "_footerInner_11970_54",
	smallGap: "_smallGap_11970_59",
	mediumGap: "_mediumGap_11970_68",
	largeGap: "_largeGap_11970_77",
	leftNavigationButton: "_leftNavigationButton_11970_87",
	rightNavigationButton: "_rightNavigationButton_11970_103",
	removeImage: "_removeImage_11970_119"
}, Mf = {
	effectItem: "_effectItem_5ag56_4",
	smallSquare: "_smallSquare_5ag56_25",
	largeSquare: "_largeSquare_5ag56_29",
	largePortrait: "_largePortrait_5ag56_33",
	smallLandscape: "_smallLandscape_5ag56_37",
	isImage: "_isImage_5ag56_41",
	isSelected: "_isSelected_5ag56_45",
	isImageError: "_isImageError_5ag56_48"
}, Nf = ({ isSelected: e = !1, isImageError: n = !1, showTooltip: r = !0, tooltipDelay: i = 1e3, size: a = "smallSquare", icon: o, acceptedImageFormats: s, onFileUploadChange: c, imageUrl: l, className: u, children: p, effectName: m, endContent: h, onClick: g, ..._ }) => {
	let [v, y] = f(!1), b = !!l, x = !!c, S = d(null), C = /*#__PURE__*/ t.createElement(Be, {
		onClick: g,
		tabIndex: 0,
		role: "button",
		onKeyDown: Tt(() => {
			g?.(), x && S.current && S.current.click();
		}),
		htmlTag: x || b ? "div" : "button",
		"aria-label": m,
		onMouseEnter: () => y(!0),
		onMouseLeave: () => y(!1),
		"data-active": e,
		className: K("align-items-center", "d-flex", "flex-direction-column", "justify-content-center", Mf.effectItem, {
			[Mf.smallSquare]: a === "smallSquare",
			[Mf.largeSquare]: a === "largeSquare",
			[Mf.largePortrait]: a === "largePortrait",
			[Mf.smallLandscape]: a === "smallLandscape",
			[Mf.isSelected]: e,
			[Mf.isImage]: b,
			[Mf.isImageError]: n
		}, u),
		...l && !n ? { style: { backgroundImage: `url('${l}')` } } : {},
		..._
	}, p, o && /*#__PURE__*/ t.createElement(H, { source: o }), n && /*#__PURE__*/ t.createElement(H, {
		color: Ee.Red70,
		source: U.IconWarningRound
	}), h?.(v));
	return n ? C : /*#__PURE__*/ t.createElement(_t, {
		text: m,
		isTooltipEnabled: r,
		delay: i
	}, x ? /*#__PURE__*/ t.createElement(Me, {
		accept: s,
		onChange: c,
		multiple: !1,
		colorScheme: "light",
		ref: S,
		noFocus: !0
	}, C) : C);
}, Pf = ({ updatingPreviewVideo: e, isSaving: n, selectedEffect: i, selectedImageUrl: a, selectedBlurAmount: o, backgroundBlurAmountLow: s, backgroundBlurAmountHigh: c, imageUrls: l, imageError: u, clearImageError: d, totalAllowedImages: p = 1, acceptedImageFormats: m, onBackgroundBlurClick: h, onNoneClick: g, onFileUploadChange: _, onImageClick: v, onRemoveImageClick: y, onCancel: b, onSave: x }) => {
	let { t: S } = w(), C = ni(), T = !C, E = Bt(), D = jt(), O = C && E, k = C && D, A = l.length < p, [j, M] = f(null), N = r((e) => {
		M(e);
	}, []), P;
	T ? P = "smallSquare" : O ? P = "largePortrait" : k && (P = "largeSquare");
	let { moveLeft: F, moveRight: I, navigationView: L, hasOverflowingContent: ee } = zt({
		moveBy: 45,
		root: j,
		isDisabled: !1,
		containerClassName: K(jf.footerInner, {
			[jf.largeGap]: k,
			[jf.mediumGap]: O,
			[jf.smallGap]: T
		}),
		content: /*#__PURE__*/ t.createElement(t.Fragment, null, /*#__PURE__*/ t.createElement(Nf, {
			onClick: g,
			isSelected: i === "none",
			size: P,
			icon: U.IconBlock,
			effectName: S("media.effect.no-background", "No background"),
			"data-testid": q.ButtonBackgroundEffectNone
		}), /*#__PURE__*/ t.createElement(Nf, {
			onClick: () => h(s),
			isSelected: i === "blur" && o === s,
			size: P,
			icon: U.IconBackgroundBlurLight,
			effectName: S("media.effect.light-blur", "Light blur"),
			"data-testid": q.ButtonBackgroundEffectBlurLow
		}), /*#__PURE__*/ t.createElement(Nf, {
			onClick: () => h(c),
			isSelected: i === "blur" && o === c,
			size: P,
			icon: U.IconBackgroundBlurStrong,
			effectName: S("media.effect.strong-blur", "Strong blur"),
			"data-testid": q.ButtonBackgroundEffectBlurHigh
		}), A && /*#__PURE__*/ t.createElement(Nf, {
			acceptedImageFormats: m,
			onFileUploadChange: _,
			isSelected: !1,
			size: P,
			icon: U.IconImport,
			effectName: S("media.effect.upload-background", "Upload background"),
			"data-testid": q.ButtonBackgroundEffectUpload
		}), u && /*#__PURE__*/ t.createElement(Xe, {
			shouldCloseOnOutsideClick: !0,
			controlledIsVisible: !0,
			controlledOnChange: () => {
				d?.();
			},
			header: u.title,
			text: u.body,
			position: "topCenter",
			closeButtonAriaLabel: S("common.close-tooltip", "Close tooltip")
		}, /*#__PURE__*/ t.createElement(Nf, {
			isImageError: !0,
			onClick: () => {
				d?.();
			},
			showTooltip: !1,
			size: T ? "smallLandscape" : P,
			effectName: u.title,
			isSelected: !1
		})), l.map(({ imageUrl: e, type: n }, r) => {
			let o = i === "overlay" && a === e;
			return /*#__PURE__*/ t.createElement(Nf, {
				key: e,
				showTooltip: !1,
				size: T ? "smallLandscape" : P,
				imageUrl: e,
				isSelected: o,
				onClick: () => {
					v(e);
				},
				"data-testid": `${q.ButtonBackgroundEffectImage}-${r}`,
				endContent: (r) => n === "user" && (C && o || !C && r) ? /*#__PURE__*/ t.createElement(z, {
					colorScheme: "light",
					className: jf.removeImage,
					onClick: (t) => {
						t.stopPropagation(), y(e);
					},
					"data-testid": q.ButtonBackgroundEffectRemoveImage,
					size: "compact",
					modifier: "disc",
					variant: "secondary",
					noEnhancerPadding: !0,
					"aria-label": S("settings.remove-image", "Remove image"),
					enhancerStart: /*#__PURE__*/ t.createElement(H, {
						source: U.IconClose,
						size: "compact"
					})
				}) : null
			});
		}))
	});
	return /*#__PURE__*/ t.createElement("div", { className: jf.container }, /*#__PURE__*/ t.createElement("div", { className: jf.header }, /*#__PURE__*/ t.createElement(z, {
		colorScheme: "light",
		size: "small",
		onClick: () => {
			b();
		},
		variant: "secondary",
		"data-testid": q.ButtonBackgroundEffectCancel,
		isDisabled: n || e
	}, S("common.cancel", "Cancel")), /*#__PURE__*/ t.createElement(z, {
		onClick: x,
		variant: "primary",
		"data-testid": q.ButtonBackgroundEffectSave,
		isLoading: n || e,
		isDisabled: n
	}, S("common.save", "Save"))), /*#__PURE__*/ t.createElement("div", {
		className: K(jf.footer, { "justify-content-center": !ee }),
		ref: N
	}, F && /*#__PURE__*/ t.createElement(Be, {
		className: K(jf.leftNavigationButton),
		onClick: F,
		"data-testid": q.ButtonBackgroundEffectNavigateLeft
	}, /*#__PURE__*/ t.createElement(H, {
		colorScheme: "dark",
		source: U.IconChevronLeft,
		size: "medium"
	})), L, I && /*#__PURE__*/ t.createElement(Be, {
		className: K(jf.rightNavigationButton),
		onClick: I,
		"data-testid": q.ButtonBackgroundEffectNavigateRight
	}, /*#__PURE__*/ t.createElement(H, {
		colorScheme: "dark",
		source: U.IconChevronRight,
		size: "medium"
	}))));
}, Ff = {
	item: "_item_1o2xb_4",
	light: "_light_1o2xb_13",
	callSucceeded: "_callSucceeded_1o2xb_13",
	dark: "_dark_1o2xb_13",
	callFailed: "_callFailed_1o2xb_16",
	avatarAndDragHandle: "_avatarAndDragHandle_1o2xb_23",
	avatarAndInfo: "_avatarAndInfo_1o2xb_31",
	avatar: "_avatar_1o2xb_23",
	info: "_info_1o2xb_44",
	menuContainer: "_menuContainer_1o2xb_55",
	directionAndDateContainer: "_directionAndDateContainer_1o2xb_59",
	directionAndDateDivider: "_directionAndDateDivider_1o2xb_69",
	outgoingIcon: "_outgoingIcon_1o2xb_79",
	incomingIcon: "_incomingIcon_1o2xb_83",
	missedIcon: "_missedIcon_1o2xb_87",
	expiredTag: "_expiredTag_1o2xb_97"
}, If = {
	container: "_container_9jh7c_1",
	meetingIdContainer: "_meetingIdContainer_9jh7c_7",
	oneTimeExpiredMessage: "_oneTimeExpiredMessage_9jh7c_11"
}, Lf = ({ isTouchDevice: e, className: n, title: r, meetingId: i }) => /*#__PURE__*/ t.createElement("div", { className: K(If.container, n) }, /*#__PURE__*/ t.createElement(ve, {
	colorScheme: "light",
	displayName: r ?? i,
	sizeModifier: "md",
	type: ye.Initials
}), /*#__PURE__*/ t.createElement(ft, {
	htmlTag: e ? V.H2 : V.H5,
	fontVariant: e ? V.H2 : V.H5,
	className: `${e ? "mt-3" : "mt-1"} text-center`
}, r ?? i), r && i && /*#__PURE__*/ t.createElement(G, { className: K(If.meetingIdContainer, "text-center") }, i)), Rf = ({ isTouchDevice: e, isRemoveFavoriteDisabled: n = !1, removeFavoriteDisabledReason: r, title: i, meetingId: a, handleCallMeetingId: o, handleDeleteRecent: s, handleRemoveFavorite: c, handleAddToFavorites: u, button: d, onOpenChange: f }) => {
	let { t: p } = w(), m = l(() => [
		!!o && {
			label: p("media.call-history.call-this-video-address", "Call this video address"),
			onItemClick: () => o?.(),
			testId: q.ActionCallMeetingId,
			key: "call-video-address",
			icon: /*#__PURE__*/ t.createElement(H, {
				size: e ? "small" : "compact",
				source: U.IconPhone
			})
		},
		!!u && {
			label: p("media.call-history.add-to-favorites", "Add to Favorites"),
			onItemClick: () => u?.(),
			testId: q.ActionAddToFavorites,
			key: "add-to-favorites",
			icon: /*#__PURE__*/ t.createElement(H, {
				size: e ? "small" : "compact",
				source: U.IconStar
			})
		},
		!!s && {
			label: p("common.delete", "Delete"),
			onItemClick: () => s?.(),
			testId: q.ActionDeleteRecent,
			key: "delete-recent",
			icon: /*#__PURE__*/ t.createElement(H, {
				size: e ? "small" : "compact",
				source: U.IconTrash
			}),
			style: { color: Ee.Red70 }
		},
		!!c && {
			label: p("media.call-history.remove-favorite", "Remove favorite"),
			onItemClick: () => c?.(),
			testId: q.ActionRemoveFavorite,
			key: "remove-favorite",
			isDisabled: n,
			description: n && r ? r : void 0,
			icon: /*#__PURE__*/ t.createElement(H, {
				size: e ? "small" : "compact",
				source: U.IconTrash
			}),
			style: n ? void 0 : { color: Ee.Red70 }
		}
	].filter(Boolean), [
		u,
		o,
		s,
		c,
		e,
		n,
		r,
		p
	]);
	return /*#__PURE__*/ t.createElement(he, {
		headerContent: /*#__PURE__*/ t.createElement(Lf, {
			isTouchDevice: !1,
			className: "pt-4 pl-4 pr-4 pb-1",
			title: i,
			meetingId: a
		}),
		onOpenChange: f,
		button: d,
		items: m,
		testId: "kebab-menu"
	});
}, zf = {
	hour: "2-digit",
	minute: "2-digit",
	hour12: !1
}, Bf = { weekday: "long" }, Vf = {
	year: "numeric",
	month: "short",
	day: "numeric"
}, Hf = 864e5, Uf = (e) => new Date(e.getFullYear(), e.getMonth(), e.getDate()).getTime(), Wf = (e, { t, language: n }, r = /* @__PURE__ */ new Date()) => {
	let i = e instanceof Date ? e : new Date(e), a = Math.round((Uf(r) - Uf(i)) / Hf), o = new Intl.DateTimeFormat(n, zf), s = new Intl.DateTimeFormat(n, Bf), c = new Intl.DateTimeFormat(n, Vf), l = o.format(i), u = t("media.date-time.full", "{{date}} {{time}}", {
		date: c.format(i),
		time: l
	});
	return a === 0 ? {
		relativeFormattedDateTime: t("media.date-time.today", "Today, {{time}}", { time: l }),
		fullFormattedDateTime: u
	} : a === 1 ? {
		relativeFormattedDateTime: t("media.date-time.yesterday", "Yesterday, {{time}}", { time: l }),
		fullFormattedDateTime: u
	} : a >= 2 && a <= 6 ? {
		relativeFormattedDateTime: t("media.date-time.weekday", "{{weekday}}, {{time}}", {
			weekday: s.format(i),
			time: l
		}),
		fullFormattedDateTime: u
	} : {
		relativeFormattedDateTime: u,
		fullFormattedDateTime: u
	};
}, Gf = ({ title: e, meetingId: n, direction: r, dateAndTime: i, imageUrl: a, isRemoveFavoriteDisabled: o = !1, removeFavoriteDisabledReason: s, callSucceeded: c, isMobile: l, draggableHandleAriaLabel: u, className: d, onClick: p, handleCallMeetingId: m, handleDeleteRecent: h, handleRemoveFavorite: g, handleAddToFavorites: _, handleReorderByKeyboard: v, setDragCaptureTarget: y }) => {
	let { t: b, i18n: x } = w(), S = i ? Wf(new Date(i), {
		t: b,
		language: x.language
	}) : void 0, C = S?.relativeFormattedDateTime, T = S?.fullFormattedDateTime, [E, D] = f(!1), [O, k] = f(!1), [A, j] = f(!1), [M, N] = f(!1), P = l || E || O || A || M, F = "", I, L = !!y;
	switch (r) {
		case bn.Incoming:
			F = b("media.call-history.incoming", "Incoming"), I = /*#__PURE__*/ t.createElement(H, {
				size: "compact",
				className: K(Ff.incomingIcon, {
					[Ff.callSucceeded]: c,
					[Ff.callFailed]: !c
				}),
				source: U.IconArrowLeftRegular
			});
			break;
		case bn.Outgoing:
			F = b("media.call-history.outgoing", "Outgoing"), I = /*#__PURE__*/ t.createElement(H, {
				size: "compact",
				className: K(Ff.outgoingIcon, {
					[Ff.callSucceeded]: c,
					[Ff.callFailed]: !c
				}),
				source: U.IconArrowLeftRegular
			});
			break;
		case bn.Missed: F = b("media.call-history.missed", "Missed"), I = /*#__PURE__*/ t.createElement(H, {
			size: "compact",
			className: K(Ff.missedIcon, Ff.callFailed),
			source: U.IconArrowCornerDown
		});
	}
	let ee = /*#__PURE__*/ t.createElement(z, {
		onClick: () => {
			j(!A);
		},
		"aria-label": b("media.call-history.open-menu", "Open call history item menu"),
		isActive: A,
		role: "button",
		variant: l ? "transparent" : "secondary",
		modifier: "square",
		size: "small",
		"data-testid": q.ButtonCallHistoryItemMenu
	}, /*#__PURE__*/ t.createElement(H, {
		size: l ? "small" : "compact",
		source: U.IconMoreVertical
	}));
	return /*#__PURE__*/ t.createElement(mt, null, ({ colorScheme: i }) => /*#__PURE__*/ t.createElement(Be, {
		"data-no-drag": !0,
		tabIndex: 0,
		htmlTag: "div",
		onClick: p,
		onKeyDown: (e) => {
			e.key === X.enter && p();
		},
		className: K(i, Ff[i], Ff.item, d),
		onMouseEnter: () => D(!0),
		onMouseLeave: () => D(!1),
		onFocus: () => {
			an() !== "pointer" && k(!0);
		},
		onBlur: (e) => {
			e.currentTarget.contains(e.relatedTarget) || (k(!1), A || N(!1));
		},
		"data-testid": q.CallHistoryItem
	}, /*#__PURE__*/ t.createElement("div", { className: Ff.avatarAndInfo }, /*#__PURE__*/ t.createElement("div", { className: Ff.avatarAndDragHandle }, L && /*#__PURE__*/ t.createElement(at, {
		"data-drag-handle": !0,
		"aria-label": u,
		onClick: (e) => {
			e.stopPropagation();
		},
		onKeyDown: (e) => {
			e.key === X.arrowUp || e.key === X.arrowDown ? (e.preventDefault(), e.stopPropagation(), v?.(e.key === X.arrowUp ? "up" : "down")) : e.key === X.enter && (e.preventDefault(), e.stopPropagation());
		},
		ref: y,
		size: "none",
		variant: "transparent"
	}, /*#__PURE__*/ t.createElement(H, {
		source: U.IconDraggable,
		size: "compact"
	})), /*#__PURE__*/ t.createElement(ve, {
		className: Ff.avatar,
		sizeModifier: "md",
		imageUrl: a,
		type: a ? ye.Image : ye.Initials,
		displayName: e ?? n
	})), /*#__PURE__*/ t.createElement("div", { className: Ff.info }, /*#__PURE__*/ t.createElement(G, {
		title: e ?? n,
		fontVariant: V.Body
	}, e ?? n), e && n && /*#__PURE__*/ t.createElement(G, {
		title: n,
		fontVariant: l ? V.Body : V.Small
	}, n), r && S && /*#__PURE__*/ t.createElement(G, {
		className: Ff.directionAndDateContainer,
		title: `${F} - ${T}`,
		fontVariant: l ? V.Body : V.Small
	}, I, F, " ", /*#__PURE__*/ t.createElement("span", { className: Ff.directionAndDateDivider }), " ", C))), /*#__PURE__*/ t.createElement("div", { className: Ff.menuContainer }, P && /*#__PURE__*/ t.createElement(Rf, {
		isTouchDevice: l,
		title: e,
		meetingId: n,
		button: ee,
		isRemoveFavoriteDisabled: o,
		removeFavoriteDisabledReason: s,
		onOpenChange: (e) => {
			if (j(e), !e) {
				let e = an() === "pointer";
				N(!e), e && k(!1);
			}
		},
		handleCallMeetingId: m,
		handleDeleteRecent: h,
		handleRemoveFavorite: g,
		handleAddToFavorites: _
	}))));
}, Kf = {
	itemDivider: "_itemDivider_1sxl7_32",
	draggableItem: "_draggableItem_1sxl7_36",
	brandingFavoriteDisabledReason: "_brandingFavoriteDisabledReason_1sxl7_44"
}, qf = ({ item: e, isMobile: n, showDivider: r, isDragDisabled: i, scrollElementRef: a, style: o, onPointerMoveExtra: s, onPointerUpExtra: c, onClick: l, handleRemoveFavorite: u, handleReorderByKeyboard: d }) => {
	let { t: p } = w(), [m, h] = f(null), g = e.isBranding ? /*#__PURE__*/ t.createElement(G, {
		htmlTag: "p",
		className: Kf.brandingFavoriteDisabledReason,
		fontVariant: V.Small,
		variant: "tinted"
	}, p("media.call-history.remove-favorite-disabled-branding", "Added by your admin and can not be removed.")) : void 0;
	return /*#__PURE__*/ t.createElement(je, {
		id: e.meetingId,
		scrollElementRef: a,
		pointerCapture: !0,
		pointerCaptureTarget: m,
		lockStyle: We.VERTICAL,
		onPointerMoveExtra: s,
		onPointerUpExtra: c,
		isDisabled: i,
		shouldCaptureClick: !1,
		style: o,
		className: K(Kf.draggableItem, { [Kf.itemDivider]: r })
	}, /*#__PURE__*/ t.createElement(Gf, {
		onClick: l,
		handleCallMeetingId: l,
		handleRemoveFavorite: u,
		isRemoveFavoriteDisabled: e.isBranding,
		removeFavoriteDisabledReason: g,
		title: e.title,
		meetingId: e.meetingId,
		imageUrl: e.avatarImageUrl,
		isMobile: n,
		draggableHandleAriaLabel: p("media.call-history.reorder-favorite-drag-handle", "Drag handle to reorder favorite"),
		handleReorderByKeyboard: d,
		setDragCaptureTarget: h
	}));
}, Jf = {
	panel: "_panel_1puh0_4",
	fullWidth: "_fullWidth_1puh0_7",
	footer: "_footer_1puh0_11",
	header: "_header_1puh0_19",
	itemDivider: "_itemDivider_1puh0_23"
}, Yf = {
	container: "_container_jwvv9_4",
	boxes: "_boxes_jwvv9_12"
}, Xf = (t) => /* @__PURE__ */ e.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 113,
	height: 103,
	viewBox: "0 0 113 103",
	fill: "none",
	...t
}, /* @__PURE__ */ e.createElement("path", {
	d: "M61.4896 81.0723L60.4001 60.1289L101.57 51.7503L103.297 72.8184L61.4896 81.0723Z",
	fill: "#D2D2D2"
}), /* @__PURE__ */ e.createElement("path", {
	d: "M60.3996 60.128L42.5118 51.6638L43.7834 73.0714L61.4891 81.0714L60.3996 60.128Z",
	fill: "#989898"
}), /* @__PURE__ */ e.createElement("path", {
	d: "M83.9878 43.1114L42.5115 51.6638L60.3246 60.2109L101.569 51.7494L83.9878 43.1114Z",
	fill: "#E6E6E6"
}), /* @__PURE__ */ e.createElement("path", {
	d: "M38.1784 35.3711L8.28573 38.6388L17.4823 63.083L45.9787 62.8362L38.1784 35.3711Z",
	fill: "#989898"
}), /* @__PURE__ */ e.createElement("path", {
	d: "M8.28553 38.6378L27.9498 20.2454L57.5062 16.9576L38.1782 35.3702L8.28553 38.6378Z",
	fill: "#E6E6E6"
}), /* @__PURE__ */ e.createElement("path", {
	d: "M65.3059 44.4226L57.5056 16.9575L38.1775 35.3701L45.9779 62.8352L65.3059 44.4226Z",
	fill: "#D2D2D2"
}), /* @__PURE__ */ e.createElement("path", {
	d: "M92.7169 5.4331L83.6035 16.2457L102.319 37.5124L111.826 26.8926L92.7169 5.4331Z",
	fill: "#989898"
}), /* @__PURE__ */ e.createElement("path", {
	d: "M83.6038 16.2461L70.5434 13.5116L79.9436 2.52365L92.7172 5.43346L83.6038 16.2461Z",
	fill: "#E6E6E6"
}), /* @__PURE__ */ e.createElement("path", {
	d: "M89.3528 34.9963L70.5433 13.5112L83.5974 16.1708L102.319 37.5124L89.3528 34.9963Z",
	fill: "#D2D2D2"
})), Zf = ({ type: e }) => {
	let { t: n } = w(), r = e === "recents" ? n("media.call-history.you-have-no-recents-title", "You have no recents") : n("media.call-history.you-have-no-favorites-title", "You have no favorites");
	return /*#__PURE__*/ t.createElement("div", { className: Yf.container }, /*#__PURE__*/ t.createElement(ut, {
		className: Yf.boxes,
		source: Xf
	}), /*#__PURE__*/ t.createElement(G, {
		htmlTag: "p",
		className: "mb-2",
		fontVariant: V.H5
	}, r));
}, Qf = ({ isFullWidth: e = !1, isMobile: n, isRoundedCorners: i, enableRecents: o = !0, enableFavorites: s = !0, fillHeight: c = !0, favorites: l, recents: u, className: p, selectedTab: m, setSelectedTab: h, deleteAllRecents: g, deleteAllFavorites: _, onClose: v, handleItemClick: y, handleRemoveFavorite: b, handleDeleteRecent: x, handleAddToFavorites: S, reorderItem: C }) => {
	let { t: T } = w(), E = d(null), [D, O] = f(null), k = d(C), A = d(l);
	a(() => {
		k.current = C, A.current = l;
	});
	let j = r((e) => {
		let t = e.id;
		if (!t) return null;
		let n = A.current, r = n.findIndex((e) => e.meetingId === t);
		if (r === -1) return null;
		let i = e.parentElement;
		if (!i) return null;
		let a = e.offsetHeight;
		if (a === 0) return null;
		let o = i.getBoundingClientRect().top, s = e.getBoundingClientRect(), c = (s.top + s.height / 2 - o) / a;
		return {
			meetingId: t,
			originalIndex: r,
			dropIndex: Math.max(0, Math.min(Math.floor(c), n.length - 1)),
			itemHeight: a
		};
	}, []), M = r((e) => {
		if (!k.current) return;
		let t = j(e);
		t && O((e) => e && e.meetingId === t.meetingId && e.originalIndex === t.originalIndex && e.dropIndex === t.dropIndex && e.itemHeight === t.itemHeight ? e : t);
	}, [j]), N = r((e) => {
		let t = k.current;
		if (!t) {
			O(null);
			return;
		}
		let n = j(e);
		O(null), n && n.dropIndex !== n.originalIndex && t(n.meetingId, n.dropIndex);
	}, [j]), P, F = l.every((e) => e.isBranding);
	m === "recents" && u.length > 0 ? P = /*#__PURE__*/ t.createElement("div", { className: Jf.footer }, /*#__PURE__*/ t.createElement(Ae, null), /*#__PURE__*/ t.createElement(z, {
		noEnhancerPadding: !0,
		enhancerStart: /*#__PURE__*/ t.createElement(H, {
			source: U.IconTrash,
			size: "compact"
		}),
		enhancerStartClassName: "me-1",
		variant: "text",
		onClick: g,
		"data-testid": q.ButtonCallHistoryDeleteAllRecents
	}, T("media.call-history.delete-all-recents", "Delete all recents"))) : m === "favorites" && l.length > 0 && !F && (P = /*#__PURE__*/ t.createElement("div", { className: Jf.footer }, /*#__PURE__*/ t.createElement(Ae, null), /*#__PURE__*/ t.createElement(z, {
		noEnhancerPadding: !0,
		enhancerStart: /*#__PURE__*/ t.createElement(H, {
			source: U.IconTrash,
			size: "compact"
		}),
		enhancerStartClassName: "me-1",
		variant: "text",
		onClick: _,
		"data-testid": q.ButtonCallHistoryDeleteAllFavorites
	}, T("media.call-history.delete-all-favorites", "Delete all favorites"))));
	let I = m === "recents" && u.length === 0 || m === "favorites" && l.length === 0;
	return /*#__PURE__*/ t.createElement(Qe, {
		scrollElementRef: E,
		className: K(Jf.panel, { [Jf.fullWidth]: e }, p),
		headerClassName: Jf.header,
		isWithBorder: !1,
		isWithShadow: !0,
		fillHeight: c,
		isRounded: i,
		padding: n ? "small" : "compact",
		footerPadding: "none",
		footerBottomPadding: n ? "small" : "compact",
		headerPadding: "none",
		headerContent: /*#__PURE__*/ t.createElement(Ml, {
			onCloseClick: v,
			closeButtonTestId: q.ButtonCallHistoryPanelClose,
			bottomPadding: "none",
			bottomContent: /*#__PURE__*/ t.createElement(De, {
				variant: "underline",
				allowActiveTabToBeClicked: !1,
				sizeModifier: "medium",
				selectedTabID: m,
				onTabChange: (e) => h(e),
				tabs: [...o ? [{
					id: "recents",
					name: T("media.call-history.recents", "Recents"),
					testId: q.ButtonCallHistoryRecentsTab
				}] : [], ...s ? [{
					id: "favorites",
					name: T("media.call-history.favorites", "Favorites"),
					testId: q.ButtonCallHistoryFavoritesTab
				}] : []]
			})
		}),
		footerContent: P,
		hasFooterShadow: !1
	}, I && /*#__PURE__*/ t.createElement(Zf, { type: m }), m === "recents" && u.map((e, r) => {
		let i = l.some((t) => t.meetingId === e.meetingId);
		return /*#__PURE__*/ t.createElement(Gf, {
			className: u.length - 1 === r ? void 0 : Jf.itemDivider,
			key: e.meetingId,
			title: e.title,
			callSucceeded: e.succeeded,
			onClick: () => {
				y(e), v();
			},
			handleCallMeetingId: () => {
				y(e), v();
			},
			handleDeleteRecent: () => {
				x(e);
			},
			handleAddToFavorites: i ? void 0 : () => {
				S(e);
			},
			meetingId: e.meetingId,
			direction: e.direction,
			dateAndTime: e.dateAndTime,
			imageUrl: e.avatarImageUrl,
			isMobile: n
		});
	}), m === "favorites" && l.map((e, r) => {
		let i = D?.meetingId === e.meetingId, a;
		if (D && !i) {
			let { originalIndex: e, dropIndex: t, itemHeight: n } = D, i = r < e ? r : r - 1, o = i + +(i >= t) - r;
			a = {
				transform: o === 0 ? void 0 : `translateY(${o * n}px)`,
				transition: "transform 0.18s ease"
			};
		}
		return /*#__PURE__*/ t.createElement(qf, {
			key: e.meetingId,
			item: e,
			isMobile: n,
			showDivider: l.length - 1 !== r,
			isDragDisabled: !C,
			scrollElementRef: E,
			style: a,
			onPointerMoveExtra: M,
			onPointerUpExtra: N,
			onClick: () => {
				y(e), v();
			},
			handleRemoveFavorite: () => {
				e.isBranding || b(e);
			},
			handleReorderByKeyboard: (t) => {
				if (C) {
					if (t === "up") {
						if (r === 0) return;
						C(e.meetingId, r - 1);
					} else r !== l.length - 1 && C(e.meetingId, r + 1);
				}
			}
		});
	}));
}, $f = {
	list: "_list_htvry_4",
	hasWidth: "_hasWidth_htvry_8",
	sectionTitle: "_sectionTitle_htvry_12",
	itemDivider: "_itemDivider_htvry_16",
	scrollbars: "_scrollbars_htvry_20",
	content: "_content_htvry_26"
}, ep = {
	item: "_item_1qiei_4",
	avatarAndInfo: "_avatarAndInfo_1qiei_17",
	avatar: "_avatar_1qiei_17",
	info: "_info_1qiei_31",
	iconFavoriteToggleContainer: "_iconFavoriteToggleContainer_1qiei_42",
	iconFavoriteToggleTooltip: "_iconFavoriteToggleTooltip_1qiei_46",
	iconFavoriteToggleContainerDisabled: "_iconFavoriteToggleContainerDisabled_1qiei_50",
	iconFavoriteToggle: "_iconFavoriteToggle_1qiei_42",
	isFavorite: "_isFavorite_1qiei_57",
	iconFavoriteToggleDisabled: "_iconFavoriteToggleDisabled_1qiei_60",
	focus: "_focus_1qiei_69"
}, tp = ({ id: e, title: n, meetingId: r, imageUrl: i, isMobile: a, className: o, isFavorite: s, isBrandingFavorite: c, onClick: l, onFavoriteToggle: u }) => {
	let { t: d } = w(), f = t.useId(), p = c;
	return /*#__PURE__*/ t.createElement(mt, null, ({ colorScheme: c }) => /*#__PURE__*/ t.createElement(Be, {
		id: e ?? f,
		htmlTag: "div",
		role: "option",
		tabIndex: 0,
		"data-keyboard-nav-item": !0,
		onKeyDown: (e) => {
			e.key === X.enter && l();
		},
		onClick: l,
		className: K(c, ep.item, o),
		focusClassName: ep.focus,
		"data-testid": q.SuggestionItem
	}, /*#__PURE__*/ t.createElement("div", { className: ep.avatarAndInfo }, /*#__PURE__*/ t.createElement(ve, {
		className: ep.avatar,
		sizeModifier: "small",
		imageUrl: i,
		type: i ? ye.Image : ye.Initials,
		displayName: n ?? r
	}), /*#__PURE__*/ t.createElement("div", { className: ep.info }, /*#__PURE__*/ t.createElement(G, {
		title: n ?? r,
		fontVariant: V.Body
	}, n ?? r), n && r && /*#__PURE__*/ t.createElement(G, {
		title: r,
		fontVariant: a ? V.Body : V.Small
	}, r))), /*#__PURE__*/ t.createElement(_t, {
		tooltipContainerClassName: ep.iconFavoriteToggleTooltip,
		text: d("media.call-history.remove-favorite-disabled-branding", "Added by your admin and can not be removed."),
		isTooltipEnabled: p
	}, /*#__PURE__*/ t.createElement(Be, {
		"aria-disabled": p,
		className: K(ep.iconFavoriteToggleContainer, { [ep.iconFavoriteToggleContainerDisabled]: p }),
		"data-testid": q.ButtonSuggestionItemFavoriteToggle,
		htmlTag: "div",
		onClick: (e) => {
			p ? e.stopPropagation() : (e.stopPropagation(), u());
		},
		tabIndex: 0,
		onKeyDown: (e) => {
			if (e.key === X.enter) {
				if (p) {
					e.stopPropagation();
					return;
				}
				e.stopPropagation(), u();
			}
		}
	}, /*#__PURE__*/ t.createElement(H, {
		className: K(ep.iconFavoriteToggle, {
			[ep.isFavorite]: s,
			[ep.iconFavoriteToggleDisabled]: p
		}),
		source: U.IconStar
	})))));
}, np = ({ id: e, recents: n, favorites: r, directories: i, isMobile: a, onItemClick: o, onItemFavoriteToggle: s, className: c, itemClassName: l, width: u, keepOriginFocusOnNavigate: d = !1 }) => {
	let { t: f } = w(), p = t.useId(), m = t.useRef(null);
	Rn({
		containerRef: m,
		itemSelector: "[data-keyboard-nav-item]",
		loop: !0,
		keepOriginFocusOnNavigate: d,
		activateActiveItemOnEnter: d
	});
	let h = u ? { "--suggestion-list-width": `${u}px` } : void 0;
	return /*#__PURE__*/ t.createElement(Se, {
		padding: "none",
		className: K($f.list, { [$f.hasWidth]: !!u }, c),
		style: h
	}, /*#__PURE__*/ t.createElement(st, {
		className: $f.scrollbars,
		classNames: { contentEl: $f.content }
	}, /*#__PURE__*/ t.createElement("div", {
		id: e ?? p,
		ref: m,
		role: "listbox"
	}, r.length > 0 && /*#__PURE__*/ t.createElement("div", null, /*#__PURE__*/ t.createElement(G, {
		htmlTag: "p",
		className: $f.sectionTitle,
		variant: "subtle",
		fontVariant: V.Body
	}, f("media.call-history.favorites", "Favorites")), r.map((e, n) => /*#__PURE__*/ t.createElement(tp, {
		className: K(l, { [$f.itemDivider]: n < r.length - 1 }),
		key: `favorite-${e.meetingId}`,
		title: e.title,
		meetingId: e.meetingId,
		imageUrl: e.avatarImageUrl,
		isMobile: a,
		isFavorite: !0,
		isBrandingFavorite: !!e.isBrandingFavorite,
		onClick: () => o(e),
		onFavoriteToggle: () => s(e, !e.isFavorite)
	}))), n.length > 0 && /*#__PURE__*/ t.createElement("div", null, /*#__PURE__*/ t.createElement(G, {
		htmlTag: "p",
		className: $f.sectionTitle,
		variant: "subtle",
		fontVariant: V.Body
	}, f("media.suggestions.recent", "Recent")), n.map((e, r) => /*#__PURE__*/ t.createElement(tp, {
		className: K(l, { [$f.itemDivider]: r < n.length - 1 }),
		key: `recent-${e.meetingId}`,
		title: e.title,
		meetingId: e.meetingId,
		imageUrl: e.avatarImageUrl,
		isMobile: a,
		isFavorite: e.isFavorite,
		isBrandingFavorite: !!e.isBrandingFavorite,
		onClick: () => o(e),
		onFavoriteToggle: () => s(e, !e.isFavorite)
	}))), i.length > 0 && /*#__PURE__*/ t.createElement("div", null, /*#__PURE__*/ t.createElement(G, {
		htmlTag: "p",
		className: $f.sectionTitle,
		variant: "subtle",
		fontVariant: V.Body
	}, f("media.suggestions.directory", "Directory")), i.map((e, n) => /*#__PURE__*/ t.createElement(tp, {
		className: K(l, { [$f.itemDivider]: n < i.length - 1 }),
		key: `directory-${e.meetingId}`,
		title: e.title,
		meetingId: e.meetingId,
		imageUrl: e.avatarImageUrl,
		isMobile: a,
		isFavorite: e.isFavorite,
		isBrandingFavorite: !!e.isBrandingFavorite,
		onClick: () => o(e),
		onFavoriteToggle: () => s(e, !e.isFavorite)
	}))))));
};
export { pr as AUDIO_MP4, dr as AUDIO_OGG_OPUS, fr as AUDIO_WEBM_OPUS, hs as AVQualityStats, yd as AddParticipantButton, Ns as AspectRatioSelfview, Wo as AudioMeter, cc as AudioMeterButton, Uo as AudioMeterView, tl as AudioOutputTestButton, xi as BROWSER_NAME, Ks as BackgroundBlurInputControl, sn as BlockedBrowserPermissionsInfoType, xf as BreakoutEditPanel, Nu as BreakoutParticipantRow, pf as BreakoutPreviewPanel, af as BreakoutRoom, _n as BreakoutRoomAssignmentMode, Qd as BreakoutRoomHeader, yn as BreakoutRoomVariant, uf as BreakoutRoomsAskingForHelpRoomRow, mf as BreakoutRoomsGoBackToModeAssignmentModal, hf as BreakoutRoomsGoBackToOpenedRoomsModal, _f as BreakoutRoomsModeAssignment, Cs as BreakoutRoomsNameAndTimeLeft, Ss as BreakoutRoomsNameAndTimeLeftView, Xd as BreakoutRoomsPanelToggleView, vn as BreakoutRoomsScreen, sf as BreakoutSetupPanel, xn as CHARACTER_LIMIT, Al as CallControlsDesktopView, Nl as CallControlsTouchView, bn as CallHistoryDirection, Qf as CallHistoryPanelView, us as CallQualityVisualizer, Kl as ChatActivityMessage, Af as ChatDirectMessagePreview, Wl as ChatMessageView, Of as ChatNewDirectMessage, Bl as ChatPanelInput, Il as ChatPanelInputButtons, Fl as ChatPanelInputSendButton, ql as ChatPanelMessages, cu as ChatPanelToggleView, Yl as ChatPanelView, pn as ChatType, Tf as ChatTypeSwitcher, kf as ChatUnsupportedDirectMessage, Mn as DEFAULT_CHAT_INPUT_HEIGHT, Ci as DEVICE_TYPE, xc as DesktopMeetingToolbar, Ws as DeviceDeniedTooltip, Jc as DeviceSelect, Qc as DevicesList, $c as DevicesSelection, Nc as DraggableFoldableInMeetingSelfview, Pc as DraggableInMeetingSelfview, Io as DraggableMeetingVideo, ao as EASE_DURATION, Pn as EFFECTS_MANAGER_NAVIGATION_MOVE_DISTANCE, Pf as EffectsManagerView, No as ExternalVideo, fc as FeccButtonView, wc as FoldedSelfview, yc as Footer, Hu as FrequencyBar, Uu as FrequencyBars, Wu as FrequencyBarsAudioMeter, Fr as GROUP_ACTIVITIES_TIME_WINDOW, tu as Header, kn as INITIAL_STREAM_QUALITY, Fn as IN_MEETING_SELFVIEW_BUTTON_TRANSPARENCY, wi as I_PAD, Fo as InMeetingDraggable, dc as InMeetingInputControl, Yd as InfoCard, Vd as InfoCardType, Bd as InfoCardWidth, Bu as InputControlToggleView, Dd as InvitationModal, Od as InvitationModalWithTransform, Sd as InvitationSearchInput, Td as InviteeResults, Ed as InviteeSearch, Uc as JoinCallDetails, Kc as JoinCallDetailsMobile, Ic as JoinCallDetailsWrapper, zc as JoinDetailsText, Bc as JoinDetailsTextWrapper, Wc as JoinMeetingButton, Gc as JoinMeetingButtonWithOptions, X as KEYBOARD_EVENT_KEY, Tl as LeaveButtonDesktop, El as LeaveButtonTouch, Ad as LinkCopy, Nn as MESSAGES_BOTTOM_OFFSET, Cn as MIN_VIEWPORT_HEIGHT, Sn as MIN_VIEWPORT_WIDTH, jn as MainBreakoutRoomId, wd as ManualInvite, vd as MeetingLayout, _d as MeetingLayoutLoading, Ru as MeetingScrim, su as MeetingStageContainer, Mo as MeetingVideo, vl as MeetingWrapper, ml as MicrophoneMonitorModal, po as MicrophoneMuteMessage, ar as MimeTypes, Xc as MissingDeviceAlert, _c as MoreMenu, ef as MoveToRoomModalView, fn as MuteState, Rd as NetworkAlert, hn as NetworkState, Qn as NewChatMessageAction, Cl as NewChatMessagePill, Sf as OpenBreakoutRoomsErrorModal, Ii as PanelAnimationTypes, Ml as PanelHeader, Iu as PanelHeaderWrapper, Pu as ParticipantRow, xu as ParticipantRowActions, Eu as ParticipantRowList, Du as ParticipantRowListItem, Mu as ParticipantRowWrapper, Pd as ParticipantsPanelFooter, zu as ParticipantsPanelToggleView, Kr as Platform, Ro as PoppedOutEmptyPresentation, Fs as PreflightContent, $s as PreflightContentMobile, Ls as PreflightControlsWrapper, Js as PreflightInputControls, on as PreflightJoinDetailsToRender, Ys as PreflightMediaControls, rc as PreflightSelfview, dn as PresentationAction, mc as PresentationButton, ln as PresentationEmphasis, Vo as PresentationMeetingVideo, un as PresentationSize, cn as PresentationType, Bo as PresenterLabel, Cf as QualityList, cs as QualityNames, _o as RESET_TIME, pc as RaiseHandButton, zd as RemoveUserConfirmation, xl as RequestAccess, wl as ResponsiveButton, yf as RoomSettingsModalView, Ra as STATE_RESET_TIMER, Si as SYSTEM_NAME, xd as SearchRow, Md as SelfViewSettings, As as Selfview, Ku as SettingsModalBody, Xu as SettingsPanel, du as SidePanelWrapper, au as SpeakerPill, bs as Stats, Zo as StatsModal, qu as StealPresentationModal, mn as StreamQuality, J as StreamStatus, tp as SuggestionItemView, np as SuggestionListView, An as TOOLTIP_Z_INDEX_BELOW_OVERLAYS, q as TestId, gl as TestYourMicLink, pl as TestYourMicStages, Fd as ToastSpeakingWhileMuted, gc as ToolbarAriaMenu, Hl as UnreadIndicator, yo as UserMediaContext, Y as VideoLayoutOptionValues, il as YouCanSayTitle, Xn as appendGroupedParticipants, Ar as browserVersion, Ea as buildErrorMessages, Zn as buildGroupedActivityMessage, di as calculateDisplayMode, rr as calculateHowManyUnreadMessages, $n as calculateNewChatMessageAction, cr as copyTextToClipboard, sr as copyToClipboardItem, Di as createChangeOfMediaDevicesSubscription, Oi as createChangeOfTrackSubscription, gr as createInMemoryMediaSourceStore, Ai as createMediaActiveSubscription, hr as createMediaRecorder, Ya as createPreviewAudioInputHook, Xa as createPreviewAudioOutputHook, Za as createPreviewControllerHook, Ka as createPreviewHook, io as createPreviewVideoInputHook, fo as createPushToTalkHook, mo as createPushToTalkMuteToastHook, ki as createRequestedMediaSubscription, xo as createUserMediaHooks, To as createVADHook, jr as currentBrowserName, ko as defaultTranslations, Dn as desktopToolbarWidth, Cr as detectBrowser, Yr as execRegex, ci as exitPiP, _r as extractVersion, Fa as generateMediaSignalHooks, mr as getAudioMimeType, ji as getAudioOutput, wr as getBrowserName, Pr as getClampLevelFn, zr as getGroupActivityMessages, Ur as getInitialStreamQuality, xa as getInputStatusType, nr as getIsLastNewMessageVisibleFn, ei as getIsMicrosoftSurface, Fi as getLangDirection, $r as getPlatform, Mi as getPreferredAudioOutput, Ti as getUserAgentDetails, Tn as inMeetingDraggableInset, uo as initPushToTalkUI, la as initialNewUnreadMessageState, wn as interfacesMargin, Lr as isActivityInTimeRange, Er as isBrowserSupported, br as isChromiumWebRTC, ai as isCompatibleMobileDevice, ya as isControlsOverlapTruthy, Dr as isCurrentBrowserSupported, kr as isFirefox, yr as isFirefoxWebRTC, er as isLastMessageByCurrentUser, Gr as isMediaLocked, Wr as isMediaMuted, ti as isMicrosoftSurface, ni as isMobileDevice, Co as isOverlappingSidePanel, ri as isPhone, Zr as isPortrait, xr as isSafariWebRTC, Ir as isSameActivityType, Or as isScreenShareSupported, Qr as isSmallScreen, oo as isSpaceKeyboard, ii as isTablet, Xr as isTouchScreen, ws as isVideoActive, Ts as isVideoMuted, vr as isWebRTCBrowser, da as newChatMessageReducer, si as onDeviceSelectChange, oi as platform, Ua as presentationReducer, li as qualityToMediaConstraints, Nr as randomNumber, lr as readTextFromClipboard, tr as scrollToLastMessage, gn as selfviewAspectRatioValues, pa as setDisplayNewMessageToast, fa as setIsLastMessageVisible, Hr as setLogger, Rr as shouldAppendActivityMessage, ir as shouldEmitNewMessage, pi as shouldResizeWindow, Es as shouldShowErrorBorder, mi as shuffleBreakoutParticipants, On as sidePanelPlusDesktopToolbarWidth, En as sidePanelWidth, ur as statefulCopyLinkToClipboard, Mr as stopMouseEventPropagation, Sr as supportUnifiedPlan, vi as toActivityMessageText, bi as toTime, zi as togglePanel, ha as updateLastNewMessageVisible, ma as updateNewMessagesCount, Ln as useAnalyzer, Rn as useArrowKeyListNavigation, zn as useAssertedContext, Vn as useAudioDetection, Gn as useAudioMeter, Kn as useBatteryStatus, Yn as useBreakoutAddRoom, Bi as useBreakoutAssignParticipantsByMode, Vi as useBreakoutChangeParticipantRoom, Hi as useBreakoutCloseAllRoomsConfirmationModal, Yi as useBreakoutEdit, Ui as useBreakoutParticipantDrag, Wi as useBreakoutRemoveRoom, Ki as useBreakoutRoomNameChange, qi as useBreakoutShuffleParticipants, Xi as useBreakoutUpdateParticipants, Zi as useCallQuality, ia as useCallQualityToast, sa as useChat, ba as useControlsRelativePosition, Da as useDeviceErrorMessage, Ca as useDeviceStatusInfo, Oa as useFallbackDeviceNotifier, Hd as useInfoCardOrientation, Ud as useInfoCardWidth, Aa as useInputSuspendedInfo, ja as useInputsState, Ma as useMedia, Na as useMediaInputs, Ia as useMeetingStageLayout, za as useNetworkState, ua as useNewChatMessageReducer, Ba as usePreflightJoinDetailsToRender, Ga as usePresentation, Ha as usePresentationPoppedOut, qa as usePreviewAnalyzer, no as usePreviewControllerHandler, ro as usePreviewErrorHandling, go as useRemoveParticipant, wa as useRequestPermissionStatusInfo, vo as useResetCopyMeetingLink, bo as useSelectDeviceChangeHandler, Ja as useSelectedInput, So as useShortcutTranslation, wo as useSidePanelTransform, Ta as useSubscribeToInputError, Z as useUserMediaContext, Oo as useWindowOrientation };

//# sourceMappingURL=media-components.js.map